/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root';
import { Route as DashboardRouteImport } from './routes/_dashboard';
import { Route as SplatRouteImport } from './routes/$';
import { Route as IndexRouteImport } from './routes/index';
import { Route as publicResetPasswordRouteImport } from './routes/(public)/reset-password';
import { Route as publicOnlinebookingresponseRouteImport } from './routes/(public)/onlinebookingresponse';
import { Route as publicLoginRouteImport } from './routes/(public)/login';
import { Route as publicInviteRouteImport } from './routes/(public)/invite';
import { Route as publicGoogleBusinessRouteImport } from './routes/(public)/google-business';
import { Route as publicForgotPasswordRouteImport } from './routes/(public)/forgot-password';
import { Route as publicCreatePasswordRouteImport } from './routes/(public)/create-password';
import { Route as DashboardDashboardIndexRouteImport } from './routes/_dashboard/dashboard/index';
import { Route as publicReviewIndexRouteImport } from './routes/(public)/review.index';
import { Route as portalPortalIndexRouteImport } from './routes/(portal)/portal.index';
import { Route as DashboardDashboardTimesheetRouteImport } from './routes/_dashboard/dashboard/timesheet';
import { Route as DashboardDashboardTechniciansRouteImport } from './routes/_dashboard/dashboard/technicians';
import { Route as DashboardDashboardTeamChatRouteImport } from './routes/_dashboard/dashboard/team-chat';
import { Route as DashboardDashboardTaxesRouteImport } from './routes/_dashboard/dashboard/taxes';
import { Route as DashboardDashboardTasksRouteImport } from './routes/_dashboard/dashboard/tasks';
import { Route as DashboardDashboardStripeRouteImport } from './routes/_dashboard/dashboard/stripe';
import { Route as DashboardDashboardSettingsRouteImport } from './routes/_dashboard/dashboard/settings';
import { Route as DashboardDashboardScheduleRouteImport } from './routes/_dashboard/dashboard/schedule';
import { Route as DashboardDashboardRoutesRouteImport } from './routes/_dashboard/dashboard/routes';
import { Route as DashboardDashboardReviewsRouteImport } from './routes/_dashboard/dashboard/reviews';
import { Route as DashboardDashboardRemindersRouteImport } from './routes/_dashboard/dashboard/reminders';
import { Route as DashboardDashboardRecurringBillingRouteImport } from './routes/_dashboard/dashboard/recurring-billing';
import { Route as DashboardDashboardRecoveryRenewalsRouteImport } from './routes/_dashboard/dashboard/recovery-renewals';
import { Route as DashboardDashboardReceiptsRouteImport } from './routes/_dashboard/dashboard/receipts';
import { Route as DashboardDashboardPurchasingRouteImport } from './routes/_dashboard/dashboard/purchasing';
import { Route as DashboardDashboardProposalsRouteImport } from './routes/_dashboard/dashboard/proposals';
import { Route as DashboardDashboardPromotionsRouteImport } from './routes/_dashboard/dashboard/promotions';
import { Route as DashboardDashboardProjectsRouteImport } from './routes/_dashboard/dashboard/projects';
import { Route as DashboardDashboardPricebookRouteImport } from './routes/_dashboard/dashboard/pricebook';
import { Route as DashboardDashboardPaymentsRouteImport } from './routes/_dashboard/dashboard/payments';
import { Route as DashboardDashboardPastDueRouteImport } from './routes/_dashboard/dashboard/past-due';
import { Route as DashboardDashboardOperationsRouteImport } from './routes/_dashboard/dashboard/operations';
import { Route as DashboardDashboardOnboardingRouteImport } from './routes/_dashboard/dashboard/onboarding';
import { Route as DashboardDashboardNotificationsRouteImport } from './routes/_dashboard/dashboard/notifications';
import { Route as DashboardDashboardMyDayRouteImport } from './routes/_dashboard/dashboard/my-day';
import { Route as DashboardDashboardMyDashboardRouteImport } from './routes/_dashboard/dashboard/my-dashboard';
import { Route as DashboardDashboardMembershipsRouteImport } from './routes/_dashboard/dashboard/memberships';
import { Route as DashboardDashboardMembershipVisitsRouteImport } from './routes/_dashboard/dashboard/membership-visits';
import { Route as DashboardDashboardMembershipPlansRouteImport } from './routes/_dashboard/dashboard/membership-plans';
import { Route as DashboardDashboardLocationsRouteImport } from './routes/_dashboard/dashboard/locations';
import { Route as DashboardDashboardLiveCallsRouteImport } from './routes/_dashboard/dashboard/live-calls';
import { Route as DashboardDashboardLeadsEngineRouteImport } from './routes/_dashboard/dashboard/leads-engine';
import { Route as DashboardDashboardLeadsRouteImport } from './routes/_dashboard/dashboard/leads';
import { Route as DashboardDashboardJobsRouteImport } from './routes/_dashboard/dashboard/jobs';
import { Route as DashboardDashboardInvoicesRouteImport } from './routes/_dashboard/dashboard/invoices';
import { Route as DashboardDashboardInventoryRouteImport } from './routes/_dashboard/dashboard/inventory';
import { Route as DashboardDashboardInboxRouteImport } from './routes/_dashboard/dashboard/inbox';
import { Route as DashboardDashboardHomeRouteImport } from './routes/_dashboard/dashboard/home';
import { Route as DashboardDashboardFormsRouteImport } from './routes/_dashboard/dashboard/forms';
import { Route as DashboardDashboardExecutiveRouteImport } from './routes/_dashboard/dashboard/executive';
import { Route as DashboardDashboardEstimatesRouteImport } from './routes/_dashboard/dashboard/estimates';
import { Route as DashboardDashboardEquipmentDescriptionsRouteImport } from './routes/_dashboard/dashboard/equipment-descriptions';
import { Route as DashboardDashboardEquipmentCategoriesRouteImport } from './routes/_dashboard/dashboard/equipment-categories';
import { Route as DashboardDashboardEquipmentRouteImport } from './routes/_dashboard/dashboard/equipment';
import { Route as DashboardDashboardDispatchRouteImport } from './routes/_dashboard/dashboard/dispatch';
import { Route as DashboardDashboardDepositsRouteImport } from './routes/_dashboard/dashboard/deposits';
import { Route as DashboardDashboardCrewsRouteImport } from './routes/_dashboard/dashboard/crews';
import { Route as DashboardDashboardCrewMembersRouteImport } from './routes/_dashboard/dashboard/crew-members';
import { Route as DashboardDashboardCreditMemosRouteImport } from './routes/_dashboard/dashboard/credit-memos';
import { Route as DashboardDashboardContractsRouteImport } from './routes/_dashboard/dashboard/contracts';
import { Route as DashboardDashboardContactsRouteImport } from './routes/_dashboard/dashboard/contacts';
import { Route as DashboardDashboardChatbotRouteImport } from './routes/_dashboard/dashboard/chatbot';
import { Route as DashboardDashboardCalllogsRouteImport } from './routes/_dashboard/dashboard/calllogs';
import { Route as DashboardDashboardBookingsRouteImport } from './routes/_dashboard/dashboard/bookings';
import { Route as DashboardDashboardBoardRouteImport } from './routes/_dashboard/dashboard/board';
import { Route as DashboardDashboardAuditRouteImport } from './routes/_dashboard/dashboard/audit';
import { Route as publicTipIdRouteImport } from './routes/(public)/tip.$id';
import { Route as publicTipOptionIdRouteImport } from './routes/(public)/tip-option.$id';
import { Route as publicTTokenRouteImport } from './routes/(public)/t.$token';
import { Route as publicSupplierOrderTokenRouteImport } from './routes/(public)/supplier-order.$token';
import { Route as publicSignedSignedIdRouteImport } from './routes/(public)/signed.$signedId';
import { Route as publicScheduleChangeTokenRouteImport } from './routes/(public)/schedule-change.$token';
import { Route as publicSCodeRouteImport } from './routes/(public)/s.$code';
import { Route as publicReviewTokenRouteImport } from './routes/(public)/review.$token';
import { Route as publicResponseIdRouteImport } from './routes/(public)/response.$id';
import { Route as publicRepairPaymentMethodTokenRouteImport } from './routes/(public)/repair-payment-method.$token';
import { Route as publicRepairMembershipTokenRouteImport } from './routes/(public)/repair-membership.$token';
import { Route as publicRecurringTokenRouteImport } from './routes/(public)/recurring.$token';
import { Route as publicRecurringRenewalTokenRouteImport } from './routes/(public)/recurring-renewal.$token';
import { Route as publicReceiptIdRouteImport } from './routes/(public)/receipt.$id';
import { Route as publicRTokenRouteImport } from './routes/(public)/r.$token';
import { Route as publicQuoteIdRouteImport } from './routes/(public)/quote.$id';
import { Route as publicProposalIdRouteImport } from './routes/(public)/proposal.$id';
import { Route as publicPreviewquoteIdRouteImport } from './routes/(public)/previewquote.$id';
import { Route as publicPreviewinvoiceIdRouteImport } from './routes/(public)/previewinvoice.$id';
import { Route as publicPdfProposalIdRouteImport } from './routes/(public)/pdf-proposal.$id';
import { Route as publicPdfInvoiceIdRouteImport } from './routes/(public)/pdf-invoice.$id';
import { Route as publicPdfEstimateIdRouteImport } from './routes/(public)/pdf-estimate.$id';
import { Route as publicPaymentMethodRequestTokenRouteImport } from './routes/(public)/payment-method-request.$token';
import { Route as publicPayTokenRouteImport } from './routes/(public)/pay.$token';
import { Route as publicOnlineformIdRouteImport } from './routes/(public)/onlineform.$id';
import { Route as publicOnlinebookingIdRouteImport } from './routes/(public)/onlinebooking.$id';
import { Route as publicLinkPhoneTokenRouteImport } from './routes/(public)/link-phone.$token';
import { Route as publicJobStoriesTokenRouteImport } from './routes/(public)/job-stories.$token';
import { Route as publicJReferenceNoRouteImport } from './routes/(public)/j.$referenceNo';
import { Route as publicInvoiceIdRouteImport } from './routes/(public)/invoice.$id';
import { Route as publicInviteTokenRouteImport } from './routes/(public)/invite.$token';
import { Route as publicIIdRouteImport } from './routes/(public)/i.$id';
import { Route as publicFormIdRouteImport } from './routes/(public)/form.$id';
import { Route as publicEstimateIdRouteImport } from './routes/(public)/estimate.$id';
import { Route as publicETokenRouteImport } from './routes/(public)/e.$token';
import { Route as publicCreatePasswordTokenRouteImport } from './routes/(public)/create-password.$token';
import { Route as publicConfirmJobReferenceNoRouteImport } from './routes/(public)/confirm-job.$referenceNo';
import { Route as publicCombinedDocTokenRouteImport } from './routes/(public)/combined-doc.$token';
import { Route as publicChangeOrderIdRouteImport } from './routes/(public)/change-order.$id';
import { Route as publicCTokenRouteImport } from './routes/(public)/c.$token';
import { Route as publicBookTokenRouteImport } from './routes/(public)/book.$token';
import { Route as publicAuthImpersonateHandoffRouteImport } from './routes/(public)/auth.impersonate-handoff';
import { Route as portalPortalVerifyRouteImport } from './routes/(portal)/portal.verify';
import { Route as portalPortalResetRouteImport } from './routes/(portal)/portal.reset';
import { Route as portalPortalRegisterRouteImport } from './routes/(portal)/portal.register';
import { Route as portalPortalLoginRouteImport } from './routes/(portal)/portal.login';
import { Route as portalPortalForgotRouteImport } from './routes/(portal)/portal.forgot';
import { Route as DashboardDashboardUnscheduledIndexRouteImport } from './routes/_dashboard/dashboard/unscheduled/index';
import { Route as DashboardDashboardTechniciansIndexRouteImport } from './routes/_dashboard/dashboard/technicians/index';
import { Route as DashboardDashboardSettingsIndexRouteImport } from './routes/_dashboard/dashboard/settings/index';
import { Route as DashboardDashboardReceiptsIndexRouteImport } from './routes/_dashboard/dashboard/receipts/index';
import { Route as DashboardDashboardPurchasingIndexRouteImport } from './routes/_dashboard/dashboard/purchasing.index';
import { Route as DashboardDashboardProposalsIndexRouteImport } from './routes/_dashboard/dashboard/proposals/index';
import { Route as DashboardDashboardPricebookIndexRouteImport } from './routes/_dashboard/dashboard/pricebook/index';
import { Route as DashboardDashboardMembershipsIndexRouteImport } from './routes/_dashboard/dashboard/memberships/index';
import { Route as DashboardDashboardMembershipPlansIndexRouteImport } from './routes/_dashboard/dashboard/membership-plans/index';
import { Route as DashboardDashboardLeadsIndexRouteImport } from './routes/_dashboard/dashboard/leads/index';
import { Route as DashboardDashboardJobsIndexRouteImport } from './routes/_dashboard/dashboard/jobs/index';
import { Route as DashboardDashboardJobformIndexRouteImport } from './routes/_dashboard/dashboard/jobform/index';
import { Route as DashboardDashboardInvoicesIndexRouteImport } from './routes/_dashboard/dashboard/invoices/index';
import { Route as DashboardDashboardInventoryIndexRouteImport } from './routes/_dashboard/dashboard/inventory.index';
import { Route as DashboardDashboardFormsIndexRouteImport } from './routes/_dashboard/dashboard/forms/index';
import { Route as DashboardDashboardEstimatesIndexRouteImport } from './routes/_dashboard/dashboard/estimates/index';
import { Route as DashboardDashboardCrewmemberIndexRouteImport } from './routes/_dashboard/dashboard/crewmember/index';
import { Route as DashboardDashboardCreditMemosIndexRouteImport } from './routes/_dashboard/dashboard/credit-memos/index';
import { Route as DashboardDashboardContactsIndexRouteImport } from './routes/_dashboard/dashboard/contacts/index';
import { Route as DashboardDashboardCalendarIndexRouteImport } from './routes/_dashboard/dashboard/calendar/index';
import { Route as DashboardDashboardBookingsIndexRouteImport } from './routes/_dashboard/dashboard/bookings/index';
import { Route as portalPortalVisitsIndexRouteImport } from './routes/(portal)/portal.visits.index';
import { Route as portalPortalProposalsIndexRouteImport } from './routes/(portal)/portal.proposals.index';
import { Route as portalPortalPlansIndexRouteImport } from './routes/(portal)/portal.plans.index';
import { Route as portalPortalMembershipsIndexRouteImport } from './routes/(portal)/portal.memberships.index';
import { Route as portalPortalInvoicesIndexRouteImport } from './routes/(portal)/portal.invoices.index';
import { Route as portalPortalEstimatesIndexRouteImport } from './routes/(portal)/portal.estimates.index';
import { Route as portalPortalEquipmentIndexRouteImport } from './routes/(portal)/portal.equipment.index';
import { Route as portalPortalDocumentsIndexRouteImport } from './routes/(portal)/portal.documents.index';
import { Route as portalPortalAccountIndexRouteImport } from './routes/(portal)/portal.account.index';
import { Route as DashboardDashboardTechniciansReportsRouteImport } from './routes/_dashboard/dashboard/technicians/reports';
import { Route as DashboardDashboardTechniciansNewRouteImport } from './routes/_dashboard/dashboard/technicians/new';
import { Route as DashboardDashboardTechniciansIdRouteImport } from './routes/_dashboard/dashboard/technicians/$id';
import { Route as DashboardDashboardTaxesSimulatorRouteImport } from './routes/_dashboard/dashboard/taxes/simulator';
import { Route as DashboardDashboardTaxesRulesRouteImport } from './routes/_dashboard/dashboard/taxes/rules';
import { Route as DashboardDashboardTaxesOverridesRouteImport } from './routes/_dashboard/dashboard/taxes/overrides';
import { Route as DashboardDashboardSettingsWebhooksRouteImport } from './routes/_dashboard/dashboard/settings/webhooks';
import { Route as DashboardDashboardSettingsUsersRouteImport } from './routes/_dashboard/dashboard/settings/users';
import { Route as DashboardDashboardSettingsTradesRouteImport } from './routes/_dashboard/dashboard/settings/trades';
import { Route as DashboardDashboardSettingsTermsAndConditionsRouteImport } from './routes/_dashboard/dashboard/settings/terms-and-conditions';
import { Route as DashboardDashboardSettingsTemplatesRouteImport } from './routes/_dashboard/dashboard/settings/templates';
import { Route as DashboardDashboardSettingsTaxesRouteImport } from './routes/_dashboard/dashboard/settings/taxes';
import { Route as DashboardDashboardSettingsTagsRouteImport } from './routes/_dashboard/dashboard/settings/tags';
import { Route as DashboardDashboardSettingsSurveysRouteImport } from './routes/_dashboard/dashboard/settings/surveys';
import { Route as DashboardDashboardSettingsSuppliersRouteImport } from './routes/_dashboard/dashboard/settings/suppliers';
import { Route as DashboardDashboardSettingsSubscriptionRouteImport } from './routes/_dashboard/dashboard/settings/subscription';
import { Route as DashboardDashboardSettingsSmsRouteImport } from './routes/_dashboard/dashboard/settings/sms';
import { Route as DashboardDashboardSettingsSkillsRouteImport } from './routes/_dashboard/dashboard/settings/skills';
import { Route as DashboardDashboardSettingsServiceAreasRouteImport } from './routes/_dashboard/dashboard/settings/service-areas';
import { Route as DashboardDashboardSettingsScopeOfWorkRouteImport } from './routes/_dashboard/dashboard/settings/scope-of-work';
import { Route as DashboardDashboardSettingsReviewsRouteImport } from './routes/_dashboard/dashboard/settings/reviews';
import { Route as DashboardDashboardSettingsReviewPlatformsRouteImport } from './routes/_dashboard/dashboard/settings/review-platforms';
import { Route as DashboardDashboardSettingsReportsRouteImport } from './routes/_dashboard/dashboard/settings/reports';
import { Route as DashboardDashboardSettingsRemindersRouteImport } from './routes/_dashboard/dashboard/settings/reminders';
import { Route as DashboardDashboardSettingsQuickbooksRouteImport } from './routes/_dashboard/dashboard/settings/quickbooks';
import { Route as DashboardDashboardSettingsPurchasingRouteImport } from './routes/_dashboard/dashboard/settings/purchasing';
import { Route as DashboardDashboardSettingsPhoneRouteImport } from './routes/_dashboard/dashboard/settings/phone';
import { Route as DashboardDashboardSettingsPermissionsRouteImport } from './routes/_dashboard/dashboard/settings/permissions';
import { Route as DashboardDashboardSettingsPayrollProfilesRouteImport } from './routes/_dashboard/dashboard/settings/payroll-profiles';
import { Route as DashboardDashboardSettingsOnlineBookingRouteImport } from './routes/_dashboard/dashboard/settings/online-booking';
import { Route as DashboardDashboardSettingsOncallRouteImport } from './routes/_dashboard/dashboard/settings/oncall';
import { Route as DashboardDashboardSettingsOfficeSettingsRouteImport } from './routes/_dashboard/dashboard/settings/office-settings';
import { Route as DashboardDashboardSettingsNotificationsRouteImport } from './routes/_dashboard/dashboard/settings/notifications';
import { Route as DashboardDashboardSettingsLogoutRouteImport } from './routes/_dashboard/dashboard/settings/logout';
import { Route as DashboardDashboardSettingsLeadsRouteImport } from './routes/_dashboard/dashboard/settings/leads';
import { Route as DashboardDashboardSettingsJobtypesRouteImport } from './routes/_dashboard/dashboard/settings/jobtypes';
import { Route as DashboardDashboardSettingsJobPipelinesRouteImport } from './routes/_dashboard/dashboard/settings/job-pipelines';
import { Route as DashboardDashboardSettingsIntegrationsRouteImport } from './routes/_dashboard/dashboard/settings/integrations';
import { Route as DashboardDashboardSettingsGroupsRouteImport } from './routes/_dashboard/dashboard/settings/groups';
import { Route as DashboardDashboardSettingsEstimatesRouteImport } from './routes/_dashboard/dashboard/settings/estimates';
import { Route as DashboardDashboardSettingsEstimateSettingsRouteImport } from './routes/_dashboard/dashboard/settings/estimate-settings';
import { Route as DashboardDashboardSettingsEstimatePdfRouteImport } from './routes/_dashboard/dashboard/settings/estimate-pdf';
import { Route as DashboardDashboardSettingsEmailAccountsRouteImport } from './routes/_dashboard/dashboard/settings/email-accounts';
import { Route as DashboardDashboardSettingsDeferredRevenueRouteImport } from './routes/_dashboard/dashboard/settings/deferred-revenue';
import { Route as DashboardDashboardSettingsCustomfieldsRouteImport } from './routes/_dashboard/dashboard/settings/customfields';
import { Route as DashboardDashboardSettingsContractsRouteImport } from './routes/_dashboard/dashboard/settings/contracts';
import { Route as DashboardDashboardSettingsContactStatusesRouteImport } from './routes/_dashboard/dashboard/settings/contact-statuses';
import { Route as DashboardDashboardSettingsConnectionsRouteImport } from './routes/_dashboard/dashboard/settings/connections';
import { Route as DashboardDashboardSettingsCompanyRouteImport } from './routes/_dashboard/dashboard/settings/company';
import { Route as DashboardDashboardSettingsClientPortalRouteImport } from './routes/_dashboard/dashboard/settings/client-portal';
import { Route as DashboardDashboardSettingsChecklistRouteImport } from './routes/_dashboard/dashboard/settings/checklist';
import { Route as DashboardDashboardSettingsChatbotRouteImport } from './routes/_dashboard/dashboard/settings/chatbot';
import { Route as DashboardDashboardSettingsChannelsRouteImport } from './routes/_dashboard/dashboard/settings/channels';
import { Route as DashboardDashboardSettingsCalltreeRouteImport } from './routes/_dashboard/dashboard/settings/calltree';
import { Route as DashboardDashboardSettingsCallSettingsRouteImport } from './routes/_dashboard/dashboard/settings/call-settings';
import { Route as DashboardDashboardSettingsBookingWindowsRouteImport } from './routes/_dashboard/dashboard/settings/booking-windows';
import { Route as DashboardDashboardSettingsBookingServicesRouteImport } from './routes/_dashboard/dashboard/settings/booking-services';
import { Route as DashboardDashboardSettingsBookingLinksRouteImport } from './routes/_dashboard/dashboard/settings/booking-links';
import { Route as DashboardDashboardSettingsBillingRouteImport } from './routes/_dashboard/dashboard/settings/billing';
import { Route as DashboardDashboardSettingsAppointmentFormsRouteImport } from './routes/_dashboard/dashboard/settings/appointment-forms';
import { Route as DashboardDashboardSettingsApiKeysRouteImport } from './routes/_dashboard/dashboard/settings/api-keys';
import { Route as DashboardDashboardSettingsAccountingRouteImport } from './routes/_dashboard/dashboard/settings/accounting';
import { Route as DashboardDashboardReportsNewRouteImport } from './routes/_dashboard/dashboard/reports/new';
import { Route as DashboardDashboardReportsIdRouteImport } from './routes/_dashboard/dashboard/reports/$id';
import { Route as DashboardDashboardReportingTargetsRouteImport } from './routes/_dashboard/dashboard/reporting/targets';
import { Route as DashboardDashboardReportingScorecardsRouteImport } from './routes/_dashboard/dashboard/reporting/scorecards';
import { Route as DashboardDashboardReportingMeRouteImport } from './routes/_dashboard/dashboard/reporting/me';
import { Route as DashboardDashboardReportingCallsRouteImport } from './routes/_dashboard/dashboard/reporting/calls';
import { Route as DashboardDashboardReceiptsIdRouteImport } from './routes/_dashboard/dashboard/receipts/$id';
import { Route as DashboardDashboardPurchasingRequestsRouteImport } from './routes/_dashboard/dashboard/purchasing.requests';
import { Route as DashboardDashboardPurchasingOverviewRouteImport } from './routes/_dashboard/dashboard/purchasing.overview';
import { Route as DashboardDashboardPurchasingFieldRouteImport } from './routes/_dashboard/dashboard/purchasing.field';
import { Route as DashboardDashboardPurchasingCostChangesRouteImport } from './routes/_dashboard/dashboard/purchasing.cost-changes';
import { Route as DashboardDashboardPurchasingCardsRouteImport } from './routes/_dashboard/dashboard/purchasing.cards';
import { Route as DashboardDashboardPurchasingBillsRouteImport } from './routes/_dashboard/dashboard/purchasing.bills';
import { Route as DashboardDashboardPurchasingApprovalsRouteImport } from './routes/_dashboard/dashboard/purchasing.approvals';
import { Route as DashboardDashboardProposalsNewRouteImport } from './routes/_dashboard/dashboard/proposals/new';
import { Route as DashboardDashboardProposalsIdRouteImport } from './routes/_dashboard/dashboard/proposals/$id';
import { Route as DashboardDashboardProjectsProjectIdRouteImport } from './routes/_dashboard/dashboard/projects/$projectId';
import { Route as DashboardDashboardPricebookNewRouteImport } from './routes/_dashboard/dashboard/pricebook/new';
import { Route as DashboardDashboardPricebookCategoriesRouteImport } from './routes/_dashboard/dashboard/pricebook/categories';
import { Route as DashboardDashboardPricebookIdRouteImport } from './routes/_dashboard/dashboard/pricebook/$id';
import { Route as DashboardDashboardPaymentsIdRouteImport } from './routes/_dashboard/dashboard/payments/$id';
import { Route as DashboardDashboardMembershipsReportsRouteImport } from './routes/_dashboard/dashboard/memberships/reports';
import { Route as DashboardDashboardMembershipsNewRouteImport } from './routes/_dashboard/dashboard/memberships/new';
import { Route as DashboardDashboardMembershipsIdRouteImport } from './routes/_dashboard/dashboard/memberships/$id';
import { Route as DashboardDashboardMembershipPlansNewRouteImport } from './routes/_dashboard/dashboard/membership-plans/new';
import { Route as DashboardDashboardMembershipPlansIdRouteImport } from './routes/_dashboard/dashboard/membership-plans/$id';
import { Route as DashboardDashboardLocationsLocationIdRouteImport } from './routes/_dashboard/dashboard/locations/$locationId';
import { Route as DashboardDashboardLeadsReportsRouteImport } from './routes/_dashboard/dashboard/leads/reports';
import { Route as DashboardDashboardLeadsNewRouteImport } from './routes/_dashboard/dashboard/leads/new';
import { Route as DashboardDashboardLeadsLeadIdRouteImport } from './routes/_dashboard/dashboard/leads/$leadId';
import { Route as DashboardDashboardJobsServiceCallsRouteImport } from './routes/_dashboard/dashboard/jobs/service-calls';
import { Route as DashboardDashboardJobsReportsRouteImport } from './routes/_dashboard/dashboard/jobs/reports';
import { Route as DashboardDashboardJobsNewRouteImport } from './routes/_dashboard/dashboard/jobs/new';
import { Route as DashboardDashboardJobsBudgetVsActualRouteImport } from './routes/_dashboard/dashboard/jobs/budget-vs-actual';
import { Route as DashboardDashboardJobsIdRouteImport } from './routes/_dashboard/dashboard/jobs/$id';
import { Route as DashboardDashboardJobformNewRouteImport } from './routes/_dashboard/dashboard/jobform/new';
import { Route as DashboardDashboardJobformIdRouteImport } from './routes/_dashboard/dashboard/jobform/$id';
import { Route as DashboardDashboardInvoicesReportsRouteImport } from './routes/_dashboard/dashboard/invoices/reports';
import { Route as DashboardDashboardInvoicesNewRouteImport } from './routes/_dashboard/dashboard/invoices/new';
import { Route as DashboardDashboardInvoicesIdRouteImport } from './routes/_dashboard/dashboard/invoices/$id';
import { Route as DashboardDashboardInventoryTruckTemplatesRouteImport } from './routes/_dashboard/dashboard/inventory.truck-templates';
import { Route as DashboardDashboardInventoryTransfersRouteImport } from './routes/_dashboard/dashboard/inventory.transfers';
import { Route as DashboardDashboardInventoryStockRouteImport } from './routes/_dashboard/dashboard/inventory.stock';
import { Route as DashboardDashboardInventoryOverviewRouteImport } from './routes/_dashboard/dashboard/inventory.overview';
import { Route as DashboardDashboardInventoryMyTruckRouteImport } from './routes/_dashboard/dashboard/inventory.my-truck';
import { Route as DashboardDashboardInventoryLocationsRouteImport } from './routes/_dashboard/dashboard/inventory.locations';
import { Route as DashboardDashboardFormsFormIdRouteImport } from './routes/_dashboard/dashboard/forms/$formId';
import { Route as DashboardDashboardEstimatesReportsRouteImport } from './routes/_dashboard/dashboard/estimates/reports';
import { Route as DashboardDashboardEstimatesNewRouteImport } from './routes/_dashboard/dashboard/estimates/new';
import { Route as DashboardDashboardEstimatesIdRouteImport } from './routes/_dashboard/dashboard/estimates/$id';
import { Route as DashboardDashboardDispatchLiveRouteImport } from './routes/_dashboard/dashboard/dispatch_.live';
import { Route as DashboardDashboardDepositsIdRouteImport } from './routes/_dashboard/dashboard/deposits/$id';
import { Route as DashboardDashboardCrewsNewRouteImport } from './routes/_dashboard/dashboard/crews/new';
import { Route as DashboardDashboardCrewsIdRouteImport } from './routes/_dashboard/dashboard/crews/$id';
import { Route as DashboardDashboardCrewmemberUserIdRouteImport } from './routes/_dashboard/dashboard/crewmember/$userId';
import { Route as DashboardDashboardCreditMemosNewRouteImport } from './routes/_dashboard/dashboard/credit-memos/new';
import { Route as DashboardDashboardCreditMemosIdRouteImport } from './routes/_dashboard/dashboard/credit-memos/$id';
import { Route as DashboardDashboardCostingReportsRouteImport } from './routes/_dashboard/dashboard/costing/reports';
import { Route as DashboardDashboardContractsIdRouteImport } from './routes/_dashboard/dashboard/contracts/$id';
import { Route as DashboardDashboardContactsTasksRouteImport } from './routes/_dashboard/dashboard/contacts/tasks';
import { Route as DashboardDashboardContactsReportsRouteImport } from './routes/_dashboard/dashboard/contacts/reports';
import { Route as DashboardDashboardContactsNewRouteImport } from './routes/_dashboard/dashboard/contacts/new';
import { Route as DashboardDashboardContactsContactIdRouteImport } from './routes/_dashboard/dashboard/contacts/$contactId';
import { Route as DashboardDashboardCalllogsReportsRouteImport } from './routes/_dashboard/dashboard/calllogs_.reports';
import { Route as DashboardDashboardCalendarMapRouteImport } from './routes/_dashboard/dashboard/calendar/map';
import { Route as DashboardDashboardCalendarIdRouteImport } from './routes/_dashboard/dashboard/calendar/$id';
import { Route as DashboardDashboardBookingsNewRouteImport } from './routes/_dashboard/dashboard/bookings/new';
import { Route as DashboardDashboardBookingsBookingIdRouteImport } from './routes/_dashboard/dashboard/bookings/$bookingId';
import { Route as DashboardDashboardAiOttoRouteImport } from './routes/_dashboard/dashboard/ai/otto';
import { Route as publicTrackingIdRefnoRouteImport } from './routes/(public)/tracking.$id.$refno';
import { Route as publicReviewReviewIdId2RouteImport } from './routes/(public)/review.$reviewId.$id2';
import { Route as portalPortalVisitsBookRouteImport } from './routes/(portal)/portal.visits.book';
import { Route as portalPortalProposalsIdRouteImport } from './routes/(portal)/portal.proposals.$id';
import { Route as portalPortalMembershipsIdRouteImport } from './routes/(portal)/portal.memberships.$id';
import { Route as portalPortalInvoicesIdRouteImport } from './routes/(portal)/portal.invoices.$id';
import { Route as portalPortalEstimatesIdRouteImport } from './routes/(portal)/portal.estimates.$id';
import { Route as DashboardDashboardSettingsTemplatesIndexRouteImport } from './routes/_dashboard/dashboard/settings/templates/index';
import { Route as DashboardDashboardSettingsJobPipelinesIndexRouteImport } from './routes/_dashboard/dashboard/settings/job-pipelines/index';
import { Route as DashboardDashboardSettingsDocumentTemplatesIndexRouteImport } from './routes/_dashboard/dashboard/settings/document-templates/index';
import { Route as DashboardDashboardSettingsContractsIndexRouteImport } from './routes/_dashboard/dashboard/settings/contracts/index';
import { Route as DashboardDashboardSettingsChecklistIndexRouteImport } from './routes/_dashboard/dashboard/settings/checklist.index';
import { Route as DashboardDashboardSettingsBusinessUnitsIndexRouteImport } from './routes/_dashboard/dashboard/settings/business-units.index';
import { Route as DashboardDashboardSettingsBillingIndexRouteImport } from './routes/_dashboard/dashboard/settings/billing/index';
import { Route as DashboardDashboardSettingsAppointmentFormsIndexRouteImport } from './routes/_dashboard/dashboard/settings/appointment-forms/index';
import { Route as DashboardDashboardReportingReportsIndexRouteImport } from './routes/_dashboard/dashboard/reporting/reports/index';
import { Route as DashboardDashboardPurchasingSuppliersIndexRouteImport } from './routes/_dashboard/dashboard/purchasing.suppliers.index';
import { Route as DashboardDashboardInventoryReplenishmentIndexRouteImport } from './routes/_dashboard/dashboard/inventory.replenishment.index';
import { Route as DashboardDashboardInventoryCountsIndexRouteImport } from './routes/_dashboard/dashboard/inventory.counts.index';
import { Route as DashboardDashboardTechniciansIdOffboardingRouteImport } from './routes/_dashboard/dashboard/technicians/$id.offboarding';
import { Route as DashboardDashboardTechniciansIdEditRouteImport } from './routes/_dashboard/dashboard/technicians/$id.edit';
import { Route as DashboardDashboardSettingsWebhooksNewRouteImport } from './routes/_dashboard/dashboard/settings/webhooks.new';
import { Route as DashboardDashboardSettingsWebhooksIdRouteImport } from './routes/_dashboard/dashboard/settings/webhooks.$id';
import { Route as DashboardDashboardSettingsUsersNewRouteImport } from './routes/_dashboard/dashboard/settings/users.new';
import { Route as DashboardDashboardSettingsUsersIdRouteImport } from './routes/_dashboard/dashboard/settings/users.$id';
import { Route as DashboardDashboardSettingsTermsAndConditionsIdRouteImport } from './routes/_dashboard/dashboard/settings/terms-and-conditions.$id';
import { Route as DashboardDashboardSettingsSkillsNewRouteImport } from './routes/_dashboard/dashboard/settings/skills.new';
import { Route as DashboardDashboardSettingsSkillsIdRouteImport } from './routes/_dashboard/dashboard/settings/skills.$id';
import { Route as DashboardDashboardSettingsScopeOfWorkIdRouteImport } from './routes/_dashboard/dashboard/settings/scope-of-work.$id';
import { Route as DashboardDashboardSettingsReportsTemplatesRouteImport } from './routes/_dashboard/dashboard/settings/reports_.templates';
import { Route as DashboardDashboardSettingsRemindersTypeRouteImport } from './routes/_dashboard/dashboard/settings/reminders/$type';
import { Route as DashboardDashboardSettingsPermissionsNewRouteImport } from './routes/_dashboard/dashboard/settings/permissions.new';
import { Route as DashboardDashboardSettingsPermissionsIdRouteImport } from './routes/_dashboard/dashboard/settings/permissions.$id';
import { Route as DashboardDashboardSettingsPartnerApiWebhooksRouteImport } from './routes/_dashboard/dashboard/settings/partner-api.webhooks';
import { Route as DashboardDashboardSettingsOfficeSettingsEditRouteImport } from './routes/_dashboard/dashboard/settings/office-settings.edit';
import { Route as DashboardDashboardSettingsNotificationsEditRouteImport } from './routes/_dashboard/dashboard/settings/notifications.edit';
import { Route as DashboardDashboardSettingsJobtypesNewRouteImport } from './routes/_dashboard/dashboard/settings/jobtypes.new';
import { Route as DashboardDashboardSettingsJobtypesIdRouteImport } from './routes/_dashboard/dashboard/settings/jobtypes.$id';
import { Route as DashboardDashboardSettingsJobPipelinesNewRouteImport } from './routes/_dashboard/dashboard/settings/job-pipelines/new';
import { Route as DashboardDashboardSettingsJobPipelinesIdRouteImport } from './routes/_dashboard/dashboard/settings/job-pipelines/$id';
import { Route as DashboardDashboardSettingsGroupsNewRouteImport } from './routes/_dashboard/dashboard/settings/groups.new';
import { Route as DashboardDashboardSettingsGroupsIdRouteImport } from './routes/_dashboard/dashboard/settings/groups.$id';
import { Route as DashboardDashboardSettingsEmailTemplatesNewRouteImport } from './routes/_dashboard/dashboard/settings/email-templates/new';
import { Route as DashboardDashboardSettingsEmailTemplatesIdRouteImport } from './routes/_dashboard/dashboard/settings/email-templates/$id';
import { Route as DashboardDashboardSettingsDocumentTemplatesNewRouteImport } from './routes/_dashboard/dashboard/settings/document-templates/new';
import { Route as DashboardDashboardSettingsDocumentTemplatesIdRouteImport } from './routes/_dashboard/dashboard/settings/document-templates/$id';
import { Route as DashboardDashboardSettingsCustomfieldsNewRouteImport } from './routes/_dashboard/dashboard/settings/customfields.new';
import { Route as DashboardDashboardSettingsCustomfieldsIdRouteImport } from './routes/_dashboard/dashboard/settings/customfields.$id';
import { Route as DashboardDashboardSettingsContractsReviewsRouteImport } from './routes/_dashboard/dashboard/settings/contracts/reviews';
import { Route as DashboardDashboardSettingsContractsRenewalCancellationRouteImport } from './routes/_dashboard/dashboard/settings/contracts/renewal-cancellation';
import { Route as DashboardDashboardSettingsContractsRenewalRouteImport } from './routes/_dashboard/dashboard/settings/contracts/renewal';
import { Route as DashboardDashboardSettingsContractsQboRouteImport } from './routes/_dashboard/dashboard/settings/contracts/qbo';
import { Route as DashboardDashboardSettingsContractsProductionKitsRouteImport } from './routes/_dashboard/dashboard/settings/contracts/production-kits';
import { Route as DashboardDashboardSettingsContractsDefaultsRouteImport } from './routes/_dashboard/dashboard/settings/contracts/defaults';
import { Route as DashboardDashboardSettingsContractsCostingRouteImport } from './routes/_dashboard/dashboard/settings/contracts/costing';
import { Route as DashboardDashboardSettingsContractsCancellationRouteImport } from './routes/_dashboard/dashboard/settings/contracts/cancellation';
import { Route as DashboardDashboardSettingsCompanyEditRouteImport } from './routes/_dashboard/dashboard/settings/company.edit';
import { Route as DashboardDashboardSettingsChecklistNewRouteImport } from './routes/_dashboard/dashboard/settings/checklist.new';
import { Route as DashboardDashboardSettingsChecklistIdRouteImport } from './routes/_dashboard/dashboard/settings/checklist.$id';
import { Route as DashboardDashboardSettingsBusinessUnitsIdRouteImport } from './routes/_dashboard/dashboard/settings/business-units.$id';
import { Route as DashboardDashboardSettingsBillingReceiptsRouteImport } from './routes/_dashboard/dashboard/settings/billing/receipts';
import { Route as DashboardDashboardSettingsBillingQuickbooksRouteImport } from './routes/_dashboard/dashboard/settings/billing/quickbooks';
import { Route as DashboardDashboardSettingsBillingPaymentsRouteImport } from './routes/_dashboard/dashboard/settings/billing/payments';
import { Route as DashboardDashboardSettingsBillingInvoicesRouteImport } from './routes/_dashboard/dashboard/settings/billing/invoices';
import { Route as DashboardDashboardSettingsBillingDepositsRouteImport } from './routes/_dashboard/dashboard/settings/billing/deposits';
import { Route as DashboardDashboardSettingsBillingCreditMemosRouteImport } from './routes/_dashboard/dashboard/settings/billing/credit-memos';
import { Route as DashboardDashboardSettingsAppointmentFormsNewRouteImport } from './routes/_dashboard/dashboard/settings/appointment-forms/new';
import { Route as DashboardDashboardSettingsAppointmentFormsIdRouteImport } from './routes/_dashboard/dashboard/settings/appointment-forms/$id';
import { Route as DashboardDashboardReportingReportsNewRouteImport } from './routes/_dashboard/dashboard/reporting/reports/new';
import { Route as DashboardDashboardReportingReportsReportIdRouteImport } from './routes/_dashboard/dashboard/reporting/reports/$reportId';
import { Route as DashboardDashboardPurchasingSuppliersSupplierIdRouteImport } from './routes/_dashboard/dashboard/purchasing.suppliers.$supplierId';
import { Route as DashboardDashboardProposalsIdPresentRouteImport } from './routes/_dashboard/dashboard/proposals/$id.present';
import { Route as DashboardDashboardProposalsIdEditRouteImport } from './routes/_dashboard/dashboard/proposals/$id.edit';
import { Route as DashboardDashboardPricebookIdEditRouteImport } from './routes/_dashboard/dashboard/pricebook/$id.edit';
import { Route as DashboardDashboardMembershipsIdEditRouteImport } from './routes/_dashboard/dashboard/memberships/$id.edit';
import { Route as DashboardDashboardMembershipPlansIdEditRouteImport } from './routes/_dashboard/dashboard/membership-plans/$id.edit';
import { Route as DashboardDashboardLeadsLeadIdEditRouteImport } from './routes/_dashboard/dashboard/leads/$leadId.edit';
import { Route as DashboardDashboardJobsIdEditRouteImport } from './routes/_dashboard/dashboard/jobs/$id.edit';
import { Route as DashboardDashboardInvoicesIdEditRouteImport } from './routes/_dashboard/dashboard/invoices/$id.edit';
import { Route as DashboardDashboardInventoryReplenishmentRunIdRouteImport } from './routes/_dashboard/dashboard/inventory.replenishment.$runId';
import { Route as DashboardDashboardInventoryPickListsNewRouteImport } from './routes/_dashboard/dashboard/inventory.pick-lists_.new';
import { Route as DashboardDashboardInventoryPickListsIdRouteImport } from './routes/_dashboard/dashboard/inventory.pick-lists_.$id';
import { Route as DashboardDashboardInventoryLocationsLocationIdRouteImport } from './routes/_dashboard/dashboard/inventory.locations_.$locationId';
import { Route as DashboardDashboardInventoryJobsJobIdRouteImport } from './routes/_dashboard/dashboard/inventory.jobs.$jobId';
import { Route as DashboardDashboardInventoryItemsItemIdRouteImport } from './routes/_dashboard/dashboard/inventory.items.$itemId';
import { Route as DashboardDashboardInventoryCountsCountIdRouteImport } from './routes/_dashboard/dashboard/inventory.counts.$countId';
import { Route as DashboardDashboardEstimatesIdPaymentScheduleRouteImport } from './routes/_dashboard/dashboard/estimates/$id.payment-schedule';
import { Route as DashboardDashboardEstimatesIdEditRouteImport } from './routes/_dashboard/dashboard/estimates/$id.edit';
import { Route as DashboardDashboardCrewsIdEditRouteImport } from './routes/_dashboard/dashboard/crews/$id.edit';
import { Route as DashboardDashboardContactsContactIdEditRouteImport } from './routes/_dashboard/dashboard/contacts/$contactId.edit';
import { Route as DashboardDashboardContactsContactIdConsentRecordsRouteImport } from './routes/_dashboard/dashboard/contacts/$contactId.consent-records';
import { Route as DashboardDashboardAiOttoReportIdRouteImport } from './routes/_dashboard/dashboard/ai/otto.$reportId';
import { Route as publicPaymentIdId2PriceidRouteImport } from './routes/(public)/payment.$id.$id2.$priceid';
import { Route as DashboardDashboardSettingsWebhooksIdEditRouteImport } from './routes/_dashboard/dashboard/settings/webhooks.$id.edit';
import { Route as DashboardDashboardSettingsUsersIdEditRouteImport } from './routes/_dashboard/dashboard/settings/users.$id.edit';
import { Route as DashboardDashboardSettingsTermsAndConditionsIdEditRouteImport } from './routes/_dashboard/dashboard/settings/terms-and-conditions.$id.edit';
import { Route as DashboardDashboardSettingsTemplatesProposalNewRouteImport } from './routes/_dashboard/dashboard/settings/templates/proposal/new';
import { Route as DashboardDashboardSettingsTemplatesProposalIdRouteImport } from './routes/_dashboard/dashboard/settings/templates/proposal/$id';
import { Route as DashboardDashboardSettingsTemplatesEstimateNewRouteImport } from './routes/_dashboard/dashboard/settings/templates/estimate/new';
import { Route as DashboardDashboardSettingsTemplatesEstimateIdRouteImport } from './routes/_dashboard/dashboard/settings/templates/estimate/$id';
import { Route as DashboardDashboardSettingsSkillsIdEditRouteImport } from './routes/_dashboard/dashboard/settings/skills.$id.edit';
import { Route as DashboardDashboardSettingsScopeOfWorkIdEditRouteImport } from './routes/_dashboard/dashboard/settings/scope-of-work.$id.edit';
import { Route as DashboardDashboardSettingsPermissionsIdEditRouteImport } from './routes/_dashboard/dashboard/settings/permissions.$id.edit';
import { Route as DashboardDashboardSettingsPartnerApiWebhooksNewRouteImport } from './routes/_dashboard/dashboard/settings/partner-api.webhooks.new';
import { Route as DashboardDashboardSettingsPartnerApiWebhooksIdRouteImport } from './routes/_dashboard/dashboard/settings/partner-api.webhooks.$id';
import { Route as DashboardDashboardSettingsJobtypesIdEditRouteImport } from './routes/_dashboard/dashboard/settings/jobtypes.$id.edit';
import { Route as DashboardDashboardSettingsJobPipelinesIdEditRouteImport } from './routes/_dashboard/dashboard/settings/job-pipelines/$id.edit';
import { Route as DashboardDashboardSettingsGroupsIdEditRouteImport } from './routes/_dashboard/dashboard/settings/groups.$id.edit';
import { Route as DashboardDashboardSettingsCustomfieldsIdEditRouteImport } from './routes/_dashboard/dashboard/settings/customfields.$id.edit';
import { Route as DashboardDashboardSettingsChecklistIdEditRouteImport } from './routes/_dashboard/dashboard/settings/checklist.$id.edit';
import { Route as DashboardDashboardSettingsCallSettingsTeamSectionRouteImport } from './routes/_dashboard/dashboard/settings/call-settings.team.$section';
import { Route as DashboardDashboardSettingsCallSettingsNumbersNumberIdRouteImport } from './routes/_dashboard/dashboard/settings/call-settings.numbers.$numberId';
import { Route as DashboardDashboardSettingsCallSettingsIvrNewRouteImport } from './routes/_dashboard/dashboard/settings/call-settings.ivr.new';
import { Route as DashboardDashboardSettingsCallSettingsIvrIdRouteImport } from './routes/_dashboard/dashboard/settings/call-settings.ivr.$id';
import { Route as DashboardDashboardSettingsCallSettingsFlowsIdRouteImport } from './routes/_dashboard/dashboard/settings/call-settings.flows.$id';
import { Route as DashboardDashboardSettingsAppointmentFormsIdEditRouteImport } from './routes/_dashboard/dashboard/settings/appointment-forms/$id.edit';
import { Route as DashboardDashboardReportingReportsReportIdEditRouteImport } from './routes/_dashboard/dashboard/reporting/reports/$reportId_.edit';
import { Route as DashboardDashboardPurchasingSuppliersSupplierIdEditRouteImport } from './routes/_dashboard/dashboard/purchasing.suppliers.$supplierId_.edit';
import { Route as DashboardDashboardJobsIdPaymentScheduleNewRouteImport } from './routes/_dashboard/dashboard/jobs/$id.payment-schedule.new';
import { Route as DashboardDashboardJobsIdPaymentScheduleEditRouteImport } from './routes/_dashboard/dashboard/jobs/$id.payment-schedule.edit';
import { Route as DashboardDashboardJobsIdInvoicesNewRouteImport } from './routes/_dashboard/dashboard/jobs/$id.invoices.new';
import { Route as DashboardDashboardJobsIdInvoicesInvoiceIdRouteImport } from './routes/_dashboard/dashboard/jobs/$id.invoices.$invoiceId';
import { Route as DashboardDashboardJobsIdExpensesNewRouteImport } from './routes/_dashboard/dashboard/jobs/$id.expenses.new';
import { Route as DashboardDashboardJobsIdExpensesExpenseIdRouteImport } from './routes/_dashboard/dashboard/jobs/$id.expenses.$expenseId';
import { Route as DashboardDashboardJobsIdChangeOrdersNewRouteImport } from './routes/_dashboard/dashboard/jobs/$id.change-orders.new';
import { Route as DashboardDashboardJobsIdChangeOrdersChangeOrderIdRouteImport } from './routes/_dashboard/dashboard/jobs/$id.change-orders.$changeOrderId';
import { Route as DashboardDashboardJobsIdAppointmentsNewRouteImport } from './routes/_dashboard/dashboard/jobs/$id.appointments.new';
import { Route as DashboardDashboardJobsIdAppointmentsAppointmentIdRouteImport } from './routes/_dashboard/dashboard/jobs/$id.appointments.$appointmentId';
import { Route as DashboardDashboardContactsContactIdBillToNewRouteImport } from './routes/_dashboard/dashboard/contacts/$contactId.bill-to.new';
import { Route as DashboardDashboardContactsContactIdAddressesNewRouteImport } from './routes/_dashboard/dashboard/contacts/$contactId.addresses.new';
import { Route as DashboardDashboardSettingsPartnerApiWebhooksIdEditRouteImport } from './routes/_dashboard/dashboard/settings/partner-api.webhooks.$id.edit';
import { Route as DashboardDashboardContactsContactIdBillToBillToIdEditRouteImport } from './routes/_dashboard/dashboard/contacts/$contactId.bill-to.$billToId.edit';
import { Route as DashboardDashboardContactsContactIdAddressesAddressIdEditRouteImport } from './routes/_dashboard/dashboard/contacts/$contactId.addresses.$addressId.edit';

const DashboardRoute = DashboardRouteImport.update({
  id: '/_dashboard',
  getParentRoute: () => rootRouteImport,
} as any);
const SplatRoute = SplatRouteImport.update({
  id: '/$',
  path: '/$',
  getParentRoute: () => rootRouteImport,
} as any);
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any);
const publicResetPasswordRoute = publicResetPasswordRouteImport.update({
  id: '/(public)/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any);
const publicOnlinebookingresponseRoute =
  publicOnlinebookingresponseRouteImport.update({
    id: '/(public)/onlinebookingresponse',
    path: '/onlinebookingresponse',
    getParentRoute: () => rootRouteImport,
  } as any);
const publicLoginRoute = publicLoginRouteImport.update({
  id: '/(public)/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any);
const publicInviteRoute = publicInviteRouteImport.update({
  id: '/(public)/invite',
  path: '/invite',
  getParentRoute: () => rootRouteImport,
} as any);
const publicGoogleBusinessRoute = publicGoogleBusinessRouteImport.update({
  id: '/(public)/google-business',
  path: '/google-business',
  getParentRoute: () => rootRouteImport,
} as any);
const publicForgotPasswordRoute = publicForgotPasswordRouteImport.update({
  id: '/(public)/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any);
const publicCreatePasswordRoute = publicCreatePasswordRouteImport.update({
  id: '/(public)/create-password',
  path: '/create-password',
  getParentRoute: () => rootRouteImport,
} as any);
const DashboardDashboardIndexRoute = DashboardDashboardIndexRouteImport.update({
  id: '/dashboard/',
  path: '/dashboard/',
  getParentRoute: () => DashboardRoute,
} as any);
const publicReviewIndexRoute = publicReviewIndexRouteImport.update({
  id: '/(public)/review/',
  path: '/review/',
  getParentRoute: () => rootRouteImport,
} as any);
const portalPortalIndexRoute = portalPortalIndexRouteImport.update({
  id: '/(portal)/portal/',
  path: '/portal/',
  getParentRoute: () => rootRouteImport,
} as any);
const DashboardDashboardTimesheetRoute =
  DashboardDashboardTimesheetRouteImport.update({
    id: '/dashboard/timesheet',
    path: '/dashboard/timesheet',
    getParentRoute: () => DashboardRoute,
  } as any);
const DashboardDashboardTechniciansRoute =
  DashboardDashboardTechniciansRouteImport.update({
    id: '/dashboard/technicians',
    path: '/dashboard/technicians',
    getParentRoute: () => DashboardRoute,
  } as any);
const DashboardDashboardTeamChatRoute =
  DashboardDashboardTeamChatRouteImport.update({
    id: '/dashboard/team-chat',
    path: '/dashboard/team-chat',
    getParentRoute: () => DashboardRoute,
  } as any);
const DashboardDashboardTaxesRoute = DashboardDashboardTaxesRouteImport.update({
  id: '/dashboard/taxes',
  path: '/dashboard/taxes',
  getParentRoute: () => DashboardRoute,
} as any);
const DashboardDashboardTasksRoute = DashboardDashboardTasksRouteImport.update({
  id: '/dashboard/tasks',
  path: '/dashboard/tasks',
  getParentRoute: () => DashboardRoute,
} as any);
const DashboardDashboardStripeRoute =
  DashboardDashboardStripeRouteImport.update({
    id: '/dashboard/stripe',
    path: '/dashboard/stripe',
    getParentRoute: () => DashboardRoute,
  } as any);
const DashboardDashboardSettingsRoute =
  DashboardDashboardSettingsRouteImport.update({
    id: '/dashboard/settings',
    path: '/dashboard/settings',
    getParentRoute: () => DashboardRoute,
  } as any);
const DashboardDashboardScheduleRoute =
  DashboardDashboardScheduleRouteImport.update({
    id: '/dashboard/schedule',
    path: '/dashboard/schedule',
    getParentRoute: () => DashboardRoute,
  } as any);
const DashboardDashboardRoutesRoute =
  DashboardDashboardRoutesRouteImport.update({
    id: '/dashboard/routes',
    path: '/dashboard/routes',
    getParentRoute: () => DashboardRoute,
  } as any);
const DashboardDashboardReviewsRoute =
  DashboardDashboardReviewsRouteImport.update({
    id: '/dashboard/reviews',
    path: '/dashboard/reviews',
    getParentRoute: () => DashboardRoute,
  } as any);
const DashboardDashboardRemindersRoute =
  DashboardDashboardRemindersRouteImport.update({
    id: '/dashboard/reminders',
    path: '/dashboard/reminders',
    getParentRoute: () => DashboardRoute,
  } as any);
const DashboardDashboardRecurringBillingRoute =
  DashboardDashboardRecurringBillingRouteImport.update({
    id: '/dashboard/recurring-billing',
    path: '/dashboard/recurring-billing',
    getParentRoute: () => DashboardRoute,
  } as any);
const DashboardDashboardRecoveryRenewalsRoute =
  DashboardDashboardRecoveryRenewalsRouteImport.update({
    id: '/dashboard/recovery-renewals',
    path: '/dashboard/recovery-renewals',
    getParentRoute: () => DashboardRoute,
  } as any);
const DashboardDashboardReceiptsRoute =
  DashboardDashboardReceiptsRouteImport.update({
    id: '/dashboard/receipts',
    path: '/dashboard/receipts',
    getParentRoute: () => DashboardRoute,
  } as any);
const DashboardDashboardPurchasingRoute =
  DashboardDashboardPurchasingRouteImport.update({
    id: '/dashboard/purchasing',
    path: '/dashboard/purchasing',
    getParentRoute: () => DashboardRoute,
  } as any);
const DashboardDashboardProposalsRoute =
  DashboardDashboardProposalsRouteImport.update({
    id: '/dashboard/proposals',
    path: '/dashboard/proposals',
    getParentRoute: () => DashboardRoute,
  } as any);
const DashboardDashboardPromotionsRoute =
  DashboardDashboardPromotionsRouteImport.update({
    id: '/dashboard/promotions',
    path: '/dashboard/promotions',
    getParentRoute: () => DashboardRoute,
  } as any);
const DashboardDashboardProjectsRoute =
  DashboardDashboardProjectsRouteImport.update({
    id: '/dashboard/projects',
    path: '/dashboard/projects',
    getParentRoute: () => DashboardRoute,
  } as any);
const DashboardDashboardPricebookRoute =
  DashboardDashboardPricebookRouteImport.update({
    id: '/dashboard/pricebook',
    path: '/dashboard/pricebook',
    getParentRoute: () => DashboardRoute,
  } as any);
const DashboardDashboardPaymentsRoute =
  DashboardDashboardPaymentsRouteImport.update({
    id: '/dashboard/payments',
    path: '/dashboard/payments',
    getParentRoute: () => DashboardRoute,
  } as any);
const DashboardDashboardPastDueRoute =
  DashboardDashboardPastDueRouteImport.update({
    id: '/dashboard/past-due',
    path: '/dashboard/past-due',
    getParentRoute: () => DashboardRoute,
  } as any);
const DashboardDashboardOperationsRoute =
  DashboardDashboardOperationsRouteImport.update({
    id: '/dashboard/operations',
    path: '/dashboard/operations',
    getParentRoute: () => DashboardRoute,
  } as any);
const DashboardDashboardOnboardingRoute =
  DashboardDashboardOnboardingRouteImport.update({
    id: '/dashboard/onboarding',
    path: '/dashboard/onboarding',
    getParentRoute: () => DashboardRoute,
  } as any);
const DashboardDashboardNotificationsRoute =
  DashboardDashboardNotificationsRouteImport.update({
    id: '/dashboard/notifications',
    path: '/dashboard/notifications',
    getParentRoute: () => DashboardRoute,
  } as any);
const DashboardDashboardMyDayRoute = DashboardDashboardMyDayRouteImport.update({
  id: '/dashboard/my-day',
  path: '/dashboard/my-day',
  getParentRoute: () => DashboardRoute,
} as any);
const DashboardDashboardMyDashboardRoute =
  DashboardDashboardMyDashboardRouteImport.update({
    id: '/dashboard/my-dashboard',
    path: '/dashboard/my-dashboard',
    getParentRoute: () => DashboardRoute,
  } as any);
const DashboardDashboardMembershipsRoute =
  DashboardDashboardMembershipsRouteImport.update({
    id: '/dashboard/memberships',
    path: '/dashboard/memberships',
    getParentRoute: () => DashboardRoute,
  } as any);
const DashboardDashboardMembershipVisitsRoute =
  DashboardDashboardMembershipVisitsRouteImport.update({
    id: '/dashboard/membership-visits',
    path: '/dashboard/membership-visits',
    getParentRoute: () => DashboardRoute,
  } as any);
const DashboardDashboardMembershipPlansRoute =
  DashboardDashboardMembershipPlansRouteImport.update({
    id: '/dashboard/membership-plans',
    path: '/dashboard/membership-plans',
    getParentRoute: () => DashboardRoute,
  } as any);
const DashboardDashboardLocationsRoute =
  DashboardDashboardLocationsRouteImport.update({
    id: '/dashboard/locations',
    path: '/dashboard/locations',
    getParentRoute: () => DashboardRoute,
  } as any);
const DashboardDashboardLiveCallsRoute =
  DashboardDashboardLiveCallsRouteImport.update({
    id: '/dashboard/live-calls',
    path: '/dashboard/live-calls',
    getParentRoute: () => DashboardRoute,
  } as any);
const DashboardDashboardLeadsEngineRoute =
  DashboardDashboardLeadsEngineRouteImport.update({
    id: '/dashboard/leads-engine',
    path: '/dashboard/leads-engine',
    getParentRoute: () => DashboardRoute,
  } as any);
const DashboardDashboardLeadsRoute = DashboardDashboardLeadsRouteImport.update({
  id: '/dashboard/leads',
  path: '/dashboard/leads',
  getParentRoute: () => DashboardRoute,
} as any);
const DashboardDashboardJobsRoute = DashboardDashboardJobsRouteImport.update({
  id: '/dashboard/jobs',
  path: '/dashboard/jobs',
  getParentRoute: () => DashboardRoute,
} as any);
const DashboardDashboardInvoicesRoute =
  DashboardDashboardInvoicesRouteImport.update({
    id: '/dashboard/invoices',
    path: '/dashboard/invoices',
    getParentRoute: () => DashboardRoute,
  } as any);
const DashboardDashboardInventoryRoute =
  DashboardDashboardInventoryRouteImport.update({
    id: '/dashboard/inventory',
    path: '/dashboard/inventory',
    getParentRoute: () => DashboardRoute,
  } as any);
const DashboardDashboardInboxRoute = DashboardDashboardInboxRouteImport.update({
  id: '/dashboard/inbox',
  path: '/dashboard/inbox',
  getParentRoute: () => DashboardRoute,
} as any);
const DashboardDashboardHomeRoute = DashboardDashboardHomeRouteImport.update({
  id: '/dashboard/home',
  path: '/dashboard/home',
  getParentRoute: () => DashboardRoute,
} as any);
const DashboardDashboardFormsRoute = DashboardDashboardFormsRouteImport.update({
  id: '/dashboard/forms',
  path: '/dashboard/forms',
  getParentRoute: () => DashboardRoute,
} as any);
const DashboardDashboardExecutiveRoute =
  DashboardDashboardExecutiveRouteImport.update({
    id: '/dashboard/executive',
    path: '/dashboard/executive',
    getParentRoute: () => DashboardRoute,
  } as any);
const DashboardDashboardEstimatesRoute =
  DashboardDashboardEstimatesRouteImport.update({
    id: '/dashboard/estimates',
    path: '/dashboard/estimates',
    getParentRoute: () => DashboardRoute,
  } as any);
const DashboardDashboardEquipmentDescriptionsRoute =
  DashboardDashboardEquipmentDescriptionsRouteImport.update({
    id: '/dashboard/equipment-descriptions',
    path: '/dashboard/equipment-descriptions',
    getParentRoute: () => DashboardRoute,
  } as any);
const DashboardDashboardEquipmentCategoriesRoute =
  DashboardDashboardEquipmentCategoriesRouteImport.update({
    id: '/dashboard/equipment-categories',
    path: '/dashboard/equipment-categories',
    getParentRoute: () => DashboardRoute,
  } as any);
const DashboardDashboardEquipmentRoute =
  DashboardDashboardEquipmentRouteImport.update({
    id: '/dashboard/equipment',
    path: '/dashboard/equipment',
    getParentRoute: () => DashboardRoute,
  } as any);
const DashboardDashboardDispatchRoute =
  DashboardDashboardDispatchRouteImport.update({
    id: '/dashboard/dispatch',
    path: '/dashboard/dispatch',
    getParentRoute: () => DashboardRoute,
  } as any);
const DashboardDashboardDepositsRoute =
  DashboardDashboardDepositsRouteImport.update({
    id: '/dashboard/deposits',
    path: '/dashboard/deposits',
    getParentRoute: () => DashboardRoute,
  } as any);
const DashboardDashboardCrewsRoute = DashboardDashboardCrewsRouteImport.update({
  id: '/dashboard/crews',
  path: '/dashboard/crews',
  getParentRoute: () => DashboardRoute,
} as any);
const DashboardDashboardCrewMembersRoute =
  DashboardDashboardCrewMembersRouteImport.update({
    id: '/dashboard/crew-members',
    path: '/dashboard/crew-members',
    getParentRoute: () => DashboardRoute,
  } as any);
const DashboardDashboardCreditMemosRoute =
  DashboardDashboardCreditMemosRouteImport.update({
    id: '/dashboard/credit-memos',
    path: '/dashboard/credit-memos',
    getParentRoute: () => DashboardRoute,
  } as any);
const DashboardDashboardContractsRoute =
  DashboardDashboardContractsRouteImport.update({
    id: '/dashboard/contracts',
    path: '/dashboard/contracts',
    getParentRoute: () => DashboardRoute,
  } as any);
const DashboardDashboardContactsRoute =
  DashboardDashboardContactsRouteImport.update({
    id: '/dashboard/contacts',
    path: '/dashboard/contacts',
    getParentRoute: () => DashboardRoute,
  } as any);
const DashboardDashboardChatbotRoute =
  DashboardDashboardChatbotRouteImport.update({
    id: '/dashboard/chatbot',
    path: '/dashboard/chatbot',
    getParentRoute: () => DashboardRoute,
  } as any);
const DashboardDashboardCalllogsRoute =
  DashboardDashboardCalllogsRouteImport.update({
    id: '/dashboard/calllogs',
    path: '/dashboard/calllogs',
    getParentRoute: () => DashboardRoute,
  } as any);
const DashboardDashboardBookingsRoute =
  DashboardDashboardBookingsRouteImport.update({
    id: '/dashboard/bookings',
    path: '/dashboard/bookings',
    getParentRoute: () => DashboardRoute,
  } as any);
const DashboardDashboardBoardRoute = DashboardDashboardBoardRouteImport.update({
  id: '/dashboard/board',
  path: '/dashboard/board',
  getParentRoute: () => DashboardRoute,
} as any);
const DashboardDashboardAuditRoute = DashboardDashboardAuditRouteImport.update({
  id: '/dashboard/audit',
  path: '/dashboard/audit',
  getParentRoute: () => DashboardRoute,
} as any);
const publicTipIdRoute = publicTipIdRouteImport.update({
  id: '/(public)/tip/$id',
  path: '/tip/$id',
  getParentRoute: () => rootRouteImport,
} as any);
const publicTipOptionIdRoute = publicTipOptionIdRouteImport.update({
  id: '/(public)/tip-option/$id',
  path: '/tip-option/$id',
  getParentRoute: () => rootRouteImport,
} as any);
const publicTTokenRoute = publicTTokenRouteImport.update({
  id: '/(public)/t/$token',
  path: '/t/$token',
  getParentRoute: () => rootRouteImport,
} as any);
const publicSupplierOrderTokenRoute =
  publicSupplierOrderTokenRouteImport.update({
    id: '/(public)/supplier-order/$token',
    path: '/supplier-order/$token',
    getParentRoute: () => rootRouteImport,
  } as any);
const publicSignedSignedIdRoute = publicSignedSignedIdRouteImport.update({
  id: '/(public)/signed/$signedId',
  path: '/signed/$signedId',
  getParentRoute: () => rootRouteImport,
} as any);
const publicScheduleChangeTokenRoute =
  publicScheduleChangeTokenRouteImport.update({
    id: '/(public)/schedule-change/$token',
    path: '/schedule-change/$token',
    getParentRoute: () => rootRouteImport,
  } as any);
const publicSCodeRoute = publicSCodeRouteImport.update({
  id: '/(public)/s/$code',
  path: '/s/$code',
  getParentRoute: () => rootRouteImport,
} as any);
const publicReviewTokenRoute = publicReviewTokenRouteImport.update({
  id: '/(public)/review/$token',
  path: '/review/$token',
  getParentRoute: () => rootRouteImport,
} as any);
const publicResponseIdRoute = publicResponseIdRouteImport.update({
  id: '/(public)/response/$id',
  path: '/response/$id',
  getParentRoute: () => rootRouteImport,
} as any);
const publicRepairPaymentMethodTokenRoute =
  publicRepairPaymentMethodTokenRouteImport.update({
    id: '/(public)/repair-payment-method/$token',
    path: '/repair-payment-method/$token',
    getParentRoute: () => rootRouteImport,
  } as any);
const publicRepairMembershipTokenRoute =
  publicRepairMembershipTokenRouteImport.update({
    id: '/(public)/repair-membership/$token',
    path: '/repair-membership/$token',
    getParentRoute: () => rootRouteImport,
  } as any);
const publicRecurringTokenRoute = publicRecurringTokenRouteImport.update({
  id: '/(public)/recurring/$token',
  path: '/recurring/$token',
  getParentRoute: () => rootRouteImport,
} as any);
const publicRecurringRenewalTokenRoute =
  publicRecurringRenewalTokenRouteImport.update({
    id: '/(public)/recurring-renewal/$token',
    path: '/recurring-renewal/$token',
    getParentRoute: () => rootRouteImport,
  } as any);
const publicReceiptIdRoute = publicReceiptIdRouteImport.update({
  id: '/(public)/receipt/$id',
  path: '/receipt/$id',
  getParentRoute: () => rootRouteImport,
} as any);
const publicRTokenRoute = publicRTokenRouteImport.update({
  id: '/(public)/r/$token',
  path: '/r/$token',
  getParentRoute: () => rootRouteImport,
} as any);
const publicQuoteIdRoute = publicQuoteIdRouteImport.update({
  id: '/(public)/quote/$id',
  path: '/quote/$id',
  getParentRoute: () => rootRouteImport,
} as any);
const publicProposalIdRoute = publicProposalIdRouteImport.update({
  id: '/(public)/proposal/$id',
  path: '/proposal/$id',
  getParentRoute: () => rootRouteImport,
} as any);
const publicPreviewquoteIdRoute = publicPreviewquoteIdRouteImport.update({
  id: '/(public)/previewquote/$id',
  path: '/previewquote/$id',
  getParentRoute: () => rootRouteImport,
} as any);
const publicPreviewinvoiceIdRoute = publicPreviewinvoiceIdRouteImport.update({
  id: '/(public)/previewinvoice/$id',
  path: '/previewinvoice/$id',
  getParentRoute: () => rootRouteImport,
} as any);
const publicPdfProposalIdRoute = publicPdfProposalIdRouteImport.update({
  id: '/(public)/pdf-proposal/$id',
  path: '/pdf-proposal/$id',
  getParentRoute: () => rootRouteImport,
} as any);
const publicPdfInvoiceIdRoute = publicPdfInvoiceIdRouteImport.update({
  id: '/(public)/pdf-invoice/$id',
  path: '/pdf-invoice/$id',
  getParentRoute: () => rootRouteImport,
} as any);
const publicPdfEstimateIdRoute = publicPdfEstimateIdRouteImport.update({
  id: '/(public)/pdf-estimate/$id',
  path: '/pdf-estimate/$id',
  getParentRoute: () => rootRouteImport,
} as any);
const publicPaymentMethodRequestTokenRoute =
  publicPaymentMethodRequestTokenRouteImport.update({
    id: '/(public)/payment-method-request/$token',
    path: '/payment-method-request/$token',
    getParentRoute: () => rootRouteImport,
  } as any);
const publicPayTokenRoute = publicPayTokenRouteImport.update({
  id: '/(public)/pay/$token',
  path: '/pay/$token',
  getParentRoute: () => rootRouteImport,
} as any);
const publicOnlineformIdRoute = publicOnlineformIdRouteImport.update({
  id: '/(public)/onlineform/$id',
  path: '/onlineform/$id',
  getParentRoute: () => rootRouteImport,
} as any);
const publicOnlinebookingIdRoute = publicOnlinebookingIdRouteImport.update({
  id: '/(public)/onlinebooking/$id',
  path: '/onlinebooking/$id',
  getParentRoute: () => rootRouteImport,
} as any);
const publicLinkPhoneTokenRoute = publicLinkPhoneTokenRouteImport.update({
  id: '/(public)/link-phone/$token',
  path: '/link-phone/$token',
  getParentRoute: () => rootRouteImport,
} as any);
const publicJobStoriesTokenRoute = publicJobStoriesTokenRouteImport.update({
  id: '/(public)/job-stories/$token',
  path: '/job-stories/$token',
  getParentRoute: () => rootRouteImport,
} as any);
const publicJReferenceNoRoute = publicJReferenceNoRouteImport.update({
  id: '/(public)/j/$referenceNo',
  path: '/j/$referenceNo',
  getParentRoute: () => rootRouteImport,
} as any);
const publicInvoiceIdRoute = publicInvoiceIdRouteImport.update({
  id: '/(public)/invoice/$id',
  path: '/invoice/$id',
  getParentRoute: () => rootRouteImport,
} as any);
const publicInviteTokenRoute = publicInviteTokenRouteImport.update({
  id: '/$token',
  path: '/$token',
  getParentRoute: () => publicInviteRoute,
} as any);
const publicIIdRoute = publicIIdRouteImport.update({
  id: '/(public)/i/$id',
  path: '/i/$id',
  getParentRoute: () => rootRouteImport,
} as any);
const publicFormIdRoute = publicFormIdRouteImport.update({
  id: '/(public)/form/$id',
  path: '/form/$id',
  getParentRoute: () => rootRouteImport,
} as any);
const publicEstimateIdRoute = publicEstimateIdRouteImport.update({
  id: '/(public)/estimate/$id',
  path: '/estimate/$id',
  getParentRoute: () => rootRouteImport,
} as any);
const publicETokenRoute = publicETokenRouteImport.update({
  id: '/(public)/e/$token',
  path: '/e/$token',
  getParentRoute: () => rootRouteImport,
} as any);
const publicCreatePasswordTokenRoute =
  publicCreatePasswordTokenRouteImport.update({
    id: '/$token',
    path: '/$token',
    getParentRoute: () => publicCreatePasswordRoute,
  } as any);
const publicConfirmJobReferenceNoRoute =
  publicConfirmJobReferenceNoRouteImport.update({
    id: '/(public)/confirm-job/$referenceNo',
    path: '/confirm-job/$referenceNo',
    getParentRoute: () => rootRouteImport,
  } as any);
const publicCombinedDocTokenRoute = publicCombinedDocTokenRouteImport.update({
  id: '/(public)/combined-doc/$token',
  path: '/combined-doc/$token',
  getParentRoute: () => rootRouteImport,
} as any);
const publicChangeOrderIdRoute = publicChangeOrderIdRouteImport.update({
  id: '/(public)/change-order/$id',
  path: '/change-order/$id',
  getParentRoute: () => rootRouteImport,
} as any);
const publicCTokenRoute = publicCTokenRouteImport.update({
  id: '/(public)/c/$token',
  path: '/c/$token',
  getParentRoute: () => rootRouteImport,
} as any);
const publicBookTokenRoute = publicBookTokenRouteImport.update({
  id: '/(public)/book/$token',
  path: '/book/$token',
  getParentRoute: () => rootRouteImport,
} as any);
const publicAuthImpersonateHandoffRoute =
  publicAuthImpersonateHandoffRouteImport.update({
    id: '/(public)/auth/impersonate-handoff',
    path: '/auth/impersonate-handoff',
    getParentRoute: () => rootRouteImport,
  } as any);
const portalPortalVerifyRoute = portalPortalVerifyRouteImport.update({
  id: '/(portal)/portal/verify',
  path: '/portal/verify',
  getParentRoute: () => rootRouteImport,
} as any);
const portalPortalResetRoute = portalPortalResetRouteImport.update({
  id: '/(portal)/portal/reset',
  path: '/portal/reset',
  getParentRoute: () => rootRouteImport,
} as any);
const portalPortalRegisterRoute = portalPortalRegisterRouteImport.update({
  id: '/(portal)/portal/register',
  path: '/portal/register',
  getParentRoute: () => rootRouteImport,
} as any);
const portalPortalLoginRoute = portalPortalLoginRouteImport.update({
  id: '/(portal)/portal/login',
  path: '/portal/login',
  getParentRoute: () => rootRouteImport,
} as any);
const portalPortalForgotRoute = portalPortalForgotRouteImport.update({
  id: '/(portal)/portal/forgot',
  path: '/portal/forgot',
  getParentRoute: () => rootRouteImport,
} as any);
const DashboardDashboardUnscheduledIndexRoute =
  DashboardDashboardUnscheduledIndexRouteImport.update({
    id: '/dashboard/unscheduled/',
    path: '/dashboard/unscheduled/',
    getParentRoute: () => DashboardRoute,
  } as any);
const DashboardDashboardTechniciansIndexRoute =
  DashboardDashboardTechniciansIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DashboardDashboardTechniciansRoute,
  } as any);
const DashboardDashboardSettingsIndexRoute =
  DashboardDashboardSettingsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DashboardDashboardSettingsRoute,
  } as any);
const DashboardDashboardReceiptsIndexRoute =
  DashboardDashboardReceiptsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DashboardDashboardReceiptsRoute,
  } as any);
const DashboardDashboardPurchasingIndexRoute =
  DashboardDashboardPurchasingIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DashboardDashboardPurchasingRoute,
  } as any);
const DashboardDashboardProposalsIndexRoute =
  DashboardDashboardProposalsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DashboardDashboardProposalsRoute,
  } as any);
const DashboardDashboardPricebookIndexRoute =
  DashboardDashboardPricebookIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DashboardDashboardPricebookRoute,
  } as any);
const DashboardDashboardMembershipsIndexRoute =
  DashboardDashboardMembershipsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DashboardDashboardMembershipsRoute,
  } as any);
const DashboardDashboardMembershipPlansIndexRoute =
  DashboardDashboardMembershipPlansIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DashboardDashboardMembershipPlansRoute,
  } as any);
const DashboardDashboardLeadsIndexRoute =
  DashboardDashboardLeadsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DashboardDashboardLeadsRoute,
  } as any);
const DashboardDashboardJobsIndexRoute =
  DashboardDashboardJobsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DashboardDashboardJobsRoute,
  } as any);
const DashboardDashboardJobformIndexRoute =
  DashboardDashboardJobformIndexRouteImport.update({
    id: '/dashboard/jobform/',
    path: '/dashboard/jobform/',
    getParentRoute: () => DashboardRoute,
  } as any);
const DashboardDashboardInvoicesIndexRoute =
  DashboardDashboardInvoicesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DashboardDashboardInvoicesRoute,
  } as any);
const DashboardDashboardInventoryIndexRoute =
  DashboardDashboardInventoryIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DashboardDashboardInventoryRoute,
  } as any);
const DashboardDashboardFormsIndexRoute =
  DashboardDashboardFormsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DashboardDashboardFormsRoute,
  } as any);
const DashboardDashboardEstimatesIndexRoute =
  DashboardDashboardEstimatesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DashboardDashboardEstimatesRoute,
  } as any);
const DashboardDashboardCrewmemberIndexRoute =
  DashboardDashboardCrewmemberIndexRouteImport.update({
    id: '/dashboard/crewmember/',
    path: '/dashboard/crewmember/',
    getParentRoute: () => DashboardRoute,
  } as any);
const DashboardDashboardCreditMemosIndexRoute =
  DashboardDashboardCreditMemosIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DashboardDashboardCreditMemosRoute,
  } as any);
const DashboardDashboardContactsIndexRoute =
  DashboardDashboardContactsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DashboardDashboardContactsRoute,
  } as any);
const DashboardDashboardCalendarIndexRoute =
  DashboardDashboardCalendarIndexRouteImport.update({
    id: '/dashboard/calendar/',
    path: '/dashboard/calendar/',
    getParentRoute: () => DashboardRoute,
  } as any);
const DashboardDashboardBookingsIndexRoute =
  DashboardDashboardBookingsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DashboardDashboardBookingsRoute,
  } as any);
const portalPortalVisitsIndexRoute = portalPortalVisitsIndexRouteImport.update({
  id: '/(portal)/portal/visits/',
  path: '/portal/visits/',
  getParentRoute: () => rootRouteImport,
} as any);
const portalPortalProposalsIndexRoute =
  portalPortalProposalsIndexRouteImport.update({
    id: '/(portal)/portal/proposals/',
    path: '/portal/proposals/',
    getParentRoute: () => rootRouteImport,
  } as any);
const portalPortalPlansIndexRoute = portalPortalPlansIndexRouteImport.update({
  id: '/(portal)/portal/plans/',
  path: '/portal/plans/',
  getParentRoute: () => rootRouteImport,
} as any);
const portalPortalMembershipsIndexRoute =
  portalPortalMembershipsIndexRouteImport.update({
    id: '/(portal)/portal/memberships/',
    path: '/portal/memberships/',
    getParentRoute: () => rootRouteImport,
  } as any);
const portalPortalInvoicesIndexRoute =
  portalPortalInvoicesIndexRouteImport.update({
    id: '/(portal)/portal/invoices/',
    path: '/portal/invoices/',
    getParentRoute: () => rootRouteImport,
  } as any);
const portalPortalEstimatesIndexRoute =
  portalPortalEstimatesIndexRouteImport.update({
    id: '/(portal)/portal/estimates/',
    path: '/portal/estimates/',
    getParentRoute: () => rootRouteImport,
  } as any);
const portalPortalEquipmentIndexRoute =
  portalPortalEquipmentIndexRouteImport.update({
    id: '/(portal)/portal/equipment/',
    path: '/portal/equipment/',
    getParentRoute: () => rootRouteImport,
  } as any);
const portalPortalDocumentsIndexRoute =
  portalPortalDocumentsIndexRouteImport.update({
    id: '/(portal)/portal/documents/',
    path: '/portal/documents/',
    getParentRoute: () => rootRouteImport,
  } as any);
const portalPortalAccountIndexRoute =
  portalPortalAccountIndexRouteImport.update({
    id: '/(portal)/portal/account/',
    path: '/portal/account/',
    getParentRoute: () => rootRouteImport,
  } as any);
const DashboardDashboardTechniciansReportsRoute =
  DashboardDashboardTechniciansReportsRouteImport.update({
    id: '/reports',
    path: '/reports',
    getParentRoute: () => DashboardDashboardTechniciansRoute,
  } as any);
const DashboardDashboardTechniciansNewRoute =
  DashboardDashboardTechniciansNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => DashboardDashboardTechniciansRoute,
  } as any);
const DashboardDashboardTechniciansIdRoute =
  DashboardDashboardTechniciansIdRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => DashboardDashboardTechniciansRoute,
  } as any);
const DashboardDashboardTaxesSimulatorRoute =
  DashboardDashboardTaxesSimulatorRouteImport.update({
    id: '/simulator',
    path: '/simulator',
    getParentRoute: () => DashboardDashboardTaxesRoute,
  } as any);
const DashboardDashboardTaxesRulesRoute =
  DashboardDashboardTaxesRulesRouteImport.update({
    id: '/rules',
    path: '/rules',
    getParentRoute: () => DashboardDashboardTaxesRoute,
  } as any);
const DashboardDashboardTaxesOverridesRoute =
  DashboardDashboardTaxesOverridesRouteImport.update({
    id: '/overrides',
    path: '/overrides',
    getParentRoute: () => DashboardDashboardTaxesRoute,
  } as any);
const DashboardDashboardSettingsWebhooksRoute =
  DashboardDashboardSettingsWebhooksRouteImport.update({
    id: '/webhooks',
    path: '/webhooks',
    getParentRoute: () => DashboardDashboardSettingsRoute,
  } as any);
const DashboardDashboardSettingsUsersRoute =
  DashboardDashboardSettingsUsersRouteImport.update({
    id: '/users',
    path: '/users',
    getParentRoute: () => DashboardDashboardSettingsRoute,
  } as any);
const DashboardDashboardSettingsTradesRoute =
  DashboardDashboardSettingsTradesRouteImport.update({
    id: '/trades',
    path: '/trades',
    getParentRoute: () => DashboardDashboardSettingsRoute,
  } as any);
const DashboardDashboardSettingsTermsAndConditionsRoute =
  DashboardDashboardSettingsTermsAndConditionsRouteImport.update({
    id: '/terms-and-conditions',
    path: '/terms-and-conditions',
    getParentRoute: () => DashboardDashboardSettingsRoute,
  } as any);
const DashboardDashboardSettingsTemplatesRoute =
  DashboardDashboardSettingsTemplatesRouteImport.update({
    id: '/templates',
    path: '/templates',
    getParentRoute: () => DashboardDashboardSettingsRoute,
  } as any);
const DashboardDashboardSettingsTaxesRoute =
  DashboardDashboardSettingsTaxesRouteImport.update({
    id: '/taxes',
    path: '/taxes',
    getParentRoute: () => DashboardDashboardSettingsRoute,
  } as any);
const DashboardDashboardSettingsTagsRoute =
  DashboardDashboardSettingsTagsRouteImport.update({
    id: '/tags',
    path: '/tags',
    getParentRoute: () => DashboardDashboardSettingsRoute,
  } as any);
const DashboardDashboardSettingsSurveysRoute =
  DashboardDashboardSettingsSurveysRouteImport.update({
    id: '/surveys',
    path: '/surveys',
    getParentRoute: () => DashboardDashboardSettingsRoute,
  } as any);
const DashboardDashboardSettingsSuppliersRoute =
  DashboardDashboardSettingsSuppliersRouteImport.update({
    id: '/suppliers',
    path: '/suppliers',
    getParentRoute: () => DashboardDashboardSettingsRoute,
  } as any);
const DashboardDashboardSettingsSubscriptionRoute =
  DashboardDashboardSettingsSubscriptionRouteImport.update({
    id: '/subscription',
    path: '/subscription',
    getParentRoute: () => DashboardDashboardSettingsRoute,
  } as any);
const DashboardDashboardSettingsSmsRoute =
  DashboardDashboardSettingsSmsRouteImport.update({
    id: '/sms',
    path: '/sms',
    getParentRoute: () => DashboardDashboardSettingsRoute,
  } as any);
const DashboardDashboardSettingsSkillsRoute =
  DashboardDashboardSettingsSkillsRouteImport.update({
    id: '/skills',
    path: '/skills',
    getParentRoute: () => DashboardDashboardSettingsRoute,
  } as any);
const DashboardDashboardSettingsServiceAreasRoute =
  DashboardDashboardSettingsServiceAreasRouteImport.update({
    id: '/service-areas',
    path: '/service-areas',
    getParentRoute: () => DashboardDashboardSettingsRoute,
  } as any);
const DashboardDashboardSettingsScopeOfWorkRoute =
  DashboardDashboardSettingsScopeOfWorkRouteImport.update({
    id: '/scope-of-work',
    path: '/scope-of-work',
    getParentRoute: () => DashboardDashboardSettingsRoute,
  } as any);
const DashboardDashboardSettingsReviewsRoute =
  DashboardDashboardSettingsReviewsRouteImport.update({
    id: '/reviews',
    path: '/reviews',
    getParentRoute: () => DashboardDashboardSettingsRoute,
  } as any);
const DashboardDashboardSettingsReviewPlatformsRoute =
  DashboardDashboardSettingsReviewPlatformsRouteImport.update({
    id: '/review-platforms',
    path: '/review-platforms',
    getParentRoute: () => DashboardDashboardSettingsRoute,
  } as any);
const DashboardDashboardSettingsReportsRoute =
  DashboardDashboardSettingsReportsRouteImport.update({
    id: '/reports',
    path: '/reports',
    getParentRoute: () => DashboardDashboardSettingsRoute,
  } as any);
const DashboardDashboardSettingsRemindersRoute =
  DashboardDashboardSettingsRemindersRouteImport.update({
    id: '/reminders',
    path: '/reminders',
    getParentRoute: () => DashboardDashboardSettingsRoute,
  } as any);
const DashboardDashboardSettingsQuickbooksRoute =
  DashboardDashboardSettingsQuickbooksRouteImport.update({
    id: '/quickbooks',
    path: '/quickbooks',
    getParentRoute: () => DashboardDashboardSettingsRoute,
  } as any);
const DashboardDashboardSettingsPurchasingRoute =
  DashboardDashboardSettingsPurchasingRouteImport.update({
    id: '/purchasing',
    path: '/purchasing',
    getParentRoute: () => DashboardDashboardSettingsRoute,
  } as any);
const DashboardDashboardSettingsPhoneRoute =
  DashboardDashboardSettingsPhoneRouteImport.update({
    id: '/phone',
    path: '/phone',
    getParentRoute: () => DashboardDashboardSettingsRoute,
  } as any);
const DashboardDashboardSettingsPermissionsRoute =
  DashboardDashboardSettingsPermissionsRouteImport.update({
    id: '/permissions',
    path: '/permissions',
    getParentRoute: () => DashboardDashboardSettingsRoute,
  } as any);
const DashboardDashboardSettingsPayrollProfilesRoute =
  DashboardDashboardSettingsPayrollProfilesRouteImport.update({
    id: '/payroll-profiles',
    path: '/payroll-profiles',
    getParentRoute: () => DashboardDashboardSettingsRoute,
  } as any);
const DashboardDashboardSettingsOnlineBookingRoute =
  DashboardDashboardSettingsOnlineBookingRouteImport.update({
    id: '/online-booking',
    path: '/online-booking',
    getParentRoute: () => DashboardDashboardSettingsRoute,
  } as any);
const DashboardDashboardSettingsOncallRoute =
  DashboardDashboardSettingsOncallRouteImport.update({
    id: '/oncall',
    path: '/oncall',
    getParentRoute: () => DashboardDashboardSettingsRoute,
  } as any);
const DashboardDashboardSettingsOfficeSettingsRoute =
  DashboardDashboardSettingsOfficeSettingsRouteImport.update({
    id: '/office-settings',
    path: '/office-settings',
    getParentRoute: () => DashboardDashboardSettingsRoute,
  } as any);
const DashboardDashboardSettingsNotificationsRoute =
  DashboardDashboardSettingsNotificationsRouteImport.update({
    id: '/notifications',
    path: '/notifications',
    getParentRoute: () => DashboardDashboardSettingsRoute,
  } as any);
const DashboardDashboardSettingsLogoutRoute =
  DashboardDashboardSettingsLogoutRouteImport.update({
    id: '/logout',
    path: '/logout',
    getParentRoute: () => DashboardDashboardSettingsRoute,
  } as any);
const DashboardDashboardSettingsLeadsRoute =
  DashboardDashboardSettingsLeadsRouteImport.update({
    id: '/leads',
    path: '/leads',
    getParentRoute: () => DashboardDashboardSettingsRoute,
  } as any);
const DashboardDashboardSettingsJobtypesRoute =
  DashboardDashboardSettingsJobtypesRouteImport.update({
    id: '/jobtypes',
    path: '/jobtypes',
    getParentRoute: () => DashboardDashboardSettingsRoute,
  } as any);
const DashboardDashboardSettingsJobPipelinesRoute =
  DashboardDashboardSettingsJobPipelinesRouteImport.update({
    id: '/job-pipelines',
    path: '/job-pipelines',
    getParentRoute: () => DashboardDashboardSettingsRoute,
  } as any);
const DashboardDashboardSettingsIntegrationsRoute =
  DashboardDashboardSettingsIntegrationsRouteImport.update({
    id: '/integrations',
    path: '/integrations',
    getParentRoute: () => DashboardDashboardSettingsRoute,
  } as any);
const DashboardDashboardSettingsGroupsRoute =
  DashboardDashboardSettingsGroupsRouteImport.update({
    id: '/groups',
    path: '/groups',
    getParentRoute: () => DashboardDashboardSettingsRoute,
  } as any);
const DashboardDashboardSettingsEstimatesRoute =
  DashboardDashboardSettingsEstimatesRouteImport.update({
    id: '/estimates',
    path: '/estimates',
    getParentRoute: () => DashboardDashboardSettingsRoute,
  } as any);
const DashboardDashboardSettingsEstimateSettingsRoute =
  DashboardDashboardSettingsEstimateSettingsRouteImport.update({
    id: '/estimate-settings',
    path: '/estimate-settings',
    getParentRoute: () => DashboardDashboardSettingsRoute,
  } as any);
const DashboardDashboardSettingsEstimatePdfRoute =
  DashboardDashboardSettingsEstimatePdfRouteImport.update({
    id: '/estimate-pdf',
    path: '/estimate-pdf',
    getParentRoute: () => DashboardDashboardSettingsRoute,
  } as any);
const DashboardDashboardSettingsEmailAccountsRoute =
  DashboardDashboardSettingsEmailAccountsRouteImport.update({
    id: '/email-accounts',
    path: '/email-accounts',
    getParentRoute: () => DashboardDashboardSettingsRoute,
  } as any);
const DashboardDashboardSettingsDeferredRevenueRoute =
  DashboardDashboardSettingsDeferredRevenueRouteImport.update({
    id: '/deferred-revenue',
    path: '/deferred-revenue',
    getParentRoute: () => DashboardDashboardSettingsRoute,
  } as any);
const DashboardDashboardSettingsCustomfieldsRoute =
  DashboardDashboardSettingsCustomfieldsRouteImport.update({
    id: '/customfields',
    path: '/customfields',
    getParentRoute: () => DashboardDashboardSettingsRoute,
  } as any);
const DashboardDashboardSettingsContractsRoute =
  DashboardDashboardSettingsContractsRouteImport.update({
    id: '/contracts',
    path: '/contracts',
    getParentRoute: () => DashboardDashboardSettingsRoute,
  } as any);
const DashboardDashboardSettingsContactStatusesRoute =
  DashboardDashboardSettingsContactStatusesRouteImport.update({
    id: '/contact-statuses',
    path: '/contact-statuses',
    getParentRoute: () => DashboardDashboardSettingsRoute,
  } as any);
const DashboardDashboardSettingsConnectionsRoute =
  DashboardDashboardSettingsConnectionsRouteImport.update({
    id: '/connections',
    path: '/connections',
    getParentRoute: () => DashboardDashboardSettingsRoute,
  } as any);
const DashboardDashboardSettingsCompanyRoute =
  DashboardDashboardSettingsCompanyRouteImport.update({
    id: '/company',
    path: '/company',
    getParentRoute: () => DashboardDashboardSettingsRoute,
  } as any);
const DashboardDashboardSettingsClientPortalRoute =
  DashboardDashboardSettingsClientPortalRouteImport.update({
    id: '/client-portal',
    path: '/client-portal',
    getParentRoute: () => DashboardDashboardSettingsRoute,
  } as any);
const DashboardDashboardSettingsChecklistRoute =
  DashboardDashboardSettingsChecklistRouteImport.update({
    id: '/checklist',
    path: '/checklist',
    getParentRoute: () => DashboardDashboardSettingsRoute,
  } as any);
const DashboardDashboardSettingsChatbotRoute =
  DashboardDashboardSettingsChatbotRouteImport.update({
    id: '/chatbot',
    path: '/chatbot',
    getParentRoute: () => DashboardDashboardSettingsRoute,
  } as any);
const DashboardDashboardSettingsChannelsRoute =
  DashboardDashboardSettingsChannelsRouteImport.update({
    id: '/channels',
    path: '/channels',
    getParentRoute: () => DashboardDashboardSettingsRoute,
  } as any);
const DashboardDashboardSettingsCalltreeRoute =
  DashboardDashboardSettingsCalltreeRouteImport.update({
    id: '/calltree',
    path: '/calltree',
    getParentRoute: () => DashboardDashboardSettingsRoute,
  } as any);
const DashboardDashboardSettingsCallSettingsRoute =
  DashboardDashboardSettingsCallSettingsRouteImport.update({
    id: '/call-settings',
    path: '/call-settings',
    getParentRoute: () => DashboardDashboardSettingsRoute,
  } as any);
const DashboardDashboardSettingsBookingWindowsRoute =
  DashboardDashboardSettingsBookingWindowsRouteImport.update({
    id: '/booking-windows',
    path: '/booking-windows',
    getParentRoute: () => DashboardDashboardSettingsRoute,
  } as any);
const DashboardDashboardSettingsBookingServicesRoute =
  DashboardDashboardSettingsBookingServicesRouteImport.update({
    id: '/booking-services',
    path: '/booking-services',
    getParentRoute: () => DashboardDashboardSettingsRoute,
  } as any);
const DashboardDashboardSettingsBookingLinksRoute =
  DashboardDashboardSettingsBookingLinksRouteImport.update({
    id: '/booking-links',
    path: '/booking-links',
    getParentRoute: () => DashboardDashboardSettingsRoute,
  } as any);
const DashboardDashboardSettingsBillingRoute =
  DashboardDashboardSettingsBillingRouteImport.update({
    id: '/billing',
    path: '/billing',
    getParentRoute: () => DashboardDashboardSettingsRoute,
  } as any);
const DashboardDashboardSettingsAppointmentFormsRoute =
  DashboardDashboardSettingsAppointmentFormsRouteImport.update({
    id: '/appointment-forms',
    path: '/appointment-forms',
    getParentRoute: () => DashboardDashboardSettingsRoute,
  } as any);
const DashboardDashboardSettingsApiKeysRoute =
  DashboardDashboardSettingsApiKeysRouteImport.update({
    id: '/api-keys',
    path: '/api-keys',
    getParentRoute: () => DashboardDashboardSettingsRoute,
  } as any);
const DashboardDashboardSettingsAccountingRoute =
  DashboardDashboardSettingsAccountingRouteImport.update({
    id: '/accounting',
    path: '/accounting',
    getParentRoute: () => DashboardDashboardSettingsRoute,
  } as any);
const DashboardDashboardReportsNewRoute =
  DashboardDashboardReportsNewRouteImport.update({
    id: '/dashboard/reports/new',
    path: '/dashboard/reports/new',
    getParentRoute: () => DashboardRoute,
  } as any);
const DashboardDashboardReportsIdRoute =
  DashboardDashboardReportsIdRouteImport.update({
    id: '/dashboard/reports/$id',
    path: '/dashboard/reports/$id',
    getParentRoute: () => DashboardRoute,
  } as any);
const DashboardDashboardReportingTargetsRoute =
  DashboardDashboardReportingTargetsRouteImport.update({
    id: '/dashboard/reporting/targets',
    path: '/dashboard/reporting/targets',
    getParentRoute: () => DashboardRoute,
  } as any);
const DashboardDashboardReportingScorecardsRoute =
  DashboardDashboardReportingScorecardsRouteImport.update({
    id: '/dashboard/reporting/scorecards',
    path: '/dashboard/reporting/scorecards',
    getParentRoute: () => DashboardRoute,
  } as any);
const DashboardDashboardReportingMeRoute =
  DashboardDashboardReportingMeRouteImport.update({
    id: '/dashboard/reporting/me',
    path: '/dashboard/reporting/me',
    getParentRoute: () => DashboardRoute,
  } as any);
const DashboardDashboardReportingCallsRoute =
  DashboardDashboardReportingCallsRouteImport.update({
    id: '/dashboard/reporting/calls',
    path: '/dashboard/reporting/calls',
    getParentRoute: () => DashboardRoute,
  } as any);
const DashboardDashboardReceiptsIdRoute =
  DashboardDashboardReceiptsIdRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => DashboardDashboardReceiptsRoute,
  } as any);
const DashboardDashboardPurchasingRequestsRoute =
  DashboardDashboardPurchasingRequestsRouteImport.update({
    id: '/requests',
    path: '/requests',
    getParentRoute: () => DashboardDashboardPurchasingRoute,
  } as any);
const DashboardDashboardPurchasingOverviewRoute =
  DashboardDashboardPurchasingOverviewRouteImport.update({
    id: '/overview',
    path: '/overview',
    getParentRoute: () => DashboardDashboardPurchasingRoute,
  } as any);
const DashboardDashboardPurchasingFieldRoute =
  DashboardDashboardPurchasingFieldRouteImport.update({
    id: '/field',
    path: '/field',
    getParentRoute: () => DashboardDashboardPurchasingRoute,
  } as any);
const DashboardDashboardPurchasingCostChangesRoute =
  DashboardDashboardPurchasingCostChangesRouteImport.update({
    id: '/cost-changes',
    path: '/cost-changes',
    getParentRoute: () => DashboardDashboardPurchasingRoute,
  } as any);
const DashboardDashboardPurchasingCardsRoute =
  DashboardDashboardPurchasingCardsRouteImport.update({
    id: '/cards',
    path: '/cards',
    getParentRoute: () => DashboardDashboardPurchasingRoute,
  } as any);
const DashboardDashboardPurchasingBillsRoute =
  DashboardDashboardPurchasingBillsRouteImport.update({
    id: '/bills',
    path: '/bills',
    getParentRoute: () => DashboardDashboardPurchasingRoute,
  } as any);
const DashboardDashboardPurchasingApprovalsRoute =
  DashboardDashboardPurchasingApprovalsRouteImport.update({
    id: '/approvals',
    path: '/approvals',
    getParentRoute: () => DashboardDashboardPurchasingRoute,
  } as any);
const DashboardDashboardProposalsNewRoute =
  DashboardDashboardProposalsNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => DashboardDashboardProposalsRoute,
  } as any);
const DashboardDashboardProposalsIdRoute =
  DashboardDashboardProposalsIdRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => DashboardDashboardProposalsRoute,
  } as any);
const DashboardDashboardProjectsProjectIdRoute =
  DashboardDashboardProjectsProjectIdRouteImport.update({
    id: '/$projectId',
    path: '/$projectId',
    getParentRoute: () => DashboardDashboardProjectsRoute,
  } as any);
const DashboardDashboardPricebookNewRoute =
  DashboardDashboardPricebookNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => DashboardDashboardPricebookRoute,
  } as any);
const DashboardDashboardPricebookCategoriesRoute =
  DashboardDashboardPricebookCategoriesRouteImport.update({
    id: '/categories',
    path: '/categories',
    getParentRoute: () => DashboardDashboardPricebookRoute,
  } as any);
const DashboardDashboardPricebookIdRoute =
  DashboardDashboardPricebookIdRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => DashboardDashboardPricebookRoute,
  } as any);
const DashboardDashboardPaymentsIdRoute =
  DashboardDashboardPaymentsIdRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => DashboardDashboardPaymentsRoute,
  } as any);
const DashboardDashboardMembershipsReportsRoute =
  DashboardDashboardMembershipsReportsRouteImport.update({
    id: '/reports',
    path: '/reports',
    getParentRoute: () => DashboardDashboardMembershipsRoute,
  } as any);
const DashboardDashboardMembershipsNewRoute =
  DashboardDashboardMembershipsNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => DashboardDashboardMembershipsRoute,
  } as any);
const DashboardDashboardMembershipsIdRoute =
  DashboardDashboardMembershipsIdRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => DashboardDashboardMembershipsRoute,
  } as any);
const DashboardDashboardMembershipPlansNewRoute =
  DashboardDashboardMembershipPlansNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => DashboardDashboardMembershipPlansRoute,
  } as any);
const DashboardDashboardMembershipPlansIdRoute =
  DashboardDashboardMembershipPlansIdRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => DashboardDashboardMembershipPlansRoute,
  } as any);
const DashboardDashboardLocationsLocationIdRoute =
  DashboardDashboardLocationsLocationIdRouteImport.update({
    id: '/$locationId',
    path: '/$locationId',
    getParentRoute: () => DashboardDashboardLocationsRoute,
  } as any);
const DashboardDashboardLeadsReportsRoute =
  DashboardDashboardLeadsReportsRouteImport.update({
    id: '/reports',
    path: '/reports',
    getParentRoute: () => DashboardDashboardLeadsRoute,
  } as any);
const DashboardDashboardLeadsNewRoute =
  DashboardDashboardLeadsNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => DashboardDashboardLeadsRoute,
  } as any);
const DashboardDashboardLeadsLeadIdRoute =
  DashboardDashboardLeadsLeadIdRouteImport.update({
    id: '/$leadId',
    path: '/$leadId',
    getParentRoute: () => DashboardDashboardLeadsRoute,
  } as any);
const DashboardDashboardJobsServiceCallsRoute =
  DashboardDashboardJobsServiceCallsRouteImport.update({
    id: '/service-calls',
    path: '/service-calls',
    getParentRoute: () => DashboardDashboardJobsRoute,
  } as any);
const DashboardDashboardJobsReportsRoute =
  DashboardDashboardJobsReportsRouteImport.update({
    id: '/reports',
    path: '/reports',
    getParentRoute: () => DashboardDashboardJobsRoute,
  } as any);
const DashboardDashboardJobsNewRoute =
  DashboardDashboardJobsNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => DashboardDashboardJobsRoute,
  } as any);
const DashboardDashboardJobsBudgetVsActualRoute =
  DashboardDashboardJobsBudgetVsActualRouteImport.update({
    id: '/budget-vs-actual',
    path: '/budget-vs-actual',
    getParentRoute: () => DashboardDashboardJobsRoute,
  } as any);
const DashboardDashboardJobsIdRoute =
  DashboardDashboardJobsIdRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => DashboardDashboardJobsRoute,
  } as any);
const DashboardDashboardJobformNewRoute =
  DashboardDashboardJobformNewRouteImport.update({
    id: '/dashboard/jobform/new',
    path: '/dashboard/jobform/new',
    getParentRoute: () => DashboardRoute,
  } as any);
const DashboardDashboardJobformIdRoute =
  DashboardDashboardJobformIdRouteImport.update({
    id: '/dashboard/jobform/$id',
    path: '/dashboard/jobform/$id',
    getParentRoute: () => DashboardRoute,
  } as any);
const DashboardDashboardInvoicesReportsRoute =
  DashboardDashboardInvoicesReportsRouteImport.update({
    id: '/reports',
    path: '/reports',
    getParentRoute: () => DashboardDashboardInvoicesRoute,
  } as any);
const DashboardDashboardInvoicesNewRoute =
  DashboardDashboardInvoicesNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => DashboardDashboardInvoicesRoute,
  } as any);
const DashboardDashboardInvoicesIdRoute =
  DashboardDashboardInvoicesIdRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => DashboardDashboardInvoicesRoute,
  } as any);
const DashboardDashboardInventoryTruckTemplatesRoute =
  DashboardDashboardInventoryTruckTemplatesRouteImport.update({
    id: '/truck-templates',
    path: '/truck-templates',
    getParentRoute: () => DashboardDashboardInventoryRoute,
  } as any);
const DashboardDashboardInventoryTransfersRoute =
  DashboardDashboardInventoryTransfersRouteImport.update({
    id: '/transfers',
    path: '/transfers',
    getParentRoute: () => DashboardDashboardInventoryRoute,
  } as any);
const DashboardDashboardInventoryStockRoute =
  DashboardDashboardInventoryStockRouteImport.update({
    id: '/stock',
    path: '/stock',
    getParentRoute: () => DashboardDashboardInventoryRoute,
  } as any);
const DashboardDashboardInventoryOverviewRoute =
  DashboardDashboardInventoryOverviewRouteImport.update({
    id: '/overview',
    path: '/overview',
    getParentRoute: () => DashboardDashboardInventoryRoute,
  } as any);
const DashboardDashboardInventoryMyTruckRoute =
  DashboardDashboardInventoryMyTruckRouteImport.update({
    id: '/my-truck',
    path: '/my-truck',
    getParentRoute: () => DashboardDashboardInventoryRoute,
  } as any);
const DashboardDashboardInventoryLocationsRoute =
  DashboardDashboardInventoryLocationsRouteImport.update({
    id: '/locations',
    path: '/locations',
    getParentRoute: () => DashboardDashboardInventoryRoute,
  } as any);
const DashboardDashboardFormsFormIdRoute =
  DashboardDashboardFormsFormIdRouteImport.update({
    id: '/$formId',
    path: '/$formId',
    getParentRoute: () => DashboardDashboardFormsRoute,
  } as any);
const DashboardDashboardEstimatesReportsRoute =
  DashboardDashboardEstimatesReportsRouteImport.update({
    id: '/reports',
    path: '/reports',
    getParentRoute: () => DashboardDashboardEstimatesRoute,
  } as any);
const DashboardDashboardEstimatesNewRoute =
  DashboardDashboardEstimatesNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => DashboardDashboardEstimatesRoute,
  } as any);
const DashboardDashboardEstimatesIdRoute =
  DashboardDashboardEstimatesIdRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => DashboardDashboardEstimatesRoute,
  } as any);
const DashboardDashboardDispatchLiveRoute =
  DashboardDashboardDispatchLiveRouteImport.update({
    id: '/dashboard/dispatch_/live',
    path: '/dashboard/dispatch/live',
    getParentRoute: () => DashboardRoute,
  } as any);
const DashboardDashboardDepositsIdRoute =
  DashboardDashboardDepositsIdRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => DashboardDashboardDepositsRoute,
  } as any);
const DashboardDashboardCrewsNewRoute =
  DashboardDashboardCrewsNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => DashboardDashboardCrewsRoute,
  } as any);
const DashboardDashboardCrewsIdRoute =
  DashboardDashboardCrewsIdRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => DashboardDashboardCrewsRoute,
  } as any);
const DashboardDashboardCrewmemberUserIdRoute =
  DashboardDashboardCrewmemberUserIdRouteImport.update({
    id: '/dashboard/crewmember/$userId',
    path: '/dashboard/crewmember/$userId',
    getParentRoute: () => DashboardRoute,
  } as any);
const DashboardDashboardCreditMemosNewRoute =
  DashboardDashboardCreditMemosNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => DashboardDashboardCreditMemosRoute,
  } as any);
const DashboardDashboardCreditMemosIdRoute =
  DashboardDashboardCreditMemosIdRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => DashboardDashboardCreditMemosRoute,
  } as any);
const DashboardDashboardCostingReportsRoute =
  DashboardDashboardCostingReportsRouteImport.update({
    id: '/dashboard/costing/reports',
    path: '/dashboard/costing/reports',
    getParentRoute: () => DashboardRoute,
  } as any);
const DashboardDashboardContractsIdRoute =
  DashboardDashboardContractsIdRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => DashboardDashboardContractsRoute,
  } as any);
const DashboardDashboardContactsTasksRoute =
  DashboardDashboardContactsTasksRouteImport.update({
    id: '/tasks',
    path: '/tasks',
    getParentRoute: () => DashboardDashboardContactsRoute,
  } as any);
const DashboardDashboardContactsReportsRoute =
  DashboardDashboardContactsReportsRouteImport.update({
    id: '/reports',
    path: '/reports',
    getParentRoute: () => DashboardDashboardContactsRoute,
  } as any);
const DashboardDashboardContactsNewRoute =
  DashboardDashboardContactsNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => DashboardDashboardContactsRoute,
  } as any);
const DashboardDashboardContactsContactIdRoute =
  DashboardDashboardContactsContactIdRouteImport.update({
    id: '/$contactId',
    path: '/$contactId',
    getParentRoute: () => DashboardDashboardContactsRoute,
  } as any);
const DashboardDashboardCalllogsReportsRoute =
  DashboardDashboardCalllogsReportsRouteImport.update({
    id: '/dashboard/calllogs_/reports',
    path: '/dashboard/calllogs/reports',
    getParentRoute: () => DashboardRoute,
  } as any);
const DashboardDashboardCalendarMapRoute =
  DashboardDashboardCalendarMapRouteImport.update({
    id: '/dashboard/calendar/map',
    path: '/dashboard/calendar/map',
    getParentRoute: () => DashboardRoute,
  } as any);
const DashboardDashboardCalendarIdRoute =
  DashboardDashboardCalendarIdRouteImport.update({
    id: '/dashboard/calendar/$id',
    path: '/dashboard/calendar/$id',
    getParentRoute: () => DashboardRoute,
  } as any);
const DashboardDashboardBookingsNewRoute =
  DashboardDashboardBookingsNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => DashboardDashboardBookingsRoute,
  } as any);
const DashboardDashboardBookingsBookingIdRoute =
  DashboardDashboardBookingsBookingIdRouteImport.update({
    id: '/$bookingId',
    path: '/$bookingId',
    getParentRoute: () => DashboardDashboardBookingsRoute,
  } as any);
const DashboardDashboardAiOttoRoute =
  DashboardDashboardAiOttoRouteImport.update({
    id: '/dashboard/ai/otto',
    path: '/dashboard/ai/otto',
    getParentRoute: () => DashboardRoute,
  } as any);
const publicTrackingIdRefnoRoute = publicTrackingIdRefnoRouteImport.update({
  id: '/(public)/tracking/$id/$refno',
  path: '/tracking/$id/$refno',
  getParentRoute: () => rootRouteImport,
} as any);
const publicReviewReviewIdId2Route = publicReviewReviewIdId2RouteImport.update({
  id: '/(public)/review/$reviewId/$id2',
  path: '/review/$reviewId/$id2',
  getParentRoute: () => rootRouteImport,
} as any);
const portalPortalVisitsBookRoute = portalPortalVisitsBookRouteImport.update({
  id: '/(portal)/portal/visits/book',
  path: '/portal/visits/book',
  getParentRoute: () => rootRouteImport,
} as any);
const portalPortalProposalsIdRoute = portalPortalProposalsIdRouteImport.update({
  id: '/(portal)/portal/proposals/$id',
  path: '/portal/proposals/$id',
  getParentRoute: () => rootRouteImport,
} as any);
const portalPortalMembershipsIdRoute =
  portalPortalMembershipsIdRouteImport.update({
    id: '/(portal)/portal/memberships/$id',
    path: '/portal/memberships/$id',
    getParentRoute: () => rootRouteImport,
  } as any);
const portalPortalInvoicesIdRoute = portalPortalInvoicesIdRouteImport.update({
  id: '/(portal)/portal/invoices/$id',
  path: '/portal/invoices/$id',
  getParentRoute: () => rootRouteImport,
} as any);
const portalPortalEstimatesIdRoute = portalPortalEstimatesIdRouteImport.update({
  id: '/(portal)/portal/estimates/$id',
  path: '/portal/estimates/$id',
  getParentRoute: () => rootRouteImport,
} as any);
const DashboardDashboardSettingsTemplatesIndexRoute =
  DashboardDashboardSettingsTemplatesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DashboardDashboardSettingsTemplatesRoute,
  } as any);
const DashboardDashboardSettingsJobPipelinesIndexRoute =
  DashboardDashboardSettingsJobPipelinesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DashboardDashboardSettingsJobPipelinesRoute,
  } as any);
const DashboardDashboardSettingsDocumentTemplatesIndexRoute =
  DashboardDashboardSettingsDocumentTemplatesIndexRouteImport.update({
    id: '/document-templates/',
    path: '/document-templates/',
    getParentRoute: () => DashboardDashboardSettingsRoute,
  } as any);
const DashboardDashboardSettingsContractsIndexRoute =
  DashboardDashboardSettingsContractsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DashboardDashboardSettingsContractsRoute,
  } as any);
const DashboardDashboardSettingsChecklistIndexRoute =
  DashboardDashboardSettingsChecklistIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DashboardDashboardSettingsChecklistRoute,
  } as any);
const DashboardDashboardSettingsBusinessUnitsIndexRoute =
  DashboardDashboardSettingsBusinessUnitsIndexRouteImport.update({
    id: '/business-units/',
    path: '/business-units/',
    getParentRoute: () => DashboardDashboardSettingsRoute,
  } as any);
const DashboardDashboardSettingsBillingIndexRoute =
  DashboardDashboardSettingsBillingIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DashboardDashboardSettingsBillingRoute,
  } as any);
const DashboardDashboardSettingsAppointmentFormsIndexRoute =
  DashboardDashboardSettingsAppointmentFormsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DashboardDashboardSettingsAppointmentFormsRoute,
  } as any);
const DashboardDashboardReportingReportsIndexRoute =
  DashboardDashboardReportingReportsIndexRouteImport.update({
    id: '/dashboard/reporting/reports/',
    path: '/dashboard/reporting/reports/',
    getParentRoute: () => DashboardRoute,
  } as any);
const DashboardDashboardPurchasingSuppliersIndexRoute =
  DashboardDashboardPurchasingSuppliersIndexRouteImport.update({
    id: '/suppliers/',
    path: '/suppliers/',
    getParentRoute: () => DashboardDashboardPurchasingRoute,
  } as any);
const DashboardDashboardInventoryReplenishmentIndexRoute =
  DashboardDashboardInventoryReplenishmentIndexRouteImport.update({
    id: '/replenishment/',
    path: '/replenishment/',
    getParentRoute: () => DashboardDashboardInventoryRoute,
  } as any);
const DashboardDashboardInventoryCountsIndexRoute =
  DashboardDashboardInventoryCountsIndexRouteImport.update({
    id: '/counts/',
    path: '/counts/',
    getParentRoute: () => DashboardDashboardInventoryRoute,
  } as any);
const DashboardDashboardTechniciansIdOffboardingRoute =
  DashboardDashboardTechniciansIdOffboardingRouteImport.update({
    id: '/offboarding',
    path: '/offboarding',
    getParentRoute: () => DashboardDashboardTechniciansIdRoute,
  } as any);
const DashboardDashboardTechniciansIdEditRoute =
  DashboardDashboardTechniciansIdEditRouteImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () => DashboardDashboardTechniciansIdRoute,
  } as any);
const DashboardDashboardSettingsWebhooksNewRoute =
  DashboardDashboardSettingsWebhooksNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => DashboardDashboardSettingsWebhooksRoute,
  } as any);
const DashboardDashboardSettingsWebhooksIdRoute =
  DashboardDashboardSettingsWebhooksIdRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => DashboardDashboardSettingsWebhooksRoute,
  } as any);
const DashboardDashboardSettingsUsersNewRoute =
  DashboardDashboardSettingsUsersNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => DashboardDashboardSettingsUsersRoute,
  } as any);
const DashboardDashboardSettingsUsersIdRoute =
  DashboardDashboardSettingsUsersIdRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => DashboardDashboardSettingsUsersRoute,
  } as any);
const DashboardDashboardSettingsTermsAndConditionsIdRoute =
  DashboardDashboardSettingsTermsAndConditionsIdRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => DashboardDashboardSettingsTermsAndConditionsRoute,
  } as any);
const DashboardDashboardSettingsSkillsNewRoute =
  DashboardDashboardSettingsSkillsNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => DashboardDashboardSettingsSkillsRoute,
  } as any);
const DashboardDashboardSettingsSkillsIdRoute =
  DashboardDashboardSettingsSkillsIdRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => DashboardDashboardSettingsSkillsRoute,
  } as any);
const DashboardDashboardSettingsScopeOfWorkIdRoute =
  DashboardDashboardSettingsScopeOfWorkIdRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => DashboardDashboardSettingsScopeOfWorkRoute,
  } as any);
const DashboardDashboardSettingsReportsTemplatesRoute =
  DashboardDashboardSettingsReportsTemplatesRouteImport.update({
    id: '/reports_/templates',
    path: '/reports/templates',
    getParentRoute: () => DashboardDashboardSettingsRoute,
  } as any);
const DashboardDashboardSettingsRemindersTypeRoute =
  DashboardDashboardSettingsRemindersTypeRouteImport.update({
    id: '/$type',
    path: '/$type',
    getParentRoute: () => DashboardDashboardSettingsRemindersRoute,
  } as any);
const DashboardDashboardSettingsPermissionsNewRoute =
  DashboardDashboardSettingsPermissionsNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => DashboardDashboardSettingsPermissionsRoute,
  } as any);
const DashboardDashboardSettingsPermissionsIdRoute =
  DashboardDashboardSettingsPermissionsIdRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => DashboardDashboardSettingsPermissionsRoute,
  } as any);
const DashboardDashboardSettingsPartnerApiWebhooksRoute =
  DashboardDashboardSettingsPartnerApiWebhooksRouteImport.update({
    id: '/partner-api/webhooks',
    path: '/partner-api/webhooks',
    getParentRoute: () => DashboardDashboardSettingsRoute,
  } as any);
const DashboardDashboardSettingsOfficeSettingsEditRoute =
  DashboardDashboardSettingsOfficeSettingsEditRouteImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () => DashboardDashboardSettingsOfficeSettingsRoute,
  } as any);
const DashboardDashboardSettingsNotificationsEditRoute =
  DashboardDashboardSettingsNotificationsEditRouteImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () => DashboardDashboardSettingsNotificationsRoute,
  } as any);
const DashboardDashboardSettingsJobtypesNewRoute =
  DashboardDashboardSettingsJobtypesNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => DashboardDashboardSettingsJobtypesRoute,
  } as any);
const DashboardDashboardSettingsJobtypesIdRoute =
  DashboardDashboardSettingsJobtypesIdRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => DashboardDashboardSettingsJobtypesRoute,
  } as any);
const DashboardDashboardSettingsJobPipelinesNewRoute =
  DashboardDashboardSettingsJobPipelinesNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => DashboardDashboardSettingsJobPipelinesRoute,
  } as any);
const DashboardDashboardSettingsJobPipelinesIdRoute =
  DashboardDashboardSettingsJobPipelinesIdRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => DashboardDashboardSettingsJobPipelinesRoute,
  } as any);
const DashboardDashboardSettingsGroupsNewRoute =
  DashboardDashboardSettingsGroupsNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => DashboardDashboardSettingsGroupsRoute,
  } as any);
const DashboardDashboardSettingsGroupsIdRoute =
  DashboardDashboardSettingsGroupsIdRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => DashboardDashboardSettingsGroupsRoute,
  } as any);
const DashboardDashboardSettingsEmailTemplatesNewRoute =
  DashboardDashboardSettingsEmailTemplatesNewRouteImport.update({
    id: '/email-templates/new',
    path: '/email-templates/new',
    getParentRoute: () => DashboardDashboardSettingsRoute,
  } as any);
const DashboardDashboardSettingsEmailTemplatesIdRoute =
  DashboardDashboardSettingsEmailTemplatesIdRouteImport.update({
    id: '/email-templates/$id',
    path: '/email-templates/$id',
    getParentRoute: () => DashboardDashboardSettingsRoute,
  } as any);
const DashboardDashboardSettingsDocumentTemplatesNewRoute =
  DashboardDashboardSettingsDocumentTemplatesNewRouteImport.update({
    id: '/document-templates/new',
    path: '/document-templates/new',
    getParentRoute: () => DashboardDashboardSettingsRoute,
  } as any);
const DashboardDashboardSettingsDocumentTemplatesIdRoute =
  DashboardDashboardSettingsDocumentTemplatesIdRouteImport.update({
    id: '/document-templates/$id',
    path: '/document-templates/$id',
    getParentRoute: () => DashboardDashboardSettingsRoute,
  } as any);
const DashboardDashboardSettingsCustomfieldsNewRoute =
  DashboardDashboardSettingsCustomfieldsNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => DashboardDashboardSettingsCustomfieldsRoute,
  } as any);
const DashboardDashboardSettingsCustomfieldsIdRoute =
  DashboardDashboardSettingsCustomfieldsIdRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => DashboardDashboardSettingsCustomfieldsRoute,
  } as any);
const DashboardDashboardSettingsContractsReviewsRoute =
  DashboardDashboardSettingsContractsReviewsRouteImport.update({
    id: '/reviews',
    path: '/reviews',
    getParentRoute: () => DashboardDashboardSettingsContractsRoute,
  } as any);
const DashboardDashboardSettingsContractsRenewalCancellationRoute =
  DashboardDashboardSettingsContractsRenewalCancellationRouteImport.update({
    id: '/renewal-cancellation',
    path: '/renewal-cancellation',
    getParentRoute: () => DashboardDashboardSettingsContractsRoute,
  } as any);
const DashboardDashboardSettingsContractsRenewalRoute =
  DashboardDashboardSettingsContractsRenewalRouteImport.update({
    id: '/renewal',
    path: '/renewal',
    getParentRoute: () => DashboardDashboardSettingsContractsRoute,
  } as any);
const DashboardDashboardSettingsContractsQboRoute =
  DashboardDashboardSettingsContractsQboRouteImport.update({
    id: '/qbo',
    path: '/qbo',
    getParentRoute: () => DashboardDashboardSettingsContractsRoute,
  } as any);
const DashboardDashboardSettingsContractsProductionKitsRoute =
  DashboardDashboardSettingsContractsProductionKitsRouteImport.update({
    id: '/production-kits',
    path: '/production-kits',
    getParentRoute: () => DashboardDashboardSettingsContractsRoute,
  } as any);
const DashboardDashboardSettingsContractsDefaultsRoute =
  DashboardDashboardSettingsContractsDefaultsRouteImport.update({
    id: '/defaults',
    path: '/defaults',
    getParentRoute: () => DashboardDashboardSettingsContractsRoute,
  } as any);
const DashboardDashboardSettingsContractsCostingRoute =
  DashboardDashboardSettingsContractsCostingRouteImport.update({
    id: '/costing',
    path: '/costing',
    getParentRoute: () => DashboardDashboardSettingsContractsRoute,
  } as any);
const DashboardDashboardSettingsContractsCancellationRoute =
  DashboardDashboardSettingsContractsCancellationRouteImport.update({
    id: '/cancellation',
    path: '/cancellation',
    getParentRoute: () => DashboardDashboardSettingsContractsRoute,
  } as any);
const DashboardDashboardSettingsCompanyEditRoute =
  DashboardDashboardSettingsCompanyEditRouteImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () => DashboardDashboardSettingsCompanyRoute,
  } as any);
const DashboardDashboardSettingsChecklistNewRoute =
  DashboardDashboardSettingsChecklistNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => DashboardDashboardSettingsChecklistRoute,
  } as any);
const DashboardDashboardSettingsChecklistIdRoute =
  DashboardDashboardSettingsChecklistIdRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => DashboardDashboardSettingsChecklistRoute,
  } as any);
const DashboardDashboardSettingsBusinessUnitsIdRoute =
  DashboardDashboardSettingsBusinessUnitsIdRouteImport.update({
    id: '/business-units/$id',
    path: '/business-units/$id',
    getParentRoute: () => DashboardDashboardSettingsRoute,
  } as any);
const DashboardDashboardSettingsBillingReceiptsRoute =
  DashboardDashboardSettingsBillingReceiptsRouteImport.update({
    id: '/receipts',
    path: '/receipts',
    getParentRoute: () => DashboardDashboardSettingsBillingRoute,
  } as any);
const DashboardDashboardSettingsBillingQuickbooksRoute =
  DashboardDashboardSettingsBillingQuickbooksRouteImport.update({
    id: '/quickbooks',
    path: '/quickbooks',
    getParentRoute: () => DashboardDashboardSettingsBillingRoute,
  } as any);
const DashboardDashboardSettingsBillingPaymentsRoute =
  DashboardDashboardSettingsBillingPaymentsRouteImport.update({
    id: '/payments',
    path: '/payments',
    getParentRoute: () => DashboardDashboardSettingsBillingRoute,
  } as any);
const DashboardDashboardSettingsBillingInvoicesRoute =
  DashboardDashboardSettingsBillingInvoicesRouteImport.update({
    id: '/invoices',
    path: '/invoices',
    getParentRoute: () => DashboardDashboardSettingsBillingRoute,
  } as any);
const DashboardDashboardSettingsBillingDepositsRoute =
  DashboardDashboardSettingsBillingDepositsRouteImport.update({
    id: '/deposits',
    path: '/deposits',
    getParentRoute: () => DashboardDashboardSettingsBillingRoute,
  } as any);
const DashboardDashboardSettingsBillingCreditMemosRoute =
  DashboardDashboardSettingsBillingCreditMemosRouteImport.update({
    id: '/credit-memos',
    path: '/credit-memos',
    getParentRoute: () => DashboardDashboardSettingsBillingRoute,
  } as any);
const DashboardDashboardSettingsAppointmentFormsNewRoute =
  DashboardDashboardSettingsAppointmentFormsNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => DashboardDashboardSettingsAppointmentFormsRoute,
  } as any);
const DashboardDashboardSettingsAppointmentFormsIdRoute =
  DashboardDashboardSettingsAppointmentFormsIdRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => DashboardDashboardSettingsAppointmentFormsRoute,
  } as any);
const DashboardDashboardReportingReportsNewRoute =
  DashboardDashboardReportingReportsNewRouteImport.update({
    id: '/dashboard/reporting/reports/new',
    path: '/dashboard/reporting/reports/new',
    getParentRoute: () => DashboardRoute,
  } as any);
const DashboardDashboardReportingReportsReportIdRoute =
  DashboardDashboardReportingReportsReportIdRouteImport.update({
    id: '/dashboard/reporting/reports/$reportId',
    path: '/dashboard/reporting/reports/$reportId',
    getParentRoute: () => DashboardRoute,
  } as any);
const DashboardDashboardPurchasingSuppliersSupplierIdRoute =
  DashboardDashboardPurchasingSuppliersSupplierIdRouteImport.update({
    id: '/suppliers/$supplierId',
    path: '/suppliers/$supplierId',
    getParentRoute: () => DashboardDashboardPurchasingRoute,
  } as any);
const DashboardDashboardProposalsIdPresentRoute =
  DashboardDashboardProposalsIdPresentRouteImport.update({
    id: '/present',
    path: '/present',
    getParentRoute: () => DashboardDashboardProposalsIdRoute,
  } as any);
const DashboardDashboardProposalsIdEditRoute =
  DashboardDashboardProposalsIdEditRouteImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () => DashboardDashboardProposalsIdRoute,
  } as any);
const DashboardDashboardPricebookIdEditRoute =
  DashboardDashboardPricebookIdEditRouteImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () => DashboardDashboardPricebookIdRoute,
  } as any);
const DashboardDashboardMembershipsIdEditRoute =
  DashboardDashboardMembershipsIdEditRouteImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () => DashboardDashboardMembershipsIdRoute,
  } as any);
const DashboardDashboardMembershipPlansIdEditRoute =
  DashboardDashboardMembershipPlansIdEditRouteImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () => DashboardDashboardMembershipPlansIdRoute,
  } as any);
const DashboardDashboardLeadsLeadIdEditRoute =
  DashboardDashboardLeadsLeadIdEditRouteImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () => DashboardDashboardLeadsLeadIdRoute,
  } as any);
const DashboardDashboardJobsIdEditRoute =
  DashboardDashboardJobsIdEditRouteImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () => DashboardDashboardJobsIdRoute,
  } as any);
const DashboardDashboardInvoicesIdEditRoute =
  DashboardDashboardInvoicesIdEditRouteImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () => DashboardDashboardInvoicesIdRoute,
  } as any);
const DashboardDashboardInventoryReplenishmentRunIdRoute =
  DashboardDashboardInventoryReplenishmentRunIdRouteImport.update({
    id: '/replenishment/$runId',
    path: '/replenishment/$runId',
    getParentRoute: () => DashboardDashboardInventoryRoute,
  } as any);
const DashboardDashboardInventoryPickListsNewRoute =
  DashboardDashboardInventoryPickListsNewRouteImport.update({
    id: '/pick-lists_/new',
    path: '/pick-lists/new',
    getParentRoute: () => DashboardDashboardInventoryRoute,
  } as any);
const DashboardDashboardInventoryPickListsIdRoute =
  DashboardDashboardInventoryPickListsIdRouteImport.update({
    id: '/pick-lists_/$id',
    path: '/pick-lists/$id',
    getParentRoute: () => DashboardDashboardInventoryRoute,
  } as any);
const DashboardDashboardInventoryLocationsLocationIdRoute =
  DashboardDashboardInventoryLocationsLocationIdRouteImport.update({
    id: '/locations_/$locationId',
    path: '/locations/$locationId',
    getParentRoute: () => DashboardDashboardInventoryRoute,
  } as any);
const DashboardDashboardInventoryJobsJobIdRoute =
  DashboardDashboardInventoryJobsJobIdRouteImport.update({
    id: '/jobs/$jobId',
    path: '/jobs/$jobId',
    getParentRoute: () => DashboardDashboardInventoryRoute,
  } as any);
const DashboardDashboardInventoryItemsItemIdRoute =
  DashboardDashboardInventoryItemsItemIdRouteImport.update({
    id: '/items/$itemId',
    path: '/items/$itemId',
    getParentRoute: () => DashboardDashboardInventoryRoute,
  } as any);
const DashboardDashboardInventoryCountsCountIdRoute =
  DashboardDashboardInventoryCountsCountIdRouteImport.update({
    id: '/counts/$countId',
    path: '/counts/$countId',
    getParentRoute: () => DashboardDashboardInventoryRoute,
  } as any);
const DashboardDashboardEstimatesIdPaymentScheduleRoute =
  DashboardDashboardEstimatesIdPaymentScheduleRouteImport.update({
    id: '/payment-schedule',
    path: '/payment-schedule',
    getParentRoute: () => DashboardDashboardEstimatesIdRoute,
  } as any);
const DashboardDashboardEstimatesIdEditRoute =
  DashboardDashboardEstimatesIdEditRouteImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () => DashboardDashboardEstimatesIdRoute,
  } as any);
const DashboardDashboardCrewsIdEditRoute =
  DashboardDashboardCrewsIdEditRouteImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () => DashboardDashboardCrewsIdRoute,
  } as any);
const DashboardDashboardContactsContactIdEditRoute =
  DashboardDashboardContactsContactIdEditRouteImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () => DashboardDashboardContactsContactIdRoute,
  } as any);
const DashboardDashboardContactsContactIdConsentRecordsRoute =
  DashboardDashboardContactsContactIdConsentRecordsRouteImport.update({
    id: '/consent-records',
    path: '/consent-records',
    getParentRoute: () => DashboardDashboardContactsContactIdRoute,
  } as any);
const DashboardDashboardAiOttoReportIdRoute =
  DashboardDashboardAiOttoReportIdRouteImport.update({
    id: '/$reportId',
    path: '/$reportId',
    getParentRoute: () => DashboardDashboardAiOttoRoute,
  } as any);
const publicPaymentIdId2PriceidRoute =
  publicPaymentIdId2PriceidRouteImport.update({
    id: '/(public)/payment/$id/$id2/$priceid',
    path: '/payment/$id/$id2/$priceid',
    getParentRoute: () => rootRouteImport,
  } as any);
const DashboardDashboardSettingsWebhooksIdEditRoute =
  DashboardDashboardSettingsWebhooksIdEditRouteImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () => DashboardDashboardSettingsWebhooksIdRoute,
  } as any);
const DashboardDashboardSettingsUsersIdEditRoute =
  DashboardDashboardSettingsUsersIdEditRouteImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () => DashboardDashboardSettingsUsersIdRoute,
  } as any);
const DashboardDashboardSettingsTermsAndConditionsIdEditRoute =
  DashboardDashboardSettingsTermsAndConditionsIdEditRouteImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () => DashboardDashboardSettingsTermsAndConditionsIdRoute,
  } as any);
const DashboardDashboardSettingsTemplatesProposalNewRoute =
  DashboardDashboardSettingsTemplatesProposalNewRouteImport.update({
    id: '/proposal/new',
    path: '/proposal/new',
    getParentRoute: () => DashboardDashboardSettingsTemplatesRoute,
  } as any);
const DashboardDashboardSettingsTemplatesProposalIdRoute =
  DashboardDashboardSettingsTemplatesProposalIdRouteImport.update({
    id: '/proposal/$id',
    path: '/proposal/$id',
    getParentRoute: () => DashboardDashboardSettingsTemplatesRoute,
  } as any);
const DashboardDashboardSettingsTemplatesEstimateNewRoute =
  DashboardDashboardSettingsTemplatesEstimateNewRouteImport.update({
    id: '/estimate/new',
    path: '/estimate/new',
    getParentRoute: () => DashboardDashboardSettingsTemplatesRoute,
  } as any);
const DashboardDashboardSettingsTemplatesEstimateIdRoute =
  DashboardDashboardSettingsTemplatesEstimateIdRouteImport.update({
    id: '/estimate/$id',
    path: '/estimate/$id',
    getParentRoute: () => DashboardDashboardSettingsTemplatesRoute,
  } as any);
const DashboardDashboardSettingsSkillsIdEditRoute =
  DashboardDashboardSettingsSkillsIdEditRouteImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () => DashboardDashboardSettingsSkillsIdRoute,
  } as any);
const DashboardDashboardSettingsScopeOfWorkIdEditRoute =
  DashboardDashboardSettingsScopeOfWorkIdEditRouteImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () => DashboardDashboardSettingsScopeOfWorkIdRoute,
  } as any);
const DashboardDashboardSettingsPermissionsIdEditRoute =
  DashboardDashboardSettingsPermissionsIdEditRouteImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () => DashboardDashboardSettingsPermissionsIdRoute,
  } as any);
const DashboardDashboardSettingsPartnerApiWebhooksNewRoute =
  DashboardDashboardSettingsPartnerApiWebhooksNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => DashboardDashboardSettingsPartnerApiWebhooksRoute,
  } as any);
const DashboardDashboardSettingsPartnerApiWebhooksIdRoute =
  DashboardDashboardSettingsPartnerApiWebhooksIdRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => DashboardDashboardSettingsPartnerApiWebhooksRoute,
  } as any);
const DashboardDashboardSettingsJobtypesIdEditRoute =
  DashboardDashboardSettingsJobtypesIdEditRouteImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () => DashboardDashboardSettingsJobtypesIdRoute,
  } as any);
const DashboardDashboardSettingsJobPipelinesIdEditRoute =
  DashboardDashboardSettingsJobPipelinesIdEditRouteImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () => DashboardDashboardSettingsJobPipelinesIdRoute,
  } as any);
const DashboardDashboardSettingsGroupsIdEditRoute =
  DashboardDashboardSettingsGroupsIdEditRouteImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () => DashboardDashboardSettingsGroupsIdRoute,
  } as any);
const DashboardDashboardSettingsCustomfieldsIdEditRoute =
  DashboardDashboardSettingsCustomfieldsIdEditRouteImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () => DashboardDashboardSettingsCustomfieldsIdRoute,
  } as any);
const DashboardDashboardSettingsChecklistIdEditRoute =
  DashboardDashboardSettingsChecklistIdEditRouteImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () => DashboardDashboardSettingsChecklistIdRoute,
  } as any);
const DashboardDashboardSettingsCallSettingsTeamSectionRoute =
  DashboardDashboardSettingsCallSettingsTeamSectionRouteImport.update({
    id: '/team/$section',
    path: '/team/$section',
    getParentRoute: () => DashboardDashboardSettingsCallSettingsRoute,
  } as any);
const DashboardDashboardSettingsCallSettingsNumbersNumberIdRoute =
  DashboardDashboardSettingsCallSettingsNumbersNumberIdRouteImport.update({
    id: '/numbers/$numberId',
    path: '/numbers/$numberId',
    getParentRoute: () => DashboardDashboardSettingsCallSettingsRoute,
  } as any);
const DashboardDashboardSettingsCallSettingsIvrNewRoute =
  DashboardDashboardSettingsCallSettingsIvrNewRouteImport.update({
    id: '/ivr/new',
    path: '/ivr/new',
    getParentRoute: () => DashboardDashboardSettingsCallSettingsRoute,
  } as any);
const DashboardDashboardSettingsCallSettingsIvrIdRoute =
  DashboardDashboardSettingsCallSettingsIvrIdRouteImport.update({
    id: '/ivr/$id',
    path: '/ivr/$id',
    getParentRoute: () => DashboardDashboardSettingsCallSettingsRoute,
  } as any);
const DashboardDashboardSettingsCallSettingsFlowsIdRoute =
  DashboardDashboardSettingsCallSettingsFlowsIdRouteImport.update({
    id: '/flows/$id',
    path: '/flows/$id',
    getParentRoute: () => DashboardDashboardSettingsCallSettingsRoute,
  } as any);
const DashboardDashboardSettingsAppointmentFormsIdEditRoute =
  DashboardDashboardSettingsAppointmentFormsIdEditRouteImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () => DashboardDashboardSettingsAppointmentFormsIdRoute,
  } as any);
const DashboardDashboardReportingReportsReportIdEditRoute =
  DashboardDashboardReportingReportsReportIdEditRouteImport.update({
    id: '/dashboard/reporting/reports/$reportId_/edit',
    path: '/dashboard/reporting/reports/$reportId/edit',
    getParentRoute: () => DashboardRoute,
  } as any);
const DashboardDashboardPurchasingSuppliersSupplierIdEditRoute =
  DashboardDashboardPurchasingSuppliersSupplierIdEditRouteImport.update({
    id: '/suppliers/$supplierId_/edit',
    path: '/suppliers/$supplierId/edit',
    getParentRoute: () => DashboardDashboardPurchasingRoute,
  } as any);
const DashboardDashboardJobsIdPaymentScheduleNewRoute =
  DashboardDashboardJobsIdPaymentScheduleNewRouteImport.update({
    id: '/payment-schedule/new',
    path: '/payment-schedule/new',
    getParentRoute: () => DashboardDashboardJobsIdRoute,
  } as any);
const DashboardDashboardJobsIdPaymentScheduleEditRoute =
  DashboardDashboardJobsIdPaymentScheduleEditRouteImport.update({
    id: '/payment-schedule/edit',
    path: '/payment-schedule/edit',
    getParentRoute: () => DashboardDashboardJobsIdRoute,
  } as any);
const DashboardDashboardJobsIdInvoicesNewRoute =
  DashboardDashboardJobsIdInvoicesNewRouteImport.update({
    id: '/invoices/new',
    path: '/invoices/new',
    getParentRoute: () => DashboardDashboardJobsIdRoute,
  } as any);
const DashboardDashboardJobsIdInvoicesInvoiceIdRoute =
  DashboardDashboardJobsIdInvoicesInvoiceIdRouteImport.update({
    id: '/invoices/$invoiceId',
    path: '/invoices/$invoiceId',
    getParentRoute: () => DashboardDashboardJobsIdRoute,
  } as any);
const DashboardDashboardJobsIdExpensesNewRoute =
  DashboardDashboardJobsIdExpensesNewRouteImport.update({
    id: '/expenses/new',
    path: '/expenses/new',
    getParentRoute: () => DashboardDashboardJobsIdRoute,
  } as any);
const DashboardDashboardJobsIdExpensesExpenseIdRoute =
  DashboardDashboardJobsIdExpensesExpenseIdRouteImport.update({
    id: '/expenses/$expenseId',
    path: '/expenses/$expenseId',
    getParentRoute: () => DashboardDashboardJobsIdRoute,
  } as any);
const DashboardDashboardJobsIdChangeOrdersNewRoute =
  DashboardDashboardJobsIdChangeOrdersNewRouteImport.update({
    id: '/change-orders/new',
    path: '/change-orders/new',
    getParentRoute: () => DashboardDashboardJobsIdRoute,
  } as any);
const DashboardDashboardJobsIdChangeOrdersChangeOrderIdRoute =
  DashboardDashboardJobsIdChangeOrdersChangeOrderIdRouteImport.update({
    id: '/change-orders/$changeOrderId',
    path: '/change-orders/$changeOrderId',
    getParentRoute: () => DashboardDashboardJobsIdRoute,
  } as any);
const DashboardDashboardJobsIdAppointmentsNewRoute =
  DashboardDashboardJobsIdAppointmentsNewRouteImport.update({
    id: '/appointments/new',
    path: '/appointments/new',
    getParentRoute: () => DashboardDashboardJobsIdRoute,
  } as any);
const DashboardDashboardJobsIdAppointmentsAppointmentIdRoute =
  DashboardDashboardJobsIdAppointmentsAppointmentIdRouteImport.update({
    id: '/appointments/$appointmentId',
    path: '/appointments/$appointmentId',
    getParentRoute: () => DashboardDashboardJobsIdRoute,
  } as any);
const DashboardDashboardContactsContactIdBillToNewRoute =
  DashboardDashboardContactsContactIdBillToNewRouteImport.update({
    id: '/bill-to/new',
    path: '/bill-to/new',
    getParentRoute: () => DashboardDashboardContactsContactIdRoute,
  } as any);
const DashboardDashboardContactsContactIdAddressesNewRoute =
  DashboardDashboardContactsContactIdAddressesNewRouteImport.update({
    id: '/addresses/new',
    path: '/addresses/new',
    getParentRoute: () => DashboardDashboardContactsContactIdRoute,
  } as any);
const DashboardDashboardSettingsPartnerApiWebhooksIdEditRoute =
  DashboardDashboardSettingsPartnerApiWebhooksIdEditRouteImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () => DashboardDashboardSettingsPartnerApiWebhooksIdRoute,
  } as any);
const DashboardDashboardContactsContactIdBillToBillToIdEditRoute =
  DashboardDashboardContactsContactIdBillToBillToIdEditRouteImport.update({
    id: '/bill-to/$billToId/edit',
    path: '/bill-to/$billToId/edit',
    getParentRoute: () => DashboardDashboardContactsContactIdRoute,
  } as any);
const DashboardDashboardContactsContactIdAddressesAddressIdEditRoute =
  DashboardDashboardContactsContactIdAddressesAddressIdEditRouteImport.update({
    id: '/addresses/$addressId/edit',
    path: '/addresses/$addressId/edit',
    getParentRoute: () => DashboardDashboardContactsContactIdRoute,
  } as any);

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute;
  '/$': typeof SplatRoute;
  '/create-password': typeof publicCreatePasswordRouteWithChildren;
  '/forgot-password': typeof publicForgotPasswordRoute;
  '/google-business': typeof publicGoogleBusinessRoute;
  '/invite': typeof publicInviteRouteWithChildren;
  '/login': typeof publicLoginRoute;
  '/onlinebookingresponse': typeof publicOnlinebookingresponseRoute;
  '/reset-password': typeof publicResetPasswordRoute;
  '/portal/forgot': typeof portalPortalForgotRoute;
  '/portal/login': typeof portalPortalLoginRoute;
  '/portal/register': typeof portalPortalRegisterRoute;
  '/portal/reset': typeof portalPortalResetRoute;
  '/portal/verify': typeof portalPortalVerifyRoute;
  '/auth/impersonate-handoff': typeof publicAuthImpersonateHandoffRoute;
  '/book/$token': typeof publicBookTokenRoute;
  '/c/$token': typeof publicCTokenRoute;
  '/change-order/$id': typeof publicChangeOrderIdRoute;
  '/combined-doc/$token': typeof publicCombinedDocTokenRoute;
  '/confirm-job/$referenceNo': typeof publicConfirmJobReferenceNoRoute;
  '/create-password/$token': typeof publicCreatePasswordTokenRoute;
  '/e/$token': typeof publicETokenRoute;
  '/estimate/$id': typeof publicEstimateIdRoute;
  '/form/$id': typeof publicFormIdRoute;
  '/i/$id': typeof publicIIdRoute;
  '/invite/$token': typeof publicInviteTokenRoute;
  '/invoice/$id': typeof publicInvoiceIdRoute;
  '/j/$referenceNo': typeof publicJReferenceNoRoute;
  '/job-stories/$token': typeof publicJobStoriesTokenRoute;
  '/link-phone/$token': typeof publicLinkPhoneTokenRoute;
  '/onlinebooking/$id': typeof publicOnlinebookingIdRoute;
  '/onlineform/$id': typeof publicOnlineformIdRoute;
  '/pay/$token': typeof publicPayTokenRoute;
  '/payment-method-request/$token': typeof publicPaymentMethodRequestTokenRoute;
  '/pdf-estimate/$id': typeof publicPdfEstimateIdRoute;
  '/pdf-invoice/$id': typeof publicPdfInvoiceIdRoute;
  '/pdf-proposal/$id': typeof publicPdfProposalIdRoute;
  '/previewinvoice/$id': typeof publicPreviewinvoiceIdRoute;
  '/previewquote/$id': typeof publicPreviewquoteIdRoute;
  '/proposal/$id': typeof publicProposalIdRoute;
  '/quote/$id': typeof publicQuoteIdRoute;
  '/r/$token': typeof publicRTokenRoute;
  '/receipt/$id': typeof publicReceiptIdRoute;
  '/recurring-renewal/$token': typeof publicRecurringRenewalTokenRoute;
  '/recurring/$token': typeof publicRecurringTokenRoute;
  '/repair-membership/$token': typeof publicRepairMembershipTokenRoute;
  '/repair-payment-method/$token': typeof publicRepairPaymentMethodTokenRoute;
  '/response/$id': typeof publicResponseIdRoute;
  '/review/$token': typeof publicReviewTokenRoute;
  '/s/$code': typeof publicSCodeRoute;
  '/schedule-change/$token': typeof publicScheduleChangeTokenRoute;
  '/signed/$signedId': typeof publicSignedSignedIdRoute;
  '/supplier-order/$token': typeof publicSupplierOrderTokenRoute;
  '/t/$token': typeof publicTTokenRoute;
  '/tip-option/$id': typeof publicTipOptionIdRoute;
  '/tip/$id': typeof publicTipIdRoute;
  '/dashboard/audit': typeof DashboardDashboardAuditRoute;
  '/dashboard/board': typeof DashboardDashboardBoardRoute;
  '/dashboard/bookings': typeof DashboardDashboardBookingsRouteWithChildren;
  '/dashboard/calllogs': typeof DashboardDashboardCalllogsRoute;
  '/dashboard/chatbot': typeof DashboardDashboardChatbotRoute;
  '/dashboard/contacts': typeof DashboardDashboardContactsRouteWithChildren;
  '/dashboard/contracts': typeof DashboardDashboardContractsRouteWithChildren;
  '/dashboard/credit-memos': typeof DashboardDashboardCreditMemosRouteWithChildren;
  '/dashboard/crew-members': typeof DashboardDashboardCrewMembersRoute;
  '/dashboard/crews': typeof DashboardDashboardCrewsRouteWithChildren;
  '/dashboard/deposits': typeof DashboardDashboardDepositsRouteWithChildren;
  '/dashboard/dispatch': typeof DashboardDashboardDispatchRoute;
  '/dashboard/equipment': typeof DashboardDashboardEquipmentRoute;
  '/dashboard/equipment-categories': typeof DashboardDashboardEquipmentCategoriesRoute;
  '/dashboard/equipment-descriptions': typeof DashboardDashboardEquipmentDescriptionsRoute;
  '/dashboard/estimates': typeof DashboardDashboardEstimatesRouteWithChildren;
  '/dashboard/executive': typeof DashboardDashboardExecutiveRoute;
  '/dashboard/forms': typeof DashboardDashboardFormsRouteWithChildren;
  '/dashboard/home': typeof DashboardDashboardHomeRoute;
  '/dashboard/inbox': typeof DashboardDashboardInboxRoute;
  '/dashboard/inventory': typeof DashboardDashboardInventoryRouteWithChildren;
  '/dashboard/invoices': typeof DashboardDashboardInvoicesRouteWithChildren;
  '/dashboard/jobs': typeof DashboardDashboardJobsRouteWithChildren;
  '/dashboard/leads': typeof DashboardDashboardLeadsRouteWithChildren;
  '/dashboard/leads-engine': typeof DashboardDashboardLeadsEngineRoute;
  '/dashboard/live-calls': typeof DashboardDashboardLiveCallsRoute;
  '/dashboard/locations': typeof DashboardDashboardLocationsRouteWithChildren;
  '/dashboard/membership-plans': typeof DashboardDashboardMembershipPlansRouteWithChildren;
  '/dashboard/membership-visits': typeof DashboardDashboardMembershipVisitsRoute;
  '/dashboard/memberships': typeof DashboardDashboardMembershipsRouteWithChildren;
  '/dashboard/my-dashboard': typeof DashboardDashboardMyDashboardRoute;
  '/dashboard/my-day': typeof DashboardDashboardMyDayRoute;
  '/dashboard/notifications': typeof DashboardDashboardNotificationsRoute;
  '/dashboard/onboarding': typeof DashboardDashboardOnboardingRoute;
  '/dashboard/operations': typeof DashboardDashboardOperationsRoute;
  '/dashboard/past-due': typeof DashboardDashboardPastDueRoute;
  '/dashboard/payments': typeof DashboardDashboardPaymentsRouteWithChildren;
  '/dashboard/pricebook': typeof DashboardDashboardPricebookRouteWithChildren;
  '/dashboard/projects': typeof DashboardDashboardProjectsRouteWithChildren;
  '/dashboard/promotions': typeof DashboardDashboardPromotionsRoute;
  '/dashboard/proposals': typeof DashboardDashboardProposalsRouteWithChildren;
  '/dashboard/purchasing': typeof DashboardDashboardPurchasingRouteWithChildren;
  '/dashboard/receipts': typeof DashboardDashboardReceiptsRouteWithChildren;
  '/dashboard/recovery-renewals': typeof DashboardDashboardRecoveryRenewalsRoute;
  '/dashboard/recurring-billing': typeof DashboardDashboardRecurringBillingRoute;
  '/dashboard/reminders': typeof DashboardDashboardRemindersRoute;
  '/dashboard/reviews': typeof DashboardDashboardReviewsRoute;
  '/dashboard/routes': typeof DashboardDashboardRoutesRoute;
  '/dashboard/schedule': typeof DashboardDashboardScheduleRoute;
  '/dashboard/settings': typeof DashboardDashboardSettingsRouteWithChildren;
  '/dashboard/stripe': typeof DashboardDashboardStripeRoute;
  '/dashboard/tasks': typeof DashboardDashboardTasksRoute;
  '/dashboard/taxes': typeof DashboardDashboardTaxesRouteWithChildren;
  '/dashboard/team-chat': typeof DashboardDashboardTeamChatRoute;
  '/dashboard/technicians': typeof DashboardDashboardTechniciansRouteWithChildren;
  '/dashboard/timesheet': typeof DashboardDashboardTimesheetRoute;
  '/portal/': typeof portalPortalIndexRoute;
  '/review/': typeof publicReviewIndexRoute;
  '/dashboard/': typeof DashboardDashboardIndexRoute;
  '/portal/estimates/$id': typeof portalPortalEstimatesIdRoute;
  '/portal/invoices/$id': typeof portalPortalInvoicesIdRoute;
  '/portal/memberships/$id': typeof portalPortalMembershipsIdRoute;
  '/portal/proposals/$id': typeof portalPortalProposalsIdRoute;
  '/portal/visits/book': typeof portalPortalVisitsBookRoute;
  '/review/$reviewId/$id2': typeof publicReviewReviewIdId2Route;
  '/tracking/$id/$refno': typeof publicTrackingIdRefnoRoute;
  '/dashboard/ai/otto': typeof DashboardDashboardAiOttoRouteWithChildren;
  '/dashboard/bookings/$bookingId': typeof DashboardDashboardBookingsBookingIdRoute;
  '/dashboard/bookings/new': typeof DashboardDashboardBookingsNewRoute;
  '/dashboard/calendar/$id': typeof DashboardDashboardCalendarIdRoute;
  '/dashboard/calendar/map': typeof DashboardDashboardCalendarMapRoute;
  '/dashboard/calllogs/reports': typeof DashboardDashboardCalllogsReportsRoute;
  '/dashboard/contacts/$contactId': typeof DashboardDashboardContactsContactIdRouteWithChildren;
  '/dashboard/contacts/new': typeof DashboardDashboardContactsNewRoute;
  '/dashboard/contacts/reports': typeof DashboardDashboardContactsReportsRoute;
  '/dashboard/contacts/tasks': typeof DashboardDashboardContactsTasksRoute;
  '/dashboard/contracts/$id': typeof DashboardDashboardContractsIdRoute;
  '/dashboard/costing/reports': typeof DashboardDashboardCostingReportsRoute;
  '/dashboard/credit-memos/$id': typeof DashboardDashboardCreditMemosIdRoute;
  '/dashboard/credit-memos/new': typeof DashboardDashboardCreditMemosNewRoute;
  '/dashboard/crewmember/$userId': typeof DashboardDashboardCrewmemberUserIdRoute;
  '/dashboard/crews/$id': typeof DashboardDashboardCrewsIdRouteWithChildren;
  '/dashboard/crews/new': typeof DashboardDashboardCrewsNewRoute;
  '/dashboard/deposits/$id': typeof DashboardDashboardDepositsIdRoute;
  '/dashboard/dispatch/live': typeof DashboardDashboardDispatchLiveRoute;
  '/dashboard/estimates/$id': typeof DashboardDashboardEstimatesIdRouteWithChildren;
  '/dashboard/estimates/new': typeof DashboardDashboardEstimatesNewRoute;
  '/dashboard/estimates/reports': typeof DashboardDashboardEstimatesReportsRoute;
  '/dashboard/forms/$formId': typeof DashboardDashboardFormsFormIdRoute;
  '/dashboard/inventory/locations': typeof DashboardDashboardInventoryLocationsRoute;
  '/dashboard/inventory/my-truck': typeof DashboardDashboardInventoryMyTruckRoute;
  '/dashboard/inventory/overview': typeof DashboardDashboardInventoryOverviewRoute;
  '/dashboard/inventory/stock': typeof DashboardDashboardInventoryStockRoute;
  '/dashboard/inventory/transfers': typeof DashboardDashboardInventoryTransfersRoute;
  '/dashboard/inventory/truck-templates': typeof DashboardDashboardInventoryTruckTemplatesRoute;
  '/dashboard/invoices/$id': typeof DashboardDashboardInvoicesIdRouteWithChildren;
  '/dashboard/invoices/new': typeof DashboardDashboardInvoicesNewRoute;
  '/dashboard/invoices/reports': typeof DashboardDashboardInvoicesReportsRoute;
  '/dashboard/jobform/$id': typeof DashboardDashboardJobformIdRoute;
  '/dashboard/jobform/new': typeof DashboardDashboardJobformNewRoute;
  '/dashboard/jobs/$id': typeof DashboardDashboardJobsIdRouteWithChildren;
  '/dashboard/jobs/budget-vs-actual': typeof DashboardDashboardJobsBudgetVsActualRoute;
  '/dashboard/jobs/new': typeof DashboardDashboardJobsNewRoute;
  '/dashboard/jobs/reports': typeof DashboardDashboardJobsReportsRoute;
  '/dashboard/jobs/service-calls': typeof DashboardDashboardJobsServiceCallsRoute;
  '/dashboard/leads/$leadId': typeof DashboardDashboardLeadsLeadIdRouteWithChildren;
  '/dashboard/leads/new': typeof DashboardDashboardLeadsNewRoute;
  '/dashboard/leads/reports': typeof DashboardDashboardLeadsReportsRoute;
  '/dashboard/locations/$locationId': typeof DashboardDashboardLocationsLocationIdRoute;
  '/dashboard/membership-plans/$id': typeof DashboardDashboardMembershipPlansIdRouteWithChildren;
  '/dashboard/membership-plans/new': typeof DashboardDashboardMembershipPlansNewRoute;
  '/dashboard/memberships/$id': typeof DashboardDashboardMembershipsIdRouteWithChildren;
  '/dashboard/memberships/new': typeof DashboardDashboardMembershipsNewRoute;
  '/dashboard/memberships/reports': typeof DashboardDashboardMembershipsReportsRoute;
  '/dashboard/payments/$id': typeof DashboardDashboardPaymentsIdRoute;
  '/dashboard/pricebook/$id': typeof DashboardDashboardPricebookIdRouteWithChildren;
  '/dashboard/pricebook/categories': typeof DashboardDashboardPricebookCategoriesRoute;
  '/dashboard/pricebook/new': typeof DashboardDashboardPricebookNewRoute;
  '/dashboard/projects/$projectId': typeof DashboardDashboardProjectsProjectIdRoute;
  '/dashboard/proposals/$id': typeof DashboardDashboardProposalsIdRouteWithChildren;
  '/dashboard/proposals/new': typeof DashboardDashboardProposalsNewRoute;
  '/dashboard/purchasing/approvals': typeof DashboardDashboardPurchasingApprovalsRoute;
  '/dashboard/purchasing/bills': typeof DashboardDashboardPurchasingBillsRoute;
  '/dashboard/purchasing/cards': typeof DashboardDashboardPurchasingCardsRoute;
  '/dashboard/purchasing/cost-changes': typeof DashboardDashboardPurchasingCostChangesRoute;
  '/dashboard/purchasing/field': typeof DashboardDashboardPurchasingFieldRoute;
  '/dashboard/purchasing/overview': typeof DashboardDashboardPurchasingOverviewRoute;
  '/dashboard/purchasing/requests': typeof DashboardDashboardPurchasingRequestsRoute;
  '/dashboard/receipts/$id': typeof DashboardDashboardReceiptsIdRoute;
  '/dashboard/reporting/calls': typeof DashboardDashboardReportingCallsRoute;
  '/dashboard/reporting/me': typeof DashboardDashboardReportingMeRoute;
  '/dashboard/reporting/scorecards': typeof DashboardDashboardReportingScorecardsRoute;
  '/dashboard/reporting/targets': typeof DashboardDashboardReportingTargetsRoute;
  '/dashboard/reports/$id': typeof DashboardDashboardReportsIdRoute;
  '/dashboard/reports/new': typeof DashboardDashboardReportsNewRoute;
  '/dashboard/settings/accounting': typeof DashboardDashboardSettingsAccountingRoute;
  '/dashboard/settings/api-keys': typeof DashboardDashboardSettingsApiKeysRoute;
  '/dashboard/settings/appointment-forms': typeof DashboardDashboardSettingsAppointmentFormsRouteWithChildren;
  '/dashboard/settings/billing': typeof DashboardDashboardSettingsBillingRouteWithChildren;
  '/dashboard/settings/booking-links': typeof DashboardDashboardSettingsBookingLinksRoute;
  '/dashboard/settings/booking-services': typeof DashboardDashboardSettingsBookingServicesRoute;
  '/dashboard/settings/booking-windows': typeof DashboardDashboardSettingsBookingWindowsRoute;
  '/dashboard/settings/call-settings': typeof DashboardDashboardSettingsCallSettingsRouteWithChildren;
  '/dashboard/settings/calltree': typeof DashboardDashboardSettingsCalltreeRoute;
  '/dashboard/settings/channels': typeof DashboardDashboardSettingsChannelsRoute;
  '/dashboard/settings/chatbot': typeof DashboardDashboardSettingsChatbotRoute;
  '/dashboard/settings/checklist': typeof DashboardDashboardSettingsChecklistRouteWithChildren;
  '/dashboard/settings/client-portal': typeof DashboardDashboardSettingsClientPortalRoute;
  '/dashboard/settings/company': typeof DashboardDashboardSettingsCompanyRouteWithChildren;
  '/dashboard/settings/connections': typeof DashboardDashboardSettingsConnectionsRoute;
  '/dashboard/settings/contact-statuses': typeof DashboardDashboardSettingsContactStatusesRoute;
  '/dashboard/settings/contracts': typeof DashboardDashboardSettingsContractsRouteWithChildren;
  '/dashboard/settings/customfields': typeof DashboardDashboardSettingsCustomfieldsRouteWithChildren;
  '/dashboard/settings/deferred-revenue': typeof DashboardDashboardSettingsDeferredRevenueRoute;
  '/dashboard/settings/email-accounts': typeof DashboardDashboardSettingsEmailAccountsRoute;
  '/dashboard/settings/estimate-pdf': typeof DashboardDashboardSettingsEstimatePdfRoute;
  '/dashboard/settings/estimate-settings': typeof DashboardDashboardSettingsEstimateSettingsRoute;
  '/dashboard/settings/estimates': typeof DashboardDashboardSettingsEstimatesRoute;
  '/dashboard/settings/groups': typeof DashboardDashboardSettingsGroupsRouteWithChildren;
  '/dashboard/settings/integrations': typeof DashboardDashboardSettingsIntegrationsRoute;
  '/dashboard/settings/job-pipelines': typeof DashboardDashboardSettingsJobPipelinesRouteWithChildren;
  '/dashboard/settings/jobtypes': typeof DashboardDashboardSettingsJobtypesRouteWithChildren;
  '/dashboard/settings/leads': typeof DashboardDashboardSettingsLeadsRoute;
  '/dashboard/settings/logout': typeof DashboardDashboardSettingsLogoutRoute;
  '/dashboard/settings/notifications': typeof DashboardDashboardSettingsNotificationsRouteWithChildren;
  '/dashboard/settings/office-settings': typeof DashboardDashboardSettingsOfficeSettingsRouteWithChildren;
  '/dashboard/settings/oncall': typeof DashboardDashboardSettingsOncallRoute;
  '/dashboard/settings/online-booking': typeof DashboardDashboardSettingsOnlineBookingRoute;
  '/dashboard/settings/payroll-profiles': typeof DashboardDashboardSettingsPayrollProfilesRoute;
  '/dashboard/settings/permissions': typeof DashboardDashboardSettingsPermissionsRouteWithChildren;
  '/dashboard/settings/phone': typeof DashboardDashboardSettingsPhoneRoute;
  '/dashboard/settings/purchasing': typeof DashboardDashboardSettingsPurchasingRoute;
  '/dashboard/settings/quickbooks': typeof DashboardDashboardSettingsQuickbooksRoute;
  '/dashboard/settings/reminders': typeof DashboardDashboardSettingsRemindersRouteWithChildren;
  '/dashboard/settings/reports': typeof DashboardDashboardSettingsReportsRoute;
  '/dashboard/settings/review-platforms': typeof DashboardDashboardSettingsReviewPlatformsRoute;
  '/dashboard/settings/reviews': typeof DashboardDashboardSettingsReviewsRoute;
  '/dashboard/settings/scope-of-work': typeof DashboardDashboardSettingsScopeOfWorkRouteWithChildren;
  '/dashboard/settings/service-areas': typeof DashboardDashboardSettingsServiceAreasRoute;
  '/dashboard/settings/skills': typeof DashboardDashboardSettingsSkillsRouteWithChildren;
  '/dashboard/settings/sms': typeof DashboardDashboardSettingsSmsRoute;
  '/dashboard/settings/subscription': typeof DashboardDashboardSettingsSubscriptionRoute;
  '/dashboard/settings/suppliers': typeof DashboardDashboardSettingsSuppliersRoute;
  '/dashboard/settings/surveys': typeof DashboardDashboardSettingsSurveysRoute;
  '/dashboard/settings/tags': typeof DashboardDashboardSettingsTagsRoute;
  '/dashboard/settings/taxes': typeof DashboardDashboardSettingsTaxesRoute;
  '/dashboard/settings/templates': typeof DashboardDashboardSettingsTemplatesRouteWithChildren;
  '/dashboard/settings/terms-and-conditions': typeof DashboardDashboardSettingsTermsAndConditionsRouteWithChildren;
  '/dashboard/settings/trades': typeof DashboardDashboardSettingsTradesRoute;
  '/dashboard/settings/users': typeof DashboardDashboardSettingsUsersRouteWithChildren;
  '/dashboard/settings/webhooks': typeof DashboardDashboardSettingsWebhooksRouteWithChildren;
  '/dashboard/taxes/overrides': typeof DashboardDashboardTaxesOverridesRoute;
  '/dashboard/taxes/rules': typeof DashboardDashboardTaxesRulesRoute;
  '/dashboard/taxes/simulator': typeof DashboardDashboardTaxesSimulatorRoute;
  '/dashboard/technicians/$id': typeof DashboardDashboardTechniciansIdRouteWithChildren;
  '/dashboard/technicians/new': typeof DashboardDashboardTechniciansNewRoute;
  '/dashboard/technicians/reports': typeof DashboardDashboardTechniciansReportsRoute;
  '/portal/account/': typeof portalPortalAccountIndexRoute;
  '/portal/documents/': typeof portalPortalDocumentsIndexRoute;
  '/portal/equipment/': typeof portalPortalEquipmentIndexRoute;
  '/portal/estimates/': typeof portalPortalEstimatesIndexRoute;
  '/portal/invoices/': typeof portalPortalInvoicesIndexRoute;
  '/portal/memberships/': typeof portalPortalMembershipsIndexRoute;
  '/portal/plans/': typeof portalPortalPlansIndexRoute;
  '/portal/proposals/': typeof portalPortalProposalsIndexRoute;
  '/portal/visits/': typeof portalPortalVisitsIndexRoute;
  '/dashboard/bookings/': typeof DashboardDashboardBookingsIndexRoute;
  '/dashboard/calendar/': typeof DashboardDashboardCalendarIndexRoute;
  '/dashboard/contacts/': typeof DashboardDashboardContactsIndexRoute;
  '/dashboard/credit-memos/': typeof DashboardDashboardCreditMemosIndexRoute;
  '/dashboard/crewmember/': typeof DashboardDashboardCrewmemberIndexRoute;
  '/dashboard/estimates/': typeof DashboardDashboardEstimatesIndexRoute;
  '/dashboard/forms/': typeof DashboardDashboardFormsIndexRoute;
  '/dashboard/inventory/': typeof DashboardDashboardInventoryIndexRoute;
  '/dashboard/invoices/': typeof DashboardDashboardInvoicesIndexRoute;
  '/dashboard/jobform/': typeof DashboardDashboardJobformIndexRoute;
  '/dashboard/jobs/': typeof DashboardDashboardJobsIndexRoute;
  '/dashboard/leads/': typeof DashboardDashboardLeadsIndexRoute;
  '/dashboard/membership-plans/': typeof DashboardDashboardMembershipPlansIndexRoute;
  '/dashboard/memberships/': typeof DashboardDashboardMembershipsIndexRoute;
  '/dashboard/pricebook/': typeof DashboardDashboardPricebookIndexRoute;
  '/dashboard/proposals/': typeof DashboardDashboardProposalsIndexRoute;
  '/dashboard/purchasing/': typeof DashboardDashboardPurchasingIndexRoute;
  '/dashboard/receipts/': typeof DashboardDashboardReceiptsIndexRoute;
  '/dashboard/settings/': typeof DashboardDashboardSettingsIndexRoute;
  '/dashboard/technicians/': typeof DashboardDashboardTechniciansIndexRoute;
  '/dashboard/unscheduled/': typeof DashboardDashboardUnscheduledIndexRoute;
  '/payment/$id/$id2/$priceid': typeof publicPaymentIdId2PriceidRoute;
  '/dashboard/ai/otto/$reportId': typeof DashboardDashboardAiOttoReportIdRoute;
  '/dashboard/contacts/$contactId/consent-records': typeof DashboardDashboardContactsContactIdConsentRecordsRoute;
  '/dashboard/contacts/$contactId/edit': typeof DashboardDashboardContactsContactIdEditRoute;
  '/dashboard/crews/$id/edit': typeof DashboardDashboardCrewsIdEditRoute;
  '/dashboard/estimates/$id/edit': typeof DashboardDashboardEstimatesIdEditRoute;
  '/dashboard/estimates/$id/payment-schedule': typeof DashboardDashboardEstimatesIdPaymentScheduleRoute;
  '/dashboard/inventory/counts/$countId': typeof DashboardDashboardInventoryCountsCountIdRoute;
  '/dashboard/inventory/items/$itemId': typeof DashboardDashboardInventoryItemsItemIdRoute;
  '/dashboard/inventory/jobs/$jobId': typeof DashboardDashboardInventoryJobsJobIdRoute;
  '/dashboard/inventory/locations/$locationId': typeof DashboardDashboardInventoryLocationsLocationIdRoute;
  '/dashboard/inventory/pick-lists/$id': typeof DashboardDashboardInventoryPickListsIdRoute;
  '/dashboard/inventory/pick-lists/new': typeof DashboardDashboardInventoryPickListsNewRoute;
  '/dashboard/inventory/replenishment/$runId': typeof DashboardDashboardInventoryReplenishmentRunIdRoute;
  '/dashboard/invoices/$id/edit': typeof DashboardDashboardInvoicesIdEditRoute;
  '/dashboard/jobs/$id/edit': typeof DashboardDashboardJobsIdEditRoute;
  '/dashboard/leads/$leadId/edit': typeof DashboardDashboardLeadsLeadIdEditRoute;
  '/dashboard/membership-plans/$id/edit': typeof DashboardDashboardMembershipPlansIdEditRoute;
  '/dashboard/memberships/$id/edit': typeof DashboardDashboardMembershipsIdEditRoute;
  '/dashboard/pricebook/$id/edit': typeof DashboardDashboardPricebookIdEditRoute;
  '/dashboard/proposals/$id/edit': typeof DashboardDashboardProposalsIdEditRoute;
  '/dashboard/proposals/$id/present': typeof DashboardDashboardProposalsIdPresentRoute;
  '/dashboard/purchasing/suppliers/$supplierId': typeof DashboardDashboardPurchasingSuppliersSupplierIdRoute;
  '/dashboard/reporting/reports/$reportId': typeof DashboardDashboardReportingReportsReportIdRoute;
  '/dashboard/reporting/reports/new': typeof DashboardDashboardReportingReportsNewRoute;
  '/dashboard/settings/appointment-forms/$id': typeof DashboardDashboardSettingsAppointmentFormsIdRouteWithChildren;
  '/dashboard/settings/appointment-forms/new': typeof DashboardDashboardSettingsAppointmentFormsNewRoute;
  '/dashboard/settings/billing/credit-memos': typeof DashboardDashboardSettingsBillingCreditMemosRoute;
  '/dashboard/settings/billing/deposits': typeof DashboardDashboardSettingsBillingDepositsRoute;
  '/dashboard/settings/billing/invoices': typeof DashboardDashboardSettingsBillingInvoicesRoute;
  '/dashboard/settings/billing/payments': typeof DashboardDashboardSettingsBillingPaymentsRoute;
  '/dashboard/settings/billing/quickbooks': typeof DashboardDashboardSettingsBillingQuickbooksRoute;
  '/dashboard/settings/billing/receipts': typeof DashboardDashboardSettingsBillingReceiptsRoute;
  '/dashboard/settings/business-units/$id': typeof DashboardDashboardSettingsBusinessUnitsIdRoute;
  '/dashboard/settings/checklist/$id': typeof DashboardDashboardSettingsChecklistIdRouteWithChildren;
  '/dashboard/settings/checklist/new': typeof DashboardDashboardSettingsChecklistNewRoute;
  '/dashboard/settings/company/edit': typeof DashboardDashboardSettingsCompanyEditRoute;
  '/dashboard/settings/contracts/cancellation': typeof DashboardDashboardSettingsContractsCancellationRoute;
  '/dashboard/settings/contracts/costing': typeof DashboardDashboardSettingsContractsCostingRoute;
  '/dashboard/settings/contracts/defaults': typeof DashboardDashboardSettingsContractsDefaultsRoute;
  '/dashboard/settings/contracts/production-kits': typeof DashboardDashboardSettingsContractsProductionKitsRoute;
  '/dashboard/settings/contracts/qbo': typeof DashboardDashboardSettingsContractsQboRoute;
  '/dashboard/settings/contracts/renewal': typeof DashboardDashboardSettingsContractsRenewalRoute;
  '/dashboard/settings/contracts/renewal-cancellation': typeof DashboardDashboardSettingsContractsRenewalCancellationRoute;
  '/dashboard/settings/contracts/reviews': typeof DashboardDashboardSettingsContractsReviewsRoute;
  '/dashboard/settings/customfields/$id': typeof DashboardDashboardSettingsCustomfieldsIdRouteWithChildren;
  '/dashboard/settings/customfields/new': typeof DashboardDashboardSettingsCustomfieldsNewRoute;
  '/dashboard/settings/document-templates/$id': typeof DashboardDashboardSettingsDocumentTemplatesIdRoute;
  '/dashboard/settings/document-templates/new': typeof DashboardDashboardSettingsDocumentTemplatesNewRoute;
  '/dashboard/settings/email-templates/$id': typeof DashboardDashboardSettingsEmailTemplatesIdRoute;
  '/dashboard/settings/email-templates/new': typeof DashboardDashboardSettingsEmailTemplatesNewRoute;
  '/dashboard/settings/groups/$id': typeof DashboardDashboardSettingsGroupsIdRouteWithChildren;
  '/dashboard/settings/groups/new': typeof DashboardDashboardSettingsGroupsNewRoute;
  '/dashboard/settings/job-pipelines/$id': typeof DashboardDashboardSettingsJobPipelinesIdRouteWithChildren;
  '/dashboard/settings/job-pipelines/new': typeof DashboardDashboardSettingsJobPipelinesNewRoute;
  '/dashboard/settings/jobtypes/$id': typeof DashboardDashboardSettingsJobtypesIdRouteWithChildren;
  '/dashboard/settings/jobtypes/new': typeof DashboardDashboardSettingsJobtypesNewRoute;
  '/dashboard/settings/notifications/edit': typeof DashboardDashboardSettingsNotificationsEditRoute;
  '/dashboard/settings/office-settings/edit': typeof DashboardDashboardSettingsOfficeSettingsEditRoute;
  '/dashboard/settings/partner-api/webhooks': typeof DashboardDashboardSettingsPartnerApiWebhooksRouteWithChildren;
  '/dashboard/settings/permissions/$id': typeof DashboardDashboardSettingsPermissionsIdRouteWithChildren;
  '/dashboard/settings/permissions/new': typeof DashboardDashboardSettingsPermissionsNewRoute;
  '/dashboard/settings/reminders/$type': typeof DashboardDashboardSettingsRemindersTypeRoute;
  '/dashboard/settings/reports/templates': typeof DashboardDashboardSettingsReportsTemplatesRoute;
  '/dashboard/settings/scope-of-work/$id': typeof DashboardDashboardSettingsScopeOfWorkIdRouteWithChildren;
  '/dashboard/settings/skills/$id': typeof DashboardDashboardSettingsSkillsIdRouteWithChildren;
  '/dashboard/settings/skills/new': typeof DashboardDashboardSettingsSkillsNewRoute;
  '/dashboard/settings/terms-and-conditions/$id': typeof DashboardDashboardSettingsTermsAndConditionsIdRouteWithChildren;
  '/dashboard/settings/users/$id': typeof DashboardDashboardSettingsUsersIdRouteWithChildren;
  '/dashboard/settings/users/new': typeof DashboardDashboardSettingsUsersNewRoute;
  '/dashboard/settings/webhooks/$id': typeof DashboardDashboardSettingsWebhooksIdRouteWithChildren;
  '/dashboard/settings/webhooks/new': typeof DashboardDashboardSettingsWebhooksNewRoute;
  '/dashboard/technicians/$id/edit': typeof DashboardDashboardTechniciansIdEditRoute;
  '/dashboard/technicians/$id/offboarding': typeof DashboardDashboardTechniciansIdOffboardingRoute;
  '/dashboard/inventory/counts/': typeof DashboardDashboardInventoryCountsIndexRoute;
  '/dashboard/inventory/replenishment/': typeof DashboardDashboardInventoryReplenishmentIndexRoute;
  '/dashboard/purchasing/suppliers/': typeof DashboardDashboardPurchasingSuppliersIndexRoute;
  '/dashboard/reporting/reports/': typeof DashboardDashboardReportingReportsIndexRoute;
  '/dashboard/settings/appointment-forms/': typeof DashboardDashboardSettingsAppointmentFormsIndexRoute;
  '/dashboard/settings/billing/': typeof DashboardDashboardSettingsBillingIndexRoute;
  '/dashboard/settings/business-units/': typeof DashboardDashboardSettingsBusinessUnitsIndexRoute;
  '/dashboard/settings/checklist/': typeof DashboardDashboardSettingsChecklistIndexRoute;
  '/dashboard/settings/contracts/': typeof DashboardDashboardSettingsContractsIndexRoute;
  '/dashboard/settings/document-templates/': typeof DashboardDashboardSettingsDocumentTemplatesIndexRoute;
  '/dashboard/settings/job-pipelines/': typeof DashboardDashboardSettingsJobPipelinesIndexRoute;
  '/dashboard/settings/templates/': typeof DashboardDashboardSettingsTemplatesIndexRoute;
  '/dashboard/contacts/$contactId/addresses/new': typeof DashboardDashboardContactsContactIdAddressesNewRoute;
  '/dashboard/contacts/$contactId/bill-to/new': typeof DashboardDashboardContactsContactIdBillToNewRoute;
  '/dashboard/jobs/$id/appointments/$appointmentId': typeof DashboardDashboardJobsIdAppointmentsAppointmentIdRoute;
  '/dashboard/jobs/$id/appointments/new': typeof DashboardDashboardJobsIdAppointmentsNewRoute;
  '/dashboard/jobs/$id/change-orders/$changeOrderId': typeof DashboardDashboardJobsIdChangeOrdersChangeOrderIdRoute;
  '/dashboard/jobs/$id/change-orders/new': typeof DashboardDashboardJobsIdChangeOrdersNewRoute;
  '/dashboard/jobs/$id/expenses/$expenseId': typeof DashboardDashboardJobsIdExpensesExpenseIdRoute;
  '/dashboard/jobs/$id/expenses/new': typeof DashboardDashboardJobsIdExpensesNewRoute;
  '/dashboard/jobs/$id/invoices/$invoiceId': typeof DashboardDashboardJobsIdInvoicesInvoiceIdRoute;
  '/dashboard/jobs/$id/invoices/new': typeof DashboardDashboardJobsIdInvoicesNewRoute;
  '/dashboard/jobs/$id/payment-schedule/edit': typeof DashboardDashboardJobsIdPaymentScheduleEditRoute;
  '/dashboard/jobs/$id/payment-schedule/new': typeof DashboardDashboardJobsIdPaymentScheduleNewRoute;
  '/dashboard/purchasing/suppliers/$supplierId/edit': typeof DashboardDashboardPurchasingSuppliersSupplierIdEditRoute;
  '/dashboard/reporting/reports/$reportId/edit': typeof DashboardDashboardReportingReportsReportIdEditRoute;
  '/dashboard/settings/appointment-forms/$id/edit': typeof DashboardDashboardSettingsAppointmentFormsIdEditRoute;
  '/dashboard/settings/call-settings/flows/$id': typeof DashboardDashboardSettingsCallSettingsFlowsIdRoute;
  '/dashboard/settings/call-settings/ivr/$id': typeof DashboardDashboardSettingsCallSettingsIvrIdRoute;
  '/dashboard/settings/call-settings/ivr/new': typeof DashboardDashboardSettingsCallSettingsIvrNewRoute;
  '/dashboard/settings/call-settings/numbers/$numberId': typeof DashboardDashboardSettingsCallSettingsNumbersNumberIdRoute;
  '/dashboard/settings/call-settings/team/$section': typeof DashboardDashboardSettingsCallSettingsTeamSectionRoute;
  '/dashboard/settings/checklist/$id/edit': typeof DashboardDashboardSettingsChecklistIdEditRoute;
  '/dashboard/settings/customfields/$id/edit': typeof DashboardDashboardSettingsCustomfieldsIdEditRoute;
  '/dashboard/settings/groups/$id/edit': typeof DashboardDashboardSettingsGroupsIdEditRoute;
  '/dashboard/settings/job-pipelines/$id/edit': typeof DashboardDashboardSettingsJobPipelinesIdEditRoute;
  '/dashboard/settings/jobtypes/$id/edit': typeof DashboardDashboardSettingsJobtypesIdEditRoute;
  '/dashboard/settings/partner-api/webhooks/$id': typeof DashboardDashboardSettingsPartnerApiWebhooksIdRouteWithChildren;
  '/dashboard/settings/partner-api/webhooks/new': typeof DashboardDashboardSettingsPartnerApiWebhooksNewRoute;
  '/dashboard/settings/permissions/$id/edit': typeof DashboardDashboardSettingsPermissionsIdEditRoute;
  '/dashboard/settings/scope-of-work/$id/edit': typeof DashboardDashboardSettingsScopeOfWorkIdEditRoute;
  '/dashboard/settings/skills/$id/edit': typeof DashboardDashboardSettingsSkillsIdEditRoute;
  '/dashboard/settings/templates/estimate/$id': typeof DashboardDashboardSettingsTemplatesEstimateIdRoute;
  '/dashboard/settings/templates/estimate/new': typeof DashboardDashboardSettingsTemplatesEstimateNewRoute;
  '/dashboard/settings/templates/proposal/$id': typeof DashboardDashboardSettingsTemplatesProposalIdRoute;
  '/dashboard/settings/templates/proposal/new': typeof DashboardDashboardSettingsTemplatesProposalNewRoute;
  '/dashboard/settings/terms-and-conditions/$id/edit': typeof DashboardDashboardSettingsTermsAndConditionsIdEditRoute;
  '/dashboard/settings/users/$id/edit': typeof DashboardDashboardSettingsUsersIdEditRoute;
  '/dashboard/settings/webhooks/$id/edit': typeof DashboardDashboardSettingsWebhooksIdEditRoute;
  '/dashboard/contacts/$contactId/addresses/$addressId/edit': typeof DashboardDashboardContactsContactIdAddressesAddressIdEditRoute;
  '/dashboard/contacts/$contactId/bill-to/$billToId/edit': typeof DashboardDashboardContactsContactIdBillToBillToIdEditRoute;
  '/dashboard/settings/partner-api/webhooks/$id/edit': typeof DashboardDashboardSettingsPartnerApiWebhooksIdEditRoute;
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute;
  '/$': typeof SplatRoute;
  '/create-password': typeof publicCreatePasswordRouteWithChildren;
  '/forgot-password': typeof publicForgotPasswordRoute;
  '/google-business': typeof publicGoogleBusinessRoute;
  '/invite': typeof publicInviteRouteWithChildren;
  '/login': typeof publicLoginRoute;
  '/onlinebookingresponse': typeof publicOnlinebookingresponseRoute;
  '/reset-password': typeof publicResetPasswordRoute;
  '/portal/forgot': typeof portalPortalForgotRoute;
  '/portal/login': typeof portalPortalLoginRoute;
  '/portal/register': typeof portalPortalRegisterRoute;
  '/portal/reset': typeof portalPortalResetRoute;
  '/portal/verify': typeof portalPortalVerifyRoute;
  '/auth/impersonate-handoff': typeof publicAuthImpersonateHandoffRoute;
  '/book/$token': typeof publicBookTokenRoute;
  '/c/$token': typeof publicCTokenRoute;
  '/change-order/$id': typeof publicChangeOrderIdRoute;
  '/combined-doc/$token': typeof publicCombinedDocTokenRoute;
  '/confirm-job/$referenceNo': typeof publicConfirmJobReferenceNoRoute;
  '/create-password/$token': typeof publicCreatePasswordTokenRoute;
  '/e/$token': typeof publicETokenRoute;
  '/estimate/$id': typeof publicEstimateIdRoute;
  '/form/$id': typeof publicFormIdRoute;
  '/i/$id': typeof publicIIdRoute;
  '/invite/$token': typeof publicInviteTokenRoute;
  '/invoice/$id': typeof publicInvoiceIdRoute;
  '/j/$referenceNo': typeof publicJReferenceNoRoute;
  '/job-stories/$token': typeof publicJobStoriesTokenRoute;
  '/link-phone/$token': typeof publicLinkPhoneTokenRoute;
  '/onlinebooking/$id': typeof publicOnlinebookingIdRoute;
  '/onlineform/$id': typeof publicOnlineformIdRoute;
  '/pay/$token': typeof publicPayTokenRoute;
  '/payment-method-request/$token': typeof publicPaymentMethodRequestTokenRoute;
  '/pdf-estimate/$id': typeof publicPdfEstimateIdRoute;
  '/pdf-invoice/$id': typeof publicPdfInvoiceIdRoute;
  '/pdf-proposal/$id': typeof publicPdfProposalIdRoute;
  '/previewinvoice/$id': typeof publicPreviewinvoiceIdRoute;
  '/previewquote/$id': typeof publicPreviewquoteIdRoute;
  '/proposal/$id': typeof publicProposalIdRoute;
  '/quote/$id': typeof publicQuoteIdRoute;
  '/r/$token': typeof publicRTokenRoute;
  '/receipt/$id': typeof publicReceiptIdRoute;
  '/recurring-renewal/$token': typeof publicRecurringRenewalTokenRoute;
  '/recurring/$token': typeof publicRecurringTokenRoute;
  '/repair-membership/$token': typeof publicRepairMembershipTokenRoute;
  '/repair-payment-method/$token': typeof publicRepairPaymentMethodTokenRoute;
  '/response/$id': typeof publicResponseIdRoute;
  '/review/$token': typeof publicReviewTokenRoute;
  '/s/$code': typeof publicSCodeRoute;
  '/schedule-change/$token': typeof publicScheduleChangeTokenRoute;
  '/signed/$signedId': typeof publicSignedSignedIdRoute;
  '/supplier-order/$token': typeof publicSupplierOrderTokenRoute;
  '/t/$token': typeof publicTTokenRoute;
  '/tip-option/$id': typeof publicTipOptionIdRoute;
  '/tip/$id': typeof publicTipIdRoute;
  '/dashboard/audit': typeof DashboardDashboardAuditRoute;
  '/dashboard/board': typeof DashboardDashboardBoardRoute;
  '/dashboard/calllogs': typeof DashboardDashboardCalllogsRoute;
  '/dashboard/chatbot': typeof DashboardDashboardChatbotRoute;
  '/dashboard/contracts': typeof DashboardDashboardContractsRouteWithChildren;
  '/dashboard/crew-members': typeof DashboardDashboardCrewMembersRoute;
  '/dashboard/crews': typeof DashboardDashboardCrewsRouteWithChildren;
  '/dashboard/deposits': typeof DashboardDashboardDepositsRouteWithChildren;
  '/dashboard/dispatch': typeof DashboardDashboardDispatchRoute;
  '/dashboard/equipment': typeof DashboardDashboardEquipmentRoute;
  '/dashboard/equipment-categories': typeof DashboardDashboardEquipmentCategoriesRoute;
  '/dashboard/equipment-descriptions': typeof DashboardDashboardEquipmentDescriptionsRoute;
  '/dashboard/executive': typeof DashboardDashboardExecutiveRoute;
  '/dashboard/home': typeof DashboardDashboardHomeRoute;
  '/dashboard/inbox': typeof DashboardDashboardInboxRoute;
  '/dashboard/leads-engine': typeof DashboardDashboardLeadsEngineRoute;
  '/dashboard/live-calls': typeof DashboardDashboardLiveCallsRoute;
  '/dashboard/locations': typeof DashboardDashboardLocationsRouteWithChildren;
  '/dashboard/membership-visits': typeof DashboardDashboardMembershipVisitsRoute;
  '/dashboard/my-dashboard': typeof DashboardDashboardMyDashboardRoute;
  '/dashboard/my-day': typeof DashboardDashboardMyDayRoute;
  '/dashboard/notifications': typeof DashboardDashboardNotificationsRoute;
  '/dashboard/onboarding': typeof DashboardDashboardOnboardingRoute;
  '/dashboard/operations': typeof DashboardDashboardOperationsRoute;
  '/dashboard/past-due': typeof DashboardDashboardPastDueRoute;
  '/dashboard/payments': typeof DashboardDashboardPaymentsRouteWithChildren;
  '/dashboard/projects': typeof DashboardDashboardProjectsRouteWithChildren;
  '/dashboard/promotions': typeof DashboardDashboardPromotionsRoute;
  '/dashboard/recovery-renewals': typeof DashboardDashboardRecoveryRenewalsRoute;
  '/dashboard/recurring-billing': typeof DashboardDashboardRecurringBillingRoute;
  '/dashboard/reminders': typeof DashboardDashboardRemindersRoute;
  '/dashboard/reviews': typeof DashboardDashboardReviewsRoute;
  '/dashboard/routes': typeof DashboardDashboardRoutesRoute;
  '/dashboard/schedule': typeof DashboardDashboardScheduleRoute;
  '/dashboard/stripe': typeof DashboardDashboardStripeRoute;
  '/dashboard/tasks': typeof DashboardDashboardTasksRoute;
  '/dashboard/taxes': typeof DashboardDashboardTaxesRouteWithChildren;
  '/dashboard/team-chat': typeof DashboardDashboardTeamChatRoute;
  '/dashboard/timesheet': typeof DashboardDashboardTimesheetRoute;
  '/portal': typeof portalPortalIndexRoute;
  '/review': typeof publicReviewIndexRoute;
  '/dashboard': typeof DashboardDashboardIndexRoute;
  '/portal/estimates/$id': typeof portalPortalEstimatesIdRoute;
  '/portal/invoices/$id': typeof portalPortalInvoicesIdRoute;
  '/portal/memberships/$id': typeof portalPortalMembershipsIdRoute;
  '/portal/proposals/$id': typeof portalPortalProposalsIdRoute;
  '/portal/visits/book': typeof portalPortalVisitsBookRoute;
  '/review/$reviewId/$id2': typeof publicReviewReviewIdId2Route;
  '/tracking/$id/$refno': typeof publicTrackingIdRefnoRoute;
  '/dashboard/ai/otto': typeof DashboardDashboardAiOttoRouteWithChildren;
  '/dashboard/bookings/$bookingId': typeof DashboardDashboardBookingsBookingIdRoute;
  '/dashboard/bookings/new': typeof DashboardDashboardBookingsNewRoute;
  '/dashboard/calendar/$id': typeof DashboardDashboardCalendarIdRoute;
  '/dashboard/calendar/map': typeof DashboardDashboardCalendarMapRoute;
  '/dashboard/calllogs/reports': typeof DashboardDashboardCalllogsReportsRoute;
  '/dashboard/contacts/$contactId': typeof DashboardDashboardContactsContactIdRouteWithChildren;
  '/dashboard/contacts/new': typeof DashboardDashboardContactsNewRoute;
  '/dashboard/contacts/reports': typeof DashboardDashboardContactsReportsRoute;
  '/dashboard/contacts/tasks': typeof DashboardDashboardContactsTasksRoute;
  '/dashboard/contracts/$id': typeof DashboardDashboardContractsIdRoute;
  '/dashboard/costing/reports': typeof DashboardDashboardCostingReportsRoute;
  '/dashboard/credit-memos/$id': typeof DashboardDashboardCreditMemosIdRoute;
  '/dashboard/credit-memos/new': typeof DashboardDashboardCreditMemosNewRoute;
  '/dashboard/crewmember/$userId': typeof DashboardDashboardCrewmemberUserIdRoute;
  '/dashboard/crews/$id': typeof DashboardDashboardCrewsIdRouteWithChildren;
  '/dashboard/crews/new': typeof DashboardDashboardCrewsNewRoute;
  '/dashboard/deposits/$id': typeof DashboardDashboardDepositsIdRoute;
  '/dashboard/dispatch/live': typeof DashboardDashboardDispatchLiveRoute;
  '/dashboard/estimates/$id': typeof DashboardDashboardEstimatesIdRouteWithChildren;
  '/dashboard/estimates/new': typeof DashboardDashboardEstimatesNewRoute;
  '/dashboard/estimates/reports': typeof DashboardDashboardEstimatesReportsRoute;
  '/dashboard/forms/$formId': typeof DashboardDashboardFormsFormIdRoute;
  '/dashboard/inventory/locations': typeof DashboardDashboardInventoryLocationsRoute;
  '/dashboard/inventory/my-truck': typeof DashboardDashboardInventoryMyTruckRoute;
  '/dashboard/inventory/overview': typeof DashboardDashboardInventoryOverviewRoute;
  '/dashboard/inventory/stock': typeof DashboardDashboardInventoryStockRoute;
  '/dashboard/inventory/transfers': typeof DashboardDashboardInventoryTransfersRoute;
  '/dashboard/inventory/truck-templates': typeof DashboardDashboardInventoryTruckTemplatesRoute;
  '/dashboard/invoices/$id': typeof DashboardDashboardInvoicesIdRouteWithChildren;
  '/dashboard/invoices/new': typeof DashboardDashboardInvoicesNewRoute;
  '/dashboard/invoices/reports': typeof DashboardDashboardInvoicesReportsRoute;
  '/dashboard/jobform/$id': typeof DashboardDashboardJobformIdRoute;
  '/dashboard/jobform/new': typeof DashboardDashboardJobformNewRoute;
  '/dashboard/jobs/$id': typeof DashboardDashboardJobsIdRouteWithChildren;
  '/dashboard/jobs/budget-vs-actual': typeof DashboardDashboardJobsBudgetVsActualRoute;
  '/dashboard/jobs/new': typeof DashboardDashboardJobsNewRoute;
  '/dashboard/jobs/reports': typeof DashboardDashboardJobsReportsRoute;
  '/dashboard/jobs/service-calls': typeof DashboardDashboardJobsServiceCallsRoute;
  '/dashboard/leads/$leadId': typeof DashboardDashboardLeadsLeadIdRouteWithChildren;
  '/dashboard/leads/new': typeof DashboardDashboardLeadsNewRoute;
  '/dashboard/leads/reports': typeof DashboardDashboardLeadsReportsRoute;
  '/dashboard/locations/$locationId': typeof DashboardDashboardLocationsLocationIdRoute;
  '/dashboard/membership-plans/$id': typeof DashboardDashboardMembershipPlansIdRouteWithChildren;
  '/dashboard/membership-plans/new': typeof DashboardDashboardMembershipPlansNewRoute;
  '/dashboard/memberships/$id': typeof DashboardDashboardMembershipsIdRouteWithChildren;
  '/dashboard/memberships/new': typeof DashboardDashboardMembershipsNewRoute;
  '/dashboard/memberships/reports': typeof DashboardDashboardMembershipsReportsRoute;
  '/dashboard/payments/$id': typeof DashboardDashboardPaymentsIdRoute;
  '/dashboard/pricebook/$id': typeof DashboardDashboardPricebookIdRouteWithChildren;
  '/dashboard/pricebook/categories': typeof DashboardDashboardPricebookCategoriesRoute;
  '/dashboard/pricebook/new': typeof DashboardDashboardPricebookNewRoute;
  '/dashboard/projects/$projectId': typeof DashboardDashboardProjectsProjectIdRoute;
  '/dashboard/proposals/$id': typeof DashboardDashboardProposalsIdRouteWithChildren;
  '/dashboard/proposals/new': typeof DashboardDashboardProposalsNewRoute;
  '/dashboard/purchasing/approvals': typeof DashboardDashboardPurchasingApprovalsRoute;
  '/dashboard/purchasing/bills': typeof DashboardDashboardPurchasingBillsRoute;
  '/dashboard/purchasing/cards': typeof DashboardDashboardPurchasingCardsRoute;
  '/dashboard/purchasing/cost-changes': typeof DashboardDashboardPurchasingCostChangesRoute;
  '/dashboard/purchasing/field': typeof DashboardDashboardPurchasingFieldRoute;
  '/dashboard/purchasing/overview': typeof DashboardDashboardPurchasingOverviewRoute;
  '/dashboard/purchasing/requests': typeof DashboardDashboardPurchasingRequestsRoute;
  '/dashboard/receipts/$id': typeof DashboardDashboardReceiptsIdRoute;
  '/dashboard/reporting/calls': typeof DashboardDashboardReportingCallsRoute;
  '/dashboard/reporting/me': typeof DashboardDashboardReportingMeRoute;
  '/dashboard/reporting/scorecards': typeof DashboardDashboardReportingScorecardsRoute;
  '/dashboard/reporting/targets': typeof DashboardDashboardReportingTargetsRoute;
  '/dashboard/reports/$id': typeof DashboardDashboardReportsIdRoute;
  '/dashboard/reports/new': typeof DashboardDashboardReportsNewRoute;
  '/dashboard/settings/accounting': typeof DashboardDashboardSettingsAccountingRoute;
  '/dashboard/settings/api-keys': typeof DashboardDashboardSettingsApiKeysRoute;
  '/dashboard/settings/booking-links': typeof DashboardDashboardSettingsBookingLinksRoute;
  '/dashboard/settings/booking-services': typeof DashboardDashboardSettingsBookingServicesRoute;
  '/dashboard/settings/booking-windows': typeof DashboardDashboardSettingsBookingWindowsRoute;
  '/dashboard/settings/call-settings': typeof DashboardDashboardSettingsCallSettingsRouteWithChildren;
  '/dashboard/settings/calltree': typeof DashboardDashboardSettingsCalltreeRoute;
  '/dashboard/settings/channels': typeof DashboardDashboardSettingsChannelsRoute;
  '/dashboard/settings/chatbot': typeof DashboardDashboardSettingsChatbotRoute;
  '/dashboard/settings/client-portal': typeof DashboardDashboardSettingsClientPortalRoute;
  '/dashboard/settings/company': typeof DashboardDashboardSettingsCompanyRouteWithChildren;
  '/dashboard/settings/connections': typeof DashboardDashboardSettingsConnectionsRoute;
  '/dashboard/settings/contact-statuses': typeof DashboardDashboardSettingsContactStatusesRoute;
  '/dashboard/settings/customfields': typeof DashboardDashboardSettingsCustomfieldsRouteWithChildren;
  '/dashboard/settings/deferred-revenue': typeof DashboardDashboardSettingsDeferredRevenueRoute;
  '/dashboard/settings/email-accounts': typeof DashboardDashboardSettingsEmailAccountsRoute;
  '/dashboard/settings/estimate-pdf': typeof DashboardDashboardSettingsEstimatePdfRoute;
  '/dashboard/settings/estimate-settings': typeof DashboardDashboardSettingsEstimateSettingsRoute;
  '/dashboard/settings/estimates': typeof DashboardDashboardSettingsEstimatesRoute;
  '/dashboard/settings/groups': typeof DashboardDashboardSettingsGroupsRouteWithChildren;
  '/dashboard/settings/integrations': typeof DashboardDashboardSettingsIntegrationsRoute;
  '/dashboard/settings/jobtypes': typeof DashboardDashboardSettingsJobtypesRouteWithChildren;
  '/dashboard/settings/leads': typeof DashboardDashboardSettingsLeadsRoute;
  '/dashboard/settings/logout': typeof DashboardDashboardSettingsLogoutRoute;
  '/dashboard/settings/notifications': typeof DashboardDashboardSettingsNotificationsRouteWithChildren;
  '/dashboard/settings/office-settings': typeof DashboardDashboardSettingsOfficeSettingsRouteWithChildren;
  '/dashboard/settings/oncall': typeof DashboardDashboardSettingsOncallRoute;
  '/dashboard/settings/online-booking': typeof DashboardDashboardSettingsOnlineBookingRoute;
  '/dashboard/settings/payroll-profiles': typeof DashboardDashboardSettingsPayrollProfilesRoute;
  '/dashboard/settings/permissions': typeof DashboardDashboardSettingsPermissionsRouteWithChildren;
  '/dashboard/settings/phone': typeof DashboardDashboardSettingsPhoneRoute;
  '/dashboard/settings/purchasing': typeof DashboardDashboardSettingsPurchasingRoute;
  '/dashboard/settings/quickbooks': typeof DashboardDashboardSettingsQuickbooksRoute;
  '/dashboard/settings/reminders': typeof DashboardDashboardSettingsRemindersRouteWithChildren;
  '/dashboard/settings/reports': typeof DashboardDashboardSettingsReportsRoute;
  '/dashboard/settings/review-platforms': typeof DashboardDashboardSettingsReviewPlatformsRoute;
  '/dashboard/settings/reviews': typeof DashboardDashboardSettingsReviewsRoute;
  '/dashboard/settings/scope-of-work': typeof DashboardDashboardSettingsScopeOfWorkRouteWithChildren;
  '/dashboard/settings/service-areas': typeof DashboardDashboardSettingsServiceAreasRoute;
  '/dashboard/settings/skills': typeof DashboardDashboardSettingsSkillsRouteWithChildren;
  '/dashboard/settings/sms': typeof DashboardDashboardSettingsSmsRoute;
  '/dashboard/settings/subscription': typeof DashboardDashboardSettingsSubscriptionRoute;
  '/dashboard/settings/suppliers': typeof DashboardDashboardSettingsSuppliersRoute;
  '/dashboard/settings/surveys': typeof DashboardDashboardSettingsSurveysRoute;
  '/dashboard/settings/tags': typeof DashboardDashboardSettingsTagsRoute;
  '/dashboard/settings/taxes': typeof DashboardDashboardSettingsTaxesRoute;
  '/dashboard/settings/terms-and-conditions': typeof DashboardDashboardSettingsTermsAndConditionsRouteWithChildren;
  '/dashboard/settings/trades': typeof DashboardDashboardSettingsTradesRoute;
  '/dashboard/settings/users': typeof DashboardDashboardSettingsUsersRouteWithChildren;
  '/dashboard/settings/webhooks': typeof DashboardDashboardSettingsWebhooksRouteWithChildren;
  '/dashboard/taxes/overrides': typeof DashboardDashboardTaxesOverridesRoute;
  '/dashboard/taxes/rules': typeof DashboardDashboardTaxesRulesRoute;
  '/dashboard/taxes/simulator': typeof DashboardDashboardTaxesSimulatorRoute;
  '/dashboard/technicians/$id': typeof DashboardDashboardTechniciansIdRouteWithChildren;
  '/dashboard/technicians/new': typeof DashboardDashboardTechniciansNewRoute;
  '/dashboard/technicians/reports': typeof DashboardDashboardTechniciansReportsRoute;
  '/portal/account': typeof portalPortalAccountIndexRoute;
  '/portal/documents': typeof portalPortalDocumentsIndexRoute;
  '/portal/equipment': typeof portalPortalEquipmentIndexRoute;
  '/portal/estimates': typeof portalPortalEstimatesIndexRoute;
  '/portal/invoices': typeof portalPortalInvoicesIndexRoute;
  '/portal/memberships': typeof portalPortalMembershipsIndexRoute;
  '/portal/plans': typeof portalPortalPlansIndexRoute;
  '/portal/proposals': typeof portalPortalProposalsIndexRoute;
  '/portal/visits': typeof portalPortalVisitsIndexRoute;
  '/dashboard/bookings': typeof DashboardDashboardBookingsIndexRoute;
  '/dashboard/calendar': typeof DashboardDashboardCalendarIndexRoute;
  '/dashboard/contacts': typeof DashboardDashboardContactsIndexRoute;
  '/dashboard/credit-memos': typeof DashboardDashboardCreditMemosIndexRoute;
  '/dashboard/crewmember': typeof DashboardDashboardCrewmemberIndexRoute;
  '/dashboard/estimates': typeof DashboardDashboardEstimatesIndexRoute;
  '/dashboard/forms': typeof DashboardDashboardFormsIndexRoute;
  '/dashboard/inventory': typeof DashboardDashboardInventoryIndexRoute;
  '/dashboard/invoices': typeof DashboardDashboardInvoicesIndexRoute;
  '/dashboard/jobform': typeof DashboardDashboardJobformIndexRoute;
  '/dashboard/jobs': typeof DashboardDashboardJobsIndexRoute;
  '/dashboard/leads': typeof DashboardDashboardLeadsIndexRoute;
  '/dashboard/membership-plans': typeof DashboardDashboardMembershipPlansIndexRoute;
  '/dashboard/memberships': typeof DashboardDashboardMembershipsIndexRoute;
  '/dashboard/pricebook': typeof DashboardDashboardPricebookIndexRoute;
  '/dashboard/proposals': typeof DashboardDashboardProposalsIndexRoute;
  '/dashboard/purchasing': typeof DashboardDashboardPurchasingIndexRoute;
  '/dashboard/receipts': typeof DashboardDashboardReceiptsIndexRoute;
  '/dashboard/settings': typeof DashboardDashboardSettingsIndexRoute;
  '/dashboard/technicians': typeof DashboardDashboardTechniciansIndexRoute;
  '/dashboard/unscheduled': typeof DashboardDashboardUnscheduledIndexRoute;
  '/payment/$id/$id2/$priceid': typeof publicPaymentIdId2PriceidRoute;
  '/dashboard/ai/otto/$reportId': typeof DashboardDashboardAiOttoReportIdRoute;
  '/dashboard/contacts/$contactId/consent-records': typeof DashboardDashboardContactsContactIdConsentRecordsRoute;
  '/dashboard/contacts/$contactId/edit': typeof DashboardDashboardContactsContactIdEditRoute;
  '/dashboard/crews/$id/edit': typeof DashboardDashboardCrewsIdEditRoute;
  '/dashboard/estimates/$id/edit': typeof DashboardDashboardEstimatesIdEditRoute;
  '/dashboard/estimates/$id/payment-schedule': typeof DashboardDashboardEstimatesIdPaymentScheduleRoute;
  '/dashboard/inventory/counts/$countId': typeof DashboardDashboardInventoryCountsCountIdRoute;
  '/dashboard/inventory/items/$itemId': typeof DashboardDashboardInventoryItemsItemIdRoute;
  '/dashboard/inventory/jobs/$jobId': typeof DashboardDashboardInventoryJobsJobIdRoute;
  '/dashboard/inventory/locations/$locationId': typeof DashboardDashboardInventoryLocationsLocationIdRoute;
  '/dashboard/inventory/pick-lists/$id': typeof DashboardDashboardInventoryPickListsIdRoute;
  '/dashboard/inventory/pick-lists/new': typeof DashboardDashboardInventoryPickListsNewRoute;
  '/dashboard/inventory/replenishment/$runId': typeof DashboardDashboardInventoryReplenishmentRunIdRoute;
  '/dashboard/invoices/$id/edit': typeof DashboardDashboardInvoicesIdEditRoute;
  '/dashboard/jobs/$id/edit': typeof DashboardDashboardJobsIdEditRoute;
  '/dashboard/leads/$leadId/edit': typeof DashboardDashboardLeadsLeadIdEditRoute;
  '/dashboard/membership-plans/$id/edit': typeof DashboardDashboardMembershipPlansIdEditRoute;
  '/dashboard/memberships/$id/edit': typeof DashboardDashboardMembershipsIdEditRoute;
  '/dashboard/pricebook/$id/edit': typeof DashboardDashboardPricebookIdEditRoute;
  '/dashboard/proposals/$id/edit': typeof DashboardDashboardProposalsIdEditRoute;
  '/dashboard/proposals/$id/present': typeof DashboardDashboardProposalsIdPresentRoute;
  '/dashboard/purchasing/suppliers/$supplierId': typeof DashboardDashboardPurchasingSuppliersSupplierIdRoute;
  '/dashboard/reporting/reports/$reportId': typeof DashboardDashboardReportingReportsReportIdRoute;
  '/dashboard/reporting/reports/new': typeof DashboardDashboardReportingReportsNewRoute;
  '/dashboard/settings/appointment-forms/$id': typeof DashboardDashboardSettingsAppointmentFormsIdRouteWithChildren;
  '/dashboard/settings/appointment-forms/new': typeof DashboardDashboardSettingsAppointmentFormsNewRoute;
  '/dashboard/settings/billing/credit-memos': typeof DashboardDashboardSettingsBillingCreditMemosRoute;
  '/dashboard/settings/billing/deposits': typeof DashboardDashboardSettingsBillingDepositsRoute;
  '/dashboard/settings/billing/invoices': typeof DashboardDashboardSettingsBillingInvoicesRoute;
  '/dashboard/settings/billing/payments': typeof DashboardDashboardSettingsBillingPaymentsRoute;
  '/dashboard/settings/billing/quickbooks': typeof DashboardDashboardSettingsBillingQuickbooksRoute;
  '/dashboard/settings/billing/receipts': typeof DashboardDashboardSettingsBillingReceiptsRoute;
  '/dashboard/settings/business-units/$id': typeof DashboardDashboardSettingsBusinessUnitsIdRoute;
  '/dashboard/settings/checklist/$id': typeof DashboardDashboardSettingsChecklistIdRouteWithChildren;
  '/dashboard/settings/checklist/new': typeof DashboardDashboardSettingsChecklistNewRoute;
  '/dashboard/settings/company/edit': typeof DashboardDashboardSettingsCompanyEditRoute;
  '/dashboard/settings/contracts/cancellation': typeof DashboardDashboardSettingsContractsCancellationRoute;
  '/dashboard/settings/contracts/costing': typeof DashboardDashboardSettingsContractsCostingRoute;
  '/dashboard/settings/contracts/defaults': typeof DashboardDashboardSettingsContractsDefaultsRoute;
  '/dashboard/settings/contracts/production-kits': typeof DashboardDashboardSettingsContractsProductionKitsRoute;
  '/dashboard/settings/contracts/qbo': typeof DashboardDashboardSettingsContractsQboRoute;
  '/dashboard/settings/contracts/renewal': typeof DashboardDashboardSettingsContractsRenewalRoute;
  '/dashboard/settings/contracts/renewal-cancellation': typeof DashboardDashboardSettingsContractsRenewalCancellationRoute;
  '/dashboard/settings/contracts/reviews': typeof DashboardDashboardSettingsContractsReviewsRoute;
  '/dashboard/settings/customfields/$id': typeof DashboardDashboardSettingsCustomfieldsIdRouteWithChildren;
  '/dashboard/settings/customfields/new': typeof DashboardDashboardSettingsCustomfieldsNewRoute;
  '/dashboard/settings/document-templates/$id': typeof DashboardDashboardSettingsDocumentTemplatesIdRoute;
  '/dashboard/settings/document-templates/new': typeof DashboardDashboardSettingsDocumentTemplatesNewRoute;
  '/dashboard/settings/email-templates/$id': typeof DashboardDashboardSettingsEmailTemplatesIdRoute;
  '/dashboard/settings/email-templates/new': typeof DashboardDashboardSettingsEmailTemplatesNewRoute;
  '/dashboard/settings/groups/$id': typeof DashboardDashboardSettingsGroupsIdRouteWithChildren;
  '/dashboard/settings/groups/new': typeof DashboardDashboardSettingsGroupsNewRoute;
  '/dashboard/settings/job-pipelines/$id': typeof DashboardDashboardSettingsJobPipelinesIdRouteWithChildren;
  '/dashboard/settings/job-pipelines/new': typeof DashboardDashboardSettingsJobPipelinesNewRoute;
  '/dashboard/settings/jobtypes/$id': typeof DashboardDashboardSettingsJobtypesIdRouteWithChildren;
  '/dashboard/settings/jobtypes/new': typeof DashboardDashboardSettingsJobtypesNewRoute;
  '/dashboard/settings/notifications/edit': typeof DashboardDashboardSettingsNotificationsEditRoute;
  '/dashboard/settings/office-settings/edit': typeof DashboardDashboardSettingsOfficeSettingsEditRoute;
  '/dashboard/settings/partner-api/webhooks': typeof DashboardDashboardSettingsPartnerApiWebhooksRouteWithChildren;
  '/dashboard/settings/permissions/$id': typeof DashboardDashboardSettingsPermissionsIdRouteWithChildren;
  '/dashboard/settings/permissions/new': typeof DashboardDashboardSettingsPermissionsNewRoute;
  '/dashboard/settings/reminders/$type': typeof DashboardDashboardSettingsRemindersTypeRoute;
  '/dashboard/settings/reports/templates': typeof DashboardDashboardSettingsReportsTemplatesRoute;
  '/dashboard/settings/scope-of-work/$id': typeof DashboardDashboardSettingsScopeOfWorkIdRouteWithChildren;
  '/dashboard/settings/skills/$id': typeof DashboardDashboardSettingsSkillsIdRouteWithChildren;
  '/dashboard/settings/skills/new': typeof DashboardDashboardSettingsSkillsNewRoute;
  '/dashboard/settings/terms-and-conditions/$id': typeof DashboardDashboardSettingsTermsAndConditionsIdRouteWithChildren;
  '/dashboard/settings/users/$id': typeof DashboardDashboardSettingsUsersIdRouteWithChildren;
  '/dashboard/settings/users/new': typeof DashboardDashboardSettingsUsersNewRoute;
  '/dashboard/settings/webhooks/$id': typeof DashboardDashboardSettingsWebhooksIdRouteWithChildren;
  '/dashboard/settings/webhooks/new': typeof DashboardDashboardSettingsWebhooksNewRoute;
  '/dashboard/technicians/$id/edit': typeof DashboardDashboardTechniciansIdEditRoute;
  '/dashboard/technicians/$id/offboarding': typeof DashboardDashboardTechniciansIdOffboardingRoute;
  '/dashboard/inventory/counts': typeof DashboardDashboardInventoryCountsIndexRoute;
  '/dashboard/inventory/replenishment': typeof DashboardDashboardInventoryReplenishmentIndexRoute;
  '/dashboard/purchasing/suppliers': typeof DashboardDashboardPurchasingSuppliersIndexRoute;
  '/dashboard/reporting/reports': typeof DashboardDashboardReportingReportsIndexRoute;
  '/dashboard/settings/appointment-forms': typeof DashboardDashboardSettingsAppointmentFormsIndexRoute;
  '/dashboard/settings/billing': typeof DashboardDashboardSettingsBillingIndexRoute;
  '/dashboard/settings/business-units': typeof DashboardDashboardSettingsBusinessUnitsIndexRoute;
  '/dashboard/settings/checklist': typeof DashboardDashboardSettingsChecklistIndexRoute;
  '/dashboard/settings/contracts': typeof DashboardDashboardSettingsContractsIndexRoute;
  '/dashboard/settings/document-templates': typeof DashboardDashboardSettingsDocumentTemplatesIndexRoute;
  '/dashboard/settings/job-pipelines': typeof DashboardDashboardSettingsJobPipelinesIndexRoute;
  '/dashboard/settings/templates': typeof DashboardDashboardSettingsTemplatesIndexRoute;
  '/dashboard/contacts/$contactId/addresses/new': typeof DashboardDashboardContactsContactIdAddressesNewRoute;
  '/dashboard/contacts/$contactId/bill-to/new': typeof DashboardDashboardContactsContactIdBillToNewRoute;
  '/dashboard/jobs/$id/appointments/$appointmentId': typeof DashboardDashboardJobsIdAppointmentsAppointmentIdRoute;
  '/dashboard/jobs/$id/appointments/new': typeof DashboardDashboardJobsIdAppointmentsNewRoute;
  '/dashboard/jobs/$id/change-orders/$changeOrderId': typeof DashboardDashboardJobsIdChangeOrdersChangeOrderIdRoute;
  '/dashboard/jobs/$id/change-orders/new': typeof DashboardDashboardJobsIdChangeOrdersNewRoute;
  '/dashboard/jobs/$id/expenses/$expenseId': typeof DashboardDashboardJobsIdExpensesExpenseIdRoute;
  '/dashboard/jobs/$id/expenses/new': typeof DashboardDashboardJobsIdExpensesNewRoute;
  '/dashboard/jobs/$id/invoices/$invoiceId': typeof DashboardDashboardJobsIdInvoicesInvoiceIdRoute;
  '/dashboard/jobs/$id/invoices/new': typeof DashboardDashboardJobsIdInvoicesNewRoute;
  '/dashboard/jobs/$id/payment-schedule/edit': typeof DashboardDashboardJobsIdPaymentScheduleEditRoute;
  '/dashboard/jobs/$id/payment-schedule/new': typeof DashboardDashboardJobsIdPaymentScheduleNewRoute;
  '/dashboard/purchasing/suppliers/$supplierId/edit': typeof DashboardDashboardPurchasingSuppliersSupplierIdEditRoute;
  '/dashboard/reporting/reports/$reportId/edit': typeof DashboardDashboardReportingReportsReportIdEditRoute;
  '/dashboard/settings/appointment-forms/$id/edit': typeof DashboardDashboardSettingsAppointmentFormsIdEditRoute;
  '/dashboard/settings/call-settings/flows/$id': typeof DashboardDashboardSettingsCallSettingsFlowsIdRoute;
  '/dashboard/settings/call-settings/ivr/$id': typeof DashboardDashboardSettingsCallSettingsIvrIdRoute;
  '/dashboard/settings/call-settings/ivr/new': typeof DashboardDashboardSettingsCallSettingsIvrNewRoute;
  '/dashboard/settings/call-settings/numbers/$numberId': typeof DashboardDashboardSettingsCallSettingsNumbersNumberIdRoute;
  '/dashboard/settings/call-settings/team/$section': typeof DashboardDashboardSettingsCallSettingsTeamSectionRoute;
  '/dashboard/settings/checklist/$id/edit': typeof DashboardDashboardSettingsChecklistIdEditRoute;
  '/dashboard/settings/customfields/$id/edit': typeof DashboardDashboardSettingsCustomfieldsIdEditRoute;
  '/dashboard/settings/groups/$id/edit': typeof DashboardDashboardSettingsGroupsIdEditRoute;
  '/dashboard/settings/job-pipelines/$id/edit': typeof DashboardDashboardSettingsJobPipelinesIdEditRoute;
  '/dashboard/settings/jobtypes/$id/edit': typeof DashboardDashboardSettingsJobtypesIdEditRoute;
  '/dashboard/settings/partner-api/webhooks/$id': typeof DashboardDashboardSettingsPartnerApiWebhooksIdRouteWithChildren;
  '/dashboard/settings/partner-api/webhooks/new': typeof DashboardDashboardSettingsPartnerApiWebhooksNewRoute;
  '/dashboard/settings/permissions/$id/edit': typeof DashboardDashboardSettingsPermissionsIdEditRoute;
  '/dashboard/settings/scope-of-work/$id/edit': typeof DashboardDashboardSettingsScopeOfWorkIdEditRoute;
  '/dashboard/settings/skills/$id/edit': typeof DashboardDashboardSettingsSkillsIdEditRoute;
  '/dashboard/settings/templates/estimate/$id': typeof DashboardDashboardSettingsTemplatesEstimateIdRoute;
  '/dashboard/settings/templates/estimate/new': typeof DashboardDashboardSettingsTemplatesEstimateNewRoute;
  '/dashboard/settings/templates/proposal/$id': typeof DashboardDashboardSettingsTemplatesProposalIdRoute;
  '/dashboard/settings/templates/proposal/new': typeof DashboardDashboardSettingsTemplatesProposalNewRoute;
  '/dashboard/settings/terms-and-conditions/$id/edit': typeof DashboardDashboardSettingsTermsAndConditionsIdEditRoute;
  '/dashboard/settings/users/$id/edit': typeof DashboardDashboardSettingsUsersIdEditRoute;
  '/dashboard/settings/webhooks/$id/edit': typeof DashboardDashboardSettingsWebhooksIdEditRoute;
  '/dashboard/contacts/$contactId/addresses/$addressId/edit': typeof DashboardDashboardContactsContactIdAddressesAddressIdEditRoute;
  '/dashboard/contacts/$contactId/bill-to/$billToId/edit': typeof DashboardDashboardContactsContactIdBillToBillToIdEditRoute;
  '/dashboard/settings/partner-api/webhooks/$id/edit': typeof DashboardDashboardSettingsPartnerApiWebhooksIdEditRoute;
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport;
  '/': typeof IndexRoute;
  '/$': typeof SplatRoute;
  '/_dashboard': typeof DashboardRouteWithChildren;
  '/(public)/create-password': typeof publicCreatePasswordRouteWithChildren;
  '/(public)/forgot-password': typeof publicForgotPasswordRoute;
  '/(public)/google-business': typeof publicGoogleBusinessRoute;
  '/(public)/invite': typeof publicInviteRouteWithChildren;
  '/(public)/login': typeof publicLoginRoute;
  '/(public)/onlinebookingresponse': typeof publicOnlinebookingresponseRoute;
  '/(public)/reset-password': typeof publicResetPasswordRoute;
  '/(portal)/portal/forgot': typeof portalPortalForgotRoute;
  '/(portal)/portal/login': typeof portalPortalLoginRoute;
  '/(portal)/portal/register': typeof portalPortalRegisterRoute;
  '/(portal)/portal/reset': typeof portalPortalResetRoute;
  '/(portal)/portal/verify': typeof portalPortalVerifyRoute;
  '/(public)/auth/impersonate-handoff': typeof publicAuthImpersonateHandoffRoute;
  '/(public)/book/$token': typeof publicBookTokenRoute;
  '/(public)/c/$token': typeof publicCTokenRoute;
  '/(public)/change-order/$id': typeof publicChangeOrderIdRoute;
  '/(public)/combined-doc/$token': typeof publicCombinedDocTokenRoute;
  '/(public)/confirm-job/$referenceNo': typeof publicConfirmJobReferenceNoRoute;
  '/(public)/create-password/$token': typeof publicCreatePasswordTokenRoute;
  '/(public)/e/$token': typeof publicETokenRoute;
  '/(public)/estimate/$id': typeof publicEstimateIdRoute;
  '/(public)/form/$id': typeof publicFormIdRoute;
  '/(public)/i/$id': typeof publicIIdRoute;
  '/(public)/invite/$token': typeof publicInviteTokenRoute;
  '/(public)/invoice/$id': typeof publicInvoiceIdRoute;
  '/(public)/j/$referenceNo': typeof publicJReferenceNoRoute;
  '/(public)/job-stories/$token': typeof publicJobStoriesTokenRoute;
  '/(public)/link-phone/$token': typeof publicLinkPhoneTokenRoute;
  '/(public)/onlinebooking/$id': typeof publicOnlinebookingIdRoute;
  '/(public)/onlineform/$id': typeof publicOnlineformIdRoute;
  '/(public)/pay/$token': typeof publicPayTokenRoute;
  '/(public)/payment-method-request/$token': typeof publicPaymentMethodRequestTokenRoute;
  '/(public)/pdf-estimate/$id': typeof publicPdfEstimateIdRoute;
  '/(public)/pdf-invoice/$id': typeof publicPdfInvoiceIdRoute;
  '/(public)/pdf-proposal/$id': typeof publicPdfProposalIdRoute;
  '/(public)/previewinvoice/$id': typeof publicPreviewinvoiceIdRoute;
  '/(public)/previewquote/$id': typeof publicPreviewquoteIdRoute;
  '/(public)/proposal/$id': typeof publicProposalIdRoute;
  '/(public)/quote/$id': typeof publicQuoteIdRoute;
  '/(public)/r/$token': typeof publicRTokenRoute;
  '/(public)/receipt/$id': typeof publicReceiptIdRoute;
  '/(public)/recurring-renewal/$token': typeof publicRecurringRenewalTokenRoute;
  '/(public)/recurring/$token': typeof publicRecurringTokenRoute;
  '/(public)/repair-membership/$token': typeof publicRepairMembershipTokenRoute;
  '/(public)/repair-payment-method/$token': typeof publicRepairPaymentMethodTokenRoute;
  '/(public)/response/$id': typeof publicResponseIdRoute;
  '/(public)/review/$token': typeof publicReviewTokenRoute;
  '/(public)/s/$code': typeof publicSCodeRoute;
  '/(public)/schedule-change/$token': typeof publicScheduleChangeTokenRoute;
  '/(public)/signed/$signedId': typeof publicSignedSignedIdRoute;
  '/(public)/supplier-order/$token': typeof publicSupplierOrderTokenRoute;
  '/(public)/t/$token': typeof publicTTokenRoute;
  '/(public)/tip-option/$id': typeof publicTipOptionIdRoute;
  '/(public)/tip/$id': typeof publicTipIdRoute;
  '/_dashboard/dashboard/audit': typeof DashboardDashboardAuditRoute;
  '/_dashboard/dashboard/board': typeof DashboardDashboardBoardRoute;
  '/_dashboard/dashboard/bookings': typeof DashboardDashboardBookingsRouteWithChildren;
  '/_dashboard/dashboard/calllogs': typeof DashboardDashboardCalllogsRoute;
  '/_dashboard/dashboard/chatbot': typeof DashboardDashboardChatbotRoute;
  '/_dashboard/dashboard/contacts': typeof DashboardDashboardContactsRouteWithChildren;
  '/_dashboard/dashboard/contracts': typeof DashboardDashboardContractsRouteWithChildren;
  '/_dashboard/dashboard/credit-memos': typeof DashboardDashboardCreditMemosRouteWithChildren;
  '/_dashboard/dashboard/crew-members': typeof DashboardDashboardCrewMembersRoute;
  '/_dashboard/dashboard/crews': typeof DashboardDashboardCrewsRouteWithChildren;
  '/_dashboard/dashboard/deposits': typeof DashboardDashboardDepositsRouteWithChildren;
  '/_dashboard/dashboard/dispatch': typeof DashboardDashboardDispatchRoute;
  '/_dashboard/dashboard/equipment': typeof DashboardDashboardEquipmentRoute;
  '/_dashboard/dashboard/equipment-categories': typeof DashboardDashboardEquipmentCategoriesRoute;
  '/_dashboard/dashboard/equipment-descriptions': typeof DashboardDashboardEquipmentDescriptionsRoute;
  '/_dashboard/dashboard/estimates': typeof DashboardDashboardEstimatesRouteWithChildren;
  '/_dashboard/dashboard/executive': typeof DashboardDashboardExecutiveRoute;
  '/_dashboard/dashboard/forms': typeof DashboardDashboardFormsRouteWithChildren;
  '/_dashboard/dashboard/home': typeof DashboardDashboardHomeRoute;
  '/_dashboard/dashboard/inbox': typeof DashboardDashboardInboxRoute;
  '/_dashboard/dashboard/inventory': typeof DashboardDashboardInventoryRouteWithChildren;
  '/_dashboard/dashboard/invoices': typeof DashboardDashboardInvoicesRouteWithChildren;
  '/_dashboard/dashboard/jobs': typeof DashboardDashboardJobsRouteWithChildren;
  '/_dashboard/dashboard/leads': typeof DashboardDashboardLeadsRouteWithChildren;
  '/_dashboard/dashboard/leads-engine': typeof DashboardDashboardLeadsEngineRoute;
  '/_dashboard/dashboard/live-calls': typeof DashboardDashboardLiveCallsRoute;
  '/_dashboard/dashboard/locations': typeof DashboardDashboardLocationsRouteWithChildren;
  '/_dashboard/dashboard/membership-plans': typeof DashboardDashboardMembershipPlansRouteWithChildren;
  '/_dashboard/dashboard/membership-visits': typeof DashboardDashboardMembershipVisitsRoute;
  '/_dashboard/dashboard/memberships': typeof DashboardDashboardMembershipsRouteWithChildren;
  '/_dashboard/dashboard/my-dashboard': typeof DashboardDashboardMyDashboardRoute;
  '/_dashboard/dashboard/my-day': typeof DashboardDashboardMyDayRoute;
  '/_dashboard/dashboard/notifications': typeof DashboardDashboardNotificationsRoute;
  '/_dashboard/dashboard/onboarding': typeof DashboardDashboardOnboardingRoute;
  '/_dashboard/dashboard/operations': typeof DashboardDashboardOperationsRoute;
  '/_dashboard/dashboard/past-due': typeof DashboardDashboardPastDueRoute;
  '/_dashboard/dashboard/payments': typeof DashboardDashboardPaymentsRouteWithChildren;
  '/_dashboard/dashboard/pricebook': typeof DashboardDashboardPricebookRouteWithChildren;
  '/_dashboard/dashboard/projects': typeof DashboardDashboardProjectsRouteWithChildren;
  '/_dashboard/dashboard/promotions': typeof DashboardDashboardPromotionsRoute;
  '/_dashboard/dashboard/proposals': typeof DashboardDashboardProposalsRouteWithChildren;
  '/_dashboard/dashboard/purchasing': typeof DashboardDashboardPurchasingRouteWithChildren;
  '/_dashboard/dashboard/receipts': typeof DashboardDashboardReceiptsRouteWithChildren;
  '/_dashboard/dashboard/recovery-renewals': typeof DashboardDashboardRecoveryRenewalsRoute;
  '/_dashboard/dashboard/recurring-billing': typeof DashboardDashboardRecurringBillingRoute;
  '/_dashboard/dashboard/reminders': typeof DashboardDashboardRemindersRoute;
  '/_dashboard/dashboard/reviews': typeof DashboardDashboardReviewsRoute;
  '/_dashboard/dashboard/routes': typeof DashboardDashboardRoutesRoute;
  '/_dashboard/dashboard/schedule': typeof DashboardDashboardScheduleRoute;
  '/_dashboard/dashboard/settings': typeof DashboardDashboardSettingsRouteWithChildren;
  '/_dashboard/dashboard/stripe': typeof DashboardDashboardStripeRoute;
  '/_dashboard/dashboard/tasks': typeof DashboardDashboardTasksRoute;
  '/_dashboard/dashboard/taxes': typeof DashboardDashboardTaxesRouteWithChildren;
  '/_dashboard/dashboard/team-chat': typeof DashboardDashboardTeamChatRoute;
  '/_dashboard/dashboard/technicians': typeof DashboardDashboardTechniciansRouteWithChildren;
  '/_dashboard/dashboard/timesheet': typeof DashboardDashboardTimesheetRoute;
  '/(portal)/portal/': typeof portalPortalIndexRoute;
  '/(public)/review/': typeof publicReviewIndexRoute;
  '/_dashboard/dashboard/': typeof DashboardDashboardIndexRoute;
  '/(portal)/portal/estimates/$id': typeof portalPortalEstimatesIdRoute;
  '/(portal)/portal/invoices/$id': typeof portalPortalInvoicesIdRoute;
  '/(portal)/portal/memberships/$id': typeof portalPortalMembershipsIdRoute;
  '/(portal)/portal/proposals/$id': typeof portalPortalProposalsIdRoute;
  '/(portal)/portal/visits/book': typeof portalPortalVisitsBookRoute;
  '/(public)/review/$reviewId/$id2': typeof publicReviewReviewIdId2Route;
  '/(public)/tracking/$id/$refno': typeof publicTrackingIdRefnoRoute;
  '/_dashboard/dashboard/ai/otto': typeof DashboardDashboardAiOttoRouteWithChildren;
  '/_dashboard/dashboard/bookings/$bookingId': typeof DashboardDashboardBookingsBookingIdRoute;
  '/_dashboard/dashboard/bookings/new': typeof DashboardDashboardBookingsNewRoute;
  '/_dashboard/dashboard/calendar/$id': typeof DashboardDashboardCalendarIdRoute;
  '/_dashboard/dashboard/calendar/map': typeof DashboardDashboardCalendarMapRoute;
  '/_dashboard/dashboard/calllogs_/reports': typeof DashboardDashboardCalllogsReportsRoute;
  '/_dashboard/dashboard/contacts/$contactId': typeof DashboardDashboardContactsContactIdRouteWithChildren;
  '/_dashboard/dashboard/contacts/new': typeof DashboardDashboardContactsNewRoute;
  '/_dashboard/dashboard/contacts/reports': typeof DashboardDashboardContactsReportsRoute;
  '/_dashboard/dashboard/contacts/tasks': typeof DashboardDashboardContactsTasksRoute;
  '/_dashboard/dashboard/contracts/$id': typeof DashboardDashboardContractsIdRoute;
  '/_dashboard/dashboard/costing/reports': typeof DashboardDashboardCostingReportsRoute;
  '/_dashboard/dashboard/credit-memos/$id': typeof DashboardDashboardCreditMemosIdRoute;
  '/_dashboard/dashboard/credit-memos/new': typeof DashboardDashboardCreditMemosNewRoute;
  '/_dashboard/dashboard/crewmember/$userId': typeof DashboardDashboardCrewmemberUserIdRoute;
  '/_dashboard/dashboard/crews/$id': typeof DashboardDashboardCrewsIdRouteWithChildren;
  '/_dashboard/dashboard/crews/new': typeof DashboardDashboardCrewsNewRoute;
  '/_dashboard/dashboard/deposits/$id': typeof DashboardDashboardDepositsIdRoute;
  '/_dashboard/dashboard/dispatch_/live': typeof DashboardDashboardDispatchLiveRoute;
  '/_dashboard/dashboard/estimates/$id': typeof DashboardDashboardEstimatesIdRouteWithChildren;
  '/_dashboard/dashboard/estimates/new': typeof DashboardDashboardEstimatesNewRoute;
  '/_dashboard/dashboard/estimates/reports': typeof DashboardDashboardEstimatesReportsRoute;
  '/_dashboard/dashboard/forms/$formId': typeof DashboardDashboardFormsFormIdRoute;
  '/_dashboard/dashboard/inventory/locations': typeof DashboardDashboardInventoryLocationsRoute;
  '/_dashboard/dashboard/inventory/my-truck': typeof DashboardDashboardInventoryMyTruckRoute;
  '/_dashboard/dashboard/inventory/overview': typeof DashboardDashboardInventoryOverviewRoute;
  '/_dashboard/dashboard/inventory/stock': typeof DashboardDashboardInventoryStockRoute;
  '/_dashboard/dashboard/inventory/transfers': typeof DashboardDashboardInventoryTransfersRoute;
  '/_dashboard/dashboard/inventory/truck-templates': typeof DashboardDashboardInventoryTruckTemplatesRoute;
  '/_dashboard/dashboard/invoices/$id': typeof DashboardDashboardInvoicesIdRouteWithChildren;
  '/_dashboard/dashboard/invoices/new': typeof DashboardDashboardInvoicesNewRoute;
  '/_dashboard/dashboard/invoices/reports': typeof DashboardDashboardInvoicesReportsRoute;
  '/_dashboard/dashboard/jobform/$id': typeof DashboardDashboardJobformIdRoute;
  '/_dashboard/dashboard/jobform/new': typeof DashboardDashboardJobformNewRoute;
  '/_dashboard/dashboard/jobs/$id': typeof DashboardDashboardJobsIdRouteWithChildren;
  '/_dashboard/dashboard/jobs/budget-vs-actual': typeof DashboardDashboardJobsBudgetVsActualRoute;
  '/_dashboard/dashboard/jobs/new': typeof DashboardDashboardJobsNewRoute;
  '/_dashboard/dashboard/jobs/reports': typeof DashboardDashboardJobsReportsRoute;
  '/_dashboard/dashboard/jobs/service-calls': typeof DashboardDashboardJobsServiceCallsRoute;
  '/_dashboard/dashboard/leads/$leadId': typeof DashboardDashboardLeadsLeadIdRouteWithChildren;
  '/_dashboard/dashboard/leads/new': typeof DashboardDashboardLeadsNewRoute;
  '/_dashboard/dashboard/leads/reports': typeof DashboardDashboardLeadsReportsRoute;
  '/_dashboard/dashboard/locations/$locationId': typeof DashboardDashboardLocationsLocationIdRoute;
  '/_dashboard/dashboard/membership-plans/$id': typeof DashboardDashboardMembershipPlansIdRouteWithChildren;
  '/_dashboard/dashboard/membership-plans/new': typeof DashboardDashboardMembershipPlansNewRoute;
  '/_dashboard/dashboard/memberships/$id': typeof DashboardDashboardMembershipsIdRouteWithChildren;
  '/_dashboard/dashboard/memberships/new': typeof DashboardDashboardMembershipsNewRoute;
  '/_dashboard/dashboard/memberships/reports': typeof DashboardDashboardMembershipsReportsRoute;
  '/_dashboard/dashboard/payments/$id': typeof DashboardDashboardPaymentsIdRoute;
  '/_dashboard/dashboard/pricebook/$id': typeof DashboardDashboardPricebookIdRouteWithChildren;
  '/_dashboard/dashboard/pricebook/categories': typeof DashboardDashboardPricebookCategoriesRoute;
  '/_dashboard/dashboard/pricebook/new': typeof DashboardDashboardPricebookNewRoute;
  '/_dashboard/dashboard/projects/$projectId': typeof DashboardDashboardProjectsProjectIdRoute;
  '/_dashboard/dashboard/proposals/$id': typeof DashboardDashboardProposalsIdRouteWithChildren;
  '/_dashboard/dashboard/proposals/new': typeof DashboardDashboardProposalsNewRoute;
  '/_dashboard/dashboard/purchasing/approvals': typeof DashboardDashboardPurchasingApprovalsRoute;
  '/_dashboard/dashboard/purchasing/bills': typeof DashboardDashboardPurchasingBillsRoute;
  '/_dashboard/dashboard/purchasing/cards': typeof DashboardDashboardPurchasingCardsRoute;
  '/_dashboard/dashboard/purchasing/cost-changes': typeof DashboardDashboardPurchasingCostChangesRoute;
  '/_dashboard/dashboard/purchasing/field': typeof DashboardDashboardPurchasingFieldRoute;
  '/_dashboard/dashboard/purchasing/overview': typeof DashboardDashboardPurchasingOverviewRoute;
  '/_dashboard/dashboard/purchasing/requests': typeof DashboardDashboardPurchasingRequestsRoute;
  '/_dashboard/dashboard/receipts/$id': typeof DashboardDashboardReceiptsIdRoute;
  '/_dashboard/dashboard/reporting/calls': typeof DashboardDashboardReportingCallsRoute;
  '/_dashboard/dashboard/reporting/me': typeof DashboardDashboardReportingMeRoute;
  '/_dashboard/dashboard/reporting/scorecards': typeof DashboardDashboardReportingScorecardsRoute;
  '/_dashboard/dashboard/reporting/targets': typeof DashboardDashboardReportingTargetsRoute;
  '/_dashboard/dashboard/reports/$id': typeof DashboardDashboardReportsIdRoute;
  '/_dashboard/dashboard/reports/new': typeof DashboardDashboardReportsNewRoute;
  '/_dashboard/dashboard/settings/accounting': typeof DashboardDashboardSettingsAccountingRoute;
  '/_dashboard/dashboard/settings/api-keys': typeof DashboardDashboardSettingsApiKeysRoute;
  '/_dashboard/dashboard/settings/appointment-forms': typeof DashboardDashboardSettingsAppointmentFormsRouteWithChildren;
  '/_dashboard/dashboard/settings/billing': typeof DashboardDashboardSettingsBillingRouteWithChildren;
  '/_dashboard/dashboard/settings/booking-links': typeof DashboardDashboardSettingsBookingLinksRoute;
  '/_dashboard/dashboard/settings/booking-services': typeof DashboardDashboardSettingsBookingServicesRoute;
  '/_dashboard/dashboard/settings/booking-windows': typeof DashboardDashboardSettingsBookingWindowsRoute;
  '/_dashboard/dashboard/settings/call-settings': typeof DashboardDashboardSettingsCallSettingsRouteWithChildren;
  '/_dashboard/dashboard/settings/calltree': typeof DashboardDashboardSettingsCalltreeRoute;
  '/_dashboard/dashboard/settings/channels': typeof DashboardDashboardSettingsChannelsRoute;
  '/_dashboard/dashboard/settings/chatbot': typeof DashboardDashboardSettingsChatbotRoute;
  '/_dashboard/dashboard/settings/checklist': typeof DashboardDashboardSettingsChecklistRouteWithChildren;
  '/_dashboard/dashboard/settings/client-portal': typeof DashboardDashboardSettingsClientPortalRoute;
  '/_dashboard/dashboard/settings/company': typeof DashboardDashboardSettingsCompanyRouteWithChildren;
  '/_dashboard/dashboard/settings/connections': typeof DashboardDashboardSettingsConnectionsRoute;
  '/_dashboard/dashboard/settings/contact-statuses': typeof DashboardDashboardSettingsContactStatusesRoute;
  '/_dashboard/dashboard/settings/contracts': typeof DashboardDashboardSettingsContractsRouteWithChildren;
  '/_dashboard/dashboard/settings/customfields': typeof DashboardDashboardSettingsCustomfieldsRouteWithChildren;
  '/_dashboard/dashboard/settings/deferred-revenue': typeof DashboardDashboardSettingsDeferredRevenueRoute;
  '/_dashboard/dashboard/settings/email-accounts': typeof DashboardDashboardSettingsEmailAccountsRoute;
  '/_dashboard/dashboard/settings/estimate-pdf': typeof DashboardDashboardSettingsEstimatePdfRoute;
  '/_dashboard/dashboard/settings/estimate-settings': typeof DashboardDashboardSettingsEstimateSettingsRoute;
  '/_dashboard/dashboard/settings/estimates': typeof DashboardDashboardSettingsEstimatesRoute;
  '/_dashboard/dashboard/settings/groups': typeof DashboardDashboardSettingsGroupsRouteWithChildren;
  '/_dashboard/dashboard/settings/integrations': typeof DashboardDashboardSettingsIntegrationsRoute;
  '/_dashboard/dashboard/settings/job-pipelines': typeof DashboardDashboardSettingsJobPipelinesRouteWithChildren;
  '/_dashboard/dashboard/settings/jobtypes': typeof DashboardDashboardSettingsJobtypesRouteWithChildren;
  '/_dashboard/dashboard/settings/leads': typeof DashboardDashboardSettingsLeadsRoute;
  '/_dashboard/dashboard/settings/logout': typeof DashboardDashboardSettingsLogoutRoute;
  '/_dashboard/dashboard/settings/notifications': typeof DashboardDashboardSettingsNotificationsRouteWithChildren;
  '/_dashboard/dashboard/settings/office-settings': typeof DashboardDashboardSettingsOfficeSettingsRouteWithChildren;
  '/_dashboard/dashboard/settings/oncall': typeof DashboardDashboardSettingsOncallRoute;
  '/_dashboard/dashboard/settings/online-booking': typeof DashboardDashboardSettingsOnlineBookingRoute;
  '/_dashboard/dashboard/settings/payroll-profiles': typeof DashboardDashboardSettingsPayrollProfilesRoute;
  '/_dashboard/dashboard/settings/permissions': typeof DashboardDashboardSettingsPermissionsRouteWithChildren;
  '/_dashboard/dashboard/settings/phone': typeof DashboardDashboardSettingsPhoneRoute;
  '/_dashboard/dashboard/settings/purchasing': typeof DashboardDashboardSettingsPurchasingRoute;
  '/_dashboard/dashboard/settings/quickbooks': typeof DashboardDashboardSettingsQuickbooksRoute;
  '/_dashboard/dashboard/settings/reminders': typeof DashboardDashboardSettingsRemindersRouteWithChildren;
  '/_dashboard/dashboard/settings/reports': typeof DashboardDashboardSettingsReportsRoute;
  '/_dashboard/dashboard/settings/review-platforms': typeof DashboardDashboardSettingsReviewPlatformsRoute;
  '/_dashboard/dashboard/settings/reviews': typeof DashboardDashboardSettingsReviewsRoute;
  '/_dashboard/dashboard/settings/scope-of-work': typeof DashboardDashboardSettingsScopeOfWorkRouteWithChildren;
  '/_dashboard/dashboard/settings/service-areas': typeof DashboardDashboardSettingsServiceAreasRoute;
  '/_dashboard/dashboard/settings/skills': typeof DashboardDashboardSettingsSkillsRouteWithChildren;
  '/_dashboard/dashboard/settings/sms': typeof DashboardDashboardSettingsSmsRoute;
  '/_dashboard/dashboard/settings/subscription': typeof DashboardDashboardSettingsSubscriptionRoute;
  '/_dashboard/dashboard/settings/suppliers': typeof DashboardDashboardSettingsSuppliersRoute;
  '/_dashboard/dashboard/settings/surveys': typeof DashboardDashboardSettingsSurveysRoute;
  '/_dashboard/dashboard/settings/tags': typeof DashboardDashboardSettingsTagsRoute;
  '/_dashboard/dashboard/settings/taxes': typeof DashboardDashboardSettingsTaxesRoute;
  '/_dashboard/dashboard/settings/templates': typeof DashboardDashboardSettingsTemplatesRouteWithChildren;
  '/_dashboard/dashboard/settings/terms-and-conditions': typeof DashboardDashboardSettingsTermsAndConditionsRouteWithChildren;
  '/_dashboard/dashboard/settings/trades': typeof DashboardDashboardSettingsTradesRoute;
  '/_dashboard/dashboard/settings/users': typeof DashboardDashboardSettingsUsersRouteWithChildren;
  '/_dashboard/dashboard/settings/webhooks': typeof DashboardDashboardSettingsWebhooksRouteWithChildren;
  '/_dashboard/dashboard/taxes/overrides': typeof DashboardDashboardTaxesOverridesRoute;
  '/_dashboard/dashboard/taxes/rules': typeof DashboardDashboardTaxesRulesRoute;
  '/_dashboard/dashboard/taxes/simulator': typeof DashboardDashboardTaxesSimulatorRoute;
  '/_dashboard/dashboard/technicians/$id': typeof DashboardDashboardTechniciansIdRouteWithChildren;
  '/_dashboard/dashboard/technicians/new': typeof DashboardDashboardTechniciansNewRoute;
  '/_dashboard/dashboard/technicians/reports': typeof DashboardDashboardTechniciansReportsRoute;
  '/(portal)/portal/account/': typeof portalPortalAccountIndexRoute;
  '/(portal)/portal/documents/': typeof portalPortalDocumentsIndexRoute;
  '/(portal)/portal/equipment/': typeof portalPortalEquipmentIndexRoute;
  '/(portal)/portal/estimates/': typeof portalPortalEstimatesIndexRoute;
  '/(portal)/portal/invoices/': typeof portalPortalInvoicesIndexRoute;
  '/(portal)/portal/memberships/': typeof portalPortalMembershipsIndexRoute;
  '/(portal)/portal/plans/': typeof portalPortalPlansIndexRoute;
  '/(portal)/portal/proposals/': typeof portalPortalProposalsIndexRoute;
  '/(portal)/portal/visits/': typeof portalPortalVisitsIndexRoute;
  '/_dashboard/dashboard/bookings/': typeof DashboardDashboardBookingsIndexRoute;
  '/_dashboard/dashboard/calendar/': typeof DashboardDashboardCalendarIndexRoute;
  '/_dashboard/dashboard/contacts/': typeof DashboardDashboardContactsIndexRoute;
  '/_dashboard/dashboard/credit-memos/': typeof DashboardDashboardCreditMemosIndexRoute;
  '/_dashboard/dashboard/crewmember/': typeof DashboardDashboardCrewmemberIndexRoute;
  '/_dashboard/dashboard/estimates/': typeof DashboardDashboardEstimatesIndexRoute;
  '/_dashboard/dashboard/forms/': typeof DashboardDashboardFormsIndexRoute;
  '/_dashboard/dashboard/inventory/': typeof DashboardDashboardInventoryIndexRoute;
  '/_dashboard/dashboard/invoices/': typeof DashboardDashboardInvoicesIndexRoute;
  '/_dashboard/dashboard/jobform/': typeof DashboardDashboardJobformIndexRoute;
  '/_dashboard/dashboard/jobs/': typeof DashboardDashboardJobsIndexRoute;
  '/_dashboard/dashboard/leads/': typeof DashboardDashboardLeadsIndexRoute;
  '/_dashboard/dashboard/membership-plans/': typeof DashboardDashboardMembershipPlansIndexRoute;
  '/_dashboard/dashboard/memberships/': typeof DashboardDashboardMembershipsIndexRoute;
  '/_dashboard/dashboard/pricebook/': typeof DashboardDashboardPricebookIndexRoute;
  '/_dashboard/dashboard/proposals/': typeof DashboardDashboardProposalsIndexRoute;
  '/_dashboard/dashboard/purchasing/': typeof DashboardDashboardPurchasingIndexRoute;
  '/_dashboard/dashboard/receipts/': typeof DashboardDashboardReceiptsIndexRoute;
  '/_dashboard/dashboard/settings/': typeof DashboardDashboardSettingsIndexRoute;
  '/_dashboard/dashboard/technicians/': typeof DashboardDashboardTechniciansIndexRoute;
  '/_dashboard/dashboard/unscheduled/': typeof DashboardDashboardUnscheduledIndexRoute;
  '/(public)/payment/$id/$id2/$priceid': typeof publicPaymentIdId2PriceidRoute;
  '/_dashboard/dashboard/ai/otto/$reportId': typeof DashboardDashboardAiOttoReportIdRoute;
  '/_dashboard/dashboard/contacts/$contactId/consent-records': typeof DashboardDashboardContactsContactIdConsentRecordsRoute;
  '/_dashboard/dashboard/contacts/$contactId/edit': typeof DashboardDashboardContactsContactIdEditRoute;
  '/_dashboard/dashboard/crews/$id/edit': typeof DashboardDashboardCrewsIdEditRoute;
  '/_dashboard/dashboard/estimates/$id/edit': typeof DashboardDashboardEstimatesIdEditRoute;
  '/_dashboard/dashboard/estimates/$id/payment-schedule': typeof DashboardDashboardEstimatesIdPaymentScheduleRoute;
  '/_dashboard/dashboard/inventory/counts/$countId': typeof DashboardDashboardInventoryCountsCountIdRoute;
  '/_dashboard/dashboard/inventory/items/$itemId': typeof DashboardDashboardInventoryItemsItemIdRoute;
  '/_dashboard/dashboard/inventory/jobs/$jobId': typeof DashboardDashboardInventoryJobsJobIdRoute;
  '/_dashboard/dashboard/inventory/locations_/$locationId': typeof DashboardDashboardInventoryLocationsLocationIdRoute;
  '/_dashboard/dashboard/inventory/pick-lists_/$id': typeof DashboardDashboardInventoryPickListsIdRoute;
  '/_dashboard/dashboard/inventory/pick-lists_/new': typeof DashboardDashboardInventoryPickListsNewRoute;
  '/_dashboard/dashboard/inventory/replenishment/$runId': typeof DashboardDashboardInventoryReplenishmentRunIdRoute;
  '/_dashboard/dashboard/invoices/$id/edit': typeof DashboardDashboardInvoicesIdEditRoute;
  '/_dashboard/dashboard/jobs/$id/edit': typeof DashboardDashboardJobsIdEditRoute;
  '/_dashboard/dashboard/leads/$leadId/edit': typeof DashboardDashboardLeadsLeadIdEditRoute;
  '/_dashboard/dashboard/membership-plans/$id/edit': typeof DashboardDashboardMembershipPlansIdEditRoute;
  '/_dashboard/dashboard/memberships/$id/edit': typeof DashboardDashboardMembershipsIdEditRoute;
  '/_dashboard/dashboard/pricebook/$id/edit': typeof DashboardDashboardPricebookIdEditRoute;
  '/_dashboard/dashboard/proposals/$id/edit': typeof DashboardDashboardProposalsIdEditRoute;
  '/_dashboard/dashboard/proposals/$id/present': typeof DashboardDashboardProposalsIdPresentRoute;
  '/_dashboard/dashboard/purchasing/suppliers/$supplierId': typeof DashboardDashboardPurchasingSuppliersSupplierIdRoute;
  '/_dashboard/dashboard/reporting/reports/$reportId': typeof DashboardDashboardReportingReportsReportIdRoute;
  '/_dashboard/dashboard/reporting/reports/new': typeof DashboardDashboardReportingReportsNewRoute;
  '/_dashboard/dashboard/settings/appointment-forms/$id': typeof DashboardDashboardSettingsAppointmentFormsIdRouteWithChildren;
  '/_dashboard/dashboard/settings/appointment-forms/new': typeof DashboardDashboardSettingsAppointmentFormsNewRoute;
  '/_dashboard/dashboard/settings/billing/credit-memos': typeof DashboardDashboardSettingsBillingCreditMemosRoute;
  '/_dashboard/dashboard/settings/billing/deposits': typeof DashboardDashboardSettingsBillingDepositsRoute;
  '/_dashboard/dashboard/settings/billing/invoices': typeof DashboardDashboardSettingsBillingInvoicesRoute;
  '/_dashboard/dashboard/settings/billing/payments': typeof DashboardDashboardSettingsBillingPaymentsRoute;
  '/_dashboard/dashboard/settings/billing/quickbooks': typeof DashboardDashboardSettingsBillingQuickbooksRoute;
  '/_dashboard/dashboard/settings/billing/receipts': typeof DashboardDashboardSettingsBillingReceiptsRoute;
  '/_dashboard/dashboard/settings/business-units/$id': typeof DashboardDashboardSettingsBusinessUnitsIdRoute;
  '/_dashboard/dashboard/settings/checklist/$id': typeof DashboardDashboardSettingsChecklistIdRouteWithChildren;
  '/_dashboard/dashboard/settings/checklist/new': typeof DashboardDashboardSettingsChecklistNewRoute;
  '/_dashboard/dashboard/settings/company/edit': typeof DashboardDashboardSettingsCompanyEditRoute;
  '/_dashboard/dashboard/settings/contracts/cancellation': typeof DashboardDashboardSettingsContractsCancellationRoute;
  '/_dashboard/dashboard/settings/contracts/costing': typeof DashboardDashboardSettingsContractsCostingRoute;
  '/_dashboard/dashboard/settings/contracts/defaults': typeof DashboardDashboardSettingsContractsDefaultsRoute;
  '/_dashboard/dashboard/settings/contracts/production-kits': typeof DashboardDashboardSettingsContractsProductionKitsRoute;
  '/_dashboard/dashboard/settings/contracts/qbo': typeof DashboardDashboardSettingsContractsQboRoute;
  '/_dashboard/dashboard/settings/contracts/renewal': typeof DashboardDashboardSettingsContractsRenewalRoute;
  '/_dashboard/dashboard/settings/contracts/renewal-cancellation': typeof DashboardDashboardSettingsContractsRenewalCancellationRoute;
  '/_dashboard/dashboard/settings/contracts/reviews': typeof DashboardDashboardSettingsContractsReviewsRoute;
  '/_dashboard/dashboard/settings/customfields/$id': typeof DashboardDashboardSettingsCustomfieldsIdRouteWithChildren;
  '/_dashboard/dashboard/settings/customfields/new': typeof DashboardDashboardSettingsCustomfieldsNewRoute;
  '/_dashboard/dashboard/settings/document-templates/$id': typeof DashboardDashboardSettingsDocumentTemplatesIdRoute;
  '/_dashboard/dashboard/settings/document-templates/new': typeof DashboardDashboardSettingsDocumentTemplatesNewRoute;
  '/_dashboard/dashboard/settings/email-templates/$id': typeof DashboardDashboardSettingsEmailTemplatesIdRoute;
  '/_dashboard/dashboard/settings/email-templates/new': typeof DashboardDashboardSettingsEmailTemplatesNewRoute;
  '/_dashboard/dashboard/settings/groups/$id': typeof DashboardDashboardSettingsGroupsIdRouteWithChildren;
  '/_dashboard/dashboard/settings/groups/new': typeof DashboardDashboardSettingsGroupsNewRoute;
  '/_dashboard/dashboard/settings/job-pipelines/$id': typeof DashboardDashboardSettingsJobPipelinesIdRouteWithChildren;
  '/_dashboard/dashboard/settings/job-pipelines/new': typeof DashboardDashboardSettingsJobPipelinesNewRoute;
  '/_dashboard/dashboard/settings/jobtypes/$id': typeof DashboardDashboardSettingsJobtypesIdRouteWithChildren;
  '/_dashboard/dashboard/settings/jobtypes/new': typeof DashboardDashboardSettingsJobtypesNewRoute;
  '/_dashboard/dashboard/settings/notifications/edit': typeof DashboardDashboardSettingsNotificationsEditRoute;
  '/_dashboard/dashboard/settings/office-settings/edit': typeof DashboardDashboardSettingsOfficeSettingsEditRoute;
  '/_dashboard/dashboard/settings/partner-api/webhooks': typeof DashboardDashboardSettingsPartnerApiWebhooksRouteWithChildren;
  '/_dashboard/dashboard/settings/permissions/$id': typeof DashboardDashboardSettingsPermissionsIdRouteWithChildren;
  '/_dashboard/dashboard/settings/permissions/new': typeof DashboardDashboardSettingsPermissionsNewRoute;
  '/_dashboard/dashboard/settings/reminders/$type': typeof DashboardDashboardSettingsRemindersTypeRoute;
  '/_dashboard/dashboard/settings/reports_/templates': typeof DashboardDashboardSettingsReportsTemplatesRoute;
  '/_dashboard/dashboard/settings/scope-of-work/$id': typeof DashboardDashboardSettingsScopeOfWorkIdRouteWithChildren;
  '/_dashboard/dashboard/settings/skills/$id': typeof DashboardDashboardSettingsSkillsIdRouteWithChildren;
  '/_dashboard/dashboard/settings/skills/new': typeof DashboardDashboardSettingsSkillsNewRoute;
  '/_dashboard/dashboard/settings/terms-and-conditions/$id': typeof DashboardDashboardSettingsTermsAndConditionsIdRouteWithChildren;
  '/_dashboard/dashboard/settings/users/$id': typeof DashboardDashboardSettingsUsersIdRouteWithChildren;
  '/_dashboard/dashboard/settings/users/new': typeof DashboardDashboardSettingsUsersNewRoute;
  '/_dashboard/dashboard/settings/webhooks/$id': typeof DashboardDashboardSettingsWebhooksIdRouteWithChildren;
  '/_dashboard/dashboard/settings/webhooks/new': typeof DashboardDashboardSettingsWebhooksNewRoute;
  '/_dashboard/dashboard/technicians/$id/edit': typeof DashboardDashboardTechniciansIdEditRoute;
  '/_dashboard/dashboard/technicians/$id/offboarding': typeof DashboardDashboardTechniciansIdOffboardingRoute;
  '/_dashboard/dashboard/inventory/counts/': typeof DashboardDashboardInventoryCountsIndexRoute;
  '/_dashboard/dashboard/inventory/replenishment/': typeof DashboardDashboardInventoryReplenishmentIndexRoute;
  '/_dashboard/dashboard/purchasing/suppliers/': typeof DashboardDashboardPurchasingSuppliersIndexRoute;
  '/_dashboard/dashboard/reporting/reports/': typeof DashboardDashboardReportingReportsIndexRoute;
  '/_dashboard/dashboard/settings/appointment-forms/': typeof DashboardDashboardSettingsAppointmentFormsIndexRoute;
  '/_dashboard/dashboard/settings/billing/': typeof DashboardDashboardSettingsBillingIndexRoute;
  '/_dashboard/dashboard/settings/business-units/': typeof DashboardDashboardSettingsBusinessUnitsIndexRoute;
  '/_dashboard/dashboard/settings/checklist/': typeof DashboardDashboardSettingsChecklistIndexRoute;
  '/_dashboard/dashboard/settings/contracts/': typeof DashboardDashboardSettingsContractsIndexRoute;
  '/_dashboard/dashboard/settings/document-templates/': typeof DashboardDashboardSettingsDocumentTemplatesIndexRoute;
  '/_dashboard/dashboard/settings/job-pipelines/': typeof DashboardDashboardSettingsJobPipelinesIndexRoute;
  '/_dashboard/dashboard/settings/templates/': typeof DashboardDashboardSettingsTemplatesIndexRoute;
  '/_dashboard/dashboard/contacts/$contactId/addresses/new': typeof DashboardDashboardContactsContactIdAddressesNewRoute;
  '/_dashboard/dashboard/contacts/$contactId/bill-to/new': typeof DashboardDashboardContactsContactIdBillToNewRoute;
  '/_dashboard/dashboard/jobs/$id/appointments/$appointmentId': typeof DashboardDashboardJobsIdAppointmentsAppointmentIdRoute;
  '/_dashboard/dashboard/jobs/$id/appointments/new': typeof DashboardDashboardJobsIdAppointmentsNewRoute;
  '/_dashboard/dashboard/jobs/$id/change-orders/$changeOrderId': typeof DashboardDashboardJobsIdChangeOrdersChangeOrderIdRoute;
  '/_dashboard/dashboard/jobs/$id/change-orders/new': typeof DashboardDashboardJobsIdChangeOrdersNewRoute;
  '/_dashboard/dashboard/jobs/$id/expenses/$expenseId': typeof DashboardDashboardJobsIdExpensesExpenseIdRoute;
  '/_dashboard/dashboard/jobs/$id/expenses/new': typeof DashboardDashboardJobsIdExpensesNewRoute;
  '/_dashboard/dashboard/jobs/$id/invoices/$invoiceId': typeof DashboardDashboardJobsIdInvoicesInvoiceIdRoute;
  '/_dashboard/dashboard/jobs/$id/invoices/new': typeof DashboardDashboardJobsIdInvoicesNewRoute;
  '/_dashboard/dashboard/jobs/$id/payment-schedule/edit': typeof DashboardDashboardJobsIdPaymentScheduleEditRoute;
  '/_dashboard/dashboard/jobs/$id/payment-schedule/new': typeof DashboardDashboardJobsIdPaymentScheduleNewRoute;
  '/_dashboard/dashboard/purchasing/suppliers/$supplierId_/edit': typeof DashboardDashboardPurchasingSuppliersSupplierIdEditRoute;
  '/_dashboard/dashboard/reporting/reports/$reportId_/edit': typeof DashboardDashboardReportingReportsReportIdEditRoute;
  '/_dashboard/dashboard/settings/appointment-forms/$id/edit': typeof DashboardDashboardSettingsAppointmentFormsIdEditRoute;
  '/_dashboard/dashboard/settings/call-settings/flows/$id': typeof DashboardDashboardSettingsCallSettingsFlowsIdRoute;
  '/_dashboard/dashboard/settings/call-settings/ivr/$id': typeof DashboardDashboardSettingsCallSettingsIvrIdRoute;
  '/_dashboard/dashboard/settings/call-settings/ivr/new': typeof DashboardDashboardSettingsCallSettingsIvrNewRoute;
  '/_dashboard/dashboard/settings/call-settings/numbers/$numberId': typeof DashboardDashboardSettingsCallSettingsNumbersNumberIdRoute;
  '/_dashboard/dashboard/settings/call-settings/team/$section': typeof DashboardDashboardSettingsCallSettingsTeamSectionRoute;
  '/_dashboard/dashboard/settings/checklist/$id/edit': typeof DashboardDashboardSettingsChecklistIdEditRoute;
  '/_dashboard/dashboard/settings/customfields/$id/edit': typeof DashboardDashboardSettingsCustomfieldsIdEditRoute;
  '/_dashboard/dashboard/settings/groups/$id/edit': typeof DashboardDashboardSettingsGroupsIdEditRoute;
  '/_dashboard/dashboard/settings/job-pipelines/$id/edit': typeof DashboardDashboardSettingsJobPipelinesIdEditRoute;
  '/_dashboard/dashboard/settings/jobtypes/$id/edit': typeof DashboardDashboardSettingsJobtypesIdEditRoute;
  '/_dashboard/dashboard/settings/partner-api/webhooks/$id': typeof DashboardDashboardSettingsPartnerApiWebhooksIdRouteWithChildren;
  '/_dashboard/dashboard/settings/partner-api/webhooks/new': typeof DashboardDashboardSettingsPartnerApiWebhooksNewRoute;
  '/_dashboard/dashboard/settings/permissions/$id/edit': typeof DashboardDashboardSettingsPermissionsIdEditRoute;
  '/_dashboard/dashboard/settings/scope-of-work/$id/edit': typeof DashboardDashboardSettingsScopeOfWorkIdEditRoute;
  '/_dashboard/dashboard/settings/skills/$id/edit': typeof DashboardDashboardSettingsSkillsIdEditRoute;
  '/_dashboard/dashboard/settings/templates/estimate/$id': typeof DashboardDashboardSettingsTemplatesEstimateIdRoute;
  '/_dashboard/dashboard/settings/templates/estimate/new': typeof DashboardDashboardSettingsTemplatesEstimateNewRoute;
  '/_dashboard/dashboard/settings/templates/proposal/$id': typeof DashboardDashboardSettingsTemplatesProposalIdRoute;
  '/_dashboard/dashboard/settings/templates/proposal/new': typeof DashboardDashboardSettingsTemplatesProposalNewRoute;
  '/_dashboard/dashboard/settings/terms-and-conditions/$id/edit': typeof DashboardDashboardSettingsTermsAndConditionsIdEditRoute;
  '/_dashboard/dashboard/settings/users/$id/edit': typeof DashboardDashboardSettingsUsersIdEditRoute;
  '/_dashboard/dashboard/settings/webhooks/$id/edit': typeof DashboardDashboardSettingsWebhooksIdEditRoute;
  '/_dashboard/dashboard/contacts/$contactId/addresses/$addressId/edit': typeof DashboardDashboardContactsContactIdAddressesAddressIdEditRoute;
  '/_dashboard/dashboard/contacts/$contactId/bill-to/$billToId/edit': typeof DashboardDashboardContactsContactIdBillToBillToIdEditRoute;
  '/_dashboard/dashboard/settings/partner-api/webhooks/$id/edit': typeof DashboardDashboardSettingsPartnerApiWebhooksIdEditRoute;
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath;
  fullPaths:
    | '/'
    | '/$'
    | '/create-password'
    | '/forgot-password'
    | '/google-business'
    | '/invite'
    | '/login'
    | '/onlinebookingresponse'
    | '/reset-password'
    | '/portal/forgot'
    | '/portal/login'
    | '/portal/register'
    | '/portal/reset'
    | '/portal/verify'
    | '/auth/impersonate-handoff'
    | '/book/$token'
    | '/c/$token'
    | '/change-order/$id'
    | '/combined-doc/$token'
    | '/confirm-job/$referenceNo'
    | '/create-password/$token'
    | '/e/$token'
    | '/estimate/$id'
    | '/form/$id'
    | '/i/$id'
    | '/invite/$token'
    | '/invoice/$id'
    | '/j/$referenceNo'
    | '/job-stories/$token'
    | '/link-phone/$token'
    | '/onlinebooking/$id'
    | '/onlineform/$id'
    | '/pay/$token'
    | '/payment-method-request/$token'
    | '/pdf-estimate/$id'
    | '/pdf-invoice/$id'
    | '/pdf-proposal/$id'
    | '/previewinvoice/$id'
    | '/previewquote/$id'
    | '/proposal/$id'
    | '/quote/$id'
    | '/r/$token'
    | '/receipt/$id'
    | '/recurring-renewal/$token'
    | '/recurring/$token'
    | '/repair-membership/$token'
    | '/repair-payment-method/$token'
    | '/response/$id'
    | '/review/$token'
    | '/s/$code'
    | '/schedule-change/$token'
    | '/signed/$signedId'
    | '/supplier-order/$token'
    | '/t/$token'
    | '/tip-option/$id'
    | '/tip/$id'
    | '/dashboard/audit'
    | '/dashboard/board'
    | '/dashboard/bookings'
    | '/dashboard/calllogs'
    | '/dashboard/chatbot'
    | '/dashboard/contacts'
    | '/dashboard/contracts'
    | '/dashboard/credit-memos'
    | '/dashboard/crew-members'
    | '/dashboard/crews'
    | '/dashboard/deposits'
    | '/dashboard/dispatch'
    | '/dashboard/equipment'
    | '/dashboard/equipment-categories'
    | '/dashboard/equipment-descriptions'
    | '/dashboard/estimates'
    | '/dashboard/executive'
    | '/dashboard/forms'
    | '/dashboard/home'
    | '/dashboard/inbox'
    | '/dashboard/inventory'
    | '/dashboard/invoices'
    | '/dashboard/jobs'
    | '/dashboard/leads'
    | '/dashboard/leads-engine'
    | '/dashboard/live-calls'
    | '/dashboard/locations'
    | '/dashboard/membership-plans'
    | '/dashboard/membership-visits'
    | '/dashboard/memberships'
    | '/dashboard/my-dashboard'
    | '/dashboard/my-day'
    | '/dashboard/notifications'
    | '/dashboard/onboarding'
    | '/dashboard/operations'
    | '/dashboard/past-due'
    | '/dashboard/payments'
    | '/dashboard/pricebook'
    | '/dashboard/projects'
    | '/dashboard/promotions'
    | '/dashboard/proposals'
    | '/dashboard/purchasing'
    | '/dashboard/receipts'
    | '/dashboard/recovery-renewals'
    | '/dashboard/recurring-billing'
    | '/dashboard/reminders'
    | '/dashboard/reviews'
    | '/dashboard/routes'
    | '/dashboard/schedule'
    | '/dashboard/settings'
    | '/dashboard/stripe'
    | '/dashboard/tasks'
    | '/dashboard/taxes'
    | '/dashboard/team-chat'
    | '/dashboard/technicians'
    | '/dashboard/timesheet'
    | '/portal/'
    | '/review/'
    | '/dashboard/'
    | '/portal/estimates/$id'
    | '/portal/invoices/$id'
    | '/portal/memberships/$id'
    | '/portal/proposals/$id'
    | '/portal/visits/book'
    | '/review/$reviewId/$id2'
    | '/tracking/$id/$refno'
    | '/dashboard/ai/otto'
    | '/dashboard/bookings/$bookingId'
    | '/dashboard/bookings/new'
    | '/dashboard/calendar/$id'
    | '/dashboard/calendar/map'
    | '/dashboard/calllogs/reports'
    | '/dashboard/contacts/$contactId'
    | '/dashboard/contacts/new'
    | '/dashboard/contacts/reports'
    | '/dashboard/contacts/tasks'
    | '/dashboard/contracts/$id'
    | '/dashboard/costing/reports'
    | '/dashboard/credit-memos/$id'
    | '/dashboard/credit-memos/new'
    | '/dashboard/crewmember/$userId'
    | '/dashboard/crews/$id'
    | '/dashboard/crews/new'
    | '/dashboard/deposits/$id'
    | '/dashboard/dispatch/live'
    | '/dashboard/estimates/$id'
    | '/dashboard/estimates/new'
    | '/dashboard/estimates/reports'
    | '/dashboard/forms/$formId'
    | '/dashboard/inventory/locations'
    | '/dashboard/inventory/my-truck'
    | '/dashboard/inventory/overview'
    | '/dashboard/inventory/stock'
    | '/dashboard/inventory/transfers'
    | '/dashboard/inventory/truck-templates'
    | '/dashboard/invoices/$id'
    | '/dashboard/invoices/new'
    | '/dashboard/invoices/reports'
    | '/dashboard/jobform/$id'
    | '/dashboard/jobform/new'
    | '/dashboard/jobs/$id'
    | '/dashboard/jobs/budget-vs-actual'
    | '/dashboard/jobs/new'
    | '/dashboard/jobs/reports'
    | '/dashboard/jobs/service-calls'
    | '/dashboard/leads/$leadId'
    | '/dashboard/leads/new'
    | '/dashboard/leads/reports'
    | '/dashboard/locations/$locationId'
    | '/dashboard/membership-plans/$id'
    | '/dashboard/membership-plans/new'
    | '/dashboard/memberships/$id'
    | '/dashboard/memberships/new'
    | '/dashboard/memberships/reports'
    | '/dashboard/payments/$id'
    | '/dashboard/pricebook/$id'
    | '/dashboard/pricebook/categories'
    | '/dashboard/pricebook/new'
    | '/dashboard/projects/$projectId'
    | '/dashboard/proposals/$id'
    | '/dashboard/proposals/new'
    | '/dashboard/purchasing/approvals'
    | '/dashboard/purchasing/bills'
    | '/dashboard/purchasing/cards'
    | '/dashboard/purchasing/cost-changes'
    | '/dashboard/purchasing/field'
    | '/dashboard/purchasing/overview'
    | '/dashboard/purchasing/requests'
    | '/dashboard/receipts/$id'
    | '/dashboard/reporting/calls'
    | '/dashboard/reporting/me'
    | '/dashboard/reporting/scorecards'
    | '/dashboard/reporting/targets'
    | '/dashboard/reports/$id'
    | '/dashboard/reports/new'
    | '/dashboard/settings/accounting'
    | '/dashboard/settings/api-keys'
    | '/dashboard/settings/appointment-forms'
    | '/dashboard/settings/billing'
    | '/dashboard/settings/booking-links'
    | '/dashboard/settings/booking-services'
    | '/dashboard/settings/booking-windows'
    | '/dashboard/settings/call-settings'
    | '/dashboard/settings/calltree'
    | '/dashboard/settings/channels'
    | '/dashboard/settings/chatbot'
    | '/dashboard/settings/checklist'
    | '/dashboard/settings/client-portal'
    | '/dashboard/settings/company'
    | '/dashboard/settings/connections'
    | '/dashboard/settings/contact-statuses'
    | '/dashboard/settings/contracts'
    | '/dashboard/settings/customfields'
    | '/dashboard/settings/deferred-revenue'
    | '/dashboard/settings/email-accounts'
    | '/dashboard/settings/estimate-pdf'
    | '/dashboard/settings/estimate-settings'
    | '/dashboard/settings/estimates'
    | '/dashboard/settings/groups'
    | '/dashboard/settings/integrations'
    | '/dashboard/settings/job-pipelines'
    | '/dashboard/settings/jobtypes'
    | '/dashboard/settings/leads'
    | '/dashboard/settings/logout'
    | '/dashboard/settings/notifications'
    | '/dashboard/settings/office-settings'
    | '/dashboard/settings/oncall'
    | '/dashboard/settings/online-booking'
    | '/dashboard/settings/payroll-profiles'
    | '/dashboard/settings/permissions'
    | '/dashboard/settings/phone'
    | '/dashboard/settings/purchasing'
    | '/dashboard/settings/quickbooks'
    | '/dashboard/settings/reminders'
    | '/dashboard/settings/reports'
    | '/dashboard/settings/review-platforms'
    | '/dashboard/settings/reviews'
    | '/dashboard/settings/scope-of-work'
    | '/dashboard/settings/service-areas'
    | '/dashboard/settings/skills'
    | '/dashboard/settings/sms'
    | '/dashboard/settings/subscription'
    | '/dashboard/settings/suppliers'
    | '/dashboard/settings/surveys'
    | '/dashboard/settings/tags'
    | '/dashboard/settings/taxes'
    | '/dashboard/settings/templates'
    | '/dashboard/settings/terms-and-conditions'
    | '/dashboard/settings/trades'
    | '/dashboard/settings/users'
    | '/dashboard/settings/webhooks'
    | '/dashboard/taxes/overrides'
    | '/dashboard/taxes/rules'
    | '/dashboard/taxes/simulator'
    | '/dashboard/technicians/$id'
    | '/dashboard/technicians/new'
    | '/dashboard/technicians/reports'
    | '/portal/account/'
    | '/portal/documents/'
    | '/portal/equipment/'
    | '/portal/estimates/'
    | '/portal/invoices/'
    | '/portal/memberships/'
    | '/portal/plans/'
    | '/portal/proposals/'
    | '/portal/visits/'
    | '/dashboard/bookings/'
    | '/dashboard/calendar/'
    | '/dashboard/contacts/'
    | '/dashboard/credit-memos/'
    | '/dashboard/crewmember/'
    | '/dashboard/estimates/'
    | '/dashboard/forms/'
    | '/dashboard/inventory/'
    | '/dashboard/invoices/'
    | '/dashboard/jobform/'
    | '/dashboard/jobs/'
    | '/dashboard/leads/'
    | '/dashboard/membership-plans/'
    | '/dashboard/memberships/'
    | '/dashboard/pricebook/'
    | '/dashboard/proposals/'
    | '/dashboard/purchasing/'
    | '/dashboard/receipts/'
    | '/dashboard/settings/'
    | '/dashboard/technicians/'
    | '/dashboard/unscheduled/'
    | '/payment/$id/$id2/$priceid'
    | '/dashboard/ai/otto/$reportId'
    | '/dashboard/contacts/$contactId/consent-records'
    | '/dashboard/contacts/$contactId/edit'
    | '/dashboard/crews/$id/edit'
    | '/dashboard/estimates/$id/edit'
    | '/dashboard/estimates/$id/payment-schedule'
    | '/dashboard/inventory/counts/$countId'
    | '/dashboard/inventory/items/$itemId'
    | '/dashboard/inventory/jobs/$jobId'
    | '/dashboard/inventory/locations/$locationId'
    | '/dashboard/inventory/pick-lists/$id'
    | '/dashboard/inventory/pick-lists/new'
    | '/dashboard/inventory/replenishment/$runId'
    | '/dashboard/invoices/$id/edit'
    | '/dashboard/jobs/$id/edit'
    | '/dashboard/leads/$leadId/edit'
    | '/dashboard/membership-plans/$id/edit'
    | '/dashboard/memberships/$id/edit'
    | '/dashboard/pricebook/$id/edit'
    | '/dashboard/proposals/$id/edit'
    | '/dashboard/proposals/$id/present'
    | '/dashboard/purchasing/suppliers/$supplierId'
    | '/dashboard/reporting/reports/$reportId'
    | '/dashboard/reporting/reports/new'
    | '/dashboard/settings/appointment-forms/$id'
    | '/dashboard/settings/appointment-forms/new'
    | '/dashboard/settings/billing/credit-memos'
    | '/dashboard/settings/billing/deposits'
    | '/dashboard/settings/billing/invoices'
    | '/dashboard/settings/billing/payments'
    | '/dashboard/settings/billing/quickbooks'
    | '/dashboard/settings/billing/receipts'
    | '/dashboard/settings/business-units/$id'
    | '/dashboard/settings/checklist/$id'
    | '/dashboard/settings/checklist/new'
    | '/dashboard/settings/company/edit'
    | '/dashboard/settings/contracts/cancellation'
    | '/dashboard/settings/contracts/costing'
    | '/dashboard/settings/contracts/defaults'
    | '/dashboard/settings/contracts/production-kits'
    | '/dashboard/settings/contracts/qbo'
    | '/dashboard/settings/contracts/renewal'
    | '/dashboard/settings/contracts/renewal-cancellation'
    | '/dashboard/settings/contracts/reviews'
    | '/dashboard/settings/customfields/$id'
    | '/dashboard/settings/customfields/new'
    | '/dashboard/settings/document-templates/$id'
    | '/dashboard/settings/document-templates/new'
    | '/dashboard/settings/email-templates/$id'
    | '/dashboard/settings/email-templates/new'
    | '/dashboard/settings/groups/$id'
    | '/dashboard/settings/groups/new'
    | '/dashboard/settings/job-pipelines/$id'
    | '/dashboard/settings/job-pipelines/new'
    | '/dashboard/settings/jobtypes/$id'
    | '/dashboard/settings/jobtypes/new'
    | '/dashboard/settings/notifications/edit'
    | '/dashboard/settings/office-settings/edit'
    | '/dashboard/settings/partner-api/webhooks'
    | '/dashboard/settings/permissions/$id'
    | '/dashboard/settings/permissions/new'
    | '/dashboard/settings/reminders/$type'
    | '/dashboard/settings/reports/templates'
    | '/dashboard/settings/scope-of-work/$id'
    | '/dashboard/settings/skills/$id'
    | '/dashboard/settings/skills/new'
    | '/dashboard/settings/terms-and-conditions/$id'
    | '/dashboard/settings/users/$id'
    | '/dashboard/settings/users/new'
    | '/dashboard/settings/webhooks/$id'
    | '/dashboard/settings/webhooks/new'
    | '/dashboard/technicians/$id/edit'
    | '/dashboard/technicians/$id/offboarding'
    | '/dashboard/inventory/counts/'
    | '/dashboard/inventory/replenishment/'
    | '/dashboard/purchasing/suppliers/'
    | '/dashboard/reporting/reports/'
    | '/dashboard/settings/appointment-forms/'
    | '/dashboard/settings/billing/'
    | '/dashboard/settings/business-units/'
    | '/dashboard/settings/checklist/'
    | '/dashboard/settings/contracts/'
    | '/dashboard/settings/document-templates/'
    | '/dashboard/settings/job-pipelines/'
    | '/dashboard/settings/templates/'
    | '/dashboard/contacts/$contactId/addresses/new'
    | '/dashboard/contacts/$contactId/bill-to/new'
    | '/dashboard/jobs/$id/appointments/$appointmentId'
    | '/dashboard/jobs/$id/appointments/new'
    | '/dashboard/jobs/$id/change-orders/$changeOrderId'
    | '/dashboard/jobs/$id/change-orders/new'
    | '/dashboard/jobs/$id/expenses/$expenseId'
    | '/dashboard/jobs/$id/expenses/new'
    | '/dashboard/jobs/$id/invoices/$invoiceId'
    | '/dashboard/jobs/$id/invoices/new'
    | '/dashboard/jobs/$id/payment-schedule/edit'
    | '/dashboard/jobs/$id/payment-schedule/new'
    | '/dashboard/purchasing/suppliers/$supplierId/edit'
    | '/dashboard/reporting/reports/$reportId/edit'
    | '/dashboard/settings/appointment-forms/$id/edit'
    | '/dashboard/settings/call-settings/flows/$id'
    | '/dashboard/settings/call-settings/ivr/$id'
    | '/dashboard/settings/call-settings/ivr/new'
    | '/dashboard/settings/call-settings/numbers/$numberId'
    | '/dashboard/settings/call-settings/team/$section'
    | '/dashboard/settings/checklist/$id/edit'
    | '/dashboard/settings/customfields/$id/edit'
    | '/dashboard/settings/groups/$id/edit'
    | '/dashboard/settings/job-pipelines/$id/edit'
    | '/dashboard/settings/jobtypes/$id/edit'
    | '/dashboard/settings/partner-api/webhooks/$id'
    | '/dashboard/settings/partner-api/webhooks/new'
    | '/dashboard/settings/permissions/$id/edit'
    | '/dashboard/settings/scope-of-work/$id/edit'
    | '/dashboard/settings/skills/$id/edit'
    | '/dashboard/settings/templates/estimate/$id'
    | '/dashboard/settings/templates/estimate/new'
    | '/dashboard/settings/templates/proposal/$id'
    | '/dashboard/settings/templates/proposal/new'
    | '/dashboard/settings/terms-and-conditions/$id/edit'
    | '/dashboard/settings/users/$id/edit'
    | '/dashboard/settings/webhooks/$id/edit'
    | '/dashboard/contacts/$contactId/addresses/$addressId/edit'
    | '/dashboard/contacts/$contactId/bill-to/$billToId/edit'
    | '/dashboard/settings/partner-api/webhooks/$id/edit';
  fileRoutesByTo: FileRoutesByTo;
  to:
    | '/'
    | '/$'
    | '/create-password'
    | '/forgot-password'
    | '/google-business'
    | '/invite'
    | '/login'
    | '/onlinebookingresponse'
    | '/reset-password'
    | '/portal/forgot'
    | '/portal/login'
    | '/portal/register'
    | '/portal/reset'
    | '/portal/verify'
    | '/auth/impersonate-handoff'
    | '/book/$token'
    | '/c/$token'
    | '/change-order/$id'
    | '/combined-doc/$token'
    | '/confirm-job/$referenceNo'
    | '/create-password/$token'
    | '/e/$token'
    | '/estimate/$id'
    | '/form/$id'
    | '/i/$id'
    | '/invite/$token'
    | '/invoice/$id'
    | '/j/$referenceNo'
    | '/job-stories/$token'
    | '/link-phone/$token'
    | '/onlinebooking/$id'
    | '/onlineform/$id'
    | '/pay/$token'
    | '/payment-method-request/$token'
    | '/pdf-estimate/$id'
    | '/pdf-invoice/$id'
    | '/pdf-proposal/$id'
    | '/previewinvoice/$id'
    | '/previewquote/$id'
    | '/proposal/$id'
    | '/quote/$id'
    | '/r/$token'
    | '/receipt/$id'
    | '/recurring-renewal/$token'
    | '/recurring/$token'
    | '/repair-membership/$token'
    | '/repair-payment-method/$token'
    | '/response/$id'
    | '/review/$token'
    | '/s/$code'
    | '/schedule-change/$token'
    | '/signed/$signedId'
    | '/supplier-order/$token'
    | '/t/$token'
    | '/tip-option/$id'
    | '/tip/$id'
    | '/dashboard/audit'
    | '/dashboard/board'
    | '/dashboard/calllogs'
    | '/dashboard/chatbot'
    | '/dashboard/contracts'
    | '/dashboard/crew-members'
    | '/dashboard/crews'
    | '/dashboard/deposits'
    | '/dashboard/dispatch'
    | '/dashboard/equipment'
    | '/dashboard/equipment-categories'
    | '/dashboard/equipment-descriptions'
    | '/dashboard/executive'
    | '/dashboard/home'
    | '/dashboard/inbox'
    | '/dashboard/leads-engine'
    | '/dashboard/live-calls'
    | '/dashboard/locations'
    | '/dashboard/membership-visits'
    | '/dashboard/my-dashboard'
    | '/dashboard/my-day'
    | '/dashboard/notifications'
    | '/dashboard/onboarding'
    | '/dashboard/operations'
    | '/dashboard/past-due'
    | '/dashboard/payments'
    | '/dashboard/projects'
    | '/dashboard/promotions'
    | '/dashboard/recovery-renewals'
    | '/dashboard/recurring-billing'
    | '/dashboard/reminders'
    | '/dashboard/reviews'
    | '/dashboard/routes'
    | '/dashboard/schedule'
    | '/dashboard/stripe'
    | '/dashboard/tasks'
    | '/dashboard/taxes'
    | '/dashboard/team-chat'
    | '/dashboard/timesheet'
    | '/portal'
    | '/review'
    | '/dashboard'
    | '/portal/estimates/$id'
    | '/portal/invoices/$id'
    | '/portal/memberships/$id'
    | '/portal/proposals/$id'
    | '/portal/visits/book'
    | '/review/$reviewId/$id2'
    | '/tracking/$id/$refno'
    | '/dashboard/ai/otto'
    | '/dashboard/bookings/$bookingId'
    | '/dashboard/bookings/new'
    | '/dashboard/calendar/$id'
    | '/dashboard/calendar/map'
    | '/dashboard/calllogs/reports'
    | '/dashboard/contacts/$contactId'
    | '/dashboard/contacts/new'
    | '/dashboard/contacts/reports'
    | '/dashboard/contacts/tasks'
    | '/dashboard/contracts/$id'
    | '/dashboard/costing/reports'
    | '/dashboard/credit-memos/$id'
    | '/dashboard/credit-memos/new'
    | '/dashboard/crewmember/$userId'
    | '/dashboard/crews/$id'
    | '/dashboard/crews/new'
    | '/dashboard/deposits/$id'
    | '/dashboard/dispatch/live'
    | '/dashboard/estimates/$id'
    | '/dashboard/estimates/new'
    | '/dashboard/estimates/reports'
    | '/dashboard/forms/$formId'
    | '/dashboard/inventory/locations'
    | '/dashboard/inventory/my-truck'
    | '/dashboard/inventory/overview'
    | '/dashboard/inventory/stock'
    | '/dashboard/inventory/transfers'
    | '/dashboard/inventory/truck-templates'
    | '/dashboard/invoices/$id'
    | '/dashboard/invoices/new'
    | '/dashboard/invoices/reports'
    | '/dashboard/jobform/$id'
    | '/dashboard/jobform/new'
    | '/dashboard/jobs/$id'
    | '/dashboard/jobs/budget-vs-actual'
    | '/dashboard/jobs/new'
    | '/dashboard/jobs/reports'
    | '/dashboard/jobs/service-calls'
    | '/dashboard/leads/$leadId'
    | '/dashboard/leads/new'
    | '/dashboard/leads/reports'
    | '/dashboard/locations/$locationId'
    | '/dashboard/membership-plans/$id'
    | '/dashboard/membership-plans/new'
    | '/dashboard/memberships/$id'
    | '/dashboard/memberships/new'
    | '/dashboard/memberships/reports'
    | '/dashboard/payments/$id'
    | '/dashboard/pricebook/$id'
    | '/dashboard/pricebook/categories'
    | '/dashboard/pricebook/new'
    | '/dashboard/projects/$projectId'
    | '/dashboard/proposals/$id'
    | '/dashboard/proposals/new'
    | '/dashboard/purchasing/approvals'
    | '/dashboard/purchasing/bills'
    | '/dashboard/purchasing/cards'
    | '/dashboard/purchasing/cost-changes'
    | '/dashboard/purchasing/field'
    | '/dashboard/purchasing/overview'
    | '/dashboard/purchasing/requests'
    | '/dashboard/receipts/$id'
    | '/dashboard/reporting/calls'
    | '/dashboard/reporting/me'
    | '/dashboard/reporting/scorecards'
    | '/dashboard/reporting/targets'
    | '/dashboard/reports/$id'
    | '/dashboard/reports/new'
    | '/dashboard/settings/accounting'
    | '/dashboard/settings/api-keys'
    | '/dashboard/settings/booking-links'
    | '/dashboard/settings/booking-services'
    | '/dashboard/settings/booking-windows'
    | '/dashboard/settings/call-settings'
    | '/dashboard/settings/calltree'
    | '/dashboard/settings/channels'
    | '/dashboard/settings/chatbot'
    | '/dashboard/settings/client-portal'
    | '/dashboard/settings/company'
    | '/dashboard/settings/connections'
    | '/dashboard/settings/contact-statuses'
    | '/dashboard/settings/customfields'
    | '/dashboard/settings/deferred-revenue'
    | '/dashboard/settings/email-accounts'
    | '/dashboard/settings/estimate-pdf'
    | '/dashboard/settings/estimate-settings'
    | '/dashboard/settings/estimates'
    | '/dashboard/settings/groups'
    | '/dashboard/settings/integrations'
    | '/dashboard/settings/jobtypes'
    | '/dashboard/settings/leads'
    | '/dashboard/settings/logout'
    | '/dashboard/settings/notifications'
    | '/dashboard/settings/office-settings'
    | '/dashboard/settings/oncall'
    | '/dashboard/settings/online-booking'
    | '/dashboard/settings/payroll-profiles'
    | '/dashboard/settings/permissions'
    | '/dashboard/settings/phone'
    | '/dashboard/settings/purchasing'
    | '/dashboard/settings/quickbooks'
    | '/dashboard/settings/reminders'
    | '/dashboard/settings/reports'
    | '/dashboard/settings/review-platforms'
    | '/dashboard/settings/reviews'
    | '/dashboard/settings/scope-of-work'
    | '/dashboard/settings/service-areas'
    | '/dashboard/settings/skills'
    | '/dashboard/settings/sms'
    | '/dashboard/settings/subscription'
    | '/dashboard/settings/suppliers'
    | '/dashboard/settings/surveys'
    | '/dashboard/settings/tags'
    | '/dashboard/settings/taxes'
    | '/dashboard/settings/terms-and-conditions'
    | '/dashboard/settings/trades'
    | '/dashboard/settings/users'
    | '/dashboard/settings/webhooks'
    | '/dashboard/taxes/overrides'
    | '/dashboard/taxes/rules'
    | '/dashboard/taxes/simulator'
    | '/dashboard/technicians/$id'
    | '/dashboard/technicians/new'
    | '/dashboard/technicians/reports'
    | '/portal/account'
    | '/portal/documents'
    | '/portal/equipment'
    | '/portal/estimates'
    | '/portal/invoices'
    | '/portal/memberships'
    | '/portal/plans'
    | '/portal/proposals'
    | '/portal/visits'
    | '/dashboard/bookings'
    | '/dashboard/calendar'
    | '/dashboard/contacts'
    | '/dashboard/credit-memos'
    | '/dashboard/crewmember'
    | '/dashboard/estimates'
    | '/dashboard/forms'
    | '/dashboard/inventory'
    | '/dashboard/invoices'
    | '/dashboard/jobform'
    | '/dashboard/jobs'
    | '/dashboard/leads'
    | '/dashboard/membership-plans'
    | '/dashboard/memberships'
    | '/dashboard/pricebook'
    | '/dashboard/proposals'
    | '/dashboard/purchasing'
    | '/dashboard/receipts'
    | '/dashboard/settings'
    | '/dashboard/technicians'
    | '/dashboard/unscheduled'
    | '/payment/$id/$id2/$priceid'
    | '/dashboard/ai/otto/$reportId'
    | '/dashboard/contacts/$contactId/consent-records'
    | '/dashboard/contacts/$contactId/edit'
    | '/dashboard/crews/$id/edit'
    | '/dashboard/estimates/$id/edit'
    | '/dashboard/estimates/$id/payment-schedule'
    | '/dashboard/inventory/counts/$countId'
    | '/dashboard/inventory/items/$itemId'
    | '/dashboard/inventory/jobs/$jobId'
    | '/dashboard/inventory/locations/$locationId'
    | '/dashboard/inventory/pick-lists/$id'
    | '/dashboard/inventory/pick-lists/new'
    | '/dashboard/inventory/replenishment/$runId'
    | '/dashboard/invoices/$id/edit'
    | '/dashboard/jobs/$id/edit'
    | '/dashboard/leads/$leadId/edit'
    | '/dashboard/membership-plans/$id/edit'
    | '/dashboard/memberships/$id/edit'
    | '/dashboard/pricebook/$id/edit'
    | '/dashboard/proposals/$id/edit'
    | '/dashboard/proposals/$id/present'
    | '/dashboard/purchasing/suppliers/$supplierId'
    | '/dashboard/reporting/reports/$reportId'
    | '/dashboard/reporting/reports/new'
    | '/dashboard/settings/appointment-forms/$id'
    | '/dashboard/settings/appointment-forms/new'
    | '/dashboard/settings/billing/credit-memos'
    | '/dashboard/settings/billing/deposits'
    | '/dashboard/settings/billing/invoices'
    | '/dashboard/settings/billing/payments'
    | '/dashboard/settings/billing/quickbooks'
    | '/dashboard/settings/billing/receipts'
    | '/dashboard/settings/business-units/$id'
    | '/dashboard/settings/checklist/$id'
    | '/dashboard/settings/checklist/new'
    | '/dashboard/settings/company/edit'
    | '/dashboard/settings/contracts/cancellation'
    | '/dashboard/settings/contracts/costing'
    | '/dashboard/settings/contracts/defaults'
    | '/dashboard/settings/contracts/production-kits'
    | '/dashboard/settings/contracts/qbo'
    | '/dashboard/settings/contracts/renewal'
    | '/dashboard/settings/contracts/renewal-cancellation'
    | '/dashboard/settings/contracts/reviews'
    | '/dashboard/settings/customfields/$id'
    | '/dashboard/settings/customfields/new'
    | '/dashboard/settings/document-templates/$id'
    | '/dashboard/settings/document-templates/new'
    | '/dashboard/settings/email-templates/$id'
    | '/dashboard/settings/email-templates/new'
    | '/dashboard/settings/groups/$id'
    | '/dashboard/settings/groups/new'
    | '/dashboard/settings/job-pipelines/$id'
    | '/dashboard/settings/job-pipelines/new'
    | '/dashboard/settings/jobtypes/$id'
    | '/dashboard/settings/jobtypes/new'
    | '/dashboard/settings/notifications/edit'
    | '/dashboard/settings/office-settings/edit'
    | '/dashboard/settings/partner-api/webhooks'
    | '/dashboard/settings/permissions/$id'
    | '/dashboard/settings/permissions/new'
    | '/dashboard/settings/reminders/$type'
    | '/dashboard/settings/reports/templates'
    | '/dashboard/settings/scope-of-work/$id'
    | '/dashboard/settings/skills/$id'
    | '/dashboard/settings/skills/new'
    | '/dashboard/settings/terms-and-conditions/$id'
    | '/dashboard/settings/users/$id'
    | '/dashboard/settings/users/new'
    | '/dashboard/settings/webhooks/$id'
    | '/dashboard/settings/webhooks/new'
    | '/dashboard/technicians/$id/edit'
    | '/dashboard/technicians/$id/offboarding'
    | '/dashboard/inventory/counts'
    | '/dashboard/inventory/replenishment'
    | '/dashboard/purchasing/suppliers'
    | '/dashboard/reporting/reports'
    | '/dashboard/settings/appointment-forms'
    | '/dashboard/settings/billing'
    | '/dashboard/settings/business-units'
    | '/dashboard/settings/checklist'
    | '/dashboard/settings/contracts'
    | '/dashboard/settings/document-templates'
    | '/dashboard/settings/job-pipelines'
    | '/dashboard/settings/templates'
    | '/dashboard/contacts/$contactId/addresses/new'
    | '/dashboard/contacts/$contactId/bill-to/new'
    | '/dashboard/jobs/$id/appointments/$appointmentId'
    | '/dashboard/jobs/$id/appointments/new'
    | '/dashboard/jobs/$id/change-orders/$changeOrderId'
    | '/dashboard/jobs/$id/change-orders/new'
    | '/dashboard/jobs/$id/expenses/$expenseId'
    | '/dashboard/jobs/$id/expenses/new'
    | '/dashboard/jobs/$id/invoices/$invoiceId'
    | '/dashboard/jobs/$id/invoices/new'
    | '/dashboard/jobs/$id/payment-schedule/edit'
    | '/dashboard/jobs/$id/payment-schedule/new'
    | '/dashboard/purchasing/suppliers/$supplierId/edit'
    | '/dashboard/reporting/reports/$reportId/edit'
    | '/dashboard/settings/appointment-forms/$id/edit'
    | '/dashboard/settings/call-settings/flows/$id'
    | '/dashboard/settings/call-settings/ivr/$id'
    | '/dashboard/settings/call-settings/ivr/new'
    | '/dashboard/settings/call-settings/numbers/$numberId'
    | '/dashboard/settings/call-settings/team/$section'
    | '/dashboard/settings/checklist/$id/edit'
    | '/dashboard/settings/customfields/$id/edit'
    | '/dashboard/settings/groups/$id/edit'
    | '/dashboard/settings/job-pipelines/$id/edit'
    | '/dashboard/settings/jobtypes/$id/edit'
    | '/dashboard/settings/partner-api/webhooks/$id'
    | '/dashboard/settings/partner-api/webhooks/new'
    | '/dashboard/settings/permissions/$id/edit'
    | '/dashboard/settings/scope-of-work/$id/edit'
    | '/dashboard/settings/skills/$id/edit'
    | '/dashboard/settings/templates/estimate/$id'
    | '/dashboard/settings/templates/estimate/new'
    | '/dashboard/settings/templates/proposal/$id'
    | '/dashboard/settings/templates/proposal/new'
    | '/dashboard/settings/terms-and-conditions/$id/edit'
    | '/dashboard/settings/users/$id/edit'
    | '/dashboard/settings/webhooks/$id/edit'
    | '/dashboard/contacts/$contactId/addresses/$addressId/edit'
    | '/dashboard/contacts/$contactId/bill-to/$billToId/edit'
    | '/dashboard/settings/partner-api/webhooks/$id/edit';
  id:
    | '__root__'
    | '/'
    | '/$'
    | '/_dashboard'
    | '/(public)/create-password'
    | '/(public)/forgot-password'
    | '/(public)/google-business'
    | '/(public)/invite'
    | '/(public)/login'
    | '/(public)/onlinebookingresponse'
    | '/(public)/reset-password'
    | '/(portal)/portal/forgot'
    | '/(portal)/portal/login'
    | '/(portal)/portal/register'
    | '/(portal)/portal/reset'
    | '/(portal)/portal/verify'
    | '/(public)/auth/impersonate-handoff'
    | '/(public)/book/$token'
    | '/(public)/c/$token'
    | '/(public)/change-order/$id'
    | '/(public)/combined-doc/$token'
    | '/(public)/confirm-job/$referenceNo'
    | '/(public)/create-password/$token'
    | '/(public)/e/$token'
    | '/(public)/estimate/$id'
    | '/(public)/form/$id'
    | '/(public)/i/$id'
    | '/(public)/invite/$token'
    | '/(public)/invoice/$id'
    | '/(public)/j/$referenceNo'
    | '/(public)/job-stories/$token'
    | '/(public)/link-phone/$token'
    | '/(public)/onlinebooking/$id'
    | '/(public)/onlineform/$id'
    | '/(public)/pay/$token'
    | '/(public)/payment-method-request/$token'
    | '/(public)/pdf-estimate/$id'
    | '/(public)/pdf-invoice/$id'
    | '/(public)/pdf-proposal/$id'
    | '/(public)/previewinvoice/$id'
    | '/(public)/previewquote/$id'
    | '/(public)/proposal/$id'
    | '/(public)/quote/$id'
    | '/(public)/r/$token'
    | '/(public)/receipt/$id'
    | '/(public)/recurring-renewal/$token'
    | '/(public)/recurring/$token'
    | '/(public)/repair-membership/$token'
    | '/(public)/repair-payment-method/$token'
    | '/(public)/response/$id'
    | '/(public)/review/$token'
    | '/(public)/s/$code'
    | '/(public)/schedule-change/$token'
    | '/(public)/signed/$signedId'
    | '/(public)/supplier-order/$token'
    | '/(public)/t/$token'
    | '/(public)/tip-option/$id'
    | '/(public)/tip/$id'
    | '/_dashboard/dashboard/audit'
    | '/_dashboard/dashboard/board'
    | '/_dashboard/dashboard/bookings'
    | '/_dashboard/dashboard/calllogs'
    | '/_dashboard/dashboard/chatbot'
    | '/_dashboard/dashboard/contacts'
    | '/_dashboard/dashboard/contracts'
    | '/_dashboard/dashboard/credit-memos'
    | '/_dashboard/dashboard/crew-members'
    | '/_dashboard/dashboard/crews'
    | '/_dashboard/dashboard/deposits'
    | '/_dashboard/dashboard/dispatch'
    | '/_dashboard/dashboard/equipment'
    | '/_dashboard/dashboard/equipment-categories'
    | '/_dashboard/dashboard/equipment-descriptions'
    | '/_dashboard/dashboard/estimates'
    | '/_dashboard/dashboard/executive'
    | '/_dashboard/dashboard/forms'
    | '/_dashboard/dashboard/home'
    | '/_dashboard/dashboard/inbox'
    | '/_dashboard/dashboard/inventory'
    | '/_dashboard/dashboard/invoices'
    | '/_dashboard/dashboard/jobs'
    | '/_dashboard/dashboard/leads'
    | '/_dashboard/dashboard/leads-engine'
    | '/_dashboard/dashboard/live-calls'
    | '/_dashboard/dashboard/locations'
    | '/_dashboard/dashboard/membership-plans'
    | '/_dashboard/dashboard/membership-visits'
    | '/_dashboard/dashboard/memberships'
    | '/_dashboard/dashboard/my-dashboard'
    | '/_dashboard/dashboard/my-day'
    | '/_dashboard/dashboard/notifications'
    | '/_dashboard/dashboard/onboarding'
    | '/_dashboard/dashboard/operations'
    | '/_dashboard/dashboard/past-due'
    | '/_dashboard/dashboard/payments'
    | '/_dashboard/dashboard/pricebook'
    | '/_dashboard/dashboard/projects'
    | '/_dashboard/dashboard/promotions'
    | '/_dashboard/dashboard/proposals'
    | '/_dashboard/dashboard/purchasing'
    | '/_dashboard/dashboard/receipts'
    | '/_dashboard/dashboard/recovery-renewals'
    | '/_dashboard/dashboard/recurring-billing'
    | '/_dashboard/dashboard/reminders'
    | '/_dashboard/dashboard/reviews'
    | '/_dashboard/dashboard/routes'
    | '/_dashboard/dashboard/schedule'
    | '/_dashboard/dashboard/settings'
    | '/_dashboard/dashboard/stripe'
    | '/_dashboard/dashboard/tasks'
    | '/_dashboard/dashboard/taxes'
    | '/_dashboard/dashboard/team-chat'
    | '/_dashboard/dashboard/technicians'
    | '/_dashboard/dashboard/timesheet'
    | '/(portal)/portal/'
    | '/(public)/review/'
    | '/_dashboard/dashboard/'
    | '/(portal)/portal/estimates/$id'
    | '/(portal)/portal/invoices/$id'
    | '/(portal)/portal/memberships/$id'
    | '/(portal)/portal/proposals/$id'
    | '/(portal)/portal/visits/book'
    | '/(public)/review/$reviewId/$id2'
    | '/(public)/tracking/$id/$refno'
    | '/_dashboard/dashboard/ai/otto'
    | '/_dashboard/dashboard/bookings/$bookingId'
    | '/_dashboard/dashboard/bookings/new'
    | '/_dashboard/dashboard/calendar/$id'
    | '/_dashboard/dashboard/calendar/map'
    | '/_dashboard/dashboard/calllogs_/reports'
    | '/_dashboard/dashboard/contacts/$contactId'
    | '/_dashboard/dashboard/contacts/new'
    | '/_dashboard/dashboard/contacts/reports'
    | '/_dashboard/dashboard/contacts/tasks'
    | '/_dashboard/dashboard/contracts/$id'
    | '/_dashboard/dashboard/costing/reports'
    | '/_dashboard/dashboard/credit-memos/$id'
    | '/_dashboard/dashboard/credit-memos/new'
    | '/_dashboard/dashboard/crewmember/$userId'
    | '/_dashboard/dashboard/crews/$id'
    | '/_dashboard/dashboard/crews/new'
    | '/_dashboard/dashboard/deposits/$id'
    | '/_dashboard/dashboard/dispatch_/live'
    | '/_dashboard/dashboard/estimates/$id'
    | '/_dashboard/dashboard/estimates/new'
    | '/_dashboard/dashboard/estimates/reports'
    | '/_dashboard/dashboard/forms/$formId'
    | '/_dashboard/dashboard/inventory/locations'
    | '/_dashboard/dashboard/inventory/my-truck'
    | '/_dashboard/dashboard/inventory/overview'
    | '/_dashboard/dashboard/inventory/stock'
    | '/_dashboard/dashboard/inventory/transfers'
    | '/_dashboard/dashboard/inventory/truck-templates'
    | '/_dashboard/dashboard/invoices/$id'
    | '/_dashboard/dashboard/invoices/new'
    | '/_dashboard/dashboard/invoices/reports'
    | '/_dashboard/dashboard/jobform/$id'
    | '/_dashboard/dashboard/jobform/new'
    | '/_dashboard/dashboard/jobs/$id'
    | '/_dashboard/dashboard/jobs/budget-vs-actual'
    | '/_dashboard/dashboard/jobs/new'
    | '/_dashboard/dashboard/jobs/reports'
    | '/_dashboard/dashboard/jobs/service-calls'
    | '/_dashboard/dashboard/leads/$leadId'
    | '/_dashboard/dashboard/leads/new'
    | '/_dashboard/dashboard/leads/reports'
    | '/_dashboard/dashboard/locations/$locationId'
    | '/_dashboard/dashboard/membership-plans/$id'
    | '/_dashboard/dashboard/membership-plans/new'
    | '/_dashboard/dashboard/memberships/$id'
    | '/_dashboard/dashboard/memberships/new'
    | '/_dashboard/dashboard/memberships/reports'
    | '/_dashboard/dashboard/payments/$id'
    | '/_dashboard/dashboard/pricebook/$id'
    | '/_dashboard/dashboard/pricebook/categories'
    | '/_dashboard/dashboard/pricebook/new'
    | '/_dashboard/dashboard/projects/$projectId'
    | '/_dashboard/dashboard/proposals/$id'
    | '/_dashboard/dashboard/proposals/new'
    | '/_dashboard/dashboard/purchasing/approvals'
    | '/_dashboard/dashboard/purchasing/bills'
    | '/_dashboard/dashboard/purchasing/cards'
    | '/_dashboard/dashboard/purchasing/cost-changes'
    | '/_dashboard/dashboard/purchasing/field'
    | '/_dashboard/dashboard/purchasing/overview'
    | '/_dashboard/dashboard/purchasing/requests'
    | '/_dashboard/dashboard/receipts/$id'
    | '/_dashboard/dashboard/reporting/calls'
    | '/_dashboard/dashboard/reporting/me'
    | '/_dashboard/dashboard/reporting/scorecards'
    | '/_dashboard/dashboard/reporting/targets'
    | '/_dashboard/dashboard/reports/$id'
    | '/_dashboard/dashboard/reports/new'
    | '/_dashboard/dashboard/settings/accounting'
    | '/_dashboard/dashboard/settings/api-keys'
    | '/_dashboard/dashboard/settings/appointment-forms'
    | '/_dashboard/dashboard/settings/billing'
    | '/_dashboard/dashboard/settings/booking-links'
    | '/_dashboard/dashboard/settings/booking-services'
    | '/_dashboard/dashboard/settings/booking-windows'
    | '/_dashboard/dashboard/settings/call-settings'
    | '/_dashboard/dashboard/settings/calltree'
    | '/_dashboard/dashboard/settings/channels'
    | '/_dashboard/dashboard/settings/chatbot'
    | '/_dashboard/dashboard/settings/checklist'
    | '/_dashboard/dashboard/settings/client-portal'
    | '/_dashboard/dashboard/settings/company'
    | '/_dashboard/dashboard/settings/connections'
    | '/_dashboard/dashboard/settings/contact-statuses'
    | '/_dashboard/dashboard/settings/contracts'
    | '/_dashboard/dashboard/settings/customfields'
    | '/_dashboard/dashboard/settings/deferred-revenue'
    | '/_dashboard/dashboard/settings/email-accounts'
    | '/_dashboard/dashboard/settings/estimate-pdf'
    | '/_dashboard/dashboard/settings/estimate-settings'
    | '/_dashboard/dashboard/settings/estimates'
    | '/_dashboard/dashboard/settings/groups'
    | '/_dashboard/dashboard/settings/integrations'
    | '/_dashboard/dashboard/settings/job-pipelines'
    | '/_dashboard/dashboard/settings/jobtypes'
    | '/_dashboard/dashboard/settings/leads'
    | '/_dashboard/dashboard/settings/logout'
    | '/_dashboard/dashboard/settings/notifications'
    | '/_dashboard/dashboard/settings/office-settings'
    | '/_dashboard/dashboard/settings/oncall'
    | '/_dashboard/dashboard/settings/online-booking'
    | '/_dashboard/dashboard/settings/payroll-profiles'
    | '/_dashboard/dashboard/settings/permissions'
    | '/_dashboard/dashboard/settings/phone'
    | '/_dashboard/dashboard/settings/purchasing'
    | '/_dashboard/dashboard/settings/quickbooks'
    | '/_dashboard/dashboard/settings/reminders'
    | '/_dashboard/dashboard/settings/reports'
    | '/_dashboard/dashboard/settings/review-platforms'
    | '/_dashboard/dashboard/settings/reviews'
    | '/_dashboard/dashboard/settings/scope-of-work'
    | '/_dashboard/dashboard/settings/service-areas'
    | '/_dashboard/dashboard/settings/skills'
    | '/_dashboard/dashboard/settings/sms'
    | '/_dashboard/dashboard/settings/subscription'
    | '/_dashboard/dashboard/settings/suppliers'
    | '/_dashboard/dashboard/settings/surveys'
    | '/_dashboard/dashboard/settings/tags'
    | '/_dashboard/dashboard/settings/taxes'
    | '/_dashboard/dashboard/settings/templates'
    | '/_dashboard/dashboard/settings/terms-and-conditions'
    | '/_dashboard/dashboard/settings/trades'
    | '/_dashboard/dashboard/settings/users'
    | '/_dashboard/dashboard/settings/webhooks'
    | '/_dashboard/dashboard/taxes/overrides'
    | '/_dashboard/dashboard/taxes/rules'
    | '/_dashboard/dashboard/taxes/simulator'
    | '/_dashboard/dashboard/technicians/$id'
    | '/_dashboard/dashboard/technicians/new'
    | '/_dashboard/dashboard/technicians/reports'
    | '/(portal)/portal/account/'
    | '/(portal)/portal/documents/'
    | '/(portal)/portal/equipment/'
    | '/(portal)/portal/estimates/'
    | '/(portal)/portal/invoices/'
    | '/(portal)/portal/memberships/'
    | '/(portal)/portal/plans/'
    | '/(portal)/portal/proposals/'
    | '/(portal)/portal/visits/'
    | '/_dashboard/dashboard/bookings/'
    | '/_dashboard/dashboard/calendar/'
    | '/_dashboard/dashboard/contacts/'
    | '/_dashboard/dashboard/credit-memos/'
    | '/_dashboard/dashboard/crewmember/'
    | '/_dashboard/dashboard/estimates/'
    | '/_dashboard/dashboard/forms/'
    | '/_dashboard/dashboard/inventory/'
    | '/_dashboard/dashboard/invoices/'
    | '/_dashboard/dashboard/jobform/'
    | '/_dashboard/dashboard/jobs/'
    | '/_dashboard/dashboard/leads/'
    | '/_dashboard/dashboard/membership-plans/'
    | '/_dashboard/dashboard/memberships/'
    | '/_dashboard/dashboard/pricebook/'
    | '/_dashboard/dashboard/proposals/'
    | '/_dashboard/dashboard/purchasing/'
    | '/_dashboard/dashboard/receipts/'
    | '/_dashboard/dashboard/settings/'
    | '/_dashboard/dashboard/technicians/'
    | '/_dashboard/dashboard/unscheduled/'
    | '/(public)/payment/$id/$id2/$priceid'
    | '/_dashboard/dashboard/ai/otto/$reportId'
    | '/_dashboard/dashboard/contacts/$contactId/consent-records'
    | '/_dashboard/dashboard/contacts/$contactId/edit'
    | '/_dashboard/dashboard/crews/$id/edit'
    | '/_dashboard/dashboard/estimates/$id/edit'
    | '/_dashboard/dashboard/estimates/$id/payment-schedule'
    | '/_dashboard/dashboard/inventory/counts/$countId'
    | '/_dashboard/dashboard/inventory/items/$itemId'
    | '/_dashboard/dashboard/inventory/jobs/$jobId'
    | '/_dashboard/dashboard/inventory/locations_/$locationId'
    | '/_dashboard/dashboard/inventory/pick-lists_/$id'
    | '/_dashboard/dashboard/inventory/pick-lists_/new'
    | '/_dashboard/dashboard/inventory/replenishment/$runId'
    | '/_dashboard/dashboard/invoices/$id/edit'
    | '/_dashboard/dashboard/jobs/$id/edit'
    | '/_dashboard/dashboard/leads/$leadId/edit'
    | '/_dashboard/dashboard/membership-plans/$id/edit'
    | '/_dashboard/dashboard/memberships/$id/edit'
    | '/_dashboard/dashboard/pricebook/$id/edit'
    | '/_dashboard/dashboard/proposals/$id/edit'
    | '/_dashboard/dashboard/proposals/$id/present'
    | '/_dashboard/dashboard/purchasing/suppliers/$supplierId'
    | '/_dashboard/dashboard/reporting/reports/$reportId'
    | '/_dashboard/dashboard/reporting/reports/new'
    | '/_dashboard/dashboard/settings/appointment-forms/$id'
    | '/_dashboard/dashboard/settings/appointment-forms/new'
    | '/_dashboard/dashboard/settings/billing/credit-memos'
    | '/_dashboard/dashboard/settings/billing/deposits'
    | '/_dashboard/dashboard/settings/billing/invoices'
    | '/_dashboard/dashboard/settings/billing/payments'
    | '/_dashboard/dashboard/settings/billing/quickbooks'
    | '/_dashboard/dashboard/settings/billing/receipts'
    | '/_dashboard/dashboard/settings/business-units/$id'
    | '/_dashboard/dashboard/settings/checklist/$id'
    | '/_dashboard/dashboard/settings/checklist/new'
    | '/_dashboard/dashboard/settings/company/edit'
    | '/_dashboard/dashboard/settings/contracts/cancellation'
    | '/_dashboard/dashboard/settings/contracts/costing'
    | '/_dashboard/dashboard/settings/contracts/defaults'
    | '/_dashboard/dashboard/settings/contracts/production-kits'
    | '/_dashboard/dashboard/settings/contracts/qbo'
    | '/_dashboard/dashboard/settings/contracts/renewal'
    | '/_dashboard/dashboard/settings/contracts/renewal-cancellation'
    | '/_dashboard/dashboard/settings/contracts/reviews'
    | '/_dashboard/dashboard/settings/customfields/$id'
    | '/_dashboard/dashboard/settings/customfields/new'
    | '/_dashboard/dashboard/settings/document-templates/$id'
    | '/_dashboard/dashboard/settings/document-templates/new'
    | '/_dashboard/dashboard/settings/email-templates/$id'
    | '/_dashboard/dashboard/settings/email-templates/new'
    | '/_dashboard/dashboard/settings/groups/$id'
    | '/_dashboard/dashboard/settings/groups/new'
    | '/_dashboard/dashboard/settings/job-pipelines/$id'
    | '/_dashboard/dashboard/settings/job-pipelines/new'
    | '/_dashboard/dashboard/settings/jobtypes/$id'
    | '/_dashboard/dashboard/settings/jobtypes/new'
    | '/_dashboard/dashboard/settings/notifications/edit'
    | '/_dashboard/dashboard/settings/office-settings/edit'
    | '/_dashboard/dashboard/settings/partner-api/webhooks'
    | '/_dashboard/dashboard/settings/permissions/$id'
    | '/_dashboard/dashboard/settings/permissions/new'
    | '/_dashboard/dashboard/settings/reminders/$type'
    | '/_dashboard/dashboard/settings/reports_/templates'
    | '/_dashboard/dashboard/settings/scope-of-work/$id'
    | '/_dashboard/dashboard/settings/skills/$id'
    | '/_dashboard/dashboard/settings/skills/new'
    | '/_dashboard/dashboard/settings/terms-and-conditions/$id'
    | '/_dashboard/dashboard/settings/users/$id'
    | '/_dashboard/dashboard/settings/users/new'
    | '/_dashboard/dashboard/settings/webhooks/$id'
    | '/_dashboard/dashboard/settings/webhooks/new'
    | '/_dashboard/dashboard/technicians/$id/edit'
    | '/_dashboard/dashboard/technicians/$id/offboarding'
    | '/_dashboard/dashboard/inventory/counts/'
    | '/_dashboard/dashboard/inventory/replenishment/'
    | '/_dashboard/dashboard/purchasing/suppliers/'
    | '/_dashboard/dashboard/reporting/reports/'
    | '/_dashboard/dashboard/settings/appointment-forms/'
    | '/_dashboard/dashboard/settings/billing/'
    | '/_dashboard/dashboard/settings/business-units/'
    | '/_dashboard/dashboard/settings/checklist/'
    | '/_dashboard/dashboard/settings/contracts/'
    | '/_dashboard/dashboard/settings/document-templates/'
    | '/_dashboard/dashboard/settings/job-pipelines/'
    | '/_dashboard/dashboard/settings/templates/'
    | '/_dashboard/dashboard/contacts/$contactId/addresses/new'
    | '/_dashboard/dashboard/contacts/$contactId/bill-to/new'
    | '/_dashboard/dashboard/jobs/$id/appointments/$appointmentId'
    | '/_dashboard/dashboard/jobs/$id/appointments/new'
    | '/_dashboard/dashboard/jobs/$id/change-orders/$changeOrderId'
    | '/_dashboard/dashboard/jobs/$id/change-orders/new'
    | '/_dashboard/dashboard/jobs/$id/expenses/$expenseId'
    | '/_dashboard/dashboard/jobs/$id/expenses/new'
    | '/_dashboard/dashboard/jobs/$id/invoices/$invoiceId'
    | '/_dashboard/dashboard/jobs/$id/invoices/new'
    | '/_dashboard/dashboard/jobs/$id/payment-schedule/edit'
    | '/_dashboard/dashboard/jobs/$id/payment-schedule/new'
    | '/_dashboard/dashboard/purchasing/suppliers/$supplierId_/edit'
    | '/_dashboard/dashboard/reporting/reports/$reportId_/edit'
    | '/_dashboard/dashboard/settings/appointment-forms/$id/edit'
    | '/_dashboard/dashboard/settings/call-settings/flows/$id'
    | '/_dashboard/dashboard/settings/call-settings/ivr/$id'
    | '/_dashboard/dashboard/settings/call-settings/ivr/new'
    | '/_dashboard/dashboard/settings/call-settings/numbers/$numberId'
    | '/_dashboard/dashboard/settings/call-settings/team/$section'
    | '/_dashboard/dashboard/settings/checklist/$id/edit'
    | '/_dashboard/dashboard/settings/customfields/$id/edit'
    | '/_dashboard/dashboard/settings/groups/$id/edit'
    | '/_dashboard/dashboard/settings/job-pipelines/$id/edit'
    | '/_dashboard/dashboard/settings/jobtypes/$id/edit'
    | '/_dashboard/dashboard/settings/partner-api/webhooks/$id'
    | '/_dashboard/dashboard/settings/partner-api/webhooks/new'
    | '/_dashboard/dashboard/settings/permissions/$id/edit'
    | '/_dashboard/dashboard/settings/scope-of-work/$id/edit'
    | '/_dashboard/dashboard/settings/skills/$id/edit'
    | '/_dashboard/dashboard/settings/templates/estimate/$id'
    | '/_dashboard/dashboard/settings/templates/estimate/new'
    | '/_dashboard/dashboard/settings/templates/proposal/$id'
    | '/_dashboard/dashboard/settings/templates/proposal/new'
    | '/_dashboard/dashboard/settings/terms-and-conditions/$id/edit'
    | '/_dashboard/dashboard/settings/users/$id/edit'
    | '/_dashboard/dashboard/settings/webhooks/$id/edit'
    | '/_dashboard/dashboard/contacts/$contactId/addresses/$addressId/edit'
    | '/_dashboard/dashboard/contacts/$contactId/bill-to/$billToId/edit'
    | '/_dashboard/dashboard/settings/partner-api/webhooks/$id/edit';
  fileRoutesById: FileRoutesById;
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute;
  SplatRoute: typeof SplatRoute;
  DashboardRoute: typeof DashboardRouteWithChildren;
  publicCreatePasswordRoute: typeof publicCreatePasswordRouteWithChildren;
  publicForgotPasswordRoute: typeof publicForgotPasswordRoute;
  publicGoogleBusinessRoute: typeof publicGoogleBusinessRoute;
  publicInviteRoute: typeof publicInviteRouteWithChildren;
  publicLoginRoute: typeof publicLoginRoute;
  publicOnlinebookingresponseRoute: typeof publicOnlinebookingresponseRoute;
  publicResetPasswordRoute: typeof publicResetPasswordRoute;
  portalPortalForgotRoute: typeof portalPortalForgotRoute;
  portalPortalLoginRoute: typeof portalPortalLoginRoute;
  portalPortalRegisterRoute: typeof portalPortalRegisterRoute;
  portalPortalResetRoute: typeof portalPortalResetRoute;
  portalPortalVerifyRoute: typeof portalPortalVerifyRoute;
  publicAuthImpersonateHandoffRoute: typeof publicAuthImpersonateHandoffRoute;
  publicBookTokenRoute: typeof publicBookTokenRoute;
  publicCTokenRoute: typeof publicCTokenRoute;
  publicChangeOrderIdRoute: typeof publicChangeOrderIdRoute;
  publicCombinedDocTokenRoute: typeof publicCombinedDocTokenRoute;
  publicConfirmJobReferenceNoRoute: typeof publicConfirmJobReferenceNoRoute;
  publicETokenRoute: typeof publicETokenRoute;
  publicEstimateIdRoute: typeof publicEstimateIdRoute;
  publicFormIdRoute: typeof publicFormIdRoute;
  publicIIdRoute: typeof publicIIdRoute;
  publicInvoiceIdRoute: typeof publicInvoiceIdRoute;
  publicJReferenceNoRoute: typeof publicJReferenceNoRoute;
  publicJobStoriesTokenRoute: typeof publicJobStoriesTokenRoute;
  publicLinkPhoneTokenRoute: typeof publicLinkPhoneTokenRoute;
  publicOnlinebookingIdRoute: typeof publicOnlinebookingIdRoute;
  publicOnlineformIdRoute: typeof publicOnlineformIdRoute;
  publicPayTokenRoute: typeof publicPayTokenRoute;
  publicPaymentMethodRequestTokenRoute: typeof publicPaymentMethodRequestTokenRoute;
  publicPdfEstimateIdRoute: typeof publicPdfEstimateIdRoute;
  publicPdfInvoiceIdRoute: typeof publicPdfInvoiceIdRoute;
  publicPdfProposalIdRoute: typeof publicPdfProposalIdRoute;
  publicPreviewinvoiceIdRoute: typeof publicPreviewinvoiceIdRoute;
  publicPreviewquoteIdRoute: typeof publicPreviewquoteIdRoute;
  publicProposalIdRoute: typeof publicProposalIdRoute;
  publicQuoteIdRoute: typeof publicQuoteIdRoute;
  publicRTokenRoute: typeof publicRTokenRoute;
  publicReceiptIdRoute: typeof publicReceiptIdRoute;
  publicRecurringRenewalTokenRoute: typeof publicRecurringRenewalTokenRoute;
  publicRecurringTokenRoute: typeof publicRecurringTokenRoute;
  publicRepairMembershipTokenRoute: typeof publicRepairMembershipTokenRoute;
  publicRepairPaymentMethodTokenRoute: typeof publicRepairPaymentMethodTokenRoute;
  publicResponseIdRoute: typeof publicResponseIdRoute;
  publicReviewTokenRoute: typeof publicReviewTokenRoute;
  publicSCodeRoute: typeof publicSCodeRoute;
  publicScheduleChangeTokenRoute: typeof publicScheduleChangeTokenRoute;
  publicSignedSignedIdRoute: typeof publicSignedSignedIdRoute;
  publicSupplierOrderTokenRoute: typeof publicSupplierOrderTokenRoute;
  publicTTokenRoute: typeof publicTTokenRoute;
  publicTipOptionIdRoute: typeof publicTipOptionIdRoute;
  publicTipIdRoute: typeof publicTipIdRoute;
  portalPortalIndexRoute: typeof portalPortalIndexRoute;
  publicReviewIndexRoute: typeof publicReviewIndexRoute;
  portalPortalEstimatesIdRoute: typeof portalPortalEstimatesIdRoute;
  portalPortalInvoicesIdRoute: typeof portalPortalInvoicesIdRoute;
  portalPortalMembershipsIdRoute: typeof portalPortalMembershipsIdRoute;
  portalPortalProposalsIdRoute: typeof portalPortalProposalsIdRoute;
  portalPortalVisitsBookRoute: typeof portalPortalVisitsBookRoute;
  publicReviewReviewIdId2Route: typeof publicReviewReviewIdId2Route;
  publicTrackingIdRefnoRoute: typeof publicTrackingIdRefnoRoute;
  portalPortalAccountIndexRoute: typeof portalPortalAccountIndexRoute;
  portalPortalDocumentsIndexRoute: typeof portalPortalDocumentsIndexRoute;
  portalPortalEquipmentIndexRoute: typeof portalPortalEquipmentIndexRoute;
  portalPortalEstimatesIndexRoute: typeof portalPortalEstimatesIndexRoute;
  portalPortalInvoicesIndexRoute: typeof portalPortalInvoicesIndexRoute;
  portalPortalMembershipsIndexRoute: typeof portalPortalMembershipsIndexRoute;
  portalPortalPlansIndexRoute: typeof portalPortalPlansIndexRoute;
  portalPortalProposalsIndexRoute: typeof portalPortalProposalsIndexRoute;
  portalPortalVisitsIndexRoute: typeof portalPortalVisitsIndexRoute;
  publicPaymentIdId2PriceidRoute: typeof publicPaymentIdId2PriceidRoute;
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_dashboard': {
      id: '/_dashboard';
      path: '';
      fullPath: '/';
      preLoaderRoute: typeof DashboardRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/$': {
      id: '/$';
      path: '/$';
      fullPath: '/$';
      preLoaderRoute: typeof SplatRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/': {
      id: '/';
      path: '/';
      fullPath: '/';
      preLoaderRoute: typeof IndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/(public)/reset-password': {
      id: '/(public)/reset-password';
      path: '/reset-password';
      fullPath: '/reset-password';
      preLoaderRoute: typeof publicResetPasswordRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/(public)/onlinebookingresponse': {
      id: '/(public)/onlinebookingresponse';
      path: '/onlinebookingresponse';
      fullPath: '/onlinebookingresponse';
      preLoaderRoute: typeof publicOnlinebookingresponseRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/(public)/login': {
      id: '/(public)/login';
      path: '/login';
      fullPath: '/login';
      preLoaderRoute: typeof publicLoginRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/(public)/invite': {
      id: '/(public)/invite';
      path: '/invite';
      fullPath: '/invite';
      preLoaderRoute: typeof publicInviteRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/(public)/google-business': {
      id: '/(public)/google-business';
      path: '/google-business';
      fullPath: '/google-business';
      preLoaderRoute: typeof publicGoogleBusinessRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/(public)/forgot-password': {
      id: '/(public)/forgot-password';
      path: '/forgot-password';
      fullPath: '/forgot-password';
      preLoaderRoute: typeof publicForgotPasswordRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/(public)/create-password': {
      id: '/(public)/create-password';
      path: '/create-password';
      fullPath: '/create-password';
      preLoaderRoute: typeof publicCreatePasswordRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/_dashboard/dashboard/': {
      id: '/_dashboard/dashboard/';
      path: '/dashboard';
      fullPath: '/dashboard/';
      preLoaderRoute: typeof DashboardDashboardIndexRouteImport;
      parentRoute: typeof DashboardRoute;
    };
    '/(public)/review/': {
      id: '/(public)/review/';
      path: '/review';
      fullPath: '/review/';
      preLoaderRoute: typeof publicReviewIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/(portal)/portal/': {
      id: '/(portal)/portal/';
      path: '/portal';
      fullPath: '/portal/';
      preLoaderRoute: typeof portalPortalIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/_dashboard/dashboard/timesheet': {
      id: '/_dashboard/dashboard/timesheet';
      path: '/dashboard/timesheet';
      fullPath: '/dashboard/timesheet';
      preLoaderRoute: typeof DashboardDashboardTimesheetRouteImport;
      parentRoute: typeof DashboardRoute;
    };
    '/_dashboard/dashboard/technicians': {
      id: '/_dashboard/dashboard/technicians';
      path: '/dashboard/technicians';
      fullPath: '/dashboard/technicians';
      preLoaderRoute: typeof DashboardDashboardTechniciansRouteImport;
      parentRoute: typeof DashboardRoute;
    };
    '/_dashboard/dashboard/team-chat': {
      id: '/_dashboard/dashboard/team-chat';
      path: '/dashboard/team-chat';
      fullPath: '/dashboard/team-chat';
      preLoaderRoute: typeof DashboardDashboardTeamChatRouteImport;
      parentRoute: typeof DashboardRoute;
    };
    '/_dashboard/dashboard/taxes': {
      id: '/_dashboard/dashboard/taxes';
      path: '/dashboard/taxes';
      fullPath: '/dashboard/taxes';
      preLoaderRoute: typeof DashboardDashboardTaxesRouteImport;
      parentRoute: typeof DashboardRoute;
    };
    '/_dashboard/dashboard/tasks': {
      id: '/_dashboard/dashboard/tasks';
      path: '/dashboard/tasks';
      fullPath: '/dashboard/tasks';
      preLoaderRoute: typeof DashboardDashboardTasksRouteImport;
      parentRoute: typeof DashboardRoute;
    };
    '/_dashboard/dashboard/stripe': {
      id: '/_dashboard/dashboard/stripe';
      path: '/dashboard/stripe';
      fullPath: '/dashboard/stripe';
      preLoaderRoute: typeof DashboardDashboardStripeRouteImport;
      parentRoute: typeof DashboardRoute;
    };
    '/_dashboard/dashboard/settings': {
      id: '/_dashboard/dashboard/settings';
      path: '/dashboard/settings';
      fullPath: '/dashboard/settings';
      preLoaderRoute: typeof DashboardDashboardSettingsRouteImport;
      parentRoute: typeof DashboardRoute;
    };
    '/_dashboard/dashboard/schedule': {
      id: '/_dashboard/dashboard/schedule';
      path: '/dashboard/schedule';
      fullPath: '/dashboard/schedule';
      preLoaderRoute: typeof DashboardDashboardScheduleRouteImport;
      parentRoute: typeof DashboardRoute;
    };
    '/_dashboard/dashboard/routes': {
      id: '/_dashboard/dashboard/routes';
      path: '/dashboard/routes';
      fullPath: '/dashboard/routes';
      preLoaderRoute: typeof DashboardDashboardRoutesRouteImport;
      parentRoute: typeof DashboardRoute;
    };
    '/_dashboard/dashboard/reviews': {
      id: '/_dashboard/dashboard/reviews';
      path: '/dashboard/reviews';
      fullPath: '/dashboard/reviews';
      preLoaderRoute: typeof DashboardDashboardReviewsRouteImport;
      parentRoute: typeof DashboardRoute;
    };
    '/_dashboard/dashboard/reminders': {
      id: '/_dashboard/dashboard/reminders';
      path: '/dashboard/reminders';
      fullPath: '/dashboard/reminders';
      preLoaderRoute: typeof DashboardDashboardRemindersRouteImport;
      parentRoute: typeof DashboardRoute;
    };
    '/_dashboard/dashboard/recurring-billing': {
      id: '/_dashboard/dashboard/recurring-billing';
      path: '/dashboard/recurring-billing';
      fullPath: '/dashboard/recurring-billing';
      preLoaderRoute: typeof DashboardDashboardRecurringBillingRouteImport;
      parentRoute: typeof DashboardRoute;
    };
    '/_dashboard/dashboard/recovery-renewals': {
      id: '/_dashboard/dashboard/recovery-renewals';
      path: '/dashboard/recovery-renewals';
      fullPath: '/dashboard/recovery-renewals';
      preLoaderRoute: typeof DashboardDashboardRecoveryRenewalsRouteImport;
      parentRoute: typeof DashboardRoute;
    };
    '/_dashboard/dashboard/receipts': {
      id: '/_dashboard/dashboard/receipts';
      path: '/dashboard/receipts';
      fullPath: '/dashboard/receipts';
      preLoaderRoute: typeof DashboardDashboardReceiptsRouteImport;
      parentRoute: typeof DashboardRoute;
    };
    '/_dashboard/dashboard/purchasing': {
      id: '/_dashboard/dashboard/purchasing';
      path: '/dashboard/purchasing';
      fullPath: '/dashboard/purchasing';
      preLoaderRoute: typeof DashboardDashboardPurchasingRouteImport;
      parentRoute: typeof DashboardRoute;
    };
    '/_dashboard/dashboard/proposals': {
      id: '/_dashboard/dashboard/proposals';
      path: '/dashboard/proposals';
      fullPath: '/dashboard/proposals';
      preLoaderRoute: typeof DashboardDashboardProposalsRouteImport;
      parentRoute: typeof DashboardRoute;
    };
    '/_dashboard/dashboard/promotions': {
      id: '/_dashboard/dashboard/promotions';
      path: '/dashboard/promotions';
      fullPath: '/dashboard/promotions';
      preLoaderRoute: typeof DashboardDashboardPromotionsRouteImport;
      parentRoute: typeof DashboardRoute;
    };
    '/_dashboard/dashboard/projects': {
      id: '/_dashboard/dashboard/projects';
      path: '/dashboard/projects';
      fullPath: '/dashboard/projects';
      preLoaderRoute: typeof DashboardDashboardProjectsRouteImport;
      parentRoute: typeof DashboardRoute;
    };
    '/_dashboard/dashboard/pricebook': {
      id: '/_dashboard/dashboard/pricebook';
      path: '/dashboard/pricebook';
      fullPath: '/dashboard/pricebook';
      preLoaderRoute: typeof DashboardDashboardPricebookRouteImport;
      parentRoute: typeof DashboardRoute;
    };
    '/_dashboard/dashboard/payments': {
      id: '/_dashboard/dashboard/payments';
      path: '/dashboard/payments';
      fullPath: '/dashboard/payments';
      preLoaderRoute: typeof DashboardDashboardPaymentsRouteImport;
      parentRoute: typeof DashboardRoute;
    };
    '/_dashboard/dashboard/past-due': {
      id: '/_dashboard/dashboard/past-due';
      path: '/dashboard/past-due';
      fullPath: '/dashboard/past-due';
      preLoaderRoute: typeof DashboardDashboardPastDueRouteImport;
      parentRoute: typeof DashboardRoute;
    };
    '/_dashboard/dashboard/operations': {
      id: '/_dashboard/dashboard/operations';
      path: '/dashboard/operations';
      fullPath: '/dashboard/operations';
      preLoaderRoute: typeof DashboardDashboardOperationsRouteImport;
      parentRoute: typeof DashboardRoute;
    };
    '/_dashboard/dashboard/onboarding': {
      id: '/_dashboard/dashboard/onboarding';
      path: '/dashboard/onboarding';
      fullPath: '/dashboard/onboarding';
      preLoaderRoute: typeof DashboardDashboardOnboardingRouteImport;
      parentRoute: typeof DashboardRoute;
    };
    '/_dashboard/dashboard/notifications': {
      id: '/_dashboard/dashboard/notifications';
      path: '/dashboard/notifications';
      fullPath: '/dashboard/notifications';
      preLoaderRoute: typeof DashboardDashboardNotificationsRouteImport;
      parentRoute: typeof DashboardRoute;
    };
    '/_dashboard/dashboard/my-day': {
      id: '/_dashboard/dashboard/my-day';
      path: '/dashboard/my-day';
      fullPath: '/dashboard/my-day';
      preLoaderRoute: typeof DashboardDashboardMyDayRouteImport;
      parentRoute: typeof DashboardRoute;
    };
    '/_dashboard/dashboard/my-dashboard': {
      id: '/_dashboard/dashboard/my-dashboard';
      path: '/dashboard/my-dashboard';
      fullPath: '/dashboard/my-dashboard';
      preLoaderRoute: typeof DashboardDashboardMyDashboardRouteImport;
      parentRoute: typeof DashboardRoute;
    };
    '/_dashboard/dashboard/memberships': {
      id: '/_dashboard/dashboard/memberships';
      path: '/dashboard/memberships';
      fullPath: '/dashboard/memberships';
      preLoaderRoute: typeof DashboardDashboardMembershipsRouteImport;
      parentRoute: typeof DashboardRoute;
    };
    '/_dashboard/dashboard/membership-visits': {
      id: '/_dashboard/dashboard/membership-visits';
      path: '/dashboard/membership-visits';
      fullPath: '/dashboard/membership-visits';
      preLoaderRoute: typeof DashboardDashboardMembershipVisitsRouteImport;
      parentRoute: typeof DashboardRoute;
    };
    '/_dashboard/dashboard/membership-plans': {
      id: '/_dashboard/dashboard/membership-plans';
      path: '/dashboard/membership-plans';
      fullPath: '/dashboard/membership-plans';
      preLoaderRoute: typeof DashboardDashboardMembershipPlansRouteImport;
      parentRoute: typeof DashboardRoute;
    };
    '/_dashboard/dashboard/locations': {
      id: '/_dashboard/dashboard/locations';
      path: '/dashboard/locations';
      fullPath: '/dashboard/locations';
      preLoaderRoute: typeof DashboardDashboardLocationsRouteImport;
      parentRoute: typeof DashboardRoute;
    };
    '/_dashboard/dashboard/live-calls': {
      id: '/_dashboard/dashboard/live-calls';
      path: '/dashboard/live-calls';
      fullPath: '/dashboard/live-calls';
      preLoaderRoute: typeof DashboardDashboardLiveCallsRouteImport;
      parentRoute: typeof DashboardRoute;
    };
    '/_dashboard/dashboard/leads-engine': {
      id: '/_dashboard/dashboard/leads-engine';
      path: '/dashboard/leads-engine';
      fullPath: '/dashboard/leads-engine';
      preLoaderRoute: typeof DashboardDashboardLeadsEngineRouteImport;
      parentRoute: typeof DashboardRoute;
    };
    '/_dashboard/dashboard/leads': {
      id: '/_dashboard/dashboard/leads';
      path: '/dashboard/leads';
      fullPath: '/dashboard/leads';
      preLoaderRoute: typeof DashboardDashboardLeadsRouteImport;
      parentRoute: typeof DashboardRoute;
    };
    '/_dashboard/dashboard/jobs': {
      id: '/_dashboard/dashboard/jobs';
      path: '/dashboard/jobs';
      fullPath: '/dashboard/jobs';
      preLoaderRoute: typeof DashboardDashboardJobsRouteImport;
      parentRoute: typeof DashboardRoute;
    };
    '/_dashboard/dashboard/invoices': {
      id: '/_dashboard/dashboard/invoices';
      path: '/dashboard/invoices';
      fullPath: '/dashboard/invoices';
      preLoaderRoute: typeof DashboardDashboardInvoicesRouteImport;
      parentRoute: typeof DashboardRoute;
    };
    '/_dashboard/dashboard/inventory': {
      id: '/_dashboard/dashboard/inventory';
      path: '/dashboard/inventory';
      fullPath: '/dashboard/inventory';
      preLoaderRoute: typeof DashboardDashboardInventoryRouteImport;
      parentRoute: typeof DashboardRoute;
    };
    '/_dashboard/dashboard/inbox': {
      id: '/_dashboard/dashboard/inbox';
      path: '/dashboard/inbox';
      fullPath: '/dashboard/inbox';
      preLoaderRoute: typeof DashboardDashboardInboxRouteImport;
      parentRoute: typeof DashboardRoute;
    };
    '/_dashboard/dashboard/home': {
      id: '/_dashboard/dashboard/home';
      path: '/dashboard/home';
      fullPath: '/dashboard/home';
      preLoaderRoute: typeof DashboardDashboardHomeRouteImport;
      parentRoute: typeof DashboardRoute;
    };
    '/_dashboard/dashboard/forms': {
      id: '/_dashboard/dashboard/forms';
      path: '/dashboard/forms';
      fullPath: '/dashboard/forms';
      preLoaderRoute: typeof DashboardDashboardFormsRouteImport;
      parentRoute: typeof DashboardRoute;
    };
    '/_dashboard/dashboard/executive': {
      id: '/_dashboard/dashboard/executive';
      path: '/dashboard/executive';
      fullPath: '/dashboard/executive';
      preLoaderRoute: typeof DashboardDashboardExecutiveRouteImport;
      parentRoute: typeof DashboardRoute;
    };
    '/_dashboard/dashboard/estimates': {
      id: '/_dashboard/dashboard/estimates';
      path: '/dashboard/estimates';
      fullPath: '/dashboard/estimates';
      preLoaderRoute: typeof DashboardDashboardEstimatesRouteImport;
      parentRoute: typeof DashboardRoute;
    };
    '/_dashboard/dashboard/equipment-descriptions': {
      id: '/_dashboard/dashboard/equipment-descriptions';
      path: '/dashboard/equipment-descriptions';
      fullPath: '/dashboard/equipment-descriptions';
      preLoaderRoute: typeof DashboardDashboardEquipmentDescriptionsRouteImport;
      parentRoute: typeof DashboardRoute;
    };
    '/_dashboard/dashboard/equipment-categories': {
      id: '/_dashboard/dashboard/equipment-categories';
      path: '/dashboard/equipment-categories';
      fullPath: '/dashboard/equipment-categories';
      preLoaderRoute: typeof DashboardDashboardEquipmentCategoriesRouteImport;
      parentRoute: typeof DashboardRoute;
    };
    '/_dashboard/dashboard/equipment': {
      id: '/_dashboard/dashboard/equipment';
      path: '/dashboard/equipment';
      fullPath: '/dashboard/equipment';
      preLoaderRoute: typeof DashboardDashboardEquipmentRouteImport;
      parentRoute: typeof DashboardRoute;
    };
    '/_dashboard/dashboard/dispatch': {
      id: '/_dashboard/dashboard/dispatch';
      path: '/dashboard/dispatch';
      fullPath: '/dashboard/dispatch';
      preLoaderRoute: typeof DashboardDashboardDispatchRouteImport;
      parentRoute: typeof DashboardRoute;
    };
    '/_dashboard/dashboard/deposits': {
      id: '/_dashboard/dashboard/deposits';
      path: '/dashboard/deposits';
      fullPath: '/dashboard/deposits';
      preLoaderRoute: typeof DashboardDashboardDepositsRouteImport;
      parentRoute: typeof DashboardRoute;
    };
    '/_dashboard/dashboard/crews': {
      id: '/_dashboard/dashboard/crews';
      path: '/dashboard/crews';
      fullPath: '/dashboard/crews';
      preLoaderRoute: typeof DashboardDashboardCrewsRouteImport;
      parentRoute: typeof DashboardRoute;
    };
    '/_dashboard/dashboard/crew-members': {
      id: '/_dashboard/dashboard/crew-members';
      path: '/dashboard/crew-members';
      fullPath: '/dashboard/crew-members';
      preLoaderRoute: typeof DashboardDashboardCrewMembersRouteImport;
      parentRoute: typeof DashboardRoute;
    };
    '/_dashboard/dashboard/credit-memos': {
      id: '/_dashboard/dashboard/credit-memos';
      path: '/dashboard/credit-memos';
      fullPath: '/dashboard/credit-memos';
      preLoaderRoute: typeof DashboardDashboardCreditMemosRouteImport;
      parentRoute: typeof DashboardRoute;
    };
    '/_dashboard/dashboard/contracts': {
      id: '/_dashboard/dashboard/contracts';
      path: '/dashboard/contracts';
      fullPath: '/dashboard/contracts';
      preLoaderRoute: typeof DashboardDashboardContractsRouteImport;
      parentRoute: typeof DashboardRoute;
    };
    '/_dashboard/dashboard/contacts': {
      id: '/_dashboard/dashboard/contacts';
      path: '/dashboard/contacts';
      fullPath: '/dashboard/contacts';
      preLoaderRoute: typeof DashboardDashboardContactsRouteImport;
      parentRoute: typeof DashboardRoute;
    };
    '/_dashboard/dashboard/chatbot': {
      id: '/_dashboard/dashboard/chatbot';
      path: '/dashboard/chatbot';
      fullPath: '/dashboard/chatbot';
      preLoaderRoute: typeof DashboardDashboardChatbotRouteImport;
      parentRoute: typeof DashboardRoute;
    };
    '/_dashboard/dashboard/calllogs': {
      id: '/_dashboard/dashboard/calllogs';
      path: '/dashboard/calllogs';
      fullPath: '/dashboard/calllogs';
      preLoaderRoute: typeof DashboardDashboardCalllogsRouteImport;
      parentRoute: typeof DashboardRoute;
    };
    '/_dashboard/dashboard/bookings': {
      id: '/_dashboard/dashboard/bookings';
      path: '/dashboard/bookings';
      fullPath: '/dashboard/bookings';
      preLoaderRoute: typeof DashboardDashboardBookingsRouteImport;
      parentRoute: typeof DashboardRoute;
    };
    '/_dashboard/dashboard/board': {
      id: '/_dashboard/dashboard/board';
      path: '/dashboard/board';
      fullPath: '/dashboard/board';
      preLoaderRoute: typeof DashboardDashboardBoardRouteImport;
      parentRoute: typeof DashboardRoute;
    };
    '/_dashboard/dashboard/audit': {
      id: '/_dashboard/dashboard/audit';
      path: '/dashboard/audit';
      fullPath: '/dashboard/audit';
      preLoaderRoute: typeof DashboardDashboardAuditRouteImport;
      parentRoute: typeof DashboardRoute;
    };
    '/(public)/tip/$id': {
      id: '/(public)/tip/$id';
      path: '/tip/$id';
      fullPath: '/tip/$id';
      preLoaderRoute: typeof publicTipIdRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/(public)/tip-option/$id': {
      id: '/(public)/tip-option/$id';
      path: '/tip-option/$id';
      fullPath: '/tip-option/$id';
      preLoaderRoute: typeof publicTipOptionIdRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/(public)/t/$token': {
      id: '/(public)/t/$token';
      path: '/t/$token';
      fullPath: '/t/$token';
      preLoaderRoute: typeof publicTTokenRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/(public)/supplier-order/$token': {
      id: '/(public)/supplier-order/$token';
      path: '/supplier-order/$token';
      fullPath: '/supplier-order/$token';
      preLoaderRoute: typeof publicSupplierOrderTokenRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/(public)/signed/$signedId': {
      id: '/(public)/signed/$signedId';
      path: '/signed/$signedId';
      fullPath: '/signed/$signedId';
      preLoaderRoute: typeof publicSignedSignedIdRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/(public)/schedule-change/$token': {
      id: '/(public)/schedule-change/$token';
      path: '/schedule-change/$token';
      fullPath: '/schedule-change/$token';
      preLoaderRoute: typeof publicScheduleChangeTokenRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/(public)/s/$code': {
      id: '/(public)/s/$code';
      path: '/s/$code';
      fullPath: '/s/$code';
      preLoaderRoute: typeof publicSCodeRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/(public)/review/$token': {
      id: '/(public)/review/$token';
      path: '/review/$token';
      fullPath: '/review/$token';
      preLoaderRoute: typeof publicReviewTokenRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/(public)/response/$id': {
      id: '/(public)/response/$id';
      path: '/response/$id';
      fullPath: '/response/$id';
      preLoaderRoute: typeof publicResponseIdRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/(public)/repair-payment-method/$token': {
      id: '/(public)/repair-payment-method/$token';
      path: '/repair-payment-method/$token';
      fullPath: '/repair-payment-method/$token';
      preLoaderRoute: typeof publicRepairPaymentMethodTokenRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/(public)/repair-membership/$token': {
      id: '/(public)/repair-membership/$token';
      path: '/repair-membership/$token';
      fullPath: '/repair-membership/$token';
      preLoaderRoute: typeof publicRepairMembershipTokenRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/(public)/recurring/$token': {
      id: '/(public)/recurring/$token';
      path: '/recurring/$token';
      fullPath: '/recurring/$token';
      preLoaderRoute: typeof publicRecurringTokenRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/(public)/recurring-renewal/$token': {
      id: '/(public)/recurring-renewal/$token';
      path: '/recurring-renewal/$token';
      fullPath: '/recurring-renewal/$token';
      preLoaderRoute: typeof publicRecurringRenewalTokenRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/(public)/receipt/$id': {
      id: '/(public)/receipt/$id';
      path: '/receipt/$id';
      fullPath: '/receipt/$id';
      preLoaderRoute: typeof publicReceiptIdRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/(public)/r/$token': {
      id: '/(public)/r/$token';
      path: '/r/$token';
      fullPath: '/r/$token';
      preLoaderRoute: typeof publicRTokenRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/(public)/quote/$id': {
      id: '/(public)/quote/$id';
      path: '/quote/$id';
      fullPath: '/quote/$id';
      preLoaderRoute: typeof publicQuoteIdRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/(public)/proposal/$id': {
      id: '/(public)/proposal/$id';
      path: '/proposal/$id';
      fullPath: '/proposal/$id';
      preLoaderRoute: typeof publicProposalIdRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/(public)/previewquote/$id': {
      id: '/(public)/previewquote/$id';
      path: '/previewquote/$id';
      fullPath: '/previewquote/$id';
      preLoaderRoute: typeof publicPreviewquoteIdRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/(public)/previewinvoice/$id': {
      id: '/(public)/previewinvoice/$id';
      path: '/previewinvoice/$id';
      fullPath: '/previewinvoice/$id';
      preLoaderRoute: typeof publicPreviewinvoiceIdRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/(public)/pdf-proposal/$id': {
      id: '/(public)/pdf-proposal/$id';
      path: '/pdf-proposal/$id';
      fullPath: '/pdf-proposal/$id';
      preLoaderRoute: typeof publicPdfProposalIdRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/(public)/pdf-invoice/$id': {
      id: '/(public)/pdf-invoice/$id';
      path: '/pdf-invoice/$id';
      fullPath: '/pdf-invoice/$id';
      preLoaderRoute: typeof publicPdfInvoiceIdRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/(public)/pdf-estimate/$id': {
      id: '/(public)/pdf-estimate/$id';
      path: '/pdf-estimate/$id';
      fullPath: '/pdf-estimate/$id';
      preLoaderRoute: typeof publicPdfEstimateIdRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/(public)/payment-method-request/$token': {
      id: '/(public)/payment-method-request/$token';
      path: '/payment-method-request/$token';
      fullPath: '/payment-method-request/$token';
      preLoaderRoute: typeof publicPaymentMethodRequestTokenRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/(public)/pay/$token': {
      id: '/(public)/pay/$token';
      path: '/pay/$token';
      fullPath: '/pay/$token';
      preLoaderRoute: typeof publicPayTokenRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/(public)/onlineform/$id': {
      id: '/(public)/onlineform/$id';
      path: '/onlineform/$id';
      fullPath: '/onlineform/$id';
      preLoaderRoute: typeof publicOnlineformIdRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/(public)/onlinebooking/$id': {
      id: '/(public)/onlinebooking/$id';
      path: '/onlinebooking/$id';
      fullPath: '/onlinebooking/$id';
      preLoaderRoute: typeof publicOnlinebookingIdRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/(public)/link-phone/$token': {
      id: '/(public)/link-phone/$token';
      path: '/link-phone/$token';
      fullPath: '/link-phone/$token';
      preLoaderRoute: typeof publicLinkPhoneTokenRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/(public)/job-stories/$token': {
      id: '/(public)/job-stories/$token';
      path: '/job-stories/$token';
      fullPath: '/job-stories/$token';
      preLoaderRoute: typeof publicJobStoriesTokenRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/(public)/j/$referenceNo': {
      id: '/(public)/j/$referenceNo';
      path: '/j/$referenceNo';
      fullPath: '/j/$referenceNo';
      preLoaderRoute: typeof publicJReferenceNoRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/(public)/invoice/$id': {
      id: '/(public)/invoice/$id';
      path: '/invoice/$id';
      fullPath: '/invoice/$id';
      preLoaderRoute: typeof publicInvoiceIdRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/(public)/invite/$token': {
      id: '/(public)/invite/$token';
      path: '/$token';
      fullPath: '/invite/$token';
      preLoaderRoute: typeof publicInviteTokenRouteImport;
      parentRoute: typeof publicInviteRoute;
    };
    '/(public)/i/$id': {
      id: '/(public)/i/$id';
      path: '/i/$id';
      fullPath: '/i/$id';
      preLoaderRoute: typeof publicIIdRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/(public)/form/$id': {
      id: '/(public)/form/$id';
      path: '/form/$id';
      fullPath: '/form/$id';
      preLoaderRoute: typeof publicFormIdRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/(public)/estimate/$id': {
      id: '/(public)/estimate/$id';
      path: '/estimate/$id';
      fullPath: '/estimate/$id';
      preLoaderRoute: typeof publicEstimateIdRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/(public)/e/$token': {
      id: '/(public)/e/$token';
      path: '/e/$token';
      fullPath: '/e/$token';
      preLoaderRoute: typeof publicETokenRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/(public)/create-password/$token': {
      id: '/(public)/create-password/$token';
      path: '/$token';
      fullPath: '/create-password/$token';
      preLoaderRoute: typeof publicCreatePasswordTokenRouteImport;
      parentRoute: typeof publicCreatePasswordRoute;
    };
    '/(public)/confirm-job/$referenceNo': {
      id: '/(public)/confirm-job/$referenceNo';
      path: '/confirm-job/$referenceNo';
      fullPath: '/confirm-job/$referenceNo';
      preLoaderRoute: typeof publicConfirmJobReferenceNoRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/(public)/combined-doc/$token': {
      id: '/(public)/combined-doc/$token';
      path: '/combined-doc/$token';
      fullPath: '/combined-doc/$token';
      preLoaderRoute: typeof publicCombinedDocTokenRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/(public)/change-order/$id': {
      id: '/(public)/change-order/$id';
      path: '/change-order/$id';
      fullPath: '/change-order/$id';
      preLoaderRoute: typeof publicChangeOrderIdRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/(public)/c/$token': {
      id: '/(public)/c/$token';
      path: '/c/$token';
      fullPath: '/c/$token';
      preLoaderRoute: typeof publicCTokenRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/(public)/book/$token': {
      id: '/(public)/book/$token';
      path: '/book/$token';
      fullPath: '/book/$token';
      preLoaderRoute: typeof publicBookTokenRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/(public)/auth/impersonate-handoff': {
      id: '/(public)/auth/impersonate-handoff';
      path: '/auth/impersonate-handoff';
      fullPath: '/auth/impersonate-handoff';
      preLoaderRoute: typeof publicAuthImpersonateHandoffRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/(portal)/portal/verify': {
      id: '/(portal)/portal/verify';
      path: '/portal/verify';
      fullPath: '/portal/verify';
      preLoaderRoute: typeof portalPortalVerifyRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/(portal)/portal/reset': {
      id: '/(portal)/portal/reset';
      path: '/portal/reset';
      fullPath: '/portal/reset';
      preLoaderRoute: typeof portalPortalResetRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/(portal)/portal/register': {
      id: '/(portal)/portal/register';
      path: '/portal/register';
      fullPath: '/portal/register';
      preLoaderRoute: typeof portalPortalRegisterRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/(portal)/portal/login': {
      id: '/(portal)/portal/login';
      path: '/portal/login';
      fullPath: '/portal/login';
      preLoaderRoute: typeof portalPortalLoginRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/(portal)/portal/forgot': {
      id: '/(portal)/portal/forgot';
      path: '/portal/forgot';
      fullPath: '/portal/forgot';
      preLoaderRoute: typeof portalPortalForgotRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/_dashboard/dashboard/unscheduled/': {
      id: '/_dashboard/dashboard/unscheduled/';
      path: '/dashboard/unscheduled';
      fullPath: '/dashboard/unscheduled/';
      preLoaderRoute: typeof DashboardDashboardUnscheduledIndexRouteImport;
      parentRoute: typeof DashboardRoute;
    };
    '/_dashboard/dashboard/technicians/': {
      id: '/_dashboard/dashboard/technicians/';
      path: '/';
      fullPath: '/dashboard/technicians/';
      preLoaderRoute: typeof DashboardDashboardTechniciansIndexRouteImport;
      parentRoute: typeof DashboardDashboardTechniciansRoute;
    };
    '/_dashboard/dashboard/settings/': {
      id: '/_dashboard/dashboard/settings/';
      path: '/';
      fullPath: '/dashboard/settings/';
      preLoaderRoute: typeof DashboardDashboardSettingsIndexRouteImport;
      parentRoute: typeof DashboardDashboardSettingsRoute;
    };
    '/_dashboard/dashboard/receipts/': {
      id: '/_dashboard/dashboard/receipts/';
      path: '/';
      fullPath: '/dashboard/receipts/';
      preLoaderRoute: typeof DashboardDashboardReceiptsIndexRouteImport;
      parentRoute: typeof DashboardDashboardReceiptsRoute;
    };
    '/_dashboard/dashboard/purchasing/': {
      id: '/_dashboard/dashboard/purchasing/';
      path: '/';
      fullPath: '/dashboard/purchasing/';
      preLoaderRoute: typeof DashboardDashboardPurchasingIndexRouteImport;
      parentRoute: typeof DashboardDashboardPurchasingRoute;
    };
    '/_dashboard/dashboard/proposals/': {
      id: '/_dashboard/dashboard/proposals/';
      path: '/';
      fullPath: '/dashboard/proposals/';
      preLoaderRoute: typeof DashboardDashboardProposalsIndexRouteImport;
      parentRoute: typeof DashboardDashboardProposalsRoute;
    };
    '/_dashboard/dashboard/pricebook/': {
      id: '/_dashboard/dashboard/pricebook/';
      path: '/';
      fullPath: '/dashboard/pricebook/';
      preLoaderRoute: typeof DashboardDashboardPricebookIndexRouteImport;
      parentRoute: typeof DashboardDashboardPricebookRoute;
    };
    '/_dashboard/dashboard/memberships/': {
      id: '/_dashboard/dashboard/memberships/';
      path: '/';
      fullPath: '/dashboard/memberships/';
      preLoaderRoute: typeof DashboardDashboardMembershipsIndexRouteImport;
      parentRoute: typeof DashboardDashboardMembershipsRoute;
    };
    '/_dashboard/dashboard/membership-plans/': {
      id: '/_dashboard/dashboard/membership-plans/';
      path: '/';
      fullPath: '/dashboard/membership-plans/';
      preLoaderRoute: typeof DashboardDashboardMembershipPlansIndexRouteImport;
      parentRoute: typeof DashboardDashboardMembershipPlansRoute;
    };
    '/_dashboard/dashboard/leads/': {
      id: '/_dashboard/dashboard/leads/';
      path: '/';
      fullPath: '/dashboard/leads/';
      preLoaderRoute: typeof DashboardDashboardLeadsIndexRouteImport;
      parentRoute: typeof DashboardDashboardLeadsRoute;
    };
    '/_dashboard/dashboard/jobs/': {
      id: '/_dashboard/dashboard/jobs/';
      path: '/';
      fullPath: '/dashboard/jobs/';
      preLoaderRoute: typeof DashboardDashboardJobsIndexRouteImport;
      parentRoute: typeof DashboardDashboardJobsRoute;
    };
    '/_dashboard/dashboard/jobform/': {
      id: '/_dashboard/dashboard/jobform/';
      path: '/dashboard/jobform';
      fullPath: '/dashboard/jobform/';
      preLoaderRoute: typeof DashboardDashboardJobformIndexRouteImport;
      parentRoute: typeof DashboardRoute;
    };
    '/_dashboard/dashboard/invoices/': {
      id: '/_dashboard/dashboard/invoices/';
      path: '/';
      fullPath: '/dashboard/invoices/';
      preLoaderRoute: typeof DashboardDashboardInvoicesIndexRouteImport;
      parentRoute: typeof DashboardDashboardInvoicesRoute;
    };
    '/_dashboard/dashboard/inventory/': {
      id: '/_dashboard/dashboard/inventory/';
      path: '/';
      fullPath: '/dashboard/inventory/';
      preLoaderRoute: typeof DashboardDashboardInventoryIndexRouteImport;
      parentRoute: typeof DashboardDashboardInventoryRoute;
    };
    '/_dashboard/dashboard/forms/': {
      id: '/_dashboard/dashboard/forms/';
      path: '/';
      fullPath: '/dashboard/forms/';
      preLoaderRoute: typeof DashboardDashboardFormsIndexRouteImport;
      parentRoute: typeof DashboardDashboardFormsRoute;
    };
    '/_dashboard/dashboard/estimates/': {
      id: '/_dashboard/dashboard/estimates/';
      path: '/';
      fullPath: '/dashboard/estimates/';
      preLoaderRoute: typeof DashboardDashboardEstimatesIndexRouteImport;
      parentRoute: typeof DashboardDashboardEstimatesRoute;
    };
    '/_dashboard/dashboard/crewmember/': {
      id: '/_dashboard/dashboard/crewmember/';
      path: '/dashboard/crewmember';
      fullPath: '/dashboard/crewmember/';
      preLoaderRoute: typeof DashboardDashboardCrewmemberIndexRouteImport;
      parentRoute: typeof DashboardRoute;
    };
    '/_dashboard/dashboard/credit-memos/': {
      id: '/_dashboard/dashboard/credit-memos/';
      path: '/';
      fullPath: '/dashboard/credit-memos/';
      preLoaderRoute: typeof DashboardDashboardCreditMemosIndexRouteImport;
      parentRoute: typeof DashboardDashboardCreditMemosRoute;
    };
    '/_dashboard/dashboard/contacts/': {
      id: '/_dashboard/dashboard/contacts/';
      path: '/';
      fullPath: '/dashboard/contacts/';
      preLoaderRoute: typeof DashboardDashboardContactsIndexRouteImport;
      parentRoute: typeof DashboardDashboardContactsRoute;
    };
    '/_dashboard/dashboard/calendar/': {
      id: '/_dashboard/dashboard/calendar/';
      path: '/dashboard/calendar';
      fullPath: '/dashboard/calendar/';
      preLoaderRoute: typeof DashboardDashboardCalendarIndexRouteImport;
      parentRoute: typeof DashboardRoute;
    };
    '/_dashboard/dashboard/bookings/': {
      id: '/_dashboard/dashboard/bookings/';
      path: '/';
      fullPath: '/dashboard/bookings/';
      preLoaderRoute: typeof DashboardDashboardBookingsIndexRouteImport;
      parentRoute: typeof DashboardDashboardBookingsRoute;
    };
    '/(portal)/portal/visits/': {
      id: '/(portal)/portal/visits/';
      path: '/portal/visits';
      fullPath: '/portal/visits/';
      preLoaderRoute: typeof portalPortalVisitsIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/(portal)/portal/proposals/': {
      id: '/(portal)/portal/proposals/';
      path: '/portal/proposals';
      fullPath: '/portal/proposals/';
      preLoaderRoute: typeof portalPortalProposalsIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/(portal)/portal/plans/': {
      id: '/(portal)/portal/plans/';
      path: '/portal/plans';
      fullPath: '/portal/plans/';
      preLoaderRoute: typeof portalPortalPlansIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/(portal)/portal/memberships/': {
      id: '/(portal)/portal/memberships/';
      path: '/portal/memberships';
      fullPath: '/portal/memberships/';
      preLoaderRoute: typeof portalPortalMembershipsIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/(portal)/portal/invoices/': {
      id: '/(portal)/portal/invoices/';
      path: '/portal/invoices';
      fullPath: '/portal/invoices/';
      preLoaderRoute: typeof portalPortalInvoicesIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/(portal)/portal/estimates/': {
      id: '/(portal)/portal/estimates/';
      path: '/portal/estimates';
      fullPath: '/portal/estimates/';
      preLoaderRoute: typeof portalPortalEstimatesIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/(portal)/portal/equipment/': {
      id: '/(portal)/portal/equipment/';
      path: '/portal/equipment';
      fullPath: '/portal/equipment/';
      preLoaderRoute: typeof portalPortalEquipmentIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/(portal)/portal/documents/': {
      id: '/(portal)/portal/documents/';
      path: '/portal/documents';
      fullPath: '/portal/documents/';
      preLoaderRoute: typeof portalPortalDocumentsIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/(portal)/portal/account/': {
      id: '/(portal)/portal/account/';
      path: '/portal/account';
      fullPath: '/portal/account/';
      preLoaderRoute: typeof portalPortalAccountIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/_dashboard/dashboard/technicians/reports': {
      id: '/_dashboard/dashboard/technicians/reports';
      path: '/reports';
      fullPath: '/dashboard/technicians/reports';
      preLoaderRoute: typeof DashboardDashboardTechniciansReportsRouteImport;
      parentRoute: typeof DashboardDashboardTechniciansRoute;
    };
    '/_dashboard/dashboard/technicians/new': {
      id: '/_dashboard/dashboard/technicians/new';
      path: '/new';
      fullPath: '/dashboard/technicians/new';
      preLoaderRoute: typeof DashboardDashboardTechniciansNewRouteImport;
      parentRoute: typeof DashboardDashboardTechniciansRoute;
    };
    '/_dashboard/dashboard/technicians/$id': {
      id: '/_dashboard/dashboard/technicians/$id';
      path: '/$id';
      fullPath: '/dashboard/technicians/$id';
      preLoaderRoute: typeof DashboardDashboardTechniciansIdRouteImport;
      parentRoute: typeof DashboardDashboardTechniciansRoute;
    };
    '/_dashboard/dashboard/taxes/simulator': {
      id: '/_dashboard/dashboard/taxes/simulator';
      path: '/simulator';
      fullPath: '/dashboard/taxes/simulator';
      preLoaderRoute: typeof DashboardDashboardTaxesSimulatorRouteImport;
      parentRoute: typeof DashboardDashboardTaxesRoute;
    };
    '/_dashboard/dashboard/taxes/rules': {
      id: '/_dashboard/dashboard/taxes/rules';
      path: '/rules';
      fullPath: '/dashboard/taxes/rules';
      preLoaderRoute: typeof DashboardDashboardTaxesRulesRouteImport;
      parentRoute: typeof DashboardDashboardTaxesRoute;
    };
    '/_dashboard/dashboard/taxes/overrides': {
      id: '/_dashboard/dashboard/taxes/overrides';
      path: '/overrides';
      fullPath: '/dashboard/taxes/overrides';
      preLoaderRoute: typeof DashboardDashboardTaxesOverridesRouteImport;
      parentRoute: typeof DashboardDashboardTaxesRoute;
    };
    '/_dashboard/dashboard/settings/webhooks': {
      id: '/_dashboard/dashboard/settings/webhooks';
      path: '/webhooks';
      fullPath: '/dashboard/settings/webhooks';
      preLoaderRoute: typeof DashboardDashboardSettingsWebhooksRouteImport;
      parentRoute: typeof DashboardDashboardSettingsRoute;
    };
    '/_dashboard/dashboard/settings/users': {
      id: '/_dashboard/dashboard/settings/users';
      path: '/users';
      fullPath: '/dashboard/settings/users';
      preLoaderRoute: typeof DashboardDashboardSettingsUsersRouteImport;
      parentRoute: typeof DashboardDashboardSettingsRoute;
    };
    '/_dashboard/dashboard/settings/trades': {
      id: '/_dashboard/dashboard/settings/trades';
      path: '/trades';
      fullPath: '/dashboard/settings/trades';
      preLoaderRoute: typeof DashboardDashboardSettingsTradesRouteImport;
      parentRoute: typeof DashboardDashboardSettingsRoute;
    };
    '/_dashboard/dashboard/settings/terms-and-conditions': {
      id: '/_dashboard/dashboard/settings/terms-and-conditions';
      path: '/terms-and-conditions';
      fullPath: '/dashboard/settings/terms-and-conditions';
      preLoaderRoute: typeof DashboardDashboardSettingsTermsAndConditionsRouteImport;
      parentRoute: typeof DashboardDashboardSettingsRoute;
    };
    '/_dashboard/dashboard/settings/templates': {
      id: '/_dashboard/dashboard/settings/templates';
      path: '/templates';
      fullPath: '/dashboard/settings/templates';
      preLoaderRoute: typeof DashboardDashboardSettingsTemplatesRouteImport;
      parentRoute: typeof DashboardDashboardSettingsRoute;
    };
    '/_dashboard/dashboard/settings/taxes': {
      id: '/_dashboard/dashboard/settings/taxes';
      path: '/taxes';
      fullPath: '/dashboard/settings/taxes';
      preLoaderRoute: typeof DashboardDashboardSettingsTaxesRouteImport;
      parentRoute: typeof DashboardDashboardSettingsRoute;
    };
    '/_dashboard/dashboard/settings/tags': {
      id: '/_dashboard/dashboard/settings/tags';
      path: '/tags';
      fullPath: '/dashboard/settings/tags';
      preLoaderRoute: typeof DashboardDashboardSettingsTagsRouteImport;
      parentRoute: typeof DashboardDashboardSettingsRoute;
    };
    '/_dashboard/dashboard/settings/surveys': {
      id: '/_dashboard/dashboard/settings/surveys';
      path: '/surveys';
      fullPath: '/dashboard/settings/surveys';
      preLoaderRoute: typeof DashboardDashboardSettingsSurveysRouteImport;
      parentRoute: typeof DashboardDashboardSettingsRoute;
    };
    '/_dashboard/dashboard/settings/suppliers': {
      id: '/_dashboard/dashboard/settings/suppliers';
      path: '/suppliers';
      fullPath: '/dashboard/settings/suppliers';
      preLoaderRoute: typeof DashboardDashboardSettingsSuppliersRouteImport;
      parentRoute: typeof DashboardDashboardSettingsRoute;
    };
    '/_dashboard/dashboard/settings/subscription': {
      id: '/_dashboard/dashboard/settings/subscription';
      path: '/subscription';
      fullPath: '/dashboard/settings/subscription';
      preLoaderRoute: typeof DashboardDashboardSettingsSubscriptionRouteImport;
      parentRoute: typeof DashboardDashboardSettingsRoute;
    };
    '/_dashboard/dashboard/settings/sms': {
      id: '/_dashboard/dashboard/settings/sms';
      path: '/sms';
      fullPath: '/dashboard/settings/sms';
      preLoaderRoute: typeof DashboardDashboardSettingsSmsRouteImport;
      parentRoute: typeof DashboardDashboardSettingsRoute;
    };
    '/_dashboard/dashboard/settings/skills': {
      id: '/_dashboard/dashboard/settings/skills';
      path: '/skills';
      fullPath: '/dashboard/settings/skills';
      preLoaderRoute: typeof DashboardDashboardSettingsSkillsRouteImport;
      parentRoute: typeof DashboardDashboardSettingsRoute;
    };
    '/_dashboard/dashboard/settings/service-areas': {
      id: '/_dashboard/dashboard/settings/service-areas';
      path: '/service-areas';
      fullPath: '/dashboard/settings/service-areas';
      preLoaderRoute: typeof DashboardDashboardSettingsServiceAreasRouteImport;
      parentRoute: typeof DashboardDashboardSettingsRoute;
    };
    '/_dashboard/dashboard/settings/scope-of-work': {
      id: '/_dashboard/dashboard/settings/scope-of-work';
      path: '/scope-of-work';
      fullPath: '/dashboard/settings/scope-of-work';
      preLoaderRoute: typeof DashboardDashboardSettingsScopeOfWorkRouteImport;
      parentRoute: typeof DashboardDashboardSettingsRoute;
    };
    '/_dashboard/dashboard/settings/reviews': {
      id: '/_dashboard/dashboard/settings/reviews';
      path: '/reviews';
      fullPath: '/dashboard/settings/reviews';
      preLoaderRoute: typeof DashboardDashboardSettingsReviewsRouteImport;
      parentRoute: typeof DashboardDashboardSettingsRoute;
    };
    '/_dashboard/dashboard/settings/review-platforms': {
      id: '/_dashboard/dashboard/settings/review-platforms';
      path: '/review-platforms';
      fullPath: '/dashboard/settings/review-platforms';
      preLoaderRoute: typeof DashboardDashboardSettingsReviewPlatformsRouteImport;
      parentRoute: typeof DashboardDashboardSettingsRoute;
    };
    '/_dashboard/dashboard/settings/reports': {
      id: '/_dashboard/dashboard/settings/reports';
      path: '/reports';
      fullPath: '/dashboard/settings/reports';
      preLoaderRoute: typeof DashboardDashboardSettingsReportsRouteImport;
      parentRoute: typeof DashboardDashboardSettingsRoute;
    };
    '/_dashboard/dashboard/settings/reminders': {
      id: '/_dashboard/dashboard/settings/reminders';
      path: '/reminders';
      fullPath: '/dashboard/settings/reminders';
      preLoaderRoute: typeof DashboardDashboardSettingsRemindersRouteImport;
      parentRoute: typeof DashboardDashboardSettingsRoute;
    };
    '/_dashboard/dashboard/settings/quickbooks': {
      id: '/_dashboard/dashboard/settings/quickbooks';
      path: '/quickbooks';
      fullPath: '/dashboard/settings/quickbooks';
      preLoaderRoute: typeof DashboardDashboardSettingsQuickbooksRouteImport;
      parentRoute: typeof DashboardDashboardSettingsRoute;
    };
    '/_dashboard/dashboard/settings/purchasing': {
      id: '/_dashboard/dashboard/settings/purchasing';
      path: '/purchasing';
      fullPath: '/dashboard/settings/purchasing';
      preLoaderRoute: typeof DashboardDashboardSettingsPurchasingRouteImport;
      parentRoute: typeof DashboardDashboardSettingsRoute;
    };
    '/_dashboard/dashboard/settings/phone': {
      id: '/_dashboard/dashboard/settings/phone';
      path: '/phone';
      fullPath: '/dashboard/settings/phone';
      preLoaderRoute: typeof DashboardDashboardSettingsPhoneRouteImport;
      parentRoute: typeof DashboardDashboardSettingsRoute;
    };
    '/_dashboard/dashboard/settings/permissions': {
      id: '/_dashboard/dashboard/settings/permissions';
      path: '/permissions';
      fullPath: '/dashboard/settings/permissions';
      preLoaderRoute: typeof DashboardDashboardSettingsPermissionsRouteImport;
      parentRoute: typeof DashboardDashboardSettingsRoute;
    };
    '/_dashboard/dashboard/settings/payroll-profiles': {
      id: '/_dashboard/dashboard/settings/payroll-profiles';
      path: '/payroll-profiles';
      fullPath: '/dashboard/settings/payroll-profiles';
      preLoaderRoute: typeof DashboardDashboardSettingsPayrollProfilesRouteImport;
      parentRoute: typeof DashboardDashboardSettingsRoute;
    };
    '/_dashboard/dashboard/settings/online-booking': {
      id: '/_dashboard/dashboard/settings/online-booking';
      path: '/online-booking';
      fullPath: '/dashboard/settings/online-booking';
      preLoaderRoute: typeof DashboardDashboardSettingsOnlineBookingRouteImport;
      parentRoute: typeof DashboardDashboardSettingsRoute;
    };
    '/_dashboard/dashboard/settings/oncall': {
      id: '/_dashboard/dashboard/settings/oncall';
      path: '/oncall';
      fullPath: '/dashboard/settings/oncall';
      preLoaderRoute: typeof DashboardDashboardSettingsOncallRouteImport;
      parentRoute: typeof DashboardDashboardSettingsRoute;
    };
    '/_dashboard/dashboard/settings/office-settings': {
      id: '/_dashboard/dashboard/settings/office-settings';
      path: '/office-settings';
      fullPath: '/dashboard/settings/office-settings';
      preLoaderRoute: typeof DashboardDashboardSettingsOfficeSettingsRouteImport;
      parentRoute: typeof DashboardDashboardSettingsRoute;
    };
    '/_dashboard/dashboard/settings/notifications': {
      id: '/_dashboard/dashboard/settings/notifications';
      path: '/notifications';
      fullPath: '/dashboard/settings/notifications';
      preLoaderRoute: typeof DashboardDashboardSettingsNotificationsRouteImport;
      parentRoute: typeof DashboardDashboardSettingsRoute;
    };
    '/_dashboard/dashboard/settings/logout': {
      id: '/_dashboard/dashboard/settings/logout';
      path: '/logout';
      fullPath: '/dashboard/settings/logout';
      preLoaderRoute: typeof DashboardDashboardSettingsLogoutRouteImport;
      parentRoute: typeof DashboardDashboardSettingsRoute;
    };
    '/_dashboard/dashboard/settings/leads': {
      id: '/_dashboard/dashboard/settings/leads';
      path: '/leads';
      fullPath: '/dashboard/settings/leads';
      preLoaderRoute: typeof DashboardDashboardSettingsLeadsRouteImport;
      parentRoute: typeof DashboardDashboardSettingsRoute;
    };
    '/_dashboard/dashboard/settings/jobtypes': {
      id: '/_dashboard/dashboard/settings/jobtypes';
      path: '/jobtypes';
      fullPath: '/dashboard/settings/jobtypes';
      preLoaderRoute: typeof DashboardDashboardSettingsJobtypesRouteImport;
      parentRoute: typeof DashboardDashboardSettingsRoute;
    };
    '/_dashboard/dashboard/settings/job-pipelines': {
      id: '/_dashboard/dashboard/settings/job-pipelines';
      path: '/job-pipelines';
      fullPath: '/dashboard/settings/job-pipelines';
      preLoaderRoute: typeof DashboardDashboardSettingsJobPipelinesRouteImport;
      parentRoute: typeof DashboardDashboardSettingsRoute;
    };
    '/_dashboard/dashboard/settings/integrations': {
      id: '/_dashboard/dashboard/settings/integrations';
      path: '/integrations';
      fullPath: '/dashboard/settings/integrations';
      preLoaderRoute: typeof DashboardDashboardSettingsIntegrationsRouteImport;
      parentRoute: typeof DashboardDashboardSettingsRoute;
    };
    '/_dashboard/dashboard/settings/groups': {
      id: '/_dashboard/dashboard/settings/groups';
      path: '/groups';
      fullPath: '/dashboard/settings/groups';
      preLoaderRoute: typeof DashboardDashboardSettingsGroupsRouteImport;
      parentRoute: typeof DashboardDashboardSettingsRoute;
    };
    '/_dashboard/dashboard/settings/estimates': {
      id: '/_dashboard/dashboard/settings/estimates';
      path: '/estimates';
      fullPath: '/dashboard/settings/estimates';
      preLoaderRoute: typeof DashboardDashboardSettingsEstimatesRouteImport;
      parentRoute: typeof DashboardDashboardSettingsRoute;
    };
    '/_dashboard/dashboard/settings/estimate-settings': {
      id: '/_dashboard/dashboard/settings/estimate-settings';
      path: '/estimate-settings';
      fullPath: '/dashboard/settings/estimate-settings';
      preLoaderRoute: typeof DashboardDashboardSettingsEstimateSettingsRouteImport;
      parentRoute: typeof DashboardDashboardSettingsRoute;
    };
    '/_dashboard/dashboard/settings/estimate-pdf': {
      id: '/_dashboard/dashboard/settings/estimate-pdf';
      path: '/estimate-pdf';
      fullPath: '/dashboard/settings/estimate-pdf';
      preLoaderRoute: typeof DashboardDashboardSettingsEstimatePdfRouteImport;
      parentRoute: typeof DashboardDashboardSettingsRoute;
    };
    '/_dashboard/dashboard/settings/email-accounts': {
      id: '/_dashboard/dashboard/settings/email-accounts';
      path: '/email-accounts';
      fullPath: '/dashboard/settings/email-accounts';
      preLoaderRoute: typeof DashboardDashboardSettingsEmailAccountsRouteImport;
      parentRoute: typeof DashboardDashboardSettingsRoute;
    };
    '/_dashboard/dashboard/settings/deferred-revenue': {
      id: '/_dashboard/dashboard/settings/deferred-revenue';
      path: '/deferred-revenue';
      fullPath: '/dashboard/settings/deferred-revenue';
      preLoaderRoute: typeof DashboardDashboardSettingsDeferredRevenueRouteImport;
      parentRoute: typeof DashboardDashboardSettingsRoute;
    };
    '/_dashboard/dashboard/settings/customfields': {
      id: '/_dashboard/dashboard/settings/customfields';
      path: '/customfields';
      fullPath: '/dashboard/settings/customfields';
      preLoaderRoute: typeof DashboardDashboardSettingsCustomfieldsRouteImport;
      parentRoute: typeof DashboardDashboardSettingsRoute;
    };
    '/_dashboard/dashboard/settings/contracts': {
      id: '/_dashboard/dashboard/settings/contracts';
      path: '/contracts';
      fullPath: '/dashboard/settings/contracts';
      preLoaderRoute: typeof DashboardDashboardSettingsContractsRouteImport;
      parentRoute: typeof DashboardDashboardSettingsRoute;
    };
    '/_dashboard/dashboard/settings/contact-statuses': {
      id: '/_dashboard/dashboard/settings/contact-statuses';
      path: '/contact-statuses';
      fullPath: '/dashboard/settings/contact-statuses';
      preLoaderRoute: typeof DashboardDashboardSettingsContactStatusesRouteImport;
      parentRoute: typeof DashboardDashboardSettingsRoute;
    };
    '/_dashboard/dashboard/settings/connections': {
      id: '/_dashboard/dashboard/settings/connections';
      path: '/connections';
      fullPath: '/dashboard/settings/connections';
      preLoaderRoute: typeof DashboardDashboardSettingsConnectionsRouteImport;
      parentRoute: typeof DashboardDashboardSettingsRoute;
    };
    '/_dashboard/dashboard/settings/company': {
      id: '/_dashboard/dashboard/settings/company';
      path: '/company';
      fullPath: '/dashboard/settings/company';
      preLoaderRoute: typeof DashboardDashboardSettingsCompanyRouteImport;
      parentRoute: typeof DashboardDashboardSettingsRoute;
    };
    '/_dashboard/dashboard/settings/client-portal': {
      id: '/_dashboard/dashboard/settings/client-portal';
      path: '/client-portal';
      fullPath: '/dashboard/settings/client-portal';
      preLoaderRoute: typeof DashboardDashboardSettingsClientPortalRouteImport;
      parentRoute: typeof DashboardDashboardSettingsRoute;
    };
    '/_dashboard/dashboard/settings/checklist': {
      id: '/_dashboard/dashboard/settings/checklist';
      path: '/checklist';
      fullPath: '/dashboard/settings/checklist';
      preLoaderRoute: typeof DashboardDashboardSettingsChecklistRouteImport;
      parentRoute: typeof DashboardDashboardSettingsRoute;
    };
    '/_dashboard/dashboard/settings/chatbot': {
      id: '/_dashboard/dashboard/settings/chatbot';
      path: '/chatbot';
      fullPath: '/dashboard/settings/chatbot';
      preLoaderRoute: typeof DashboardDashboardSettingsChatbotRouteImport;
      parentRoute: typeof DashboardDashboardSettingsRoute;
    };
    '/_dashboard/dashboard/settings/channels': {
      id: '/_dashboard/dashboard/settings/channels';
      path: '/channels';
      fullPath: '/dashboard/settings/channels';
      preLoaderRoute: typeof DashboardDashboardSettingsChannelsRouteImport;
      parentRoute: typeof DashboardDashboardSettingsRoute;
    };
    '/_dashboard/dashboard/settings/calltree': {
      id: '/_dashboard/dashboard/settings/calltree';
      path: '/calltree';
      fullPath: '/dashboard/settings/calltree';
      preLoaderRoute: typeof DashboardDashboardSettingsCalltreeRouteImport;
      parentRoute: typeof DashboardDashboardSettingsRoute;
    };
    '/_dashboard/dashboard/settings/call-settings': {
      id: '/_dashboard/dashboard/settings/call-settings';
      path: '/call-settings';
      fullPath: '/dashboard/settings/call-settings';
      preLoaderRoute: typeof DashboardDashboardSettingsCallSettingsRouteImport;
      parentRoute: typeof DashboardDashboardSettingsRoute;
    };
    '/_dashboard/dashboard/settings/booking-windows': {
      id: '/_dashboard/dashboard/settings/booking-windows';
      path: '/booking-windows';
      fullPath: '/dashboard/settings/booking-windows';
      preLoaderRoute: typeof DashboardDashboardSettingsBookingWindowsRouteImport;
      parentRoute: typeof DashboardDashboardSettingsRoute;
    };
    '/_dashboard/dashboard/settings/booking-services': {
      id: '/_dashboard/dashboard/settings/booking-services';
      path: '/booking-services';
      fullPath: '/dashboard/settings/booking-services';
      preLoaderRoute: typeof DashboardDashboardSettingsBookingServicesRouteImport;
      parentRoute: typeof DashboardDashboardSettingsRoute;
    };
    '/_dashboard/dashboard/settings/booking-links': {
      id: '/_dashboard/dashboard/settings/booking-links';
      path: '/booking-links';
      fullPath: '/dashboard/settings/booking-links';
      preLoaderRoute: typeof DashboardDashboardSettingsBookingLinksRouteImport;
      parentRoute: typeof DashboardDashboardSettingsRoute;
    };
    '/_dashboard/dashboard/settings/billing': {
      id: '/_dashboard/dashboard/settings/billing';
      path: '/billing';
      fullPath: '/dashboard/settings/billing';
      preLoaderRoute: typeof DashboardDashboardSettingsBillingRouteImport;
      parentRoute: typeof DashboardDashboardSettingsRoute;
    };
    '/_dashboard/dashboard/settings/appointment-forms': {
      id: '/_dashboard/dashboard/settings/appointment-forms';
      path: '/appointment-forms';
      fullPath: '/dashboard/settings/appointment-forms';
      preLoaderRoute: typeof DashboardDashboardSettingsAppointmentFormsRouteImport;
      parentRoute: typeof DashboardDashboardSettingsRoute;
    };
    '/_dashboard/dashboard/settings/api-keys': {
      id: '/_dashboard/dashboard/settings/api-keys';
      path: '/api-keys';
      fullPath: '/dashboard/settings/api-keys';
      preLoaderRoute: typeof DashboardDashboardSettingsApiKeysRouteImport;
      parentRoute: typeof DashboardDashboardSettingsRoute;
    };
    '/_dashboard/dashboard/settings/accounting': {
      id: '/_dashboard/dashboard/settings/accounting';
      path: '/accounting';
      fullPath: '/dashboard/settings/accounting';
      preLoaderRoute: typeof DashboardDashboardSettingsAccountingRouteImport;
      parentRoute: typeof DashboardDashboardSettingsRoute;
    };
    '/_dashboard/dashboard/reports/new': {
      id: '/_dashboard/dashboard/reports/new';
      path: '/dashboard/reports/new';
      fullPath: '/dashboard/reports/new';
      preLoaderRoute: typeof DashboardDashboardReportsNewRouteImport;
      parentRoute: typeof DashboardRoute;
    };
    '/_dashboard/dashboard/reports/$id': {
      id: '/_dashboard/dashboard/reports/$id';
      path: '/dashboard/reports/$id';
      fullPath: '/dashboard/reports/$id';
      preLoaderRoute: typeof DashboardDashboardReportsIdRouteImport;
      parentRoute: typeof DashboardRoute;
    };
    '/_dashboard/dashboard/reporting/targets': {
      id: '/_dashboard/dashboard/reporting/targets';
      path: '/dashboard/reporting/targets';
      fullPath: '/dashboard/reporting/targets';
      preLoaderRoute: typeof DashboardDashboardReportingTargetsRouteImport;
      parentRoute: typeof DashboardRoute;
    };
    '/_dashboard/dashboard/reporting/scorecards': {
      id: '/_dashboard/dashboard/reporting/scorecards';
      path: '/dashboard/reporting/scorecards';
      fullPath: '/dashboard/reporting/scorecards';
      preLoaderRoute: typeof DashboardDashboardReportingScorecardsRouteImport;
      parentRoute: typeof DashboardRoute;
    };
    '/_dashboard/dashboard/reporting/me': {
      id: '/_dashboard/dashboard/reporting/me';
      path: '/dashboard/reporting/me';
      fullPath: '/dashboard/reporting/me';
      preLoaderRoute: typeof DashboardDashboardReportingMeRouteImport;
      parentRoute: typeof DashboardRoute;
    };
    '/_dashboard/dashboard/reporting/calls': {
      id: '/_dashboard/dashboard/reporting/calls';
      path: '/dashboard/reporting/calls';
      fullPath: '/dashboard/reporting/calls';
      preLoaderRoute: typeof DashboardDashboardReportingCallsRouteImport;
      parentRoute: typeof DashboardRoute;
    };
    '/_dashboard/dashboard/receipts/$id': {
      id: '/_dashboard/dashboard/receipts/$id';
      path: '/$id';
      fullPath: '/dashboard/receipts/$id';
      preLoaderRoute: typeof DashboardDashboardReceiptsIdRouteImport;
      parentRoute: typeof DashboardDashboardReceiptsRoute;
    };
    '/_dashboard/dashboard/purchasing/requests': {
      id: '/_dashboard/dashboard/purchasing/requests';
      path: '/requests';
      fullPath: '/dashboard/purchasing/requests';
      preLoaderRoute: typeof DashboardDashboardPurchasingRequestsRouteImport;
      parentRoute: typeof DashboardDashboardPurchasingRoute;
    };
    '/_dashboard/dashboard/purchasing/overview': {
      id: '/_dashboard/dashboard/purchasing/overview';
      path: '/overview';
      fullPath: '/dashboard/purchasing/overview';
      preLoaderRoute: typeof DashboardDashboardPurchasingOverviewRouteImport;
      parentRoute: typeof DashboardDashboardPurchasingRoute;
    };
    '/_dashboard/dashboard/purchasing/field': {
      id: '/_dashboard/dashboard/purchasing/field';
      path: '/field';
      fullPath: '/dashboard/purchasing/field';
      preLoaderRoute: typeof DashboardDashboardPurchasingFieldRouteImport;
      parentRoute: typeof DashboardDashboardPurchasingRoute;
    };
    '/_dashboard/dashboard/purchasing/cost-changes': {
      id: '/_dashboard/dashboard/purchasing/cost-changes';
      path: '/cost-changes';
      fullPath: '/dashboard/purchasing/cost-changes';
      preLoaderRoute: typeof DashboardDashboardPurchasingCostChangesRouteImport;
      parentRoute: typeof DashboardDashboardPurchasingRoute;
    };
    '/_dashboard/dashboard/purchasing/cards': {
      id: '/_dashboard/dashboard/purchasing/cards';
      path: '/cards';
      fullPath: '/dashboard/purchasing/cards';
      preLoaderRoute: typeof DashboardDashboardPurchasingCardsRouteImport;
      parentRoute: typeof DashboardDashboardPurchasingRoute;
    };
    '/_dashboard/dashboard/purchasing/bills': {
      id: '/_dashboard/dashboard/purchasing/bills';
      path: '/bills';
      fullPath: '/dashboard/purchasing/bills';
      preLoaderRoute: typeof DashboardDashboardPurchasingBillsRouteImport;
      parentRoute: typeof DashboardDashboardPurchasingRoute;
    };
    '/_dashboard/dashboard/purchasing/approvals': {
      id: '/_dashboard/dashboard/purchasing/approvals';
      path: '/approvals';
      fullPath: '/dashboard/purchasing/approvals';
      preLoaderRoute: typeof DashboardDashboardPurchasingApprovalsRouteImport;
      parentRoute: typeof DashboardDashboardPurchasingRoute;
    };
    '/_dashboard/dashboard/proposals/new': {
      id: '/_dashboard/dashboard/proposals/new';
      path: '/new';
      fullPath: '/dashboard/proposals/new';
      preLoaderRoute: typeof DashboardDashboardProposalsNewRouteImport;
      parentRoute: typeof DashboardDashboardProposalsRoute;
    };
    '/_dashboard/dashboard/proposals/$id': {
      id: '/_dashboard/dashboard/proposals/$id';
      path: '/$id';
      fullPath: '/dashboard/proposals/$id';
      preLoaderRoute: typeof DashboardDashboardProposalsIdRouteImport;
      parentRoute: typeof DashboardDashboardProposalsRoute;
    };
    '/_dashboard/dashboard/projects/$projectId': {
      id: '/_dashboard/dashboard/projects/$projectId';
      path: '/$projectId';
      fullPath: '/dashboard/projects/$projectId';
      preLoaderRoute: typeof DashboardDashboardProjectsProjectIdRouteImport;
      parentRoute: typeof DashboardDashboardProjectsRoute;
    };
    '/_dashboard/dashboard/pricebook/new': {
      id: '/_dashboard/dashboard/pricebook/new';
      path: '/new';
      fullPath: '/dashboard/pricebook/new';
      preLoaderRoute: typeof DashboardDashboardPricebookNewRouteImport;
      parentRoute: typeof DashboardDashboardPricebookRoute;
    };
    '/_dashboard/dashboard/pricebook/categories': {
      id: '/_dashboard/dashboard/pricebook/categories';
      path: '/categories';
      fullPath: '/dashboard/pricebook/categories';
      preLoaderRoute: typeof DashboardDashboardPricebookCategoriesRouteImport;
      parentRoute: typeof DashboardDashboardPricebookRoute;
    };
    '/_dashboard/dashboard/pricebook/$id': {
      id: '/_dashboard/dashboard/pricebook/$id';
      path: '/$id';
      fullPath: '/dashboard/pricebook/$id';
      preLoaderRoute: typeof DashboardDashboardPricebookIdRouteImport;
      parentRoute: typeof DashboardDashboardPricebookRoute;
    };
    '/_dashboard/dashboard/payments/$id': {
      id: '/_dashboard/dashboard/payments/$id';
      path: '/$id';
      fullPath: '/dashboard/payments/$id';
      preLoaderRoute: typeof DashboardDashboardPaymentsIdRouteImport;
      parentRoute: typeof DashboardDashboardPaymentsRoute;
    };
    '/_dashboard/dashboard/memberships/reports': {
      id: '/_dashboard/dashboard/memberships/reports';
      path: '/reports';
      fullPath: '/dashboard/memberships/reports';
      preLoaderRoute: typeof DashboardDashboardMembershipsReportsRouteImport;
      parentRoute: typeof DashboardDashboardMembershipsRoute;
    };
    '/_dashboard/dashboard/memberships/new': {
      id: '/_dashboard/dashboard/memberships/new';
      path: '/new';
      fullPath: '/dashboard/memberships/new';
      preLoaderRoute: typeof DashboardDashboardMembershipsNewRouteImport;
      parentRoute: typeof DashboardDashboardMembershipsRoute;
    };
    '/_dashboard/dashboard/memberships/$id': {
      id: '/_dashboard/dashboard/memberships/$id';
      path: '/$id';
      fullPath: '/dashboard/memberships/$id';
      preLoaderRoute: typeof DashboardDashboardMembershipsIdRouteImport;
      parentRoute: typeof DashboardDashboardMembershipsRoute;
    };
    '/_dashboard/dashboard/membership-plans/new': {
      id: '/_dashboard/dashboard/membership-plans/new';
      path: '/new';
      fullPath: '/dashboard/membership-plans/new';
      preLoaderRoute: typeof DashboardDashboardMembershipPlansNewRouteImport;
      parentRoute: typeof DashboardDashboardMembershipPlansRoute;
    };
    '/_dashboard/dashboard/membership-plans/$id': {
      id: '/_dashboard/dashboard/membership-plans/$id';
      path: '/$id';
      fullPath: '/dashboard/membership-plans/$id';
      preLoaderRoute: typeof DashboardDashboardMembershipPlansIdRouteImport;
      parentRoute: typeof DashboardDashboardMembershipPlansRoute;
    };
    '/_dashboard/dashboard/locations/$locationId': {
      id: '/_dashboard/dashboard/locations/$locationId';
      path: '/$locationId';
      fullPath: '/dashboard/locations/$locationId';
      preLoaderRoute: typeof DashboardDashboardLocationsLocationIdRouteImport;
      parentRoute: typeof DashboardDashboardLocationsRoute;
    };
    '/_dashboard/dashboard/leads/reports': {
      id: '/_dashboard/dashboard/leads/reports';
      path: '/reports';
      fullPath: '/dashboard/leads/reports';
      preLoaderRoute: typeof DashboardDashboardLeadsReportsRouteImport;
      parentRoute: typeof DashboardDashboardLeadsRoute;
    };
    '/_dashboard/dashboard/leads/new': {
      id: '/_dashboard/dashboard/leads/new';
      path: '/new';
      fullPath: '/dashboard/leads/new';
      preLoaderRoute: typeof DashboardDashboardLeadsNewRouteImport;
      parentRoute: typeof DashboardDashboardLeadsRoute;
    };
    '/_dashboard/dashboard/leads/$leadId': {
      id: '/_dashboard/dashboard/leads/$leadId';
      path: '/$leadId';
      fullPath: '/dashboard/leads/$leadId';
      preLoaderRoute: typeof DashboardDashboardLeadsLeadIdRouteImport;
      parentRoute: typeof DashboardDashboardLeadsRoute;
    };
    '/_dashboard/dashboard/jobs/service-calls': {
      id: '/_dashboard/dashboard/jobs/service-calls';
      path: '/service-calls';
      fullPath: '/dashboard/jobs/service-calls';
      preLoaderRoute: typeof DashboardDashboardJobsServiceCallsRouteImport;
      parentRoute: typeof DashboardDashboardJobsRoute;
    };
    '/_dashboard/dashboard/jobs/reports': {
      id: '/_dashboard/dashboard/jobs/reports';
      path: '/reports';
      fullPath: '/dashboard/jobs/reports';
      preLoaderRoute: typeof DashboardDashboardJobsReportsRouteImport;
      parentRoute: typeof DashboardDashboardJobsRoute;
    };
    '/_dashboard/dashboard/jobs/new': {
      id: '/_dashboard/dashboard/jobs/new';
      path: '/new';
      fullPath: '/dashboard/jobs/new';
      preLoaderRoute: typeof DashboardDashboardJobsNewRouteImport;
      parentRoute: typeof DashboardDashboardJobsRoute;
    };
    '/_dashboard/dashboard/jobs/budget-vs-actual': {
      id: '/_dashboard/dashboard/jobs/budget-vs-actual';
      path: '/budget-vs-actual';
      fullPath: '/dashboard/jobs/budget-vs-actual';
      preLoaderRoute: typeof DashboardDashboardJobsBudgetVsActualRouteImport;
      parentRoute: typeof DashboardDashboardJobsRoute;
    };
    '/_dashboard/dashboard/jobs/$id': {
      id: '/_dashboard/dashboard/jobs/$id';
      path: '/$id';
      fullPath: '/dashboard/jobs/$id';
      preLoaderRoute: typeof DashboardDashboardJobsIdRouteImport;
      parentRoute: typeof DashboardDashboardJobsRoute;
    };
    '/_dashboard/dashboard/jobform/new': {
      id: '/_dashboard/dashboard/jobform/new';
      path: '/dashboard/jobform/new';
      fullPath: '/dashboard/jobform/new';
      preLoaderRoute: typeof DashboardDashboardJobformNewRouteImport;
      parentRoute: typeof DashboardRoute;
    };
    '/_dashboard/dashboard/jobform/$id': {
      id: '/_dashboard/dashboard/jobform/$id';
      path: '/dashboard/jobform/$id';
      fullPath: '/dashboard/jobform/$id';
      preLoaderRoute: typeof DashboardDashboardJobformIdRouteImport;
      parentRoute: typeof DashboardRoute;
    };
    '/_dashboard/dashboard/invoices/reports': {
      id: '/_dashboard/dashboard/invoices/reports';
      path: '/reports';
      fullPath: '/dashboard/invoices/reports';
      preLoaderRoute: typeof DashboardDashboardInvoicesReportsRouteImport;
      parentRoute: typeof DashboardDashboardInvoicesRoute;
    };
    '/_dashboard/dashboard/invoices/new': {
      id: '/_dashboard/dashboard/invoices/new';
      path: '/new';
      fullPath: '/dashboard/invoices/new';
      preLoaderRoute: typeof DashboardDashboardInvoicesNewRouteImport;
      parentRoute: typeof DashboardDashboardInvoicesRoute;
    };
    '/_dashboard/dashboard/invoices/$id': {
      id: '/_dashboard/dashboard/invoices/$id';
      path: '/$id';
      fullPath: '/dashboard/invoices/$id';
      preLoaderRoute: typeof DashboardDashboardInvoicesIdRouteImport;
      parentRoute: typeof DashboardDashboardInvoicesRoute;
    };
    '/_dashboard/dashboard/inventory/truck-templates': {
      id: '/_dashboard/dashboard/inventory/truck-templates';
      path: '/truck-templates';
      fullPath: '/dashboard/inventory/truck-templates';
      preLoaderRoute: typeof DashboardDashboardInventoryTruckTemplatesRouteImport;
      parentRoute: typeof DashboardDashboardInventoryRoute;
    };
    '/_dashboard/dashboard/inventory/transfers': {
      id: '/_dashboard/dashboard/inventory/transfers';
      path: '/transfers';
      fullPath: '/dashboard/inventory/transfers';
      preLoaderRoute: typeof DashboardDashboardInventoryTransfersRouteImport;
      parentRoute: typeof DashboardDashboardInventoryRoute;
    };
    '/_dashboard/dashboard/inventory/stock': {
      id: '/_dashboard/dashboard/inventory/stock';
      path: '/stock';
      fullPath: '/dashboard/inventory/stock';
      preLoaderRoute: typeof DashboardDashboardInventoryStockRouteImport;
      parentRoute: typeof DashboardDashboardInventoryRoute;
    };
    '/_dashboard/dashboard/inventory/overview': {
      id: '/_dashboard/dashboard/inventory/overview';
      path: '/overview';
      fullPath: '/dashboard/inventory/overview';
      preLoaderRoute: typeof DashboardDashboardInventoryOverviewRouteImport;
      parentRoute: typeof DashboardDashboardInventoryRoute;
    };
    '/_dashboard/dashboard/inventory/my-truck': {
      id: '/_dashboard/dashboard/inventory/my-truck';
      path: '/my-truck';
      fullPath: '/dashboard/inventory/my-truck';
      preLoaderRoute: typeof DashboardDashboardInventoryMyTruckRouteImport;
      parentRoute: typeof DashboardDashboardInventoryRoute;
    };
    '/_dashboard/dashboard/inventory/locations': {
      id: '/_dashboard/dashboard/inventory/locations';
      path: '/locations';
      fullPath: '/dashboard/inventory/locations';
      preLoaderRoute: typeof DashboardDashboardInventoryLocationsRouteImport;
      parentRoute: typeof DashboardDashboardInventoryRoute;
    };
    '/_dashboard/dashboard/forms/$formId': {
      id: '/_dashboard/dashboard/forms/$formId';
      path: '/$formId';
      fullPath: '/dashboard/forms/$formId';
      preLoaderRoute: typeof DashboardDashboardFormsFormIdRouteImport;
      parentRoute: typeof DashboardDashboardFormsRoute;
    };
    '/_dashboard/dashboard/estimates/reports': {
      id: '/_dashboard/dashboard/estimates/reports';
      path: '/reports';
      fullPath: '/dashboard/estimates/reports';
      preLoaderRoute: typeof DashboardDashboardEstimatesReportsRouteImport;
      parentRoute: typeof DashboardDashboardEstimatesRoute;
    };
    '/_dashboard/dashboard/estimates/new': {
      id: '/_dashboard/dashboard/estimates/new';
      path: '/new';
      fullPath: '/dashboard/estimates/new';
      preLoaderRoute: typeof DashboardDashboardEstimatesNewRouteImport;
      parentRoute: typeof DashboardDashboardEstimatesRoute;
    };
    '/_dashboard/dashboard/estimates/$id': {
      id: '/_dashboard/dashboard/estimates/$id';
      path: '/$id';
      fullPath: '/dashboard/estimates/$id';
      preLoaderRoute: typeof DashboardDashboardEstimatesIdRouteImport;
      parentRoute: typeof DashboardDashboardEstimatesRoute;
    };
    '/_dashboard/dashboard/dispatch_/live': {
      id: '/_dashboard/dashboard/dispatch_/live';
      path: '/dashboard/dispatch/live';
      fullPath: '/dashboard/dispatch/live';
      preLoaderRoute: typeof DashboardDashboardDispatchLiveRouteImport;
      parentRoute: typeof DashboardRoute;
    };
    '/_dashboard/dashboard/deposits/$id': {
      id: '/_dashboard/dashboard/deposits/$id';
      path: '/$id';
      fullPath: '/dashboard/deposits/$id';
      preLoaderRoute: typeof DashboardDashboardDepositsIdRouteImport;
      parentRoute: typeof DashboardDashboardDepositsRoute;
    };
    '/_dashboard/dashboard/crews/new': {
      id: '/_dashboard/dashboard/crews/new';
      path: '/new';
      fullPath: '/dashboard/crews/new';
      preLoaderRoute: typeof DashboardDashboardCrewsNewRouteImport;
      parentRoute: typeof DashboardDashboardCrewsRoute;
    };
    '/_dashboard/dashboard/crews/$id': {
      id: '/_dashboard/dashboard/crews/$id';
      path: '/$id';
      fullPath: '/dashboard/crews/$id';
      preLoaderRoute: typeof DashboardDashboardCrewsIdRouteImport;
      parentRoute: typeof DashboardDashboardCrewsRoute;
    };
    '/_dashboard/dashboard/crewmember/$userId': {
      id: '/_dashboard/dashboard/crewmember/$userId';
      path: '/dashboard/crewmember/$userId';
      fullPath: '/dashboard/crewmember/$userId';
      preLoaderRoute: typeof DashboardDashboardCrewmemberUserIdRouteImport;
      parentRoute: typeof DashboardRoute;
    };
    '/_dashboard/dashboard/credit-memos/new': {
      id: '/_dashboard/dashboard/credit-memos/new';
      path: '/new';
      fullPath: '/dashboard/credit-memos/new';
      preLoaderRoute: typeof DashboardDashboardCreditMemosNewRouteImport;
      parentRoute: typeof DashboardDashboardCreditMemosRoute;
    };
    '/_dashboard/dashboard/credit-memos/$id': {
      id: '/_dashboard/dashboard/credit-memos/$id';
      path: '/$id';
      fullPath: '/dashboard/credit-memos/$id';
      preLoaderRoute: typeof DashboardDashboardCreditMemosIdRouteImport;
      parentRoute: typeof DashboardDashboardCreditMemosRoute;
    };
    '/_dashboard/dashboard/costing/reports': {
      id: '/_dashboard/dashboard/costing/reports';
      path: '/dashboard/costing/reports';
      fullPath: '/dashboard/costing/reports';
      preLoaderRoute: typeof DashboardDashboardCostingReportsRouteImport;
      parentRoute: typeof DashboardRoute;
    };
    '/_dashboard/dashboard/contracts/$id': {
      id: '/_dashboard/dashboard/contracts/$id';
      path: '/$id';
      fullPath: '/dashboard/contracts/$id';
      preLoaderRoute: typeof DashboardDashboardContractsIdRouteImport;
      parentRoute: typeof DashboardDashboardContractsRoute;
    };
    '/_dashboard/dashboard/contacts/tasks': {
      id: '/_dashboard/dashboard/contacts/tasks';
      path: '/tasks';
      fullPath: '/dashboard/contacts/tasks';
      preLoaderRoute: typeof DashboardDashboardContactsTasksRouteImport;
      parentRoute: typeof DashboardDashboardContactsRoute;
    };
    '/_dashboard/dashboard/contacts/reports': {
      id: '/_dashboard/dashboard/contacts/reports';
      path: '/reports';
      fullPath: '/dashboard/contacts/reports';
      preLoaderRoute: typeof DashboardDashboardContactsReportsRouteImport;
      parentRoute: typeof DashboardDashboardContactsRoute;
    };
    '/_dashboard/dashboard/contacts/new': {
      id: '/_dashboard/dashboard/contacts/new';
      path: '/new';
      fullPath: '/dashboard/contacts/new';
      preLoaderRoute: typeof DashboardDashboardContactsNewRouteImport;
      parentRoute: typeof DashboardDashboardContactsRoute;
    };
    '/_dashboard/dashboard/contacts/$contactId': {
      id: '/_dashboard/dashboard/contacts/$contactId';
      path: '/$contactId';
      fullPath: '/dashboard/contacts/$contactId';
      preLoaderRoute: typeof DashboardDashboardContactsContactIdRouteImport;
      parentRoute: typeof DashboardDashboardContactsRoute;
    };
    '/_dashboard/dashboard/calllogs_/reports': {
      id: '/_dashboard/dashboard/calllogs_/reports';
      path: '/dashboard/calllogs/reports';
      fullPath: '/dashboard/calllogs/reports';
      preLoaderRoute: typeof DashboardDashboardCalllogsReportsRouteImport;
      parentRoute: typeof DashboardRoute;
    };
    '/_dashboard/dashboard/calendar/map': {
      id: '/_dashboard/dashboard/calendar/map';
      path: '/dashboard/calendar/map';
      fullPath: '/dashboard/calendar/map';
      preLoaderRoute: typeof DashboardDashboardCalendarMapRouteImport;
      parentRoute: typeof DashboardRoute;
    };
    '/_dashboard/dashboard/calendar/$id': {
      id: '/_dashboard/dashboard/calendar/$id';
      path: '/dashboard/calendar/$id';
      fullPath: '/dashboard/calendar/$id';
      preLoaderRoute: typeof DashboardDashboardCalendarIdRouteImport;
      parentRoute: typeof DashboardRoute;
    };
    '/_dashboard/dashboard/bookings/new': {
      id: '/_dashboard/dashboard/bookings/new';
      path: '/new';
      fullPath: '/dashboard/bookings/new';
      preLoaderRoute: typeof DashboardDashboardBookingsNewRouteImport;
      parentRoute: typeof DashboardDashboardBookingsRoute;
    };
    '/_dashboard/dashboard/bookings/$bookingId': {
      id: '/_dashboard/dashboard/bookings/$bookingId';
      path: '/$bookingId';
      fullPath: '/dashboard/bookings/$bookingId';
      preLoaderRoute: typeof DashboardDashboardBookingsBookingIdRouteImport;
      parentRoute: typeof DashboardDashboardBookingsRoute;
    };
    '/_dashboard/dashboard/ai/otto': {
      id: '/_dashboard/dashboard/ai/otto';
      path: '/dashboard/ai/otto';
      fullPath: '/dashboard/ai/otto';
      preLoaderRoute: typeof DashboardDashboardAiOttoRouteImport;
      parentRoute: typeof DashboardRoute;
    };
    '/(public)/tracking/$id/$refno': {
      id: '/(public)/tracking/$id/$refno';
      path: '/tracking/$id/$refno';
      fullPath: '/tracking/$id/$refno';
      preLoaderRoute: typeof publicTrackingIdRefnoRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/(public)/review/$reviewId/$id2': {
      id: '/(public)/review/$reviewId/$id2';
      path: '/review/$reviewId/$id2';
      fullPath: '/review/$reviewId/$id2';
      preLoaderRoute: typeof publicReviewReviewIdId2RouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/(portal)/portal/visits/book': {
      id: '/(portal)/portal/visits/book';
      path: '/portal/visits/book';
      fullPath: '/portal/visits/book';
      preLoaderRoute: typeof portalPortalVisitsBookRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/(portal)/portal/proposals/$id': {
      id: '/(portal)/portal/proposals/$id';
      path: '/portal/proposals/$id';
      fullPath: '/portal/proposals/$id';
      preLoaderRoute: typeof portalPortalProposalsIdRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/(portal)/portal/memberships/$id': {
      id: '/(portal)/portal/memberships/$id';
      path: '/portal/memberships/$id';
      fullPath: '/portal/memberships/$id';
      preLoaderRoute: typeof portalPortalMembershipsIdRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/(portal)/portal/invoices/$id': {
      id: '/(portal)/portal/invoices/$id';
      path: '/portal/invoices/$id';
      fullPath: '/portal/invoices/$id';
      preLoaderRoute: typeof portalPortalInvoicesIdRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/(portal)/portal/estimates/$id': {
      id: '/(portal)/portal/estimates/$id';
      path: '/portal/estimates/$id';
      fullPath: '/portal/estimates/$id';
      preLoaderRoute: typeof portalPortalEstimatesIdRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/_dashboard/dashboard/settings/templates/': {
      id: '/_dashboard/dashboard/settings/templates/';
      path: '/';
      fullPath: '/dashboard/settings/templates/';
      preLoaderRoute: typeof DashboardDashboardSettingsTemplatesIndexRouteImport;
      parentRoute: typeof DashboardDashboardSettingsTemplatesRoute;
    };
    '/_dashboard/dashboard/settings/job-pipelines/': {
      id: '/_dashboard/dashboard/settings/job-pipelines/';
      path: '/';
      fullPath: '/dashboard/settings/job-pipelines/';
      preLoaderRoute: typeof DashboardDashboardSettingsJobPipelinesIndexRouteImport;
      parentRoute: typeof DashboardDashboardSettingsJobPipelinesRoute;
    };
    '/_dashboard/dashboard/settings/document-templates/': {
      id: '/_dashboard/dashboard/settings/document-templates/';
      path: '/document-templates';
      fullPath: '/dashboard/settings/document-templates/';
      preLoaderRoute: typeof DashboardDashboardSettingsDocumentTemplatesIndexRouteImport;
      parentRoute: typeof DashboardDashboardSettingsRoute;
    };
    '/_dashboard/dashboard/settings/contracts/': {
      id: '/_dashboard/dashboard/settings/contracts/';
      path: '/';
      fullPath: '/dashboard/settings/contracts/';
      preLoaderRoute: typeof DashboardDashboardSettingsContractsIndexRouteImport;
      parentRoute: typeof DashboardDashboardSettingsContractsRoute;
    };
    '/_dashboard/dashboard/settings/checklist/': {
      id: '/_dashboard/dashboard/settings/checklist/';
      path: '/';
      fullPath: '/dashboard/settings/checklist/';
      preLoaderRoute: typeof DashboardDashboardSettingsChecklistIndexRouteImport;
      parentRoute: typeof DashboardDashboardSettingsChecklistRoute;
    };
    '/_dashboard/dashboard/settings/business-units/': {
      id: '/_dashboard/dashboard/settings/business-units/';
      path: '/business-units';
      fullPath: '/dashboard/settings/business-units/';
      preLoaderRoute: typeof DashboardDashboardSettingsBusinessUnitsIndexRouteImport;
      parentRoute: typeof DashboardDashboardSettingsRoute;
    };
    '/_dashboard/dashboard/settings/billing/': {
      id: '/_dashboard/dashboard/settings/billing/';
      path: '/';
      fullPath: '/dashboard/settings/billing/';
      preLoaderRoute: typeof DashboardDashboardSettingsBillingIndexRouteImport;
      parentRoute: typeof DashboardDashboardSettingsBillingRoute;
    };
    '/_dashboard/dashboard/settings/appointment-forms/': {
      id: '/_dashboard/dashboard/settings/appointment-forms/';
      path: '/';
      fullPath: '/dashboard/settings/appointment-forms/';
      preLoaderRoute: typeof DashboardDashboardSettingsAppointmentFormsIndexRouteImport;
      parentRoute: typeof DashboardDashboardSettingsAppointmentFormsRoute;
    };
    '/_dashboard/dashboard/reporting/reports/': {
      id: '/_dashboard/dashboard/reporting/reports/';
      path: '/dashboard/reporting/reports';
      fullPath: '/dashboard/reporting/reports/';
      preLoaderRoute: typeof DashboardDashboardReportingReportsIndexRouteImport;
      parentRoute: typeof DashboardRoute;
    };
    '/_dashboard/dashboard/purchasing/suppliers/': {
      id: '/_dashboard/dashboard/purchasing/suppliers/';
      path: '/suppliers';
      fullPath: '/dashboard/purchasing/suppliers/';
      preLoaderRoute: typeof DashboardDashboardPurchasingSuppliersIndexRouteImport;
      parentRoute: typeof DashboardDashboardPurchasingRoute;
    };
    '/_dashboard/dashboard/inventory/replenishment/': {
      id: '/_dashboard/dashboard/inventory/replenishment/';
      path: '/replenishment';
      fullPath: '/dashboard/inventory/replenishment/';
      preLoaderRoute: typeof DashboardDashboardInventoryReplenishmentIndexRouteImport;
      parentRoute: typeof DashboardDashboardInventoryRoute;
    };
    '/_dashboard/dashboard/inventory/counts/': {
      id: '/_dashboard/dashboard/inventory/counts/';
      path: '/counts';
      fullPath: '/dashboard/inventory/counts/';
      preLoaderRoute: typeof DashboardDashboardInventoryCountsIndexRouteImport;
      parentRoute: typeof DashboardDashboardInventoryRoute;
    };
    '/_dashboard/dashboard/technicians/$id/offboarding': {
      id: '/_dashboard/dashboard/technicians/$id/offboarding';
      path: '/offboarding';
      fullPath: '/dashboard/technicians/$id/offboarding';
      preLoaderRoute: typeof DashboardDashboardTechniciansIdOffboardingRouteImport;
      parentRoute: typeof DashboardDashboardTechniciansIdRoute;
    };
    '/_dashboard/dashboard/technicians/$id/edit': {
      id: '/_dashboard/dashboard/technicians/$id/edit';
      path: '/edit';
      fullPath: '/dashboard/technicians/$id/edit';
      preLoaderRoute: typeof DashboardDashboardTechniciansIdEditRouteImport;
      parentRoute: typeof DashboardDashboardTechniciansIdRoute;
    };
    '/_dashboard/dashboard/settings/webhooks/new': {
      id: '/_dashboard/dashboard/settings/webhooks/new';
      path: '/new';
      fullPath: '/dashboard/settings/webhooks/new';
      preLoaderRoute: typeof DashboardDashboardSettingsWebhooksNewRouteImport;
      parentRoute: typeof DashboardDashboardSettingsWebhooksRoute;
    };
    '/_dashboard/dashboard/settings/webhooks/$id': {
      id: '/_dashboard/dashboard/settings/webhooks/$id';
      path: '/$id';
      fullPath: '/dashboard/settings/webhooks/$id';
      preLoaderRoute: typeof DashboardDashboardSettingsWebhooksIdRouteImport;
      parentRoute: typeof DashboardDashboardSettingsWebhooksRoute;
    };
    '/_dashboard/dashboard/settings/users/new': {
      id: '/_dashboard/dashboard/settings/users/new';
      path: '/new';
      fullPath: '/dashboard/settings/users/new';
      preLoaderRoute: typeof DashboardDashboardSettingsUsersNewRouteImport;
      parentRoute: typeof DashboardDashboardSettingsUsersRoute;
    };
    '/_dashboard/dashboard/settings/users/$id': {
      id: '/_dashboard/dashboard/settings/users/$id';
      path: '/$id';
      fullPath: '/dashboard/settings/users/$id';
      preLoaderRoute: typeof DashboardDashboardSettingsUsersIdRouteImport;
      parentRoute: typeof DashboardDashboardSettingsUsersRoute;
    };
    '/_dashboard/dashboard/settings/terms-and-conditions/$id': {
      id: '/_dashboard/dashboard/settings/terms-and-conditions/$id';
      path: '/$id';
      fullPath: '/dashboard/settings/terms-and-conditions/$id';
      preLoaderRoute: typeof DashboardDashboardSettingsTermsAndConditionsIdRouteImport;
      parentRoute: typeof DashboardDashboardSettingsTermsAndConditionsRoute;
    };
    '/_dashboard/dashboard/settings/skills/new': {
      id: '/_dashboard/dashboard/settings/skills/new';
      path: '/new';
      fullPath: '/dashboard/settings/skills/new';
      preLoaderRoute: typeof DashboardDashboardSettingsSkillsNewRouteImport;
      parentRoute: typeof DashboardDashboardSettingsSkillsRoute;
    };
    '/_dashboard/dashboard/settings/skills/$id': {
      id: '/_dashboard/dashboard/settings/skills/$id';
      path: '/$id';
      fullPath: '/dashboard/settings/skills/$id';
      preLoaderRoute: typeof DashboardDashboardSettingsSkillsIdRouteImport;
      parentRoute: typeof DashboardDashboardSettingsSkillsRoute;
    };
    '/_dashboard/dashboard/settings/scope-of-work/$id': {
      id: '/_dashboard/dashboard/settings/scope-of-work/$id';
      path: '/$id';
      fullPath: '/dashboard/settings/scope-of-work/$id';
      preLoaderRoute: typeof DashboardDashboardSettingsScopeOfWorkIdRouteImport;
      parentRoute: typeof DashboardDashboardSettingsScopeOfWorkRoute;
    };
    '/_dashboard/dashboard/settings/reports_/templates': {
      id: '/_dashboard/dashboard/settings/reports_/templates';
      path: '/reports/templates';
      fullPath: '/dashboard/settings/reports/templates';
      preLoaderRoute: typeof DashboardDashboardSettingsReportsTemplatesRouteImport;
      parentRoute: typeof DashboardDashboardSettingsRoute;
    };
    '/_dashboard/dashboard/settings/reminders/$type': {
      id: '/_dashboard/dashboard/settings/reminders/$type';
      path: '/$type';
      fullPath: '/dashboard/settings/reminders/$type';
      preLoaderRoute: typeof DashboardDashboardSettingsRemindersTypeRouteImport;
      parentRoute: typeof DashboardDashboardSettingsRemindersRoute;
    };
    '/_dashboard/dashboard/settings/permissions/new': {
      id: '/_dashboard/dashboard/settings/permissions/new';
      path: '/new';
      fullPath: '/dashboard/settings/permissions/new';
      preLoaderRoute: typeof DashboardDashboardSettingsPermissionsNewRouteImport;
      parentRoute: typeof DashboardDashboardSettingsPermissionsRoute;
    };
    '/_dashboard/dashboard/settings/permissions/$id': {
      id: '/_dashboard/dashboard/settings/permissions/$id';
      path: '/$id';
      fullPath: '/dashboard/settings/permissions/$id';
      preLoaderRoute: typeof DashboardDashboardSettingsPermissionsIdRouteImport;
      parentRoute: typeof DashboardDashboardSettingsPermissionsRoute;
    };
    '/_dashboard/dashboard/settings/partner-api/webhooks': {
      id: '/_dashboard/dashboard/settings/partner-api/webhooks';
      path: '/partner-api/webhooks';
      fullPath: '/dashboard/settings/partner-api/webhooks';
      preLoaderRoute: typeof DashboardDashboardSettingsPartnerApiWebhooksRouteImport;
      parentRoute: typeof DashboardDashboardSettingsRoute;
    };
    '/_dashboard/dashboard/settings/office-settings/edit': {
      id: '/_dashboard/dashboard/settings/office-settings/edit';
      path: '/edit';
      fullPath: '/dashboard/settings/office-settings/edit';
      preLoaderRoute: typeof DashboardDashboardSettingsOfficeSettingsEditRouteImport;
      parentRoute: typeof DashboardDashboardSettingsOfficeSettingsRoute;
    };
    '/_dashboard/dashboard/settings/notifications/edit': {
      id: '/_dashboard/dashboard/settings/notifications/edit';
      path: '/edit';
      fullPath: '/dashboard/settings/notifications/edit';
      preLoaderRoute: typeof DashboardDashboardSettingsNotificationsEditRouteImport;
      parentRoute: typeof DashboardDashboardSettingsNotificationsRoute;
    };
    '/_dashboard/dashboard/settings/jobtypes/new': {
      id: '/_dashboard/dashboard/settings/jobtypes/new';
      path: '/new';
      fullPath: '/dashboard/settings/jobtypes/new';
      preLoaderRoute: typeof DashboardDashboardSettingsJobtypesNewRouteImport;
      parentRoute: typeof DashboardDashboardSettingsJobtypesRoute;
    };
    '/_dashboard/dashboard/settings/jobtypes/$id': {
      id: '/_dashboard/dashboard/settings/jobtypes/$id';
      path: '/$id';
      fullPath: '/dashboard/settings/jobtypes/$id';
      preLoaderRoute: typeof DashboardDashboardSettingsJobtypesIdRouteImport;
      parentRoute: typeof DashboardDashboardSettingsJobtypesRoute;
    };
    '/_dashboard/dashboard/settings/job-pipelines/new': {
      id: '/_dashboard/dashboard/settings/job-pipelines/new';
      path: '/new';
      fullPath: '/dashboard/settings/job-pipelines/new';
      preLoaderRoute: typeof DashboardDashboardSettingsJobPipelinesNewRouteImport;
      parentRoute: typeof DashboardDashboardSettingsJobPipelinesRoute;
    };
    '/_dashboard/dashboard/settings/job-pipelines/$id': {
      id: '/_dashboard/dashboard/settings/job-pipelines/$id';
      path: '/$id';
      fullPath: '/dashboard/settings/job-pipelines/$id';
      preLoaderRoute: typeof DashboardDashboardSettingsJobPipelinesIdRouteImport;
      parentRoute: typeof DashboardDashboardSettingsJobPipelinesRoute;
    };
    '/_dashboard/dashboard/settings/groups/new': {
      id: '/_dashboard/dashboard/settings/groups/new';
      path: '/new';
      fullPath: '/dashboard/settings/groups/new';
      preLoaderRoute: typeof DashboardDashboardSettingsGroupsNewRouteImport;
      parentRoute: typeof DashboardDashboardSettingsGroupsRoute;
    };
    '/_dashboard/dashboard/settings/groups/$id': {
      id: '/_dashboard/dashboard/settings/groups/$id';
      path: '/$id';
      fullPath: '/dashboard/settings/groups/$id';
      preLoaderRoute: typeof DashboardDashboardSettingsGroupsIdRouteImport;
      parentRoute: typeof DashboardDashboardSettingsGroupsRoute;
    };
    '/_dashboard/dashboard/settings/email-templates/new': {
      id: '/_dashboard/dashboard/settings/email-templates/new';
      path: '/email-templates/new';
      fullPath: '/dashboard/settings/email-templates/new';
      preLoaderRoute: typeof DashboardDashboardSettingsEmailTemplatesNewRouteImport;
      parentRoute: typeof DashboardDashboardSettingsRoute;
    };
    '/_dashboard/dashboard/settings/email-templates/$id': {
      id: '/_dashboard/dashboard/settings/email-templates/$id';
      path: '/email-templates/$id';
      fullPath: '/dashboard/settings/email-templates/$id';
      preLoaderRoute: typeof DashboardDashboardSettingsEmailTemplatesIdRouteImport;
      parentRoute: typeof DashboardDashboardSettingsRoute;
    };
    '/_dashboard/dashboard/settings/document-templates/new': {
      id: '/_dashboard/dashboard/settings/document-templates/new';
      path: '/document-templates/new';
      fullPath: '/dashboard/settings/document-templates/new';
      preLoaderRoute: typeof DashboardDashboardSettingsDocumentTemplatesNewRouteImport;
      parentRoute: typeof DashboardDashboardSettingsRoute;
    };
    '/_dashboard/dashboard/settings/document-templates/$id': {
      id: '/_dashboard/dashboard/settings/document-templates/$id';
      path: '/document-templates/$id';
      fullPath: '/dashboard/settings/document-templates/$id';
      preLoaderRoute: typeof DashboardDashboardSettingsDocumentTemplatesIdRouteImport;
      parentRoute: typeof DashboardDashboardSettingsRoute;
    };
    '/_dashboard/dashboard/settings/customfields/new': {
      id: '/_dashboard/dashboard/settings/customfields/new';
      path: '/new';
      fullPath: '/dashboard/settings/customfields/new';
      preLoaderRoute: typeof DashboardDashboardSettingsCustomfieldsNewRouteImport;
      parentRoute: typeof DashboardDashboardSettingsCustomfieldsRoute;
    };
    '/_dashboard/dashboard/settings/customfields/$id': {
      id: '/_dashboard/dashboard/settings/customfields/$id';
      path: '/$id';
      fullPath: '/dashboard/settings/customfields/$id';
      preLoaderRoute: typeof DashboardDashboardSettingsCustomfieldsIdRouteImport;
      parentRoute: typeof DashboardDashboardSettingsCustomfieldsRoute;
    };
    '/_dashboard/dashboard/settings/contracts/reviews': {
      id: '/_dashboard/dashboard/settings/contracts/reviews';
      path: '/reviews';
      fullPath: '/dashboard/settings/contracts/reviews';
      preLoaderRoute: typeof DashboardDashboardSettingsContractsReviewsRouteImport;
      parentRoute: typeof DashboardDashboardSettingsContractsRoute;
    };
    '/_dashboard/dashboard/settings/contracts/renewal-cancellation': {
      id: '/_dashboard/dashboard/settings/contracts/renewal-cancellation';
      path: '/renewal-cancellation';
      fullPath: '/dashboard/settings/contracts/renewal-cancellation';
      preLoaderRoute: typeof DashboardDashboardSettingsContractsRenewalCancellationRouteImport;
      parentRoute: typeof DashboardDashboardSettingsContractsRoute;
    };
    '/_dashboard/dashboard/settings/contracts/renewal': {
      id: '/_dashboard/dashboard/settings/contracts/renewal';
      path: '/renewal';
      fullPath: '/dashboard/settings/contracts/renewal';
      preLoaderRoute: typeof DashboardDashboardSettingsContractsRenewalRouteImport;
      parentRoute: typeof DashboardDashboardSettingsContractsRoute;
    };
    '/_dashboard/dashboard/settings/contracts/qbo': {
      id: '/_dashboard/dashboard/settings/contracts/qbo';
      path: '/qbo';
      fullPath: '/dashboard/settings/contracts/qbo';
      preLoaderRoute: typeof DashboardDashboardSettingsContractsQboRouteImport;
      parentRoute: typeof DashboardDashboardSettingsContractsRoute;
    };
    '/_dashboard/dashboard/settings/contracts/production-kits': {
      id: '/_dashboard/dashboard/settings/contracts/production-kits';
      path: '/production-kits';
      fullPath: '/dashboard/settings/contracts/production-kits';
      preLoaderRoute: typeof DashboardDashboardSettingsContractsProductionKitsRouteImport;
      parentRoute: typeof DashboardDashboardSettingsContractsRoute;
    };
    '/_dashboard/dashboard/settings/contracts/defaults': {
      id: '/_dashboard/dashboard/settings/contracts/defaults';
      path: '/defaults';
      fullPath: '/dashboard/settings/contracts/defaults';
      preLoaderRoute: typeof DashboardDashboardSettingsContractsDefaultsRouteImport;
      parentRoute: typeof DashboardDashboardSettingsContractsRoute;
    };
    '/_dashboard/dashboard/settings/contracts/costing': {
      id: '/_dashboard/dashboard/settings/contracts/costing';
      path: '/costing';
      fullPath: '/dashboard/settings/contracts/costing';
      preLoaderRoute: typeof DashboardDashboardSettingsContractsCostingRouteImport;
      parentRoute: typeof DashboardDashboardSettingsContractsRoute;
    };
    '/_dashboard/dashboard/settings/contracts/cancellation': {
      id: '/_dashboard/dashboard/settings/contracts/cancellation';
      path: '/cancellation';
      fullPath: '/dashboard/settings/contracts/cancellation';
      preLoaderRoute: typeof DashboardDashboardSettingsContractsCancellationRouteImport;
      parentRoute: typeof DashboardDashboardSettingsContractsRoute;
    };
    '/_dashboard/dashboard/settings/company/edit': {
      id: '/_dashboard/dashboard/settings/company/edit';
      path: '/edit';
      fullPath: '/dashboard/settings/company/edit';
      preLoaderRoute: typeof DashboardDashboardSettingsCompanyEditRouteImport;
      parentRoute: typeof DashboardDashboardSettingsCompanyRoute;
    };
    '/_dashboard/dashboard/settings/checklist/new': {
      id: '/_dashboard/dashboard/settings/checklist/new';
      path: '/new';
      fullPath: '/dashboard/settings/checklist/new';
      preLoaderRoute: typeof DashboardDashboardSettingsChecklistNewRouteImport;
      parentRoute: typeof DashboardDashboardSettingsChecklistRoute;
    };
    '/_dashboard/dashboard/settings/checklist/$id': {
      id: '/_dashboard/dashboard/settings/checklist/$id';
      path: '/$id';
      fullPath: '/dashboard/settings/checklist/$id';
      preLoaderRoute: typeof DashboardDashboardSettingsChecklistIdRouteImport;
      parentRoute: typeof DashboardDashboardSettingsChecklistRoute;
    };
    '/_dashboard/dashboard/settings/business-units/$id': {
      id: '/_dashboard/dashboard/settings/business-units/$id';
      path: '/business-units/$id';
      fullPath: '/dashboard/settings/business-units/$id';
      preLoaderRoute: typeof DashboardDashboardSettingsBusinessUnitsIdRouteImport;
      parentRoute: typeof DashboardDashboardSettingsRoute;
    };
    '/_dashboard/dashboard/settings/billing/receipts': {
      id: '/_dashboard/dashboard/settings/billing/receipts';
      path: '/receipts';
      fullPath: '/dashboard/settings/billing/receipts';
      preLoaderRoute: typeof DashboardDashboardSettingsBillingReceiptsRouteImport;
      parentRoute: typeof DashboardDashboardSettingsBillingRoute;
    };
    '/_dashboard/dashboard/settings/billing/quickbooks': {
      id: '/_dashboard/dashboard/settings/billing/quickbooks';
      path: '/quickbooks';
      fullPath: '/dashboard/settings/billing/quickbooks';
      preLoaderRoute: typeof DashboardDashboardSettingsBillingQuickbooksRouteImport;
      parentRoute: typeof DashboardDashboardSettingsBillingRoute;
    };
    '/_dashboard/dashboard/settings/billing/payments': {
      id: '/_dashboard/dashboard/settings/billing/payments';
      path: '/payments';
      fullPath: '/dashboard/settings/billing/payments';
      preLoaderRoute: typeof DashboardDashboardSettingsBillingPaymentsRouteImport;
      parentRoute: typeof DashboardDashboardSettingsBillingRoute;
    };
    '/_dashboard/dashboard/settings/billing/invoices': {
      id: '/_dashboard/dashboard/settings/billing/invoices';
      path: '/invoices';
      fullPath: '/dashboard/settings/billing/invoices';
      preLoaderRoute: typeof DashboardDashboardSettingsBillingInvoicesRouteImport;
      parentRoute: typeof DashboardDashboardSettingsBillingRoute;
    };
    '/_dashboard/dashboard/settings/billing/deposits': {
      id: '/_dashboard/dashboard/settings/billing/deposits';
      path: '/deposits';
      fullPath: '/dashboard/settings/billing/deposits';
      preLoaderRoute: typeof DashboardDashboardSettingsBillingDepositsRouteImport;
      parentRoute: typeof DashboardDashboardSettingsBillingRoute;
    };
    '/_dashboard/dashboard/settings/billing/credit-memos': {
      id: '/_dashboard/dashboard/settings/billing/credit-memos';
      path: '/credit-memos';
      fullPath: '/dashboard/settings/billing/credit-memos';
      preLoaderRoute: typeof DashboardDashboardSettingsBillingCreditMemosRouteImport;
      parentRoute: typeof DashboardDashboardSettingsBillingRoute;
    };
    '/_dashboard/dashboard/settings/appointment-forms/new': {
      id: '/_dashboard/dashboard/settings/appointment-forms/new';
      path: '/new';
      fullPath: '/dashboard/settings/appointment-forms/new';
      preLoaderRoute: typeof DashboardDashboardSettingsAppointmentFormsNewRouteImport;
      parentRoute: typeof DashboardDashboardSettingsAppointmentFormsRoute;
    };
    '/_dashboard/dashboard/settings/appointment-forms/$id': {
      id: '/_dashboard/dashboard/settings/appointment-forms/$id';
      path: '/$id';
      fullPath: '/dashboard/settings/appointment-forms/$id';
      preLoaderRoute: typeof DashboardDashboardSettingsAppointmentFormsIdRouteImport;
      parentRoute: typeof DashboardDashboardSettingsAppointmentFormsRoute;
    };
    '/_dashboard/dashboard/reporting/reports/new': {
      id: '/_dashboard/dashboard/reporting/reports/new';
      path: '/dashboard/reporting/reports/new';
      fullPath: '/dashboard/reporting/reports/new';
      preLoaderRoute: typeof DashboardDashboardReportingReportsNewRouteImport;
      parentRoute: typeof DashboardRoute;
    };
    '/_dashboard/dashboard/reporting/reports/$reportId': {
      id: '/_dashboard/dashboard/reporting/reports/$reportId';
      path: '/dashboard/reporting/reports/$reportId';
      fullPath: '/dashboard/reporting/reports/$reportId';
      preLoaderRoute: typeof DashboardDashboardReportingReportsReportIdRouteImport;
      parentRoute: typeof DashboardRoute;
    };
    '/_dashboard/dashboard/purchasing/suppliers/$supplierId': {
      id: '/_dashboard/dashboard/purchasing/suppliers/$supplierId';
      path: '/suppliers/$supplierId';
      fullPath: '/dashboard/purchasing/suppliers/$supplierId';
      preLoaderRoute: typeof DashboardDashboardPurchasingSuppliersSupplierIdRouteImport;
      parentRoute: typeof DashboardDashboardPurchasingRoute;
    };
    '/_dashboard/dashboard/proposals/$id/present': {
      id: '/_dashboard/dashboard/proposals/$id/present';
      path: '/present';
      fullPath: '/dashboard/proposals/$id/present';
      preLoaderRoute: typeof DashboardDashboardProposalsIdPresentRouteImport;
      parentRoute: typeof DashboardDashboardProposalsIdRoute;
    };
    '/_dashboard/dashboard/proposals/$id/edit': {
      id: '/_dashboard/dashboard/proposals/$id/edit';
      path: '/edit';
      fullPath: '/dashboard/proposals/$id/edit';
      preLoaderRoute: typeof DashboardDashboardProposalsIdEditRouteImport;
      parentRoute: typeof DashboardDashboardProposalsIdRoute;
    };
    '/_dashboard/dashboard/pricebook/$id/edit': {
      id: '/_dashboard/dashboard/pricebook/$id/edit';
      path: '/edit';
      fullPath: '/dashboard/pricebook/$id/edit';
      preLoaderRoute: typeof DashboardDashboardPricebookIdEditRouteImport;
      parentRoute: typeof DashboardDashboardPricebookIdRoute;
    };
    '/_dashboard/dashboard/memberships/$id/edit': {
      id: '/_dashboard/dashboard/memberships/$id/edit';
      path: '/edit';
      fullPath: '/dashboard/memberships/$id/edit';
      preLoaderRoute: typeof DashboardDashboardMembershipsIdEditRouteImport;
      parentRoute: typeof DashboardDashboardMembershipsIdRoute;
    };
    '/_dashboard/dashboard/membership-plans/$id/edit': {
      id: '/_dashboard/dashboard/membership-plans/$id/edit';
      path: '/edit';
      fullPath: '/dashboard/membership-plans/$id/edit';
      preLoaderRoute: typeof DashboardDashboardMembershipPlansIdEditRouteImport;
      parentRoute: typeof DashboardDashboardMembershipPlansIdRoute;
    };
    '/_dashboard/dashboard/leads/$leadId/edit': {
      id: '/_dashboard/dashboard/leads/$leadId/edit';
      path: '/edit';
      fullPath: '/dashboard/leads/$leadId/edit';
      preLoaderRoute: typeof DashboardDashboardLeadsLeadIdEditRouteImport;
      parentRoute: typeof DashboardDashboardLeadsLeadIdRoute;
    };
    '/_dashboard/dashboard/jobs/$id/edit': {
      id: '/_dashboard/dashboard/jobs/$id/edit';
      path: '/edit';
      fullPath: '/dashboard/jobs/$id/edit';
      preLoaderRoute: typeof DashboardDashboardJobsIdEditRouteImport;
      parentRoute: typeof DashboardDashboardJobsIdRoute;
    };
    '/_dashboard/dashboard/invoices/$id/edit': {
      id: '/_dashboard/dashboard/invoices/$id/edit';
      path: '/edit';
      fullPath: '/dashboard/invoices/$id/edit';
      preLoaderRoute: typeof DashboardDashboardInvoicesIdEditRouteImport;
      parentRoute: typeof DashboardDashboardInvoicesIdRoute;
    };
    '/_dashboard/dashboard/inventory/replenishment/$runId': {
      id: '/_dashboard/dashboard/inventory/replenishment/$runId';
      path: '/replenishment/$runId';
      fullPath: '/dashboard/inventory/replenishment/$runId';
      preLoaderRoute: typeof DashboardDashboardInventoryReplenishmentRunIdRouteImport;
      parentRoute: typeof DashboardDashboardInventoryRoute;
    };
    '/_dashboard/dashboard/inventory/pick-lists_/new': {
      id: '/_dashboard/dashboard/inventory/pick-lists_/new';
      path: '/pick-lists/new';
      fullPath: '/dashboard/inventory/pick-lists/new';
      preLoaderRoute: typeof DashboardDashboardInventoryPickListsNewRouteImport;
      parentRoute: typeof DashboardDashboardInventoryRoute;
    };
    '/_dashboard/dashboard/inventory/pick-lists_/$id': {
      id: '/_dashboard/dashboard/inventory/pick-lists_/$id';
      path: '/pick-lists/$id';
      fullPath: '/dashboard/inventory/pick-lists/$id';
      preLoaderRoute: typeof DashboardDashboardInventoryPickListsIdRouteImport;
      parentRoute: typeof DashboardDashboardInventoryRoute;
    };
    '/_dashboard/dashboard/inventory/locations_/$locationId': {
      id: '/_dashboard/dashboard/inventory/locations_/$locationId';
      path: '/locations/$locationId';
      fullPath: '/dashboard/inventory/locations/$locationId';
      preLoaderRoute: typeof DashboardDashboardInventoryLocationsLocationIdRouteImport;
      parentRoute: typeof DashboardDashboardInventoryRoute;
    };
    '/_dashboard/dashboard/inventory/jobs/$jobId': {
      id: '/_dashboard/dashboard/inventory/jobs/$jobId';
      path: '/jobs/$jobId';
      fullPath: '/dashboard/inventory/jobs/$jobId';
      preLoaderRoute: typeof DashboardDashboardInventoryJobsJobIdRouteImport;
      parentRoute: typeof DashboardDashboardInventoryRoute;
    };
    '/_dashboard/dashboard/inventory/items/$itemId': {
      id: '/_dashboard/dashboard/inventory/items/$itemId';
      path: '/items/$itemId';
      fullPath: '/dashboard/inventory/items/$itemId';
      preLoaderRoute: typeof DashboardDashboardInventoryItemsItemIdRouteImport;
      parentRoute: typeof DashboardDashboardInventoryRoute;
    };
    '/_dashboard/dashboard/inventory/counts/$countId': {
      id: '/_dashboard/dashboard/inventory/counts/$countId';
      path: '/counts/$countId';
      fullPath: '/dashboard/inventory/counts/$countId';
      preLoaderRoute: typeof DashboardDashboardInventoryCountsCountIdRouteImport;
      parentRoute: typeof DashboardDashboardInventoryRoute;
    };
    '/_dashboard/dashboard/estimates/$id/payment-schedule': {
      id: '/_dashboard/dashboard/estimates/$id/payment-schedule';
      path: '/payment-schedule';
      fullPath: '/dashboard/estimates/$id/payment-schedule';
      preLoaderRoute: typeof DashboardDashboardEstimatesIdPaymentScheduleRouteImport;
      parentRoute: typeof DashboardDashboardEstimatesIdRoute;
    };
    '/_dashboard/dashboard/estimates/$id/edit': {
      id: '/_dashboard/dashboard/estimates/$id/edit';
      path: '/edit';
      fullPath: '/dashboard/estimates/$id/edit';
      preLoaderRoute: typeof DashboardDashboardEstimatesIdEditRouteImport;
      parentRoute: typeof DashboardDashboardEstimatesIdRoute;
    };
    '/_dashboard/dashboard/crews/$id/edit': {
      id: '/_dashboard/dashboard/crews/$id/edit';
      path: '/edit';
      fullPath: '/dashboard/crews/$id/edit';
      preLoaderRoute: typeof DashboardDashboardCrewsIdEditRouteImport;
      parentRoute: typeof DashboardDashboardCrewsIdRoute;
    };
    '/_dashboard/dashboard/contacts/$contactId/edit': {
      id: '/_dashboard/dashboard/contacts/$contactId/edit';
      path: '/edit';
      fullPath: '/dashboard/contacts/$contactId/edit';
      preLoaderRoute: typeof DashboardDashboardContactsContactIdEditRouteImport;
      parentRoute: typeof DashboardDashboardContactsContactIdRoute;
    };
    '/_dashboard/dashboard/contacts/$contactId/consent-records': {
      id: '/_dashboard/dashboard/contacts/$contactId/consent-records';
      path: '/consent-records';
      fullPath: '/dashboard/contacts/$contactId/consent-records';
      preLoaderRoute: typeof DashboardDashboardContactsContactIdConsentRecordsRouteImport;
      parentRoute: typeof DashboardDashboardContactsContactIdRoute;
    };
    '/_dashboard/dashboard/ai/otto/$reportId': {
      id: '/_dashboard/dashboard/ai/otto/$reportId';
      path: '/$reportId';
      fullPath: '/dashboard/ai/otto/$reportId';
      preLoaderRoute: typeof DashboardDashboardAiOttoReportIdRouteImport;
      parentRoute: typeof DashboardDashboardAiOttoRoute;
    };
    '/(public)/payment/$id/$id2/$priceid': {
      id: '/(public)/payment/$id/$id2/$priceid';
      path: '/payment/$id/$id2/$priceid';
      fullPath: '/payment/$id/$id2/$priceid';
      preLoaderRoute: typeof publicPaymentIdId2PriceidRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/_dashboard/dashboard/settings/webhooks/$id/edit': {
      id: '/_dashboard/dashboard/settings/webhooks/$id/edit';
      path: '/edit';
      fullPath: '/dashboard/settings/webhooks/$id/edit';
      preLoaderRoute: typeof DashboardDashboardSettingsWebhooksIdEditRouteImport;
      parentRoute: typeof DashboardDashboardSettingsWebhooksIdRoute;
    };
    '/_dashboard/dashboard/settings/users/$id/edit': {
      id: '/_dashboard/dashboard/settings/users/$id/edit';
      path: '/edit';
      fullPath: '/dashboard/settings/users/$id/edit';
      preLoaderRoute: typeof DashboardDashboardSettingsUsersIdEditRouteImport;
      parentRoute: typeof DashboardDashboardSettingsUsersIdRoute;
    };
    '/_dashboard/dashboard/settings/terms-and-conditions/$id/edit': {
      id: '/_dashboard/dashboard/settings/terms-and-conditions/$id/edit';
      path: '/edit';
      fullPath: '/dashboard/settings/terms-and-conditions/$id/edit';
      preLoaderRoute: typeof DashboardDashboardSettingsTermsAndConditionsIdEditRouteImport;
      parentRoute: typeof DashboardDashboardSettingsTermsAndConditionsIdRoute;
    };
    '/_dashboard/dashboard/settings/templates/proposal/new': {
      id: '/_dashboard/dashboard/settings/templates/proposal/new';
      path: '/proposal/new';
      fullPath: '/dashboard/settings/templates/proposal/new';
      preLoaderRoute: typeof DashboardDashboardSettingsTemplatesProposalNewRouteImport;
      parentRoute: typeof DashboardDashboardSettingsTemplatesRoute;
    };
    '/_dashboard/dashboard/settings/templates/proposal/$id': {
      id: '/_dashboard/dashboard/settings/templates/proposal/$id';
      path: '/proposal/$id';
      fullPath: '/dashboard/settings/templates/proposal/$id';
      preLoaderRoute: typeof DashboardDashboardSettingsTemplatesProposalIdRouteImport;
      parentRoute: typeof DashboardDashboardSettingsTemplatesRoute;
    };
    '/_dashboard/dashboard/settings/templates/estimate/new': {
      id: '/_dashboard/dashboard/settings/templates/estimate/new';
      path: '/estimate/new';
      fullPath: '/dashboard/settings/templates/estimate/new';
      preLoaderRoute: typeof DashboardDashboardSettingsTemplatesEstimateNewRouteImport;
      parentRoute: typeof DashboardDashboardSettingsTemplatesRoute;
    };
    '/_dashboard/dashboard/settings/templates/estimate/$id': {
      id: '/_dashboard/dashboard/settings/templates/estimate/$id';
      path: '/estimate/$id';
      fullPath: '/dashboard/settings/templates/estimate/$id';
      preLoaderRoute: typeof DashboardDashboardSettingsTemplatesEstimateIdRouteImport;
      parentRoute: typeof DashboardDashboardSettingsTemplatesRoute;
    };
    '/_dashboard/dashboard/settings/skills/$id/edit': {
      id: '/_dashboard/dashboard/settings/skills/$id/edit';
      path: '/edit';
      fullPath: '/dashboard/settings/skills/$id/edit';
      preLoaderRoute: typeof DashboardDashboardSettingsSkillsIdEditRouteImport;
      parentRoute: typeof DashboardDashboardSettingsSkillsIdRoute;
    };
    '/_dashboard/dashboard/settings/scope-of-work/$id/edit': {
      id: '/_dashboard/dashboard/settings/scope-of-work/$id/edit';
      path: '/edit';
      fullPath: '/dashboard/settings/scope-of-work/$id/edit';
      preLoaderRoute: typeof DashboardDashboardSettingsScopeOfWorkIdEditRouteImport;
      parentRoute: typeof DashboardDashboardSettingsScopeOfWorkIdRoute;
    };
    '/_dashboard/dashboard/settings/permissions/$id/edit': {
      id: '/_dashboard/dashboard/settings/permissions/$id/edit';
      path: '/edit';
      fullPath: '/dashboard/settings/permissions/$id/edit';
      preLoaderRoute: typeof DashboardDashboardSettingsPermissionsIdEditRouteImport;
      parentRoute: typeof DashboardDashboardSettingsPermissionsIdRoute;
    };
    '/_dashboard/dashboard/settings/partner-api/webhooks/new': {
      id: '/_dashboard/dashboard/settings/partner-api/webhooks/new';
      path: '/new';
      fullPath: '/dashboard/settings/partner-api/webhooks/new';
      preLoaderRoute: typeof DashboardDashboardSettingsPartnerApiWebhooksNewRouteImport;
      parentRoute: typeof DashboardDashboardSettingsPartnerApiWebhooksRoute;
    };
    '/_dashboard/dashboard/settings/partner-api/webhooks/$id': {
      id: '/_dashboard/dashboard/settings/partner-api/webhooks/$id';
      path: '/$id';
      fullPath: '/dashboard/settings/partner-api/webhooks/$id';
      preLoaderRoute: typeof DashboardDashboardSettingsPartnerApiWebhooksIdRouteImport;
      parentRoute: typeof DashboardDashboardSettingsPartnerApiWebhooksRoute;
    };
    '/_dashboard/dashboard/settings/jobtypes/$id/edit': {
      id: '/_dashboard/dashboard/settings/jobtypes/$id/edit';
      path: '/edit';
      fullPath: '/dashboard/settings/jobtypes/$id/edit';
      preLoaderRoute: typeof DashboardDashboardSettingsJobtypesIdEditRouteImport;
      parentRoute: typeof DashboardDashboardSettingsJobtypesIdRoute;
    };
    '/_dashboard/dashboard/settings/job-pipelines/$id/edit': {
      id: '/_dashboard/dashboard/settings/job-pipelines/$id/edit';
      path: '/edit';
      fullPath: '/dashboard/settings/job-pipelines/$id/edit';
      preLoaderRoute: typeof DashboardDashboardSettingsJobPipelinesIdEditRouteImport;
      parentRoute: typeof DashboardDashboardSettingsJobPipelinesIdRoute;
    };
    '/_dashboard/dashboard/settings/groups/$id/edit': {
      id: '/_dashboard/dashboard/settings/groups/$id/edit';
      path: '/edit';
      fullPath: '/dashboard/settings/groups/$id/edit';
      preLoaderRoute: typeof DashboardDashboardSettingsGroupsIdEditRouteImport;
      parentRoute: typeof DashboardDashboardSettingsGroupsIdRoute;
    };
    '/_dashboard/dashboard/settings/customfields/$id/edit': {
      id: '/_dashboard/dashboard/settings/customfields/$id/edit';
      path: '/edit';
      fullPath: '/dashboard/settings/customfields/$id/edit';
      preLoaderRoute: typeof DashboardDashboardSettingsCustomfieldsIdEditRouteImport;
      parentRoute: typeof DashboardDashboardSettingsCustomfieldsIdRoute;
    };
    '/_dashboard/dashboard/settings/checklist/$id/edit': {
      id: '/_dashboard/dashboard/settings/checklist/$id/edit';
      path: '/edit';
      fullPath: '/dashboard/settings/checklist/$id/edit';
      preLoaderRoute: typeof DashboardDashboardSettingsChecklistIdEditRouteImport;
      parentRoute: typeof DashboardDashboardSettingsChecklistIdRoute;
    };
    '/_dashboard/dashboard/settings/call-settings/team/$section': {
      id: '/_dashboard/dashboard/settings/call-settings/team/$section';
      path: '/team/$section';
      fullPath: '/dashboard/settings/call-settings/team/$section';
      preLoaderRoute: typeof DashboardDashboardSettingsCallSettingsTeamSectionRouteImport;
      parentRoute: typeof DashboardDashboardSettingsCallSettingsRoute;
    };
    '/_dashboard/dashboard/settings/call-settings/numbers/$numberId': {
      id: '/_dashboard/dashboard/settings/call-settings/numbers/$numberId';
      path: '/numbers/$numberId';
      fullPath: '/dashboard/settings/call-settings/numbers/$numberId';
      preLoaderRoute: typeof DashboardDashboardSettingsCallSettingsNumbersNumberIdRouteImport;
      parentRoute: typeof DashboardDashboardSettingsCallSettingsRoute;
    };
    '/_dashboard/dashboard/settings/call-settings/ivr/new': {
      id: '/_dashboard/dashboard/settings/call-settings/ivr/new';
      path: '/ivr/new';
      fullPath: '/dashboard/settings/call-settings/ivr/new';
      preLoaderRoute: typeof DashboardDashboardSettingsCallSettingsIvrNewRouteImport;
      parentRoute: typeof DashboardDashboardSettingsCallSettingsRoute;
    };
    '/_dashboard/dashboard/settings/call-settings/ivr/$id': {
      id: '/_dashboard/dashboard/settings/call-settings/ivr/$id';
      path: '/ivr/$id';
      fullPath: '/dashboard/settings/call-settings/ivr/$id';
      preLoaderRoute: typeof DashboardDashboardSettingsCallSettingsIvrIdRouteImport;
      parentRoute: typeof DashboardDashboardSettingsCallSettingsRoute;
    };
    '/_dashboard/dashboard/settings/call-settings/flows/$id': {
      id: '/_dashboard/dashboard/settings/call-settings/flows/$id';
      path: '/flows/$id';
      fullPath: '/dashboard/settings/call-settings/flows/$id';
      preLoaderRoute: typeof DashboardDashboardSettingsCallSettingsFlowsIdRouteImport;
      parentRoute: typeof DashboardDashboardSettingsCallSettingsRoute;
    };
    '/_dashboard/dashboard/settings/appointment-forms/$id/edit': {
      id: '/_dashboard/dashboard/settings/appointment-forms/$id/edit';
      path: '/edit';
      fullPath: '/dashboard/settings/appointment-forms/$id/edit';
      preLoaderRoute: typeof DashboardDashboardSettingsAppointmentFormsIdEditRouteImport;
      parentRoute: typeof DashboardDashboardSettingsAppointmentFormsIdRoute;
    };
    '/_dashboard/dashboard/reporting/reports/$reportId_/edit': {
      id: '/_dashboard/dashboard/reporting/reports/$reportId_/edit';
      path: '/dashboard/reporting/reports/$reportId/edit';
      fullPath: '/dashboard/reporting/reports/$reportId/edit';
      preLoaderRoute: typeof DashboardDashboardReportingReportsReportIdEditRouteImport;
      parentRoute: typeof DashboardRoute;
    };
    '/_dashboard/dashboard/purchasing/suppliers/$supplierId_/edit': {
      id: '/_dashboard/dashboard/purchasing/suppliers/$supplierId_/edit';
      path: '/suppliers/$supplierId/edit';
      fullPath: '/dashboard/purchasing/suppliers/$supplierId/edit';
      preLoaderRoute: typeof DashboardDashboardPurchasingSuppliersSupplierIdEditRouteImport;
      parentRoute: typeof DashboardDashboardPurchasingRoute;
    };
    '/_dashboard/dashboard/jobs/$id/payment-schedule/new': {
      id: '/_dashboard/dashboard/jobs/$id/payment-schedule/new';
      path: '/payment-schedule/new';
      fullPath: '/dashboard/jobs/$id/payment-schedule/new';
      preLoaderRoute: typeof DashboardDashboardJobsIdPaymentScheduleNewRouteImport;
      parentRoute: typeof DashboardDashboardJobsIdRoute;
    };
    '/_dashboard/dashboard/jobs/$id/payment-schedule/edit': {
      id: '/_dashboard/dashboard/jobs/$id/payment-schedule/edit';
      path: '/payment-schedule/edit';
      fullPath: '/dashboard/jobs/$id/payment-schedule/edit';
      preLoaderRoute: typeof DashboardDashboardJobsIdPaymentScheduleEditRouteImport;
      parentRoute: typeof DashboardDashboardJobsIdRoute;
    };
    '/_dashboard/dashboard/jobs/$id/invoices/new': {
      id: '/_dashboard/dashboard/jobs/$id/invoices/new';
      path: '/invoices/new';
      fullPath: '/dashboard/jobs/$id/invoices/new';
      preLoaderRoute: typeof DashboardDashboardJobsIdInvoicesNewRouteImport;
      parentRoute: typeof DashboardDashboardJobsIdRoute;
    };
    '/_dashboard/dashboard/jobs/$id/invoices/$invoiceId': {
      id: '/_dashboard/dashboard/jobs/$id/invoices/$invoiceId';
      path: '/invoices/$invoiceId';
      fullPath: '/dashboard/jobs/$id/invoices/$invoiceId';
      preLoaderRoute: typeof DashboardDashboardJobsIdInvoicesInvoiceIdRouteImport;
      parentRoute: typeof DashboardDashboardJobsIdRoute;
    };
    '/_dashboard/dashboard/jobs/$id/expenses/new': {
      id: '/_dashboard/dashboard/jobs/$id/expenses/new';
      path: '/expenses/new';
      fullPath: '/dashboard/jobs/$id/expenses/new';
      preLoaderRoute: typeof DashboardDashboardJobsIdExpensesNewRouteImport;
      parentRoute: typeof DashboardDashboardJobsIdRoute;
    };
    '/_dashboard/dashboard/jobs/$id/expenses/$expenseId': {
      id: '/_dashboard/dashboard/jobs/$id/expenses/$expenseId';
      path: '/expenses/$expenseId';
      fullPath: '/dashboard/jobs/$id/expenses/$expenseId';
      preLoaderRoute: typeof DashboardDashboardJobsIdExpensesExpenseIdRouteImport;
      parentRoute: typeof DashboardDashboardJobsIdRoute;
    };
    '/_dashboard/dashboard/jobs/$id/change-orders/new': {
      id: '/_dashboard/dashboard/jobs/$id/change-orders/new';
      path: '/change-orders/new';
      fullPath: '/dashboard/jobs/$id/change-orders/new';
      preLoaderRoute: typeof DashboardDashboardJobsIdChangeOrdersNewRouteImport;
      parentRoute: typeof DashboardDashboardJobsIdRoute;
    };
    '/_dashboard/dashboard/jobs/$id/change-orders/$changeOrderId': {
      id: '/_dashboard/dashboard/jobs/$id/change-orders/$changeOrderId';
      path: '/change-orders/$changeOrderId';
      fullPath: '/dashboard/jobs/$id/change-orders/$changeOrderId';
      preLoaderRoute: typeof DashboardDashboardJobsIdChangeOrdersChangeOrderIdRouteImport;
      parentRoute: typeof DashboardDashboardJobsIdRoute;
    };
    '/_dashboard/dashboard/jobs/$id/appointments/new': {
      id: '/_dashboard/dashboard/jobs/$id/appointments/new';
      path: '/appointments/new';
      fullPath: '/dashboard/jobs/$id/appointments/new';
      preLoaderRoute: typeof DashboardDashboardJobsIdAppointmentsNewRouteImport;
      parentRoute: typeof DashboardDashboardJobsIdRoute;
    };
    '/_dashboard/dashboard/jobs/$id/appointments/$appointmentId': {
      id: '/_dashboard/dashboard/jobs/$id/appointments/$appointmentId';
      path: '/appointments/$appointmentId';
      fullPath: '/dashboard/jobs/$id/appointments/$appointmentId';
      preLoaderRoute: typeof DashboardDashboardJobsIdAppointmentsAppointmentIdRouteImport;
      parentRoute: typeof DashboardDashboardJobsIdRoute;
    };
    '/_dashboard/dashboard/contacts/$contactId/bill-to/new': {
      id: '/_dashboard/dashboard/contacts/$contactId/bill-to/new';
      path: '/bill-to/new';
      fullPath: '/dashboard/contacts/$contactId/bill-to/new';
      preLoaderRoute: typeof DashboardDashboardContactsContactIdBillToNewRouteImport;
      parentRoute: typeof DashboardDashboardContactsContactIdRoute;
    };
    '/_dashboard/dashboard/contacts/$contactId/addresses/new': {
      id: '/_dashboard/dashboard/contacts/$contactId/addresses/new';
      path: '/addresses/new';
      fullPath: '/dashboard/contacts/$contactId/addresses/new';
      preLoaderRoute: typeof DashboardDashboardContactsContactIdAddressesNewRouteImport;
      parentRoute: typeof DashboardDashboardContactsContactIdRoute;
    };
    '/_dashboard/dashboard/settings/partner-api/webhooks/$id/edit': {
      id: '/_dashboard/dashboard/settings/partner-api/webhooks/$id/edit';
      path: '/edit';
      fullPath: '/dashboard/settings/partner-api/webhooks/$id/edit';
      preLoaderRoute: typeof DashboardDashboardSettingsPartnerApiWebhooksIdEditRouteImport;
      parentRoute: typeof DashboardDashboardSettingsPartnerApiWebhooksIdRoute;
    };
    '/_dashboard/dashboard/contacts/$contactId/bill-to/$billToId/edit': {
      id: '/_dashboard/dashboard/contacts/$contactId/bill-to/$billToId/edit';
      path: '/bill-to/$billToId/edit';
      fullPath: '/dashboard/contacts/$contactId/bill-to/$billToId/edit';
      preLoaderRoute: typeof DashboardDashboardContactsContactIdBillToBillToIdEditRouteImport;
      parentRoute: typeof DashboardDashboardContactsContactIdRoute;
    };
    '/_dashboard/dashboard/contacts/$contactId/addresses/$addressId/edit': {
      id: '/_dashboard/dashboard/contacts/$contactId/addresses/$addressId/edit';
      path: '/addresses/$addressId/edit';
      fullPath: '/dashboard/contacts/$contactId/addresses/$addressId/edit';
      preLoaderRoute: typeof DashboardDashboardContactsContactIdAddressesAddressIdEditRouteImport;
      parentRoute: typeof DashboardDashboardContactsContactIdRoute;
    };
  }
}

interface DashboardDashboardBookingsRouteChildren {
  DashboardDashboardBookingsBookingIdRoute: typeof DashboardDashboardBookingsBookingIdRoute;
  DashboardDashboardBookingsNewRoute: typeof DashboardDashboardBookingsNewRoute;
  DashboardDashboardBookingsIndexRoute: typeof DashboardDashboardBookingsIndexRoute;
}

const DashboardDashboardBookingsRouteChildren: DashboardDashboardBookingsRouteChildren =
  {
    DashboardDashboardBookingsBookingIdRoute:
      DashboardDashboardBookingsBookingIdRoute,
    DashboardDashboardBookingsNewRoute: DashboardDashboardBookingsNewRoute,
    DashboardDashboardBookingsIndexRoute: DashboardDashboardBookingsIndexRoute,
  };

const DashboardDashboardBookingsRouteWithChildren =
  DashboardDashboardBookingsRoute._addFileChildren(
    DashboardDashboardBookingsRouteChildren,
  );

interface DashboardDashboardContactsContactIdRouteChildren {
  DashboardDashboardContactsContactIdConsentRecordsRoute: typeof DashboardDashboardContactsContactIdConsentRecordsRoute;
  DashboardDashboardContactsContactIdEditRoute: typeof DashboardDashboardContactsContactIdEditRoute;
  DashboardDashboardContactsContactIdAddressesNewRoute: typeof DashboardDashboardContactsContactIdAddressesNewRoute;
  DashboardDashboardContactsContactIdBillToNewRoute: typeof DashboardDashboardContactsContactIdBillToNewRoute;
  DashboardDashboardContactsContactIdAddressesAddressIdEditRoute: typeof DashboardDashboardContactsContactIdAddressesAddressIdEditRoute;
  DashboardDashboardContactsContactIdBillToBillToIdEditRoute: typeof DashboardDashboardContactsContactIdBillToBillToIdEditRoute;
}

const DashboardDashboardContactsContactIdRouteChildren: DashboardDashboardContactsContactIdRouteChildren =
  {
    DashboardDashboardContactsContactIdConsentRecordsRoute:
      DashboardDashboardContactsContactIdConsentRecordsRoute,
    DashboardDashboardContactsContactIdEditRoute:
      DashboardDashboardContactsContactIdEditRoute,
    DashboardDashboardContactsContactIdAddressesNewRoute:
      DashboardDashboardContactsContactIdAddressesNewRoute,
    DashboardDashboardContactsContactIdBillToNewRoute:
      DashboardDashboardContactsContactIdBillToNewRoute,
    DashboardDashboardContactsContactIdAddressesAddressIdEditRoute:
      DashboardDashboardContactsContactIdAddressesAddressIdEditRoute,
    DashboardDashboardContactsContactIdBillToBillToIdEditRoute:
      DashboardDashboardContactsContactIdBillToBillToIdEditRoute,
  };

const DashboardDashboardContactsContactIdRouteWithChildren =
  DashboardDashboardContactsContactIdRoute._addFileChildren(
    DashboardDashboardContactsContactIdRouteChildren,
  );

interface DashboardDashboardContactsRouteChildren {
  DashboardDashboardContactsContactIdRoute: typeof DashboardDashboardContactsContactIdRouteWithChildren;
  DashboardDashboardContactsNewRoute: typeof DashboardDashboardContactsNewRoute;
  DashboardDashboardContactsReportsRoute: typeof DashboardDashboardContactsReportsRoute;
  DashboardDashboardContactsTasksRoute: typeof DashboardDashboardContactsTasksRoute;
  DashboardDashboardContactsIndexRoute: typeof DashboardDashboardContactsIndexRoute;
}

const DashboardDashboardContactsRouteChildren: DashboardDashboardContactsRouteChildren =
  {
    DashboardDashboardContactsContactIdRoute:
      DashboardDashboardContactsContactIdRouteWithChildren,
    DashboardDashboardContactsNewRoute: DashboardDashboardContactsNewRoute,
    DashboardDashboardContactsReportsRoute:
      DashboardDashboardContactsReportsRoute,
    DashboardDashboardContactsTasksRoute: DashboardDashboardContactsTasksRoute,
    DashboardDashboardContactsIndexRoute: DashboardDashboardContactsIndexRoute,
  };

const DashboardDashboardContactsRouteWithChildren =
  DashboardDashboardContactsRoute._addFileChildren(
    DashboardDashboardContactsRouteChildren,
  );

interface DashboardDashboardContractsRouteChildren {
  DashboardDashboardContractsIdRoute: typeof DashboardDashboardContractsIdRoute;
}

const DashboardDashboardContractsRouteChildren: DashboardDashboardContractsRouteChildren =
  {
    DashboardDashboardContractsIdRoute: DashboardDashboardContractsIdRoute,
  };

const DashboardDashboardContractsRouteWithChildren =
  DashboardDashboardContractsRoute._addFileChildren(
    DashboardDashboardContractsRouteChildren,
  );

interface DashboardDashboardCreditMemosRouteChildren {
  DashboardDashboardCreditMemosIdRoute: typeof DashboardDashboardCreditMemosIdRoute;
  DashboardDashboardCreditMemosNewRoute: typeof DashboardDashboardCreditMemosNewRoute;
  DashboardDashboardCreditMemosIndexRoute: typeof DashboardDashboardCreditMemosIndexRoute;
}

const DashboardDashboardCreditMemosRouteChildren: DashboardDashboardCreditMemosRouteChildren =
  {
    DashboardDashboardCreditMemosIdRoute: DashboardDashboardCreditMemosIdRoute,
    DashboardDashboardCreditMemosNewRoute:
      DashboardDashboardCreditMemosNewRoute,
    DashboardDashboardCreditMemosIndexRoute:
      DashboardDashboardCreditMemosIndexRoute,
  };

const DashboardDashboardCreditMemosRouteWithChildren =
  DashboardDashboardCreditMemosRoute._addFileChildren(
    DashboardDashboardCreditMemosRouteChildren,
  );

interface DashboardDashboardCrewsIdRouteChildren {
  DashboardDashboardCrewsIdEditRoute: typeof DashboardDashboardCrewsIdEditRoute;
}

const DashboardDashboardCrewsIdRouteChildren: DashboardDashboardCrewsIdRouteChildren =
  {
    DashboardDashboardCrewsIdEditRoute: DashboardDashboardCrewsIdEditRoute,
  };

const DashboardDashboardCrewsIdRouteWithChildren =
  DashboardDashboardCrewsIdRoute._addFileChildren(
    DashboardDashboardCrewsIdRouteChildren,
  );

interface DashboardDashboardCrewsRouteChildren {
  DashboardDashboardCrewsIdRoute: typeof DashboardDashboardCrewsIdRouteWithChildren;
  DashboardDashboardCrewsNewRoute: typeof DashboardDashboardCrewsNewRoute;
}

const DashboardDashboardCrewsRouteChildren: DashboardDashboardCrewsRouteChildren =
  {
    DashboardDashboardCrewsIdRoute: DashboardDashboardCrewsIdRouteWithChildren,
    DashboardDashboardCrewsNewRoute: DashboardDashboardCrewsNewRoute,
  };

const DashboardDashboardCrewsRouteWithChildren =
  DashboardDashboardCrewsRoute._addFileChildren(
    DashboardDashboardCrewsRouteChildren,
  );

interface DashboardDashboardDepositsRouteChildren {
  DashboardDashboardDepositsIdRoute: typeof DashboardDashboardDepositsIdRoute;
}

const DashboardDashboardDepositsRouteChildren: DashboardDashboardDepositsRouteChildren =
  {
    DashboardDashboardDepositsIdRoute: DashboardDashboardDepositsIdRoute,
  };

const DashboardDashboardDepositsRouteWithChildren =
  DashboardDashboardDepositsRoute._addFileChildren(
    DashboardDashboardDepositsRouteChildren,
  );

interface DashboardDashboardEstimatesIdRouteChildren {
  DashboardDashboardEstimatesIdEditRoute: typeof DashboardDashboardEstimatesIdEditRoute;
  DashboardDashboardEstimatesIdPaymentScheduleRoute: typeof DashboardDashboardEstimatesIdPaymentScheduleRoute;
}

const DashboardDashboardEstimatesIdRouteChildren: DashboardDashboardEstimatesIdRouteChildren =
  {
    DashboardDashboardEstimatesIdEditRoute:
      DashboardDashboardEstimatesIdEditRoute,
    DashboardDashboardEstimatesIdPaymentScheduleRoute:
      DashboardDashboardEstimatesIdPaymentScheduleRoute,
  };

const DashboardDashboardEstimatesIdRouteWithChildren =
  DashboardDashboardEstimatesIdRoute._addFileChildren(
    DashboardDashboardEstimatesIdRouteChildren,
  );

interface DashboardDashboardEstimatesRouteChildren {
  DashboardDashboardEstimatesIdRoute: typeof DashboardDashboardEstimatesIdRouteWithChildren;
  DashboardDashboardEstimatesNewRoute: typeof DashboardDashboardEstimatesNewRoute;
  DashboardDashboardEstimatesReportsRoute: typeof DashboardDashboardEstimatesReportsRoute;
  DashboardDashboardEstimatesIndexRoute: typeof DashboardDashboardEstimatesIndexRoute;
}

const DashboardDashboardEstimatesRouteChildren: DashboardDashboardEstimatesRouteChildren =
  {
    DashboardDashboardEstimatesIdRoute:
      DashboardDashboardEstimatesIdRouteWithChildren,
    DashboardDashboardEstimatesNewRoute: DashboardDashboardEstimatesNewRoute,
    DashboardDashboardEstimatesReportsRoute:
      DashboardDashboardEstimatesReportsRoute,
    DashboardDashboardEstimatesIndexRoute:
      DashboardDashboardEstimatesIndexRoute,
  };

const DashboardDashboardEstimatesRouteWithChildren =
  DashboardDashboardEstimatesRoute._addFileChildren(
    DashboardDashboardEstimatesRouteChildren,
  );

interface DashboardDashboardFormsRouteChildren {
  DashboardDashboardFormsFormIdRoute: typeof DashboardDashboardFormsFormIdRoute;
  DashboardDashboardFormsIndexRoute: typeof DashboardDashboardFormsIndexRoute;
}

const DashboardDashboardFormsRouteChildren: DashboardDashboardFormsRouteChildren =
  {
    DashboardDashboardFormsFormIdRoute: DashboardDashboardFormsFormIdRoute,
    DashboardDashboardFormsIndexRoute: DashboardDashboardFormsIndexRoute,
  };

const DashboardDashboardFormsRouteWithChildren =
  DashboardDashboardFormsRoute._addFileChildren(
    DashboardDashboardFormsRouteChildren,
  );

interface DashboardDashboardInventoryRouteChildren {
  DashboardDashboardInventoryLocationsRoute: typeof DashboardDashboardInventoryLocationsRoute;
  DashboardDashboardInventoryMyTruckRoute: typeof DashboardDashboardInventoryMyTruckRoute;
  DashboardDashboardInventoryOverviewRoute: typeof DashboardDashboardInventoryOverviewRoute;
  DashboardDashboardInventoryStockRoute: typeof DashboardDashboardInventoryStockRoute;
  DashboardDashboardInventoryTransfersRoute: typeof DashboardDashboardInventoryTransfersRoute;
  DashboardDashboardInventoryTruckTemplatesRoute: typeof DashboardDashboardInventoryTruckTemplatesRoute;
  DashboardDashboardInventoryIndexRoute: typeof DashboardDashboardInventoryIndexRoute;
  DashboardDashboardInventoryCountsCountIdRoute: typeof DashboardDashboardInventoryCountsCountIdRoute;
  DashboardDashboardInventoryItemsItemIdRoute: typeof DashboardDashboardInventoryItemsItemIdRoute;
  DashboardDashboardInventoryJobsJobIdRoute: typeof DashboardDashboardInventoryJobsJobIdRoute;
  DashboardDashboardInventoryLocationsLocationIdRoute: typeof DashboardDashboardInventoryLocationsLocationIdRoute;
  DashboardDashboardInventoryPickListsIdRoute: typeof DashboardDashboardInventoryPickListsIdRoute;
  DashboardDashboardInventoryPickListsNewRoute: typeof DashboardDashboardInventoryPickListsNewRoute;
  DashboardDashboardInventoryReplenishmentRunIdRoute: typeof DashboardDashboardInventoryReplenishmentRunIdRoute;
  DashboardDashboardInventoryCountsIndexRoute: typeof DashboardDashboardInventoryCountsIndexRoute;
  DashboardDashboardInventoryReplenishmentIndexRoute: typeof DashboardDashboardInventoryReplenishmentIndexRoute;
}

const DashboardDashboardInventoryRouteChildren: DashboardDashboardInventoryRouteChildren =
  {
    DashboardDashboardInventoryLocationsRoute:
      DashboardDashboardInventoryLocationsRoute,
    DashboardDashboardInventoryMyTruckRoute:
      DashboardDashboardInventoryMyTruckRoute,
    DashboardDashboardInventoryOverviewRoute:
      DashboardDashboardInventoryOverviewRoute,
    DashboardDashboardInventoryStockRoute:
      DashboardDashboardInventoryStockRoute,
    DashboardDashboardInventoryTransfersRoute:
      DashboardDashboardInventoryTransfersRoute,
    DashboardDashboardInventoryTruckTemplatesRoute:
      DashboardDashboardInventoryTruckTemplatesRoute,
    DashboardDashboardInventoryIndexRoute:
      DashboardDashboardInventoryIndexRoute,
    DashboardDashboardInventoryCountsCountIdRoute:
      DashboardDashboardInventoryCountsCountIdRoute,
    DashboardDashboardInventoryItemsItemIdRoute:
      DashboardDashboardInventoryItemsItemIdRoute,
    DashboardDashboardInventoryJobsJobIdRoute:
      DashboardDashboardInventoryJobsJobIdRoute,
    DashboardDashboardInventoryLocationsLocationIdRoute:
      DashboardDashboardInventoryLocationsLocationIdRoute,
    DashboardDashboardInventoryPickListsIdRoute:
      DashboardDashboardInventoryPickListsIdRoute,
    DashboardDashboardInventoryPickListsNewRoute:
      DashboardDashboardInventoryPickListsNewRoute,
    DashboardDashboardInventoryReplenishmentRunIdRoute:
      DashboardDashboardInventoryReplenishmentRunIdRoute,
    DashboardDashboardInventoryCountsIndexRoute:
      DashboardDashboardInventoryCountsIndexRoute,
    DashboardDashboardInventoryReplenishmentIndexRoute:
      DashboardDashboardInventoryReplenishmentIndexRoute,
  };

const DashboardDashboardInventoryRouteWithChildren =
  DashboardDashboardInventoryRoute._addFileChildren(
    DashboardDashboardInventoryRouteChildren,
  );

interface DashboardDashboardInvoicesIdRouteChildren {
  DashboardDashboardInvoicesIdEditRoute: typeof DashboardDashboardInvoicesIdEditRoute;
}

const DashboardDashboardInvoicesIdRouteChildren: DashboardDashboardInvoicesIdRouteChildren =
  {
    DashboardDashboardInvoicesIdEditRoute:
      DashboardDashboardInvoicesIdEditRoute,
  };

const DashboardDashboardInvoicesIdRouteWithChildren =
  DashboardDashboardInvoicesIdRoute._addFileChildren(
    DashboardDashboardInvoicesIdRouteChildren,
  );

interface DashboardDashboardInvoicesRouteChildren {
  DashboardDashboardInvoicesIdRoute: typeof DashboardDashboardInvoicesIdRouteWithChildren;
  DashboardDashboardInvoicesNewRoute: typeof DashboardDashboardInvoicesNewRoute;
  DashboardDashboardInvoicesReportsRoute: typeof DashboardDashboardInvoicesReportsRoute;
  DashboardDashboardInvoicesIndexRoute: typeof DashboardDashboardInvoicesIndexRoute;
}

const DashboardDashboardInvoicesRouteChildren: DashboardDashboardInvoicesRouteChildren =
  {
    DashboardDashboardInvoicesIdRoute:
      DashboardDashboardInvoicesIdRouteWithChildren,
    DashboardDashboardInvoicesNewRoute: DashboardDashboardInvoicesNewRoute,
    DashboardDashboardInvoicesReportsRoute:
      DashboardDashboardInvoicesReportsRoute,
    DashboardDashboardInvoicesIndexRoute: DashboardDashboardInvoicesIndexRoute,
  };

const DashboardDashboardInvoicesRouteWithChildren =
  DashboardDashboardInvoicesRoute._addFileChildren(
    DashboardDashboardInvoicesRouteChildren,
  );

interface DashboardDashboardJobsIdRouteChildren {
  DashboardDashboardJobsIdEditRoute: typeof DashboardDashboardJobsIdEditRoute;
  DashboardDashboardJobsIdAppointmentsAppointmentIdRoute: typeof DashboardDashboardJobsIdAppointmentsAppointmentIdRoute;
  DashboardDashboardJobsIdAppointmentsNewRoute: typeof DashboardDashboardJobsIdAppointmentsNewRoute;
  DashboardDashboardJobsIdChangeOrdersChangeOrderIdRoute: typeof DashboardDashboardJobsIdChangeOrdersChangeOrderIdRoute;
  DashboardDashboardJobsIdChangeOrdersNewRoute: typeof DashboardDashboardJobsIdChangeOrdersNewRoute;
  DashboardDashboardJobsIdExpensesExpenseIdRoute: typeof DashboardDashboardJobsIdExpensesExpenseIdRoute;
  DashboardDashboardJobsIdExpensesNewRoute: typeof DashboardDashboardJobsIdExpensesNewRoute;
  DashboardDashboardJobsIdInvoicesInvoiceIdRoute: typeof DashboardDashboardJobsIdInvoicesInvoiceIdRoute;
  DashboardDashboardJobsIdInvoicesNewRoute: typeof DashboardDashboardJobsIdInvoicesNewRoute;
  DashboardDashboardJobsIdPaymentScheduleEditRoute: typeof DashboardDashboardJobsIdPaymentScheduleEditRoute;
  DashboardDashboardJobsIdPaymentScheduleNewRoute: typeof DashboardDashboardJobsIdPaymentScheduleNewRoute;
}

const DashboardDashboardJobsIdRouteChildren: DashboardDashboardJobsIdRouteChildren =
  {
    DashboardDashboardJobsIdEditRoute: DashboardDashboardJobsIdEditRoute,
    DashboardDashboardJobsIdAppointmentsAppointmentIdRoute:
      DashboardDashboardJobsIdAppointmentsAppointmentIdRoute,
    DashboardDashboardJobsIdAppointmentsNewRoute:
      DashboardDashboardJobsIdAppointmentsNewRoute,
    DashboardDashboardJobsIdChangeOrdersChangeOrderIdRoute:
      DashboardDashboardJobsIdChangeOrdersChangeOrderIdRoute,
    DashboardDashboardJobsIdChangeOrdersNewRoute:
      DashboardDashboardJobsIdChangeOrdersNewRoute,
    DashboardDashboardJobsIdExpensesExpenseIdRoute:
      DashboardDashboardJobsIdExpensesExpenseIdRoute,
    DashboardDashboardJobsIdExpensesNewRoute:
      DashboardDashboardJobsIdExpensesNewRoute,
    DashboardDashboardJobsIdInvoicesInvoiceIdRoute:
      DashboardDashboardJobsIdInvoicesInvoiceIdRoute,
    DashboardDashboardJobsIdInvoicesNewRoute:
      DashboardDashboardJobsIdInvoicesNewRoute,
    DashboardDashboardJobsIdPaymentScheduleEditRoute:
      DashboardDashboardJobsIdPaymentScheduleEditRoute,
    DashboardDashboardJobsIdPaymentScheduleNewRoute:
      DashboardDashboardJobsIdPaymentScheduleNewRoute,
  };

const DashboardDashboardJobsIdRouteWithChildren =
  DashboardDashboardJobsIdRoute._addFileChildren(
    DashboardDashboardJobsIdRouteChildren,
  );

interface DashboardDashboardJobsRouteChildren {
  DashboardDashboardJobsIdRoute: typeof DashboardDashboardJobsIdRouteWithChildren;
  DashboardDashboardJobsBudgetVsActualRoute: typeof DashboardDashboardJobsBudgetVsActualRoute;
  DashboardDashboardJobsNewRoute: typeof DashboardDashboardJobsNewRoute;
  DashboardDashboardJobsReportsRoute: typeof DashboardDashboardJobsReportsRoute;
  DashboardDashboardJobsServiceCallsRoute: typeof DashboardDashboardJobsServiceCallsRoute;
  DashboardDashboardJobsIndexRoute: typeof DashboardDashboardJobsIndexRoute;
}

const DashboardDashboardJobsRouteChildren: DashboardDashboardJobsRouteChildren =
  {
    DashboardDashboardJobsIdRoute: DashboardDashboardJobsIdRouteWithChildren,
    DashboardDashboardJobsBudgetVsActualRoute:
      DashboardDashboardJobsBudgetVsActualRoute,
    DashboardDashboardJobsNewRoute: DashboardDashboardJobsNewRoute,
    DashboardDashboardJobsReportsRoute: DashboardDashboardJobsReportsRoute,
    DashboardDashboardJobsServiceCallsRoute:
      DashboardDashboardJobsServiceCallsRoute,
    DashboardDashboardJobsIndexRoute: DashboardDashboardJobsIndexRoute,
  };

const DashboardDashboardJobsRouteWithChildren =
  DashboardDashboardJobsRoute._addFileChildren(
    DashboardDashboardJobsRouteChildren,
  );

interface DashboardDashboardLeadsLeadIdRouteChildren {
  DashboardDashboardLeadsLeadIdEditRoute: typeof DashboardDashboardLeadsLeadIdEditRoute;
}

const DashboardDashboardLeadsLeadIdRouteChildren: DashboardDashboardLeadsLeadIdRouteChildren =
  {
    DashboardDashboardLeadsLeadIdEditRoute:
      DashboardDashboardLeadsLeadIdEditRoute,
  };

const DashboardDashboardLeadsLeadIdRouteWithChildren =
  DashboardDashboardLeadsLeadIdRoute._addFileChildren(
    DashboardDashboardLeadsLeadIdRouteChildren,
  );

interface DashboardDashboardLeadsRouteChildren {
  DashboardDashboardLeadsLeadIdRoute: typeof DashboardDashboardLeadsLeadIdRouteWithChildren;
  DashboardDashboardLeadsNewRoute: typeof DashboardDashboardLeadsNewRoute;
  DashboardDashboardLeadsReportsRoute: typeof DashboardDashboardLeadsReportsRoute;
  DashboardDashboardLeadsIndexRoute: typeof DashboardDashboardLeadsIndexRoute;
}

const DashboardDashboardLeadsRouteChildren: DashboardDashboardLeadsRouteChildren =
  {
    DashboardDashboardLeadsLeadIdRoute:
      DashboardDashboardLeadsLeadIdRouteWithChildren,
    DashboardDashboardLeadsNewRoute: DashboardDashboardLeadsNewRoute,
    DashboardDashboardLeadsReportsRoute: DashboardDashboardLeadsReportsRoute,
    DashboardDashboardLeadsIndexRoute: DashboardDashboardLeadsIndexRoute,
  };

const DashboardDashboardLeadsRouteWithChildren =
  DashboardDashboardLeadsRoute._addFileChildren(
    DashboardDashboardLeadsRouteChildren,
  );

interface DashboardDashboardLocationsRouteChildren {
  DashboardDashboardLocationsLocationIdRoute: typeof DashboardDashboardLocationsLocationIdRoute;
}

const DashboardDashboardLocationsRouteChildren: DashboardDashboardLocationsRouteChildren =
  {
    DashboardDashboardLocationsLocationIdRoute:
      DashboardDashboardLocationsLocationIdRoute,
  };

const DashboardDashboardLocationsRouteWithChildren =
  DashboardDashboardLocationsRoute._addFileChildren(
    DashboardDashboardLocationsRouteChildren,
  );

interface DashboardDashboardMembershipPlansIdRouteChildren {
  DashboardDashboardMembershipPlansIdEditRoute: typeof DashboardDashboardMembershipPlansIdEditRoute;
}

const DashboardDashboardMembershipPlansIdRouteChildren: DashboardDashboardMembershipPlansIdRouteChildren =
  {
    DashboardDashboardMembershipPlansIdEditRoute:
      DashboardDashboardMembershipPlansIdEditRoute,
  };

const DashboardDashboardMembershipPlansIdRouteWithChildren =
  DashboardDashboardMembershipPlansIdRoute._addFileChildren(
    DashboardDashboardMembershipPlansIdRouteChildren,
  );

interface DashboardDashboardMembershipPlansRouteChildren {
  DashboardDashboardMembershipPlansIdRoute: typeof DashboardDashboardMembershipPlansIdRouteWithChildren;
  DashboardDashboardMembershipPlansNewRoute: typeof DashboardDashboardMembershipPlansNewRoute;
  DashboardDashboardMembershipPlansIndexRoute: typeof DashboardDashboardMembershipPlansIndexRoute;
}

const DashboardDashboardMembershipPlansRouteChildren: DashboardDashboardMembershipPlansRouteChildren =
  {
    DashboardDashboardMembershipPlansIdRoute:
      DashboardDashboardMembershipPlansIdRouteWithChildren,
    DashboardDashboardMembershipPlansNewRoute:
      DashboardDashboardMembershipPlansNewRoute,
    DashboardDashboardMembershipPlansIndexRoute:
      DashboardDashboardMembershipPlansIndexRoute,
  };

const DashboardDashboardMembershipPlansRouteWithChildren =
  DashboardDashboardMembershipPlansRoute._addFileChildren(
    DashboardDashboardMembershipPlansRouteChildren,
  );

interface DashboardDashboardMembershipsIdRouteChildren {
  DashboardDashboardMembershipsIdEditRoute: typeof DashboardDashboardMembershipsIdEditRoute;
}

const DashboardDashboardMembershipsIdRouteChildren: DashboardDashboardMembershipsIdRouteChildren =
  {
    DashboardDashboardMembershipsIdEditRoute:
      DashboardDashboardMembershipsIdEditRoute,
  };

const DashboardDashboardMembershipsIdRouteWithChildren =
  DashboardDashboardMembershipsIdRoute._addFileChildren(
    DashboardDashboardMembershipsIdRouteChildren,
  );

interface DashboardDashboardMembershipsRouteChildren {
  DashboardDashboardMembershipsIdRoute: typeof DashboardDashboardMembershipsIdRouteWithChildren;
  DashboardDashboardMembershipsNewRoute: typeof DashboardDashboardMembershipsNewRoute;
  DashboardDashboardMembershipsReportsRoute: typeof DashboardDashboardMembershipsReportsRoute;
  DashboardDashboardMembershipsIndexRoute: typeof DashboardDashboardMembershipsIndexRoute;
}

const DashboardDashboardMembershipsRouteChildren: DashboardDashboardMembershipsRouteChildren =
  {
    DashboardDashboardMembershipsIdRoute:
      DashboardDashboardMembershipsIdRouteWithChildren,
    DashboardDashboardMembershipsNewRoute:
      DashboardDashboardMembershipsNewRoute,
    DashboardDashboardMembershipsReportsRoute:
      DashboardDashboardMembershipsReportsRoute,
    DashboardDashboardMembershipsIndexRoute:
      DashboardDashboardMembershipsIndexRoute,
  };

const DashboardDashboardMembershipsRouteWithChildren =
  DashboardDashboardMembershipsRoute._addFileChildren(
    DashboardDashboardMembershipsRouteChildren,
  );

interface DashboardDashboardPaymentsRouteChildren {
  DashboardDashboardPaymentsIdRoute: typeof DashboardDashboardPaymentsIdRoute;
}

const DashboardDashboardPaymentsRouteChildren: DashboardDashboardPaymentsRouteChildren =
  {
    DashboardDashboardPaymentsIdRoute: DashboardDashboardPaymentsIdRoute,
  };

const DashboardDashboardPaymentsRouteWithChildren =
  DashboardDashboardPaymentsRoute._addFileChildren(
    DashboardDashboardPaymentsRouteChildren,
  );

interface DashboardDashboardPricebookIdRouteChildren {
  DashboardDashboardPricebookIdEditRoute: typeof DashboardDashboardPricebookIdEditRoute;
}

const DashboardDashboardPricebookIdRouteChildren: DashboardDashboardPricebookIdRouteChildren =
  {
    DashboardDashboardPricebookIdEditRoute:
      DashboardDashboardPricebookIdEditRoute,
  };

const DashboardDashboardPricebookIdRouteWithChildren =
  DashboardDashboardPricebookIdRoute._addFileChildren(
    DashboardDashboardPricebookIdRouteChildren,
  );

interface DashboardDashboardPricebookRouteChildren {
  DashboardDashboardPricebookIdRoute: typeof DashboardDashboardPricebookIdRouteWithChildren;
  DashboardDashboardPricebookCategoriesRoute: typeof DashboardDashboardPricebookCategoriesRoute;
  DashboardDashboardPricebookNewRoute: typeof DashboardDashboardPricebookNewRoute;
  DashboardDashboardPricebookIndexRoute: typeof DashboardDashboardPricebookIndexRoute;
}

const DashboardDashboardPricebookRouteChildren: DashboardDashboardPricebookRouteChildren =
  {
    DashboardDashboardPricebookIdRoute:
      DashboardDashboardPricebookIdRouteWithChildren,
    DashboardDashboardPricebookCategoriesRoute:
      DashboardDashboardPricebookCategoriesRoute,
    DashboardDashboardPricebookNewRoute: DashboardDashboardPricebookNewRoute,
    DashboardDashboardPricebookIndexRoute:
      DashboardDashboardPricebookIndexRoute,
  };

const DashboardDashboardPricebookRouteWithChildren =
  DashboardDashboardPricebookRoute._addFileChildren(
    DashboardDashboardPricebookRouteChildren,
  );

interface DashboardDashboardProjectsRouteChildren {
  DashboardDashboardProjectsProjectIdRoute: typeof DashboardDashboardProjectsProjectIdRoute;
}

const DashboardDashboardProjectsRouteChildren: DashboardDashboardProjectsRouteChildren =
  {
    DashboardDashboardProjectsProjectIdRoute:
      DashboardDashboardProjectsProjectIdRoute,
  };

const DashboardDashboardProjectsRouteWithChildren =
  DashboardDashboardProjectsRoute._addFileChildren(
    DashboardDashboardProjectsRouteChildren,
  );

interface DashboardDashboardProposalsIdRouteChildren {
  DashboardDashboardProposalsIdEditRoute: typeof DashboardDashboardProposalsIdEditRoute;
  DashboardDashboardProposalsIdPresentRoute: typeof DashboardDashboardProposalsIdPresentRoute;
}

const DashboardDashboardProposalsIdRouteChildren: DashboardDashboardProposalsIdRouteChildren =
  {
    DashboardDashboardProposalsIdEditRoute:
      DashboardDashboardProposalsIdEditRoute,
    DashboardDashboardProposalsIdPresentRoute:
      DashboardDashboardProposalsIdPresentRoute,
  };

const DashboardDashboardProposalsIdRouteWithChildren =
  DashboardDashboardProposalsIdRoute._addFileChildren(
    DashboardDashboardProposalsIdRouteChildren,
  );

interface DashboardDashboardProposalsRouteChildren {
  DashboardDashboardProposalsIdRoute: typeof DashboardDashboardProposalsIdRouteWithChildren;
  DashboardDashboardProposalsNewRoute: typeof DashboardDashboardProposalsNewRoute;
  DashboardDashboardProposalsIndexRoute: typeof DashboardDashboardProposalsIndexRoute;
}

const DashboardDashboardProposalsRouteChildren: DashboardDashboardProposalsRouteChildren =
  {
    DashboardDashboardProposalsIdRoute:
      DashboardDashboardProposalsIdRouteWithChildren,
    DashboardDashboardProposalsNewRoute: DashboardDashboardProposalsNewRoute,
    DashboardDashboardProposalsIndexRoute:
      DashboardDashboardProposalsIndexRoute,
  };

const DashboardDashboardProposalsRouteWithChildren =
  DashboardDashboardProposalsRoute._addFileChildren(
    DashboardDashboardProposalsRouteChildren,
  );

interface DashboardDashboardPurchasingRouteChildren {
  DashboardDashboardPurchasingApprovalsRoute: typeof DashboardDashboardPurchasingApprovalsRoute;
  DashboardDashboardPurchasingBillsRoute: typeof DashboardDashboardPurchasingBillsRoute;
  DashboardDashboardPurchasingCardsRoute: typeof DashboardDashboardPurchasingCardsRoute;
  DashboardDashboardPurchasingCostChangesRoute: typeof DashboardDashboardPurchasingCostChangesRoute;
  DashboardDashboardPurchasingFieldRoute: typeof DashboardDashboardPurchasingFieldRoute;
  DashboardDashboardPurchasingOverviewRoute: typeof DashboardDashboardPurchasingOverviewRoute;
  DashboardDashboardPurchasingRequestsRoute: typeof DashboardDashboardPurchasingRequestsRoute;
  DashboardDashboardPurchasingIndexRoute: typeof DashboardDashboardPurchasingIndexRoute;
  DashboardDashboardPurchasingSuppliersSupplierIdRoute: typeof DashboardDashboardPurchasingSuppliersSupplierIdRoute;
  DashboardDashboardPurchasingSuppliersIndexRoute: typeof DashboardDashboardPurchasingSuppliersIndexRoute;
  DashboardDashboardPurchasingSuppliersSupplierIdEditRoute: typeof DashboardDashboardPurchasingSuppliersSupplierIdEditRoute;
}

const DashboardDashboardPurchasingRouteChildren: DashboardDashboardPurchasingRouteChildren =
  {
    DashboardDashboardPurchasingApprovalsRoute:
      DashboardDashboardPurchasingApprovalsRoute,
    DashboardDashboardPurchasingBillsRoute:
      DashboardDashboardPurchasingBillsRoute,
    DashboardDashboardPurchasingCardsRoute:
      DashboardDashboardPurchasingCardsRoute,
    DashboardDashboardPurchasingCostChangesRoute:
      DashboardDashboardPurchasingCostChangesRoute,
    DashboardDashboardPurchasingFieldRoute:
      DashboardDashboardPurchasingFieldRoute,
    DashboardDashboardPurchasingOverviewRoute:
      DashboardDashboardPurchasingOverviewRoute,
    DashboardDashboardPurchasingRequestsRoute:
      DashboardDashboardPurchasingRequestsRoute,
    DashboardDashboardPurchasingIndexRoute:
      DashboardDashboardPurchasingIndexRoute,
    DashboardDashboardPurchasingSuppliersSupplierIdRoute:
      DashboardDashboardPurchasingSuppliersSupplierIdRoute,
    DashboardDashboardPurchasingSuppliersIndexRoute:
      DashboardDashboardPurchasingSuppliersIndexRoute,
    DashboardDashboardPurchasingSuppliersSupplierIdEditRoute:
      DashboardDashboardPurchasingSuppliersSupplierIdEditRoute,
  };

const DashboardDashboardPurchasingRouteWithChildren =
  DashboardDashboardPurchasingRoute._addFileChildren(
    DashboardDashboardPurchasingRouteChildren,
  );

interface DashboardDashboardReceiptsRouteChildren {
  DashboardDashboardReceiptsIdRoute: typeof DashboardDashboardReceiptsIdRoute;
  DashboardDashboardReceiptsIndexRoute: typeof DashboardDashboardReceiptsIndexRoute;
}

const DashboardDashboardReceiptsRouteChildren: DashboardDashboardReceiptsRouteChildren =
  {
    DashboardDashboardReceiptsIdRoute: DashboardDashboardReceiptsIdRoute,
    DashboardDashboardReceiptsIndexRoute: DashboardDashboardReceiptsIndexRoute,
  };

const DashboardDashboardReceiptsRouteWithChildren =
  DashboardDashboardReceiptsRoute._addFileChildren(
    DashboardDashboardReceiptsRouteChildren,
  );

interface DashboardDashboardSettingsAppointmentFormsIdRouteChildren {
  DashboardDashboardSettingsAppointmentFormsIdEditRoute: typeof DashboardDashboardSettingsAppointmentFormsIdEditRoute;
}

const DashboardDashboardSettingsAppointmentFormsIdRouteChildren: DashboardDashboardSettingsAppointmentFormsIdRouteChildren =
  {
    DashboardDashboardSettingsAppointmentFormsIdEditRoute:
      DashboardDashboardSettingsAppointmentFormsIdEditRoute,
  };

const DashboardDashboardSettingsAppointmentFormsIdRouteWithChildren =
  DashboardDashboardSettingsAppointmentFormsIdRoute._addFileChildren(
    DashboardDashboardSettingsAppointmentFormsIdRouteChildren,
  );

interface DashboardDashboardSettingsAppointmentFormsRouteChildren {
  DashboardDashboardSettingsAppointmentFormsIdRoute: typeof DashboardDashboardSettingsAppointmentFormsIdRouteWithChildren;
  DashboardDashboardSettingsAppointmentFormsNewRoute: typeof DashboardDashboardSettingsAppointmentFormsNewRoute;
  DashboardDashboardSettingsAppointmentFormsIndexRoute: typeof DashboardDashboardSettingsAppointmentFormsIndexRoute;
}

const DashboardDashboardSettingsAppointmentFormsRouteChildren: DashboardDashboardSettingsAppointmentFormsRouteChildren =
  {
    DashboardDashboardSettingsAppointmentFormsIdRoute:
      DashboardDashboardSettingsAppointmentFormsIdRouteWithChildren,
    DashboardDashboardSettingsAppointmentFormsNewRoute:
      DashboardDashboardSettingsAppointmentFormsNewRoute,
    DashboardDashboardSettingsAppointmentFormsIndexRoute:
      DashboardDashboardSettingsAppointmentFormsIndexRoute,
  };

const DashboardDashboardSettingsAppointmentFormsRouteWithChildren =
  DashboardDashboardSettingsAppointmentFormsRoute._addFileChildren(
    DashboardDashboardSettingsAppointmentFormsRouteChildren,
  );

interface DashboardDashboardSettingsBillingRouteChildren {
  DashboardDashboardSettingsBillingCreditMemosRoute: typeof DashboardDashboardSettingsBillingCreditMemosRoute;
  DashboardDashboardSettingsBillingDepositsRoute: typeof DashboardDashboardSettingsBillingDepositsRoute;
  DashboardDashboardSettingsBillingInvoicesRoute: typeof DashboardDashboardSettingsBillingInvoicesRoute;
  DashboardDashboardSettingsBillingPaymentsRoute: typeof DashboardDashboardSettingsBillingPaymentsRoute;
  DashboardDashboardSettingsBillingQuickbooksRoute: typeof DashboardDashboardSettingsBillingQuickbooksRoute;
  DashboardDashboardSettingsBillingReceiptsRoute: typeof DashboardDashboardSettingsBillingReceiptsRoute;
  DashboardDashboardSettingsBillingIndexRoute: typeof DashboardDashboardSettingsBillingIndexRoute;
}

const DashboardDashboardSettingsBillingRouteChildren: DashboardDashboardSettingsBillingRouteChildren =
  {
    DashboardDashboardSettingsBillingCreditMemosRoute:
      DashboardDashboardSettingsBillingCreditMemosRoute,
    DashboardDashboardSettingsBillingDepositsRoute:
      DashboardDashboardSettingsBillingDepositsRoute,
    DashboardDashboardSettingsBillingInvoicesRoute:
      DashboardDashboardSettingsBillingInvoicesRoute,
    DashboardDashboardSettingsBillingPaymentsRoute:
      DashboardDashboardSettingsBillingPaymentsRoute,
    DashboardDashboardSettingsBillingQuickbooksRoute:
      DashboardDashboardSettingsBillingQuickbooksRoute,
    DashboardDashboardSettingsBillingReceiptsRoute:
      DashboardDashboardSettingsBillingReceiptsRoute,
    DashboardDashboardSettingsBillingIndexRoute:
      DashboardDashboardSettingsBillingIndexRoute,
  };

const DashboardDashboardSettingsBillingRouteWithChildren =
  DashboardDashboardSettingsBillingRoute._addFileChildren(
    DashboardDashboardSettingsBillingRouteChildren,
  );

interface DashboardDashboardSettingsCallSettingsRouteChildren {
  DashboardDashboardSettingsCallSettingsFlowsIdRoute: typeof DashboardDashboardSettingsCallSettingsFlowsIdRoute;
  DashboardDashboardSettingsCallSettingsIvrIdRoute: typeof DashboardDashboardSettingsCallSettingsIvrIdRoute;
  DashboardDashboardSettingsCallSettingsIvrNewRoute: typeof DashboardDashboardSettingsCallSettingsIvrNewRoute;
  DashboardDashboardSettingsCallSettingsNumbersNumberIdRoute: typeof DashboardDashboardSettingsCallSettingsNumbersNumberIdRoute;
  DashboardDashboardSettingsCallSettingsTeamSectionRoute: typeof DashboardDashboardSettingsCallSettingsTeamSectionRoute;
}

const DashboardDashboardSettingsCallSettingsRouteChildren: DashboardDashboardSettingsCallSettingsRouteChildren =
  {
    DashboardDashboardSettingsCallSettingsFlowsIdRoute:
      DashboardDashboardSettingsCallSettingsFlowsIdRoute,
    DashboardDashboardSettingsCallSettingsIvrIdRoute:
      DashboardDashboardSettingsCallSettingsIvrIdRoute,
    DashboardDashboardSettingsCallSettingsIvrNewRoute:
      DashboardDashboardSettingsCallSettingsIvrNewRoute,
    DashboardDashboardSettingsCallSettingsNumbersNumberIdRoute:
      DashboardDashboardSettingsCallSettingsNumbersNumberIdRoute,
    DashboardDashboardSettingsCallSettingsTeamSectionRoute:
      DashboardDashboardSettingsCallSettingsTeamSectionRoute,
  };

const DashboardDashboardSettingsCallSettingsRouteWithChildren =
  DashboardDashboardSettingsCallSettingsRoute._addFileChildren(
    DashboardDashboardSettingsCallSettingsRouteChildren,
  );

interface DashboardDashboardSettingsChecklistIdRouteChildren {
  DashboardDashboardSettingsChecklistIdEditRoute: typeof DashboardDashboardSettingsChecklistIdEditRoute;
}

const DashboardDashboardSettingsChecklistIdRouteChildren: DashboardDashboardSettingsChecklistIdRouteChildren =
  {
    DashboardDashboardSettingsChecklistIdEditRoute:
      DashboardDashboardSettingsChecklistIdEditRoute,
  };

const DashboardDashboardSettingsChecklistIdRouteWithChildren =
  DashboardDashboardSettingsChecklistIdRoute._addFileChildren(
    DashboardDashboardSettingsChecklistIdRouteChildren,
  );

interface DashboardDashboardSettingsChecklistRouteChildren {
  DashboardDashboardSettingsChecklistIdRoute: typeof DashboardDashboardSettingsChecklistIdRouteWithChildren;
  DashboardDashboardSettingsChecklistNewRoute: typeof DashboardDashboardSettingsChecklistNewRoute;
  DashboardDashboardSettingsChecklistIndexRoute: typeof DashboardDashboardSettingsChecklistIndexRoute;
}

const DashboardDashboardSettingsChecklistRouteChildren: DashboardDashboardSettingsChecklistRouteChildren =
  {
    DashboardDashboardSettingsChecklistIdRoute:
      DashboardDashboardSettingsChecklistIdRouteWithChildren,
    DashboardDashboardSettingsChecklistNewRoute:
      DashboardDashboardSettingsChecklistNewRoute,
    DashboardDashboardSettingsChecklistIndexRoute:
      DashboardDashboardSettingsChecklistIndexRoute,
  };

const DashboardDashboardSettingsChecklistRouteWithChildren =
  DashboardDashboardSettingsChecklistRoute._addFileChildren(
    DashboardDashboardSettingsChecklistRouteChildren,
  );

interface DashboardDashboardSettingsCompanyRouteChildren {
  DashboardDashboardSettingsCompanyEditRoute: typeof DashboardDashboardSettingsCompanyEditRoute;
}

const DashboardDashboardSettingsCompanyRouteChildren: DashboardDashboardSettingsCompanyRouteChildren =
  {
    DashboardDashboardSettingsCompanyEditRoute:
      DashboardDashboardSettingsCompanyEditRoute,
  };

const DashboardDashboardSettingsCompanyRouteWithChildren =
  DashboardDashboardSettingsCompanyRoute._addFileChildren(
    DashboardDashboardSettingsCompanyRouteChildren,
  );

interface DashboardDashboardSettingsContractsRouteChildren {
  DashboardDashboardSettingsContractsCancellationRoute: typeof DashboardDashboardSettingsContractsCancellationRoute;
  DashboardDashboardSettingsContractsCostingRoute: typeof DashboardDashboardSettingsContractsCostingRoute;
  DashboardDashboardSettingsContractsDefaultsRoute: typeof DashboardDashboardSettingsContractsDefaultsRoute;
  DashboardDashboardSettingsContractsProductionKitsRoute: typeof DashboardDashboardSettingsContractsProductionKitsRoute;
  DashboardDashboardSettingsContractsQboRoute: typeof DashboardDashboardSettingsContractsQboRoute;
  DashboardDashboardSettingsContractsRenewalRoute: typeof DashboardDashboardSettingsContractsRenewalRoute;
  DashboardDashboardSettingsContractsRenewalCancellationRoute: typeof DashboardDashboardSettingsContractsRenewalCancellationRoute;
  DashboardDashboardSettingsContractsReviewsRoute: typeof DashboardDashboardSettingsContractsReviewsRoute;
  DashboardDashboardSettingsContractsIndexRoute: typeof DashboardDashboardSettingsContractsIndexRoute;
}

const DashboardDashboardSettingsContractsRouteChildren: DashboardDashboardSettingsContractsRouteChildren =
  {
    DashboardDashboardSettingsContractsCancellationRoute:
      DashboardDashboardSettingsContractsCancellationRoute,
    DashboardDashboardSettingsContractsCostingRoute:
      DashboardDashboardSettingsContractsCostingRoute,
    DashboardDashboardSettingsContractsDefaultsRoute:
      DashboardDashboardSettingsContractsDefaultsRoute,
    DashboardDashboardSettingsContractsProductionKitsRoute:
      DashboardDashboardSettingsContractsProductionKitsRoute,
    DashboardDashboardSettingsContractsQboRoute:
      DashboardDashboardSettingsContractsQboRoute,
    DashboardDashboardSettingsContractsRenewalRoute:
      DashboardDashboardSettingsContractsRenewalRoute,
    DashboardDashboardSettingsContractsRenewalCancellationRoute:
      DashboardDashboardSettingsContractsRenewalCancellationRoute,
    DashboardDashboardSettingsContractsReviewsRoute:
      DashboardDashboardSettingsContractsReviewsRoute,
    DashboardDashboardSettingsContractsIndexRoute:
      DashboardDashboardSettingsContractsIndexRoute,
  };

const DashboardDashboardSettingsContractsRouteWithChildren =
  DashboardDashboardSettingsContractsRoute._addFileChildren(
    DashboardDashboardSettingsContractsRouteChildren,
  );

interface DashboardDashboardSettingsCustomfieldsIdRouteChildren {
  DashboardDashboardSettingsCustomfieldsIdEditRoute: typeof DashboardDashboardSettingsCustomfieldsIdEditRoute;
}

const DashboardDashboardSettingsCustomfieldsIdRouteChildren: DashboardDashboardSettingsCustomfieldsIdRouteChildren =
  {
    DashboardDashboardSettingsCustomfieldsIdEditRoute:
      DashboardDashboardSettingsCustomfieldsIdEditRoute,
  };

const DashboardDashboardSettingsCustomfieldsIdRouteWithChildren =
  DashboardDashboardSettingsCustomfieldsIdRoute._addFileChildren(
    DashboardDashboardSettingsCustomfieldsIdRouteChildren,
  );

interface DashboardDashboardSettingsCustomfieldsRouteChildren {
  DashboardDashboardSettingsCustomfieldsIdRoute: typeof DashboardDashboardSettingsCustomfieldsIdRouteWithChildren;
  DashboardDashboardSettingsCustomfieldsNewRoute: typeof DashboardDashboardSettingsCustomfieldsNewRoute;
}

const DashboardDashboardSettingsCustomfieldsRouteChildren: DashboardDashboardSettingsCustomfieldsRouteChildren =
  {
    DashboardDashboardSettingsCustomfieldsIdRoute:
      DashboardDashboardSettingsCustomfieldsIdRouteWithChildren,
    DashboardDashboardSettingsCustomfieldsNewRoute:
      DashboardDashboardSettingsCustomfieldsNewRoute,
  };

const DashboardDashboardSettingsCustomfieldsRouteWithChildren =
  DashboardDashboardSettingsCustomfieldsRoute._addFileChildren(
    DashboardDashboardSettingsCustomfieldsRouteChildren,
  );

interface DashboardDashboardSettingsGroupsIdRouteChildren {
  DashboardDashboardSettingsGroupsIdEditRoute: typeof DashboardDashboardSettingsGroupsIdEditRoute;
}

const DashboardDashboardSettingsGroupsIdRouteChildren: DashboardDashboardSettingsGroupsIdRouteChildren =
  {
    DashboardDashboardSettingsGroupsIdEditRoute:
      DashboardDashboardSettingsGroupsIdEditRoute,
  };

const DashboardDashboardSettingsGroupsIdRouteWithChildren =
  DashboardDashboardSettingsGroupsIdRoute._addFileChildren(
    DashboardDashboardSettingsGroupsIdRouteChildren,
  );

interface DashboardDashboardSettingsGroupsRouteChildren {
  DashboardDashboardSettingsGroupsIdRoute: typeof DashboardDashboardSettingsGroupsIdRouteWithChildren;
  DashboardDashboardSettingsGroupsNewRoute: typeof DashboardDashboardSettingsGroupsNewRoute;
}

const DashboardDashboardSettingsGroupsRouteChildren: DashboardDashboardSettingsGroupsRouteChildren =
  {
    DashboardDashboardSettingsGroupsIdRoute:
      DashboardDashboardSettingsGroupsIdRouteWithChildren,
    DashboardDashboardSettingsGroupsNewRoute:
      DashboardDashboardSettingsGroupsNewRoute,
  };

const DashboardDashboardSettingsGroupsRouteWithChildren =
  DashboardDashboardSettingsGroupsRoute._addFileChildren(
    DashboardDashboardSettingsGroupsRouteChildren,
  );

interface DashboardDashboardSettingsJobPipelinesIdRouteChildren {
  DashboardDashboardSettingsJobPipelinesIdEditRoute: typeof DashboardDashboardSettingsJobPipelinesIdEditRoute;
}

const DashboardDashboardSettingsJobPipelinesIdRouteChildren: DashboardDashboardSettingsJobPipelinesIdRouteChildren =
  {
    DashboardDashboardSettingsJobPipelinesIdEditRoute:
      DashboardDashboardSettingsJobPipelinesIdEditRoute,
  };

const DashboardDashboardSettingsJobPipelinesIdRouteWithChildren =
  DashboardDashboardSettingsJobPipelinesIdRoute._addFileChildren(
    DashboardDashboardSettingsJobPipelinesIdRouteChildren,
  );

interface DashboardDashboardSettingsJobPipelinesRouteChildren {
  DashboardDashboardSettingsJobPipelinesIdRoute: typeof DashboardDashboardSettingsJobPipelinesIdRouteWithChildren;
  DashboardDashboardSettingsJobPipelinesNewRoute: typeof DashboardDashboardSettingsJobPipelinesNewRoute;
  DashboardDashboardSettingsJobPipelinesIndexRoute: typeof DashboardDashboardSettingsJobPipelinesIndexRoute;
}

const DashboardDashboardSettingsJobPipelinesRouteChildren: DashboardDashboardSettingsJobPipelinesRouteChildren =
  {
    DashboardDashboardSettingsJobPipelinesIdRoute:
      DashboardDashboardSettingsJobPipelinesIdRouteWithChildren,
    DashboardDashboardSettingsJobPipelinesNewRoute:
      DashboardDashboardSettingsJobPipelinesNewRoute,
    DashboardDashboardSettingsJobPipelinesIndexRoute:
      DashboardDashboardSettingsJobPipelinesIndexRoute,
  };

const DashboardDashboardSettingsJobPipelinesRouteWithChildren =
  DashboardDashboardSettingsJobPipelinesRoute._addFileChildren(
    DashboardDashboardSettingsJobPipelinesRouteChildren,
  );

interface DashboardDashboardSettingsJobtypesIdRouteChildren {
  DashboardDashboardSettingsJobtypesIdEditRoute: typeof DashboardDashboardSettingsJobtypesIdEditRoute;
}

const DashboardDashboardSettingsJobtypesIdRouteChildren: DashboardDashboardSettingsJobtypesIdRouteChildren =
  {
    DashboardDashboardSettingsJobtypesIdEditRoute:
      DashboardDashboardSettingsJobtypesIdEditRoute,
  };

const DashboardDashboardSettingsJobtypesIdRouteWithChildren =
  DashboardDashboardSettingsJobtypesIdRoute._addFileChildren(
    DashboardDashboardSettingsJobtypesIdRouteChildren,
  );

interface DashboardDashboardSettingsJobtypesRouteChildren {
  DashboardDashboardSettingsJobtypesIdRoute: typeof DashboardDashboardSettingsJobtypesIdRouteWithChildren;
  DashboardDashboardSettingsJobtypesNewRoute: typeof DashboardDashboardSettingsJobtypesNewRoute;
}

const DashboardDashboardSettingsJobtypesRouteChildren: DashboardDashboardSettingsJobtypesRouteChildren =
  {
    DashboardDashboardSettingsJobtypesIdRoute:
      DashboardDashboardSettingsJobtypesIdRouteWithChildren,
    DashboardDashboardSettingsJobtypesNewRoute:
      DashboardDashboardSettingsJobtypesNewRoute,
  };

const DashboardDashboardSettingsJobtypesRouteWithChildren =
  DashboardDashboardSettingsJobtypesRoute._addFileChildren(
    DashboardDashboardSettingsJobtypesRouteChildren,
  );

interface DashboardDashboardSettingsNotificationsRouteChildren {
  DashboardDashboardSettingsNotificationsEditRoute: typeof DashboardDashboardSettingsNotificationsEditRoute;
}

const DashboardDashboardSettingsNotificationsRouteChildren: DashboardDashboardSettingsNotificationsRouteChildren =
  {
    DashboardDashboardSettingsNotificationsEditRoute:
      DashboardDashboardSettingsNotificationsEditRoute,
  };

const DashboardDashboardSettingsNotificationsRouteWithChildren =
  DashboardDashboardSettingsNotificationsRoute._addFileChildren(
    DashboardDashboardSettingsNotificationsRouteChildren,
  );

interface DashboardDashboardSettingsOfficeSettingsRouteChildren {
  DashboardDashboardSettingsOfficeSettingsEditRoute: typeof DashboardDashboardSettingsOfficeSettingsEditRoute;
}

const DashboardDashboardSettingsOfficeSettingsRouteChildren: DashboardDashboardSettingsOfficeSettingsRouteChildren =
  {
    DashboardDashboardSettingsOfficeSettingsEditRoute:
      DashboardDashboardSettingsOfficeSettingsEditRoute,
  };

const DashboardDashboardSettingsOfficeSettingsRouteWithChildren =
  DashboardDashboardSettingsOfficeSettingsRoute._addFileChildren(
    DashboardDashboardSettingsOfficeSettingsRouteChildren,
  );

interface DashboardDashboardSettingsPermissionsIdRouteChildren {
  DashboardDashboardSettingsPermissionsIdEditRoute: typeof DashboardDashboardSettingsPermissionsIdEditRoute;
}

const DashboardDashboardSettingsPermissionsIdRouteChildren: DashboardDashboardSettingsPermissionsIdRouteChildren =
  {
    DashboardDashboardSettingsPermissionsIdEditRoute:
      DashboardDashboardSettingsPermissionsIdEditRoute,
  };

const DashboardDashboardSettingsPermissionsIdRouteWithChildren =
  DashboardDashboardSettingsPermissionsIdRoute._addFileChildren(
    DashboardDashboardSettingsPermissionsIdRouteChildren,
  );

interface DashboardDashboardSettingsPermissionsRouteChildren {
  DashboardDashboardSettingsPermissionsIdRoute: typeof DashboardDashboardSettingsPermissionsIdRouteWithChildren;
  DashboardDashboardSettingsPermissionsNewRoute: typeof DashboardDashboardSettingsPermissionsNewRoute;
}

const DashboardDashboardSettingsPermissionsRouteChildren: DashboardDashboardSettingsPermissionsRouteChildren =
  {
    DashboardDashboardSettingsPermissionsIdRoute:
      DashboardDashboardSettingsPermissionsIdRouteWithChildren,
    DashboardDashboardSettingsPermissionsNewRoute:
      DashboardDashboardSettingsPermissionsNewRoute,
  };

const DashboardDashboardSettingsPermissionsRouteWithChildren =
  DashboardDashboardSettingsPermissionsRoute._addFileChildren(
    DashboardDashboardSettingsPermissionsRouteChildren,
  );

interface DashboardDashboardSettingsRemindersRouteChildren {
  DashboardDashboardSettingsRemindersTypeRoute: typeof DashboardDashboardSettingsRemindersTypeRoute;
}

const DashboardDashboardSettingsRemindersRouteChildren: DashboardDashboardSettingsRemindersRouteChildren =
  {
    DashboardDashboardSettingsRemindersTypeRoute:
      DashboardDashboardSettingsRemindersTypeRoute,
  };

const DashboardDashboardSettingsRemindersRouteWithChildren =
  DashboardDashboardSettingsRemindersRoute._addFileChildren(
    DashboardDashboardSettingsRemindersRouteChildren,
  );

interface DashboardDashboardSettingsScopeOfWorkIdRouteChildren {
  DashboardDashboardSettingsScopeOfWorkIdEditRoute: typeof DashboardDashboardSettingsScopeOfWorkIdEditRoute;
}

const DashboardDashboardSettingsScopeOfWorkIdRouteChildren: DashboardDashboardSettingsScopeOfWorkIdRouteChildren =
  {
    DashboardDashboardSettingsScopeOfWorkIdEditRoute:
      DashboardDashboardSettingsScopeOfWorkIdEditRoute,
  };

const DashboardDashboardSettingsScopeOfWorkIdRouteWithChildren =
  DashboardDashboardSettingsScopeOfWorkIdRoute._addFileChildren(
    DashboardDashboardSettingsScopeOfWorkIdRouteChildren,
  );

interface DashboardDashboardSettingsScopeOfWorkRouteChildren {
  DashboardDashboardSettingsScopeOfWorkIdRoute: typeof DashboardDashboardSettingsScopeOfWorkIdRouteWithChildren;
}

const DashboardDashboardSettingsScopeOfWorkRouteChildren: DashboardDashboardSettingsScopeOfWorkRouteChildren =
  {
    DashboardDashboardSettingsScopeOfWorkIdRoute:
      DashboardDashboardSettingsScopeOfWorkIdRouteWithChildren,
  };

const DashboardDashboardSettingsScopeOfWorkRouteWithChildren =
  DashboardDashboardSettingsScopeOfWorkRoute._addFileChildren(
    DashboardDashboardSettingsScopeOfWorkRouteChildren,
  );

interface DashboardDashboardSettingsSkillsIdRouteChildren {
  DashboardDashboardSettingsSkillsIdEditRoute: typeof DashboardDashboardSettingsSkillsIdEditRoute;
}

const DashboardDashboardSettingsSkillsIdRouteChildren: DashboardDashboardSettingsSkillsIdRouteChildren =
  {
    DashboardDashboardSettingsSkillsIdEditRoute:
      DashboardDashboardSettingsSkillsIdEditRoute,
  };

const DashboardDashboardSettingsSkillsIdRouteWithChildren =
  DashboardDashboardSettingsSkillsIdRoute._addFileChildren(
    DashboardDashboardSettingsSkillsIdRouteChildren,
  );

interface DashboardDashboardSettingsSkillsRouteChildren {
  DashboardDashboardSettingsSkillsIdRoute: typeof DashboardDashboardSettingsSkillsIdRouteWithChildren;
  DashboardDashboardSettingsSkillsNewRoute: typeof DashboardDashboardSettingsSkillsNewRoute;
}

const DashboardDashboardSettingsSkillsRouteChildren: DashboardDashboardSettingsSkillsRouteChildren =
  {
    DashboardDashboardSettingsSkillsIdRoute:
      DashboardDashboardSettingsSkillsIdRouteWithChildren,
    DashboardDashboardSettingsSkillsNewRoute:
      DashboardDashboardSettingsSkillsNewRoute,
  };

const DashboardDashboardSettingsSkillsRouteWithChildren =
  DashboardDashboardSettingsSkillsRoute._addFileChildren(
    DashboardDashboardSettingsSkillsRouteChildren,
  );

interface DashboardDashboardSettingsTemplatesRouteChildren {
  DashboardDashboardSettingsTemplatesIndexRoute: typeof DashboardDashboardSettingsTemplatesIndexRoute;
  DashboardDashboardSettingsTemplatesEstimateIdRoute: typeof DashboardDashboardSettingsTemplatesEstimateIdRoute;
  DashboardDashboardSettingsTemplatesEstimateNewRoute: typeof DashboardDashboardSettingsTemplatesEstimateNewRoute;
  DashboardDashboardSettingsTemplatesProposalIdRoute: typeof DashboardDashboardSettingsTemplatesProposalIdRoute;
  DashboardDashboardSettingsTemplatesProposalNewRoute: typeof DashboardDashboardSettingsTemplatesProposalNewRoute;
}

const DashboardDashboardSettingsTemplatesRouteChildren: DashboardDashboardSettingsTemplatesRouteChildren =
  {
    DashboardDashboardSettingsTemplatesIndexRoute:
      DashboardDashboardSettingsTemplatesIndexRoute,
    DashboardDashboardSettingsTemplatesEstimateIdRoute:
      DashboardDashboardSettingsTemplatesEstimateIdRoute,
    DashboardDashboardSettingsTemplatesEstimateNewRoute:
      DashboardDashboardSettingsTemplatesEstimateNewRoute,
    DashboardDashboardSettingsTemplatesProposalIdRoute:
      DashboardDashboardSettingsTemplatesProposalIdRoute,
    DashboardDashboardSettingsTemplatesProposalNewRoute:
      DashboardDashboardSettingsTemplatesProposalNewRoute,
  };

const DashboardDashboardSettingsTemplatesRouteWithChildren =
  DashboardDashboardSettingsTemplatesRoute._addFileChildren(
    DashboardDashboardSettingsTemplatesRouteChildren,
  );

interface DashboardDashboardSettingsTermsAndConditionsIdRouteChildren {
  DashboardDashboardSettingsTermsAndConditionsIdEditRoute: typeof DashboardDashboardSettingsTermsAndConditionsIdEditRoute;
}

const DashboardDashboardSettingsTermsAndConditionsIdRouteChildren: DashboardDashboardSettingsTermsAndConditionsIdRouteChildren =
  {
    DashboardDashboardSettingsTermsAndConditionsIdEditRoute:
      DashboardDashboardSettingsTermsAndConditionsIdEditRoute,
  };

const DashboardDashboardSettingsTermsAndConditionsIdRouteWithChildren =
  DashboardDashboardSettingsTermsAndConditionsIdRoute._addFileChildren(
    DashboardDashboardSettingsTermsAndConditionsIdRouteChildren,
  );

interface DashboardDashboardSettingsTermsAndConditionsRouteChildren {
  DashboardDashboardSettingsTermsAndConditionsIdRoute: typeof DashboardDashboardSettingsTermsAndConditionsIdRouteWithChildren;
}

const DashboardDashboardSettingsTermsAndConditionsRouteChildren: DashboardDashboardSettingsTermsAndConditionsRouteChildren =
  {
    DashboardDashboardSettingsTermsAndConditionsIdRoute:
      DashboardDashboardSettingsTermsAndConditionsIdRouteWithChildren,
  };

const DashboardDashboardSettingsTermsAndConditionsRouteWithChildren =
  DashboardDashboardSettingsTermsAndConditionsRoute._addFileChildren(
    DashboardDashboardSettingsTermsAndConditionsRouteChildren,
  );

interface DashboardDashboardSettingsUsersIdRouteChildren {
  DashboardDashboardSettingsUsersIdEditRoute: typeof DashboardDashboardSettingsUsersIdEditRoute;
}

const DashboardDashboardSettingsUsersIdRouteChildren: DashboardDashboardSettingsUsersIdRouteChildren =
  {
    DashboardDashboardSettingsUsersIdEditRoute:
      DashboardDashboardSettingsUsersIdEditRoute,
  };

const DashboardDashboardSettingsUsersIdRouteWithChildren =
  DashboardDashboardSettingsUsersIdRoute._addFileChildren(
    DashboardDashboardSettingsUsersIdRouteChildren,
  );

interface DashboardDashboardSettingsUsersRouteChildren {
  DashboardDashboardSettingsUsersIdRoute: typeof DashboardDashboardSettingsUsersIdRouteWithChildren;
  DashboardDashboardSettingsUsersNewRoute: typeof DashboardDashboardSettingsUsersNewRoute;
}

const DashboardDashboardSettingsUsersRouteChildren: DashboardDashboardSettingsUsersRouteChildren =
  {
    DashboardDashboardSettingsUsersIdRoute:
      DashboardDashboardSettingsUsersIdRouteWithChildren,
    DashboardDashboardSettingsUsersNewRoute:
      DashboardDashboardSettingsUsersNewRoute,
  };

const DashboardDashboardSettingsUsersRouteWithChildren =
  DashboardDashboardSettingsUsersRoute._addFileChildren(
    DashboardDashboardSettingsUsersRouteChildren,
  );

interface DashboardDashboardSettingsWebhooksIdRouteChildren {
  DashboardDashboardSettingsWebhooksIdEditRoute: typeof DashboardDashboardSettingsWebhooksIdEditRoute;
}

const DashboardDashboardSettingsWebhooksIdRouteChildren: DashboardDashboardSettingsWebhooksIdRouteChildren =
  {
    DashboardDashboardSettingsWebhooksIdEditRoute:
      DashboardDashboardSettingsWebhooksIdEditRoute,
  };

const DashboardDashboardSettingsWebhooksIdRouteWithChildren =
  DashboardDashboardSettingsWebhooksIdRoute._addFileChildren(
    DashboardDashboardSettingsWebhooksIdRouteChildren,
  );

interface DashboardDashboardSettingsWebhooksRouteChildren {
  DashboardDashboardSettingsWebhooksIdRoute: typeof DashboardDashboardSettingsWebhooksIdRouteWithChildren;
  DashboardDashboardSettingsWebhooksNewRoute: typeof DashboardDashboardSettingsWebhooksNewRoute;
}

const DashboardDashboardSettingsWebhooksRouteChildren: DashboardDashboardSettingsWebhooksRouteChildren =
  {
    DashboardDashboardSettingsWebhooksIdRoute:
      DashboardDashboardSettingsWebhooksIdRouteWithChildren,
    DashboardDashboardSettingsWebhooksNewRoute:
      DashboardDashboardSettingsWebhooksNewRoute,
  };

const DashboardDashboardSettingsWebhooksRouteWithChildren =
  DashboardDashboardSettingsWebhooksRoute._addFileChildren(
    DashboardDashboardSettingsWebhooksRouteChildren,
  );

interface DashboardDashboardSettingsPartnerApiWebhooksIdRouteChildren {
  DashboardDashboardSettingsPartnerApiWebhooksIdEditRoute: typeof DashboardDashboardSettingsPartnerApiWebhooksIdEditRoute;
}

const DashboardDashboardSettingsPartnerApiWebhooksIdRouteChildren: DashboardDashboardSettingsPartnerApiWebhooksIdRouteChildren =
  {
    DashboardDashboardSettingsPartnerApiWebhooksIdEditRoute:
      DashboardDashboardSettingsPartnerApiWebhooksIdEditRoute,
  };

const DashboardDashboardSettingsPartnerApiWebhooksIdRouteWithChildren =
  DashboardDashboardSettingsPartnerApiWebhooksIdRoute._addFileChildren(
    DashboardDashboardSettingsPartnerApiWebhooksIdRouteChildren,
  );

interface DashboardDashboardSettingsPartnerApiWebhooksRouteChildren {
  DashboardDashboardSettingsPartnerApiWebhooksIdRoute: typeof DashboardDashboardSettingsPartnerApiWebhooksIdRouteWithChildren;
  DashboardDashboardSettingsPartnerApiWebhooksNewRoute: typeof DashboardDashboardSettingsPartnerApiWebhooksNewRoute;
}

const DashboardDashboardSettingsPartnerApiWebhooksRouteChildren: DashboardDashboardSettingsPartnerApiWebhooksRouteChildren =
  {
    DashboardDashboardSettingsPartnerApiWebhooksIdRoute:
      DashboardDashboardSettingsPartnerApiWebhooksIdRouteWithChildren,
    DashboardDashboardSettingsPartnerApiWebhooksNewRoute:
      DashboardDashboardSettingsPartnerApiWebhooksNewRoute,
  };

const DashboardDashboardSettingsPartnerApiWebhooksRouteWithChildren =
  DashboardDashboardSettingsPartnerApiWebhooksRoute._addFileChildren(
    DashboardDashboardSettingsPartnerApiWebhooksRouteChildren,
  );

interface DashboardDashboardSettingsRouteChildren {
  DashboardDashboardSettingsAccountingRoute: typeof DashboardDashboardSettingsAccountingRoute;
  DashboardDashboardSettingsApiKeysRoute: typeof DashboardDashboardSettingsApiKeysRoute;
  DashboardDashboardSettingsAppointmentFormsRoute: typeof DashboardDashboardSettingsAppointmentFormsRouteWithChildren;
  DashboardDashboardSettingsBillingRoute: typeof DashboardDashboardSettingsBillingRouteWithChildren;
  DashboardDashboardSettingsBookingLinksRoute: typeof DashboardDashboardSettingsBookingLinksRoute;
  DashboardDashboardSettingsBookingServicesRoute: typeof DashboardDashboardSettingsBookingServicesRoute;
  DashboardDashboardSettingsBookingWindowsRoute: typeof DashboardDashboardSettingsBookingWindowsRoute;
  DashboardDashboardSettingsCallSettingsRoute: typeof DashboardDashboardSettingsCallSettingsRouteWithChildren;
  DashboardDashboardSettingsCalltreeRoute: typeof DashboardDashboardSettingsCalltreeRoute;
  DashboardDashboardSettingsChannelsRoute: typeof DashboardDashboardSettingsChannelsRoute;
  DashboardDashboardSettingsChatbotRoute: typeof DashboardDashboardSettingsChatbotRoute;
  DashboardDashboardSettingsChecklistRoute: typeof DashboardDashboardSettingsChecklistRouteWithChildren;
  DashboardDashboardSettingsClientPortalRoute: typeof DashboardDashboardSettingsClientPortalRoute;
  DashboardDashboardSettingsCompanyRoute: typeof DashboardDashboardSettingsCompanyRouteWithChildren;
  DashboardDashboardSettingsConnectionsRoute: typeof DashboardDashboardSettingsConnectionsRoute;
  DashboardDashboardSettingsContactStatusesRoute: typeof DashboardDashboardSettingsContactStatusesRoute;
  DashboardDashboardSettingsContractsRoute: typeof DashboardDashboardSettingsContractsRouteWithChildren;
  DashboardDashboardSettingsCustomfieldsRoute: typeof DashboardDashboardSettingsCustomfieldsRouteWithChildren;
  DashboardDashboardSettingsDeferredRevenueRoute: typeof DashboardDashboardSettingsDeferredRevenueRoute;
  DashboardDashboardSettingsEmailAccountsRoute: typeof DashboardDashboardSettingsEmailAccountsRoute;
  DashboardDashboardSettingsEstimatePdfRoute: typeof DashboardDashboardSettingsEstimatePdfRoute;
  DashboardDashboardSettingsEstimateSettingsRoute: typeof DashboardDashboardSettingsEstimateSettingsRoute;
  DashboardDashboardSettingsEstimatesRoute: typeof DashboardDashboardSettingsEstimatesRoute;
  DashboardDashboardSettingsGroupsRoute: typeof DashboardDashboardSettingsGroupsRouteWithChildren;
  DashboardDashboardSettingsIntegrationsRoute: typeof DashboardDashboardSettingsIntegrationsRoute;
  DashboardDashboardSettingsJobPipelinesRoute: typeof DashboardDashboardSettingsJobPipelinesRouteWithChildren;
  DashboardDashboardSettingsJobtypesRoute: typeof DashboardDashboardSettingsJobtypesRouteWithChildren;
  DashboardDashboardSettingsLeadsRoute: typeof DashboardDashboardSettingsLeadsRoute;
  DashboardDashboardSettingsLogoutRoute: typeof DashboardDashboardSettingsLogoutRoute;
  DashboardDashboardSettingsNotificationsRoute: typeof DashboardDashboardSettingsNotificationsRouteWithChildren;
  DashboardDashboardSettingsOfficeSettingsRoute: typeof DashboardDashboardSettingsOfficeSettingsRouteWithChildren;
  DashboardDashboardSettingsOncallRoute: typeof DashboardDashboardSettingsOncallRoute;
  DashboardDashboardSettingsOnlineBookingRoute: typeof DashboardDashboardSettingsOnlineBookingRoute;
  DashboardDashboardSettingsPayrollProfilesRoute: typeof DashboardDashboardSettingsPayrollProfilesRoute;
  DashboardDashboardSettingsPermissionsRoute: typeof DashboardDashboardSettingsPermissionsRouteWithChildren;
  DashboardDashboardSettingsPhoneRoute: typeof DashboardDashboardSettingsPhoneRoute;
  DashboardDashboardSettingsPurchasingRoute: typeof DashboardDashboardSettingsPurchasingRoute;
  DashboardDashboardSettingsQuickbooksRoute: typeof DashboardDashboardSettingsQuickbooksRoute;
  DashboardDashboardSettingsRemindersRoute: typeof DashboardDashboardSettingsRemindersRouteWithChildren;
  DashboardDashboardSettingsReportsRoute: typeof DashboardDashboardSettingsReportsRoute;
  DashboardDashboardSettingsReviewPlatformsRoute: typeof DashboardDashboardSettingsReviewPlatformsRoute;
  DashboardDashboardSettingsReviewsRoute: typeof DashboardDashboardSettingsReviewsRoute;
  DashboardDashboardSettingsScopeOfWorkRoute: typeof DashboardDashboardSettingsScopeOfWorkRouteWithChildren;
  DashboardDashboardSettingsServiceAreasRoute: typeof DashboardDashboardSettingsServiceAreasRoute;
  DashboardDashboardSettingsSkillsRoute: typeof DashboardDashboardSettingsSkillsRouteWithChildren;
  DashboardDashboardSettingsSmsRoute: typeof DashboardDashboardSettingsSmsRoute;
  DashboardDashboardSettingsSubscriptionRoute: typeof DashboardDashboardSettingsSubscriptionRoute;
  DashboardDashboardSettingsSuppliersRoute: typeof DashboardDashboardSettingsSuppliersRoute;
  DashboardDashboardSettingsSurveysRoute: typeof DashboardDashboardSettingsSurveysRoute;
  DashboardDashboardSettingsTagsRoute: typeof DashboardDashboardSettingsTagsRoute;
  DashboardDashboardSettingsTaxesRoute: typeof DashboardDashboardSettingsTaxesRoute;
  DashboardDashboardSettingsTemplatesRoute: typeof DashboardDashboardSettingsTemplatesRouteWithChildren;
  DashboardDashboardSettingsTermsAndConditionsRoute: typeof DashboardDashboardSettingsTermsAndConditionsRouteWithChildren;
  DashboardDashboardSettingsTradesRoute: typeof DashboardDashboardSettingsTradesRoute;
  DashboardDashboardSettingsUsersRoute: typeof DashboardDashboardSettingsUsersRouteWithChildren;
  DashboardDashboardSettingsWebhooksRoute: typeof DashboardDashboardSettingsWebhooksRouteWithChildren;
  DashboardDashboardSettingsIndexRoute: typeof DashboardDashboardSettingsIndexRoute;
  DashboardDashboardSettingsBusinessUnitsIdRoute: typeof DashboardDashboardSettingsBusinessUnitsIdRoute;
  DashboardDashboardSettingsDocumentTemplatesIdRoute: typeof DashboardDashboardSettingsDocumentTemplatesIdRoute;
  DashboardDashboardSettingsDocumentTemplatesNewRoute: typeof DashboardDashboardSettingsDocumentTemplatesNewRoute;
  DashboardDashboardSettingsEmailTemplatesIdRoute: typeof DashboardDashboardSettingsEmailTemplatesIdRoute;
  DashboardDashboardSettingsEmailTemplatesNewRoute: typeof DashboardDashboardSettingsEmailTemplatesNewRoute;
  DashboardDashboardSettingsPartnerApiWebhooksRoute: typeof DashboardDashboardSettingsPartnerApiWebhooksRouteWithChildren;
  DashboardDashboardSettingsReportsTemplatesRoute: typeof DashboardDashboardSettingsReportsTemplatesRoute;
  DashboardDashboardSettingsBusinessUnitsIndexRoute: typeof DashboardDashboardSettingsBusinessUnitsIndexRoute;
  DashboardDashboardSettingsDocumentTemplatesIndexRoute: typeof DashboardDashboardSettingsDocumentTemplatesIndexRoute;
}

const DashboardDashboardSettingsRouteChildren: DashboardDashboardSettingsRouteChildren =
  {
    DashboardDashboardSettingsAccountingRoute:
      DashboardDashboardSettingsAccountingRoute,
    DashboardDashboardSettingsApiKeysRoute:
      DashboardDashboardSettingsApiKeysRoute,
    DashboardDashboardSettingsAppointmentFormsRoute:
      DashboardDashboardSettingsAppointmentFormsRouteWithChildren,
    DashboardDashboardSettingsBillingRoute:
      DashboardDashboardSettingsBillingRouteWithChildren,
    DashboardDashboardSettingsBookingLinksRoute:
      DashboardDashboardSettingsBookingLinksRoute,
    DashboardDashboardSettingsBookingServicesRoute:
      DashboardDashboardSettingsBookingServicesRoute,
    DashboardDashboardSettingsBookingWindowsRoute:
      DashboardDashboardSettingsBookingWindowsRoute,
    DashboardDashboardSettingsCallSettingsRoute:
      DashboardDashboardSettingsCallSettingsRouteWithChildren,
    DashboardDashboardSettingsCalltreeRoute:
      DashboardDashboardSettingsCalltreeRoute,
    DashboardDashboardSettingsChannelsRoute:
      DashboardDashboardSettingsChannelsRoute,
    DashboardDashboardSettingsChatbotRoute:
      DashboardDashboardSettingsChatbotRoute,
    DashboardDashboardSettingsChecklistRoute:
      DashboardDashboardSettingsChecklistRouteWithChildren,
    DashboardDashboardSettingsClientPortalRoute:
      DashboardDashboardSettingsClientPortalRoute,
    DashboardDashboardSettingsCompanyRoute:
      DashboardDashboardSettingsCompanyRouteWithChildren,
    DashboardDashboardSettingsConnectionsRoute:
      DashboardDashboardSettingsConnectionsRoute,
    DashboardDashboardSettingsContactStatusesRoute:
      DashboardDashboardSettingsContactStatusesRoute,
    DashboardDashboardSettingsContractsRoute:
      DashboardDashboardSettingsContractsRouteWithChildren,
    DashboardDashboardSettingsCustomfieldsRoute:
      DashboardDashboardSettingsCustomfieldsRouteWithChildren,
    DashboardDashboardSettingsDeferredRevenueRoute:
      DashboardDashboardSettingsDeferredRevenueRoute,
    DashboardDashboardSettingsEmailAccountsRoute:
      DashboardDashboardSettingsEmailAccountsRoute,
    DashboardDashboardSettingsEstimatePdfRoute:
      DashboardDashboardSettingsEstimatePdfRoute,
    DashboardDashboardSettingsEstimateSettingsRoute:
      DashboardDashboardSettingsEstimateSettingsRoute,
    DashboardDashboardSettingsEstimatesRoute:
      DashboardDashboardSettingsEstimatesRoute,
    DashboardDashboardSettingsGroupsRoute:
      DashboardDashboardSettingsGroupsRouteWithChildren,
    DashboardDashboardSettingsIntegrationsRoute:
      DashboardDashboardSettingsIntegrationsRoute,
    DashboardDashboardSettingsJobPipelinesRoute:
      DashboardDashboardSettingsJobPipelinesRouteWithChildren,
    DashboardDashboardSettingsJobtypesRoute:
      DashboardDashboardSettingsJobtypesRouteWithChildren,
    DashboardDashboardSettingsLeadsRoute: DashboardDashboardSettingsLeadsRoute,
    DashboardDashboardSettingsLogoutRoute:
      DashboardDashboardSettingsLogoutRoute,
    DashboardDashboardSettingsNotificationsRoute:
      DashboardDashboardSettingsNotificationsRouteWithChildren,
    DashboardDashboardSettingsOfficeSettingsRoute:
      DashboardDashboardSettingsOfficeSettingsRouteWithChildren,
    DashboardDashboardSettingsOncallRoute:
      DashboardDashboardSettingsOncallRoute,
    DashboardDashboardSettingsOnlineBookingRoute:
      DashboardDashboardSettingsOnlineBookingRoute,
    DashboardDashboardSettingsPayrollProfilesRoute:
      DashboardDashboardSettingsPayrollProfilesRoute,
    DashboardDashboardSettingsPermissionsRoute:
      DashboardDashboardSettingsPermissionsRouteWithChildren,
    DashboardDashboardSettingsPhoneRoute: DashboardDashboardSettingsPhoneRoute,
    DashboardDashboardSettingsPurchasingRoute:
      DashboardDashboardSettingsPurchasingRoute,
    DashboardDashboardSettingsQuickbooksRoute:
      DashboardDashboardSettingsQuickbooksRoute,
    DashboardDashboardSettingsRemindersRoute:
      DashboardDashboardSettingsRemindersRouteWithChildren,
    DashboardDashboardSettingsReportsRoute:
      DashboardDashboardSettingsReportsRoute,
    DashboardDashboardSettingsReviewPlatformsRoute:
      DashboardDashboardSettingsReviewPlatformsRoute,
    DashboardDashboardSettingsReviewsRoute:
      DashboardDashboardSettingsReviewsRoute,
    DashboardDashboardSettingsScopeOfWorkRoute:
      DashboardDashboardSettingsScopeOfWorkRouteWithChildren,
    DashboardDashboardSettingsServiceAreasRoute:
      DashboardDashboardSettingsServiceAreasRoute,
    DashboardDashboardSettingsSkillsRoute:
      DashboardDashboardSettingsSkillsRouteWithChildren,
    DashboardDashboardSettingsSmsRoute: DashboardDashboardSettingsSmsRoute,
    DashboardDashboardSettingsSubscriptionRoute:
      DashboardDashboardSettingsSubscriptionRoute,
    DashboardDashboardSettingsSuppliersRoute:
      DashboardDashboardSettingsSuppliersRoute,
    DashboardDashboardSettingsSurveysRoute:
      DashboardDashboardSettingsSurveysRoute,
    DashboardDashboardSettingsTagsRoute: DashboardDashboardSettingsTagsRoute,
    DashboardDashboardSettingsTaxesRoute: DashboardDashboardSettingsTaxesRoute,
    DashboardDashboardSettingsTemplatesRoute:
      DashboardDashboardSettingsTemplatesRouteWithChildren,
    DashboardDashboardSettingsTermsAndConditionsRoute:
      DashboardDashboardSettingsTermsAndConditionsRouteWithChildren,
    DashboardDashboardSettingsTradesRoute:
      DashboardDashboardSettingsTradesRoute,
    DashboardDashboardSettingsUsersRoute:
      DashboardDashboardSettingsUsersRouteWithChildren,
    DashboardDashboardSettingsWebhooksRoute:
      DashboardDashboardSettingsWebhooksRouteWithChildren,
    DashboardDashboardSettingsIndexRoute: DashboardDashboardSettingsIndexRoute,
    DashboardDashboardSettingsBusinessUnitsIdRoute:
      DashboardDashboardSettingsBusinessUnitsIdRoute,
    DashboardDashboardSettingsDocumentTemplatesIdRoute:
      DashboardDashboardSettingsDocumentTemplatesIdRoute,
    DashboardDashboardSettingsDocumentTemplatesNewRoute:
      DashboardDashboardSettingsDocumentTemplatesNewRoute,
    DashboardDashboardSettingsEmailTemplatesIdRoute:
      DashboardDashboardSettingsEmailTemplatesIdRoute,
    DashboardDashboardSettingsEmailTemplatesNewRoute:
      DashboardDashboardSettingsEmailTemplatesNewRoute,
    DashboardDashboardSettingsPartnerApiWebhooksRoute:
      DashboardDashboardSettingsPartnerApiWebhooksRouteWithChildren,
    DashboardDashboardSettingsReportsTemplatesRoute:
      DashboardDashboardSettingsReportsTemplatesRoute,
    DashboardDashboardSettingsBusinessUnitsIndexRoute:
      DashboardDashboardSettingsBusinessUnitsIndexRoute,
    DashboardDashboardSettingsDocumentTemplatesIndexRoute:
      DashboardDashboardSettingsDocumentTemplatesIndexRoute,
  };

const DashboardDashboardSettingsRouteWithChildren =
  DashboardDashboardSettingsRoute._addFileChildren(
    DashboardDashboardSettingsRouteChildren,
  );

interface DashboardDashboardTaxesRouteChildren {
  DashboardDashboardTaxesOverridesRoute: typeof DashboardDashboardTaxesOverridesRoute;
  DashboardDashboardTaxesRulesRoute: typeof DashboardDashboardTaxesRulesRoute;
  DashboardDashboardTaxesSimulatorRoute: typeof DashboardDashboardTaxesSimulatorRoute;
}

const DashboardDashboardTaxesRouteChildren: DashboardDashboardTaxesRouteChildren =
  {
    DashboardDashboardTaxesOverridesRoute:
      DashboardDashboardTaxesOverridesRoute,
    DashboardDashboardTaxesRulesRoute: DashboardDashboardTaxesRulesRoute,
    DashboardDashboardTaxesSimulatorRoute:
      DashboardDashboardTaxesSimulatorRoute,
  };

const DashboardDashboardTaxesRouteWithChildren =
  DashboardDashboardTaxesRoute._addFileChildren(
    DashboardDashboardTaxesRouteChildren,
  );

interface DashboardDashboardTechniciansIdRouteChildren {
  DashboardDashboardTechniciansIdEditRoute: typeof DashboardDashboardTechniciansIdEditRoute;
  DashboardDashboardTechniciansIdOffboardingRoute: typeof DashboardDashboardTechniciansIdOffboardingRoute;
}

const DashboardDashboardTechniciansIdRouteChildren: DashboardDashboardTechniciansIdRouteChildren =
  {
    DashboardDashboardTechniciansIdEditRoute:
      DashboardDashboardTechniciansIdEditRoute,
    DashboardDashboardTechniciansIdOffboardingRoute:
      DashboardDashboardTechniciansIdOffboardingRoute,
  };

const DashboardDashboardTechniciansIdRouteWithChildren =
  DashboardDashboardTechniciansIdRoute._addFileChildren(
    DashboardDashboardTechniciansIdRouteChildren,
  );

interface DashboardDashboardTechniciansRouteChildren {
  DashboardDashboardTechniciansIdRoute: typeof DashboardDashboardTechniciansIdRouteWithChildren;
  DashboardDashboardTechniciansNewRoute: typeof DashboardDashboardTechniciansNewRoute;
  DashboardDashboardTechniciansReportsRoute: typeof DashboardDashboardTechniciansReportsRoute;
  DashboardDashboardTechniciansIndexRoute: typeof DashboardDashboardTechniciansIndexRoute;
}

const DashboardDashboardTechniciansRouteChildren: DashboardDashboardTechniciansRouteChildren =
  {
    DashboardDashboardTechniciansIdRoute:
      DashboardDashboardTechniciansIdRouteWithChildren,
    DashboardDashboardTechniciansNewRoute:
      DashboardDashboardTechniciansNewRoute,
    DashboardDashboardTechniciansReportsRoute:
      DashboardDashboardTechniciansReportsRoute,
    DashboardDashboardTechniciansIndexRoute:
      DashboardDashboardTechniciansIndexRoute,
  };

const DashboardDashboardTechniciansRouteWithChildren =
  DashboardDashboardTechniciansRoute._addFileChildren(
    DashboardDashboardTechniciansRouteChildren,
  );

interface DashboardDashboardAiOttoRouteChildren {
  DashboardDashboardAiOttoReportIdRoute: typeof DashboardDashboardAiOttoReportIdRoute;
}

const DashboardDashboardAiOttoRouteChildren: DashboardDashboardAiOttoRouteChildren =
  {
    DashboardDashboardAiOttoReportIdRoute:
      DashboardDashboardAiOttoReportIdRoute,
  };

const DashboardDashboardAiOttoRouteWithChildren =
  DashboardDashboardAiOttoRoute._addFileChildren(
    DashboardDashboardAiOttoRouteChildren,
  );

interface DashboardRouteChildren {
  DashboardDashboardAuditRoute: typeof DashboardDashboardAuditRoute;
  DashboardDashboardBoardRoute: typeof DashboardDashboardBoardRoute;
  DashboardDashboardBookingsRoute: typeof DashboardDashboardBookingsRouteWithChildren;
  DashboardDashboardCalllogsRoute: typeof DashboardDashboardCalllogsRoute;
  DashboardDashboardChatbotRoute: typeof DashboardDashboardChatbotRoute;
  DashboardDashboardContactsRoute: typeof DashboardDashboardContactsRouteWithChildren;
  DashboardDashboardContractsRoute: typeof DashboardDashboardContractsRouteWithChildren;
  DashboardDashboardCreditMemosRoute: typeof DashboardDashboardCreditMemosRouteWithChildren;
  DashboardDashboardCrewMembersRoute: typeof DashboardDashboardCrewMembersRoute;
  DashboardDashboardCrewsRoute: typeof DashboardDashboardCrewsRouteWithChildren;
  DashboardDashboardDepositsRoute: typeof DashboardDashboardDepositsRouteWithChildren;
  DashboardDashboardDispatchRoute: typeof DashboardDashboardDispatchRoute;
  DashboardDashboardEquipmentRoute: typeof DashboardDashboardEquipmentRoute;
  DashboardDashboardEquipmentCategoriesRoute: typeof DashboardDashboardEquipmentCategoriesRoute;
  DashboardDashboardEquipmentDescriptionsRoute: typeof DashboardDashboardEquipmentDescriptionsRoute;
  DashboardDashboardEstimatesRoute: typeof DashboardDashboardEstimatesRouteWithChildren;
  DashboardDashboardExecutiveRoute: typeof DashboardDashboardExecutiveRoute;
  DashboardDashboardFormsRoute: typeof DashboardDashboardFormsRouteWithChildren;
  DashboardDashboardHomeRoute: typeof DashboardDashboardHomeRoute;
  DashboardDashboardInboxRoute: typeof DashboardDashboardInboxRoute;
  DashboardDashboardInventoryRoute: typeof DashboardDashboardInventoryRouteWithChildren;
  DashboardDashboardInvoicesRoute: typeof DashboardDashboardInvoicesRouteWithChildren;
  DashboardDashboardJobsRoute: typeof DashboardDashboardJobsRouteWithChildren;
  DashboardDashboardLeadsRoute: typeof DashboardDashboardLeadsRouteWithChildren;
  DashboardDashboardLeadsEngineRoute: typeof DashboardDashboardLeadsEngineRoute;
  DashboardDashboardLiveCallsRoute: typeof DashboardDashboardLiveCallsRoute;
  DashboardDashboardLocationsRoute: typeof DashboardDashboardLocationsRouteWithChildren;
  DashboardDashboardMembershipPlansRoute: typeof DashboardDashboardMembershipPlansRouteWithChildren;
  DashboardDashboardMembershipVisitsRoute: typeof DashboardDashboardMembershipVisitsRoute;
  DashboardDashboardMembershipsRoute: typeof DashboardDashboardMembershipsRouteWithChildren;
  DashboardDashboardMyDashboardRoute: typeof DashboardDashboardMyDashboardRoute;
  DashboardDashboardMyDayRoute: typeof DashboardDashboardMyDayRoute;
  DashboardDashboardNotificationsRoute: typeof DashboardDashboardNotificationsRoute;
  DashboardDashboardOnboardingRoute: typeof DashboardDashboardOnboardingRoute;
  DashboardDashboardOperationsRoute: typeof DashboardDashboardOperationsRoute;
  DashboardDashboardPastDueRoute: typeof DashboardDashboardPastDueRoute;
  DashboardDashboardPaymentsRoute: typeof DashboardDashboardPaymentsRouteWithChildren;
  DashboardDashboardPricebookRoute: typeof DashboardDashboardPricebookRouteWithChildren;
  DashboardDashboardProjectsRoute: typeof DashboardDashboardProjectsRouteWithChildren;
  DashboardDashboardPromotionsRoute: typeof DashboardDashboardPromotionsRoute;
  DashboardDashboardProposalsRoute: typeof DashboardDashboardProposalsRouteWithChildren;
  DashboardDashboardPurchasingRoute: typeof DashboardDashboardPurchasingRouteWithChildren;
  DashboardDashboardReceiptsRoute: typeof DashboardDashboardReceiptsRouteWithChildren;
  DashboardDashboardRecoveryRenewalsRoute: typeof DashboardDashboardRecoveryRenewalsRoute;
  DashboardDashboardRecurringBillingRoute: typeof DashboardDashboardRecurringBillingRoute;
  DashboardDashboardRemindersRoute: typeof DashboardDashboardRemindersRoute;
  DashboardDashboardReviewsRoute: typeof DashboardDashboardReviewsRoute;
  DashboardDashboardRoutesRoute: typeof DashboardDashboardRoutesRoute;
  DashboardDashboardScheduleRoute: typeof DashboardDashboardScheduleRoute;
  DashboardDashboardSettingsRoute: typeof DashboardDashboardSettingsRouteWithChildren;
  DashboardDashboardStripeRoute: typeof DashboardDashboardStripeRoute;
  DashboardDashboardTasksRoute: typeof DashboardDashboardTasksRoute;
  DashboardDashboardTaxesRoute: typeof DashboardDashboardTaxesRouteWithChildren;
  DashboardDashboardTeamChatRoute: typeof DashboardDashboardTeamChatRoute;
  DashboardDashboardTechniciansRoute: typeof DashboardDashboardTechniciansRouteWithChildren;
  DashboardDashboardTimesheetRoute: typeof DashboardDashboardTimesheetRoute;
  DashboardDashboardIndexRoute: typeof DashboardDashboardIndexRoute;
  DashboardDashboardAiOttoRoute: typeof DashboardDashboardAiOttoRouteWithChildren;
  DashboardDashboardCalendarIdRoute: typeof DashboardDashboardCalendarIdRoute;
  DashboardDashboardCalendarMapRoute: typeof DashboardDashboardCalendarMapRoute;
  DashboardDashboardCalllogsReportsRoute: typeof DashboardDashboardCalllogsReportsRoute;
  DashboardDashboardCostingReportsRoute: typeof DashboardDashboardCostingReportsRoute;
  DashboardDashboardCrewmemberUserIdRoute: typeof DashboardDashboardCrewmemberUserIdRoute;
  DashboardDashboardDispatchLiveRoute: typeof DashboardDashboardDispatchLiveRoute;
  DashboardDashboardJobformIdRoute: typeof DashboardDashboardJobformIdRoute;
  DashboardDashboardJobformNewRoute: typeof DashboardDashboardJobformNewRoute;
  DashboardDashboardReportingCallsRoute: typeof DashboardDashboardReportingCallsRoute;
  DashboardDashboardReportingMeRoute: typeof DashboardDashboardReportingMeRoute;
  DashboardDashboardReportingScorecardsRoute: typeof DashboardDashboardReportingScorecardsRoute;
  DashboardDashboardReportingTargetsRoute: typeof DashboardDashboardReportingTargetsRoute;
  DashboardDashboardReportsIdRoute: typeof DashboardDashboardReportsIdRoute;
  DashboardDashboardReportsNewRoute: typeof DashboardDashboardReportsNewRoute;
  DashboardDashboardCalendarIndexRoute: typeof DashboardDashboardCalendarIndexRoute;
  DashboardDashboardCrewmemberIndexRoute: typeof DashboardDashboardCrewmemberIndexRoute;
  DashboardDashboardJobformIndexRoute: typeof DashboardDashboardJobformIndexRoute;
  DashboardDashboardUnscheduledIndexRoute: typeof DashboardDashboardUnscheduledIndexRoute;
  DashboardDashboardReportingReportsReportIdRoute: typeof DashboardDashboardReportingReportsReportIdRoute;
  DashboardDashboardReportingReportsNewRoute: typeof DashboardDashboardReportingReportsNewRoute;
  DashboardDashboardReportingReportsIndexRoute: typeof DashboardDashboardReportingReportsIndexRoute;
  DashboardDashboardReportingReportsReportIdEditRoute: typeof DashboardDashboardReportingReportsReportIdEditRoute;
}

const DashboardRouteChildren: DashboardRouteChildren = {
  DashboardDashboardAuditRoute: DashboardDashboardAuditRoute,
  DashboardDashboardBoardRoute: DashboardDashboardBoardRoute,
  DashboardDashboardBookingsRoute: DashboardDashboardBookingsRouteWithChildren,
  DashboardDashboardCalllogsRoute: DashboardDashboardCalllogsRoute,
  DashboardDashboardChatbotRoute: DashboardDashboardChatbotRoute,
  DashboardDashboardContactsRoute: DashboardDashboardContactsRouteWithChildren,
  DashboardDashboardContractsRoute:
    DashboardDashboardContractsRouteWithChildren,
  DashboardDashboardCreditMemosRoute:
    DashboardDashboardCreditMemosRouteWithChildren,
  DashboardDashboardCrewMembersRoute: DashboardDashboardCrewMembersRoute,
  DashboardDashboardCrewsRoute: DashboardDashboardCrewsRouteWithChildren,
  DashboardDashboardDepositsRoute: DashboardDashboardDepositsRouteWithChildren,
  DashboardDashboardDispatchRoute: DashboardDashboardDispatchRoute,
  DashboardDashboardEquipmentRoute: DashboardDashboardEquipmentRoute,
  DashboardDashboardEquipmentCategoriesRoute:
    DashboardDashboardEquipmentCategoriesRoute,
  DashboardDashboardEquipmentDescriptionsRoute:
    DashboardDashboardEquipmentDescriptionsRoute,
  DashboardDashboardEstimatesRoute:
    DashboardDashboardEstimatesRouteWithChildren,
  DashboardDashboardExecutiveRoute: DashboardDashboardExecutiveRoute,
  DashboardDashboardFormsRoute: DashboardDashboardFormsRouteWithChildren,
  DashboardDashboardHomeRoute: DashboardDashboardHomeRoute,
  DashboardDashboardInboxRoute: DashboardDashboardInboxRoute,
  DashboardDashboardInventoryRoute:
    DashboardDashboardInventoryRouteWithChildren,
  DashboardDashboardInvoicesRoute: DashboardDashboardInvoicesRouteWithChildren,
  DashboardDashboardJobsRoute: DashboardDashboardJobsRouteWithChildren,
  DashboardDashboardLeadsRoute: DashboardDashboardLeadsRouteWithChildren,
  DashboardDashboardLeadsEngineRoute: DashboardDashboardLeadsEngineRoute,
  DashboardDashboardLiveCallsRoute: DashboardDashboardLiveCallsRoute,
  DashboardDashboardLocationsRoute:
    DashboardDashboardLocationsRouteWithChildren,
  DashboardDashboardMembershipPlansRoute:
    DashboardDashboardMembershipPlansRouteWithChildren,
  DashboardDashboardMembershipVisitsRoute:
    DashboardDashboardMembershipVisitsRoute,
  DashboardDashboardMembershipsRoute:
    DashboardDashboardMembershipsRouteWithChildren,
  DashboardDashboardMyDashboardRoute: DashboardDashboardMyDashboardRoute,
  DashboardDashboardMyDayRoute: DashboardDashboardMyDayRoute,
  DashboardDashboardNotificationsRoute: DashboardDashboardNotificationsRoute,
  DashboardDashboardOnboardingRoute: DashboardDashboardOnboardingRoute,
  DashboardDashboardOperationsRoute: DashboardDashboardOperationsRoute,
  DashboardDashboardPastDueRoute: DashboardDashboardPastDueRoute,
  DashboardDashboardPaymentsRoute: DashboardDashboardPaymentsRouteWithChildren,
  DashboardDashboardPricebookRoute:
    DashboardDashboardPricebookRouteWithChildren,
  DashboardDashboardProjectsRoute: DashboardDashboardProjectsRouteWithChildren,
  DashboardDashboardPromotionsRoute: DashboardDashboardPromotionsRoute,
  DashboardDashboardProposalsRoute:
    DashboardDashboardProposalsRouteWithChildren,
  DashboardDashboardPurchasingRoute:
    DashboardDashboardPurchasingRouteWithChildren,
  DashboardDashboardReceiptsRoute: DashboardDashboardReceiptsRouteWithChildren,
  DashboardDashboardRecoveryRenewalsRoute:
    DashboardDashboardRecoveryRenewalsRoute,
  DashboardDashboardRecurringBillingRoute:
    DashboardDashboardRecurringBillingRoute,
  DashboardDashboardRemindersRoute: DashboardDashboardRemindersRoute,
  DashboardDashboardReviewsRoute: DashboardDashboardReviewsRoute,
  DashboardDashboardRoutesRoute: DashboardDashboardRoutesRoute,
  DashboardDashboardScheduleRoute: DashboardDashboardScheduleRoute,
  DashboardDashboardSettingsRoute: DashboardDashboardSettingsRouteWithChildren,
  DashboardDashboardStripeRoute: DashboardDashboardStripeRoute,
  DashboardDashboardTasksRoute: DashboardDashboardTasksRoute,
  DashboardDashboardTaxesRoute: DashboardDashboardTaxesRouteWithChildren,
  DashboardDashboardTeamChatRoute: DashboardDashboardTeamChatRoute,
  DashboardDashboardTechniciansRoute:
    DashboardDashboardTechniciansRouteWithChildren,
  DashboardDashboardTimesheetRoute: DashboardDashboardTimesheetRoute,
  DashboardDashboardIndexRoute: DashboardDashboardIndexRoute,
  DashboardDashboardAiOttoRoute: DashboardDashboardAiOttoRouteWithChildren,
  DashboardDashboardCalendarIdRoute: DashboardDashboardCalendarIdRoute,
  DashboardDashboardCalendarMapRoute: DashboardDashboardCalendarMapRoute,
  DashboardDashboardCalllogsReportsRoute:
    DashboardDashboardCalllogsReportsRoute,
  DashboardDashboardCostingReportsRoute: DashboardDashboardCostingReportsRoute,
  DashboardDashboardCrewmemberUserIdRoute:
    DashboardDashboardCrewmemberUserIdRoute,
  DashboardDashboardDispatchLiveRoute: DashboardDashboardDispatchLiveRoute,
  DashboardDashboardJobformIdRoute: DashboardDashboardJobformIdRoute,
  DashboardDashboardJobformNewRoute: DashboardDashboardJobformNewRoute,
  DashboardDashboardReportingCallsRoute: DashboardDashboardReportingCallsRoute,
  DashboardDashboardReportingMeRoute: DashboardDashboardReportingMeRoute,
  DashboardDashboardReportingScorecardsRoute:
    DashboardDashboardReportingScorecardsRoute,
  DashboardDashboardReportingTargetsRoute:
    DashboardDashboardReportingTargetsRoute,
  DashboardDashboardReportsIdRoute: DashboardDashboardReportsIdRoute,
  DashboardDashboardReportsNewRoute: DashboardDashboardReportsNewRoute,
  DashboardDashboardCalendarIndexRoute: DashboardDashboardCalendarIndexRoute,
  DashboardDashboardCrewmemberIndexRoute:
    DashboardDashboardCrewmemberIndexRoute,
  DashboardDashboardJobformIndexRoute: DashboardDashboardJobformIndexRoute,
  DashboardDashboardUnscheduledIndexRoute:
    DashboardDashboardUnscheduledIndexRoute,
  DashboardDashboardReportingReportsReportIdRoute:
    DashboardDashboardReportingReportsReportIdRoute,
  DashboardDashboardReportingReportsNewRoute:
    DashboardDashboardReportingReportsNewRoute,
  DashboardDashboardReportingReportsIndexRoute:
    DashboardDashboardReportingReportsIndexRoute,
  DashboardDashboardReportingReportsReportIdEditRoute:
    DashboardDashboardReportingReportsReportIdEditRoute,
};

const DashboardRouteWithChildren = DashboardRoute._addFileChildren(
  DashboardRouteChildren,
);

interface publicCreatePasswordRouteChildren {
  publicCreatePasswordTokenRoute: typeof publicCreatePasswordTokenRoute;
}

const publicCreatePasswordRouteChildren: publicCreatePasswordRouteChildren = {
  publicCreatePasswordTokenRoute: publicCreatePasswordTokenRoute,
};

const publicCreatePasswordRouteWithChildren =
  publicCreatePasswordRoute._addFileChildren(publicCreatePasswordRouteChildren);

interface publicInviteRouteChildren {
  publicInviteTokenRoute: typeof publicInviteTokenRoute;
}

const publicInviteRouteChildren: publicInviteRouteChildren = {
  publicInviteTokenRoute: publicInviteTokenRoute,
};

const publicInviteRouteWithChildren = publicInviteRoute._addFileChildren(
  publicInviteRouteChildren,
);

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  SplatRoute: SplatRoute,
  DashboardRoute: DashboardRouteWithChildren,
  publicCreatePasswordRoute: publicCreatePasswordRouteWithChildren,
  publicForgotPasswordRoute: publicForgotPasswordRoute,
  publicGoogleBusinessRoute: publicGoogleBusinessRoute,
  publicInviteRoute: publicInviteRouteWithChildren,
  publicLoginRoute: publicLoginRoute,
  publicOnlinebookingresponseRoute: publicOnlinebookingresponseRoute,
  publicResetPasswordRoute: publicResetPasswordRoute,
  portalPortalForgotRoute: portalPortalForgotRoute,
  portalPortalLoginRoute: portalPortalLoginRoute,
  portalPortalRegisterRoute: portalPortalRegisterRoute,
  portalPortalResetRoute: portalPortalResetRoute,
  portalPortalVerifyRoute: portalPortalVerifyRoute,
  publicAuthImpersonateHandoffRoute: publicAuthImpersonateHandoffRoute,
  publicBookTokenRoute: publicBookTokenRoute,
  publicCTokenRoute: publicCTokenRoute,
  publicChangeOrderIdRoute: publicChangeOrderIdRoute,
  publicCombinedDocTokenRoute: publicCombinedDocTokenRoute,
  publicConfirmJobReferenceNoRoute: publicConfirmJobReferenceNoRoute,
  publicETokenRoute: publicETokenRoute,
  publicEstimateIdRoute: publicEstimateIdRoute,
  publicFormIdRoute: publicFormIdRoute,
  publicIIdRoute: publicIIdRoute,
  publicInvoiceIdRoute: publicInvoiceIdRoute,
  publicJReferenceNoRoute: publicJReferenceNoRoute,
  publicJobStoriesTokenRoute: publicJobStoriesTokenRoute,
  publicLinkPhoneTokenRoute: publicLinkPhoneTokenRoute,
  publicOnlinebookingIdRoute: publicOnlinebookingIdRoute,
  publicOnlineformIdRoute: publicOnlineformIdRoute,
  publicPayTokenRoute: publicPayTokenRoute,
  publicPaymentMethodRequestTokenRoute: publicPaymentMethodRequestTokenRoute,
  publicPdfEstimateIdRoute: publicPdfEstimateIdRoute,
  publicPdfInvoiceIdRoute: publicPdfInvoiceIdRoute,
  publicPdfProposalIdRoute: publicPdfProposalIdRoute,
  publicPreviewinvoiceIdRoute: publicPreviewinvoiceIdRoute,
  publicPreviewquoteIdRoute: publicPreviewquoteIdRoute,
  publicProposalIdRoute: publicProposalIdRoute,
  publicQuoteIdRoute: publicQuoteIdRoute,
  publicRTokenRoute: publicRTokenRoute,
  publicReceiptIdRoute: publicReceiptIdRoute,
  publicRecurringRenewalTokenRoute: publicRecurringRenewalTokenRoute,
  publicRecurringTokenRoute: publicRecurringTokenRoute,
  publicRepairMembershipTokenRoute: publicRepairMembershipTokenRoute,
  publicRepairPaymentMethodTokenRoute: publicRepairPaymentMethodTokenRoute,
  publicResponseIdRoute: publicResponseIdRoute,
  publicReviewTokenRoute: publicReviewTokenRoute,
  publicSCodeRoute: publicSCodeRoute,
  publicScheduleChangeTokenRoute: publicScheduleChangeTokenRoute,
  publicSignedSignedIdRoute: publicSignedSignedIdRoute,
  publicSupplierOrderTokenRoute: publicSupplierOrderTokenRoute,
  publicTTokenRoute: publicTTokenRoute,
  publicTipOptionIdRoute: publicTipOptionIdRoute,
  publicTipIdRoute: publicTipIdRoute,
  portalPortalIndexRoute: portalPortalIndexRoute,
  publicReviewIndexRoute: publicReviewIndexRoute,
  portalPortalEstimatesIdRoute: portalPortalEstimatesIdRoute,
  portalPortalInvoicesIdRoute: portalPortalInvoicesIdRoute,
  portalPortalMembershipsIdRoute: portalPortalMembershipsIdRoute,
  portalPortalProposalsIdRoute: portalPortalProposalsIdRoute,
  portalPortalVisitsBookRoute: portalPortalVisitsBookRoute,
  publicReviewReviewIdId2Route: publicReviewReviewIdId2Route,
  publicTrackingIdRefnoRoute: publicTrackingIdRefnoRoute,
  portalPortalAccountIndexRoute: portalPortalAccountIndexRoute,
  portalPortalDocumentsIndexRoute: portalPortalDocumentsIndexRoute,
  portalPortalEquipmentIndexRoute: portalPortalEquipmentIndexRoute,
  portalPortalEstimatesIndexRoute: portalPortalEstimatesIndexRoute,
  portalPortalInvoicesIndexRoute: portalPortalInvoicesIndexRoute,
  portalPortalMembershipsIndexRoute: portalPortalMembershipsIndexRoute,
  portalPortalPlansIndexRoute: portalPortalPlansIndexRoute,
  portalPortalProposalsIndexRoute: portalPortalProposalsIndexRoute,
  portalPortalVisitsIndexRoute: portalPortalVisitsIndexRoute,
  publicPaymentIdId2PriceidRoute: publicPaymentIdId2PriceidRoute,
};
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>();
